/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    AttachmentType: { input: any; output: any };
    ChannelType: { input: any; output: any };
    ContactInteractionType: { input: any; output: any };
    ContactSuggestionReason: { input: any; output: any };
    Creator: { input: any; output: any };
    DeliveryStatus: { input: any; output: any };
    JobStatus: { input: any; output: any };
    LinkedinConnectionStatus: { input: any; output: any };
    MessageType: { input: any; output: any };
    PromptCategory: { input: any; output: any };
    ResourceType: { input: any; output: any };
    UserContactStatus: { input: any; output: any };
    bigint: { input: any; output: any };
    float8: { input: any; output: any };
    jsonb: { input: any; output: any };
    numeric: { input: any; output: any };
    timestamp: { input: any; output: any };
    vector: { input: any; output: any };
};

/** columns and relationships of "Accounts" */
export type Accounts = {
    __typename?: 'Accounts';
    /** An array relationship */
    Contacts: Array<Contacts>;
    /** An aggregate relationship */
    Contacts_aggregate: Contacts_Aggregate;
    /** An array relationship */
    Resources: Array<Resources>;
    /** An aggregate relationship */
    Resources_aggregate: Resources_Aggregate;
    accountIdentifier: Scalars['String']['output'];
    createdAt: Scalars['timestamp']['output'];
    embedding?: Maybe<Scalars['vector']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    foundedYear?: Maybe<Scalars['Int']['output']>;
    id: Scalars['String']['output'];
    industry?: Maybe<Scalars['String']['output']>;
    lastContactedAt?: Maybe<Scalars['timestamp']['output']>;
    linkedinCompanyId?: Maybe<Scalars['String']['output']>;
    linkedinUrl?: Maybe<Scalars['String']['output']>;
    locations?: Maybe<Array<Scalars['String']['output']>>;
    logoUrl?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['jsonb']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    name: Scalars['String']['output'];
    organizationId: Scalars['String']['output'];
    size?: Maybe<Scalars['String']['output']>;
    slogan?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
    website?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "Accounts" */
export type AccountsContactsArgs = {
    distinct_on?: InputMaybe<Array<Contacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Contacts_Order_By>>;
    where?: InputMaybe<Contacts_Bool_Exp>;
};

/** columns and relationships of "Accounts" */
export type AccountsContacts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Contacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Contacts_Order_By>>;
    where?: InputMaybe<Contacts_Bool_Exp>;
};

/** columns and relationships of "Accounts" */
export type AccountsResourcesArgs = {
    distinct_on?: InputMaybe<Array<Resources_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Resources_Order_By>>;
    where?: InputMaybe<Resources_Bool_Exp>;
};

/** columns and relationships of "Accounts" */
export type AccountsResources_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Resources_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Resources_Order_By>>;
    where?: InputMaybe<Resources_Bool_Exp>;
};

/** columns and relationships of "Accounts" */
export type AccountsMetadataArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Accounts" */
export type Accounts_Aggregate = {
    __typename?: 'Accounts_aggregate';
    aggregate?: Maybe<Accounts_Aggregate_Fields>;
    nodes: Array<Accounts>;
};

/** aggregate fields of "Accounts" */
export type Accounts_Aggregate_Fields = {
    __typename?: 'Accounts_aggregate_fields';
    avg?: Maybe<Accounts_Avg_Fields>;
    count: Scalars['Int']['output'];
    max?: Maybe<Accounts_Max_Fields>;
    min?: Maybe<Accounts_Min_Fields>;
    stddev?: Maybe<Accounts_Stddev_Fields>;
    stddev_pop?: Maybe<Accounts_Stddev_Pop_Fields>;
    stddev_samp?: Maybe<Accounts_Stddev_Samp_Fields>;
    sum?: Maybe<Accounts_Sum_Fields>;
    var_pop?: Maybe<Accounts_Var_Pop_Fields>;
    var_samp?: Maybe<Accounts_Var_Samp_Fields>;
    variance?: Maybe<Accounts_Variance_Fields>;
};

/** aggregate fields of "Accounts" */
export type Accounts_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<Accounts_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Accounts_Append_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Accounts_Avg_Fields = {
    __typename?: 'Accounts_avg_fields';
    foundedYear?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "Accounts". All fields are combined with a logical 'AND'. */
export type Accounts_Bool_Exp = {
    Contacts?: InputMaybe<Contacts_Bool_Exp>;
    Contacts_aggregate?: InputMaybe<Contacts_Aggregate_Bool_Exp>;
    Resources?: InputMaybe<Resources_Bool_Exp>;
    Resources_aggregate?: InputMaybe<Resources_Aggregate_Bool_Exp>;
    _and?: InputMaybe<Array<Accounts_Bool_Exp>>;
    _not?: InputMaybe<Accounts_Bool_Exp>;
    _or?: InputMaybe<Array<Accounts_Bool_Exp>>;
    accountIdentifier?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    embedding?: InputMaybe<Vector_Comparison_Exp>;
    embeddingLastUpdatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    foundedYear?: InputMaybe<Int_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    industry?: InputMaybe<String_Comparison_Exp>;
    lastContactedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    linkedinCompanyId?: InputMaybe<String_Comparison_Exp>;
    linkedinUrl?: InputMaybe<String_Comparison_Exp>;
    locations?: InputMaybe<String_Array_Comparison_Exp>;
    logoUrl?: InputMaybe<String_Comparison_Exp>;
    metadata?: InputMaybe<Jsonb_Comparison_Exp>;
    metadataLastUpdatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    name?: InputMaybe<String_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    size?: InputMaybe<String_Comparison_Exp>;
    slogan?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
    website?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Accounts" */
export enum Accounts_Constraint {
    /** unique or primary key constraint on columns "accountIdentifier" */
    AccountsAccountIdentifierKey = 'Accounts_accountIdentifier_key',
    /** unique or primary key constraint on columns "id" */
    AccountsPkey = 'Accounts_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Accounts_Delete_At_Path_Input = {
    metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Accounts_Delete_Elem_Input = {
    metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Accounts_Delete_Key_Input = {
    metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "Accounts" */
export type Accounts_Inc_Input = {
    foundedYear?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "Accounts" */
export type Accounts_Insert_Input = {
    Contacts?: InputMaybe<Contacts_Arr_Rel_Insert_Input>;
    Resources?: InputMaybe<Resources_Arr_Rel_Insert_Input>;
    accountIdentifier?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    foundedYear?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    industry?: InputMaybe<Scalars['String']['input']>;
    lastContactedAt?: InputMaybe<Scalars['timestamp']['input']>;
    linkedinCompanyId?: InputMaybe<Scalars['String']['input']>;
    linkedinUrl?: InputMaybe<Scalars['String']['input']>;
    locations?: InputMaybe<Array<Scalars['String']['input']>>;
    logoUrl?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    size?: InputMaybe<Scalars['String']['input']>;
    slogan?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Accounts_Max_Fields = {
    __typename?: 'Accounts_max_fields';
    accountIdentifier?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    foundedYear?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    industry?: Maybe<Scalars['String']['output']>;
    lastContactedAt?: Maybe<Scalars['timestamp']['output']>;
    linkedinCompanyId?: Maybe<Scalars['String']['output']>;
    linkedinUrl?: Maybe<Scalars['String']['output']>;
    locations?: Maybe<Array<Scalars['String']['output']>>;
    logoUrl?: Maybe<Scalars['String']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    size?: Maybe<Scalars['String']['output']>;
    slogan?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    website?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Accounts_Min_Fields = {
    __typename?: 'Accounts_min_fields';
    accountIdentifier?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    foundedYear?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    industry?: Maybe<Scalars['String']['output']>;
    lastContactedAt?: Maybe<Scalars['timestamp']['output']>;
    linkedinCompanyId?: Maybe<Scalars['String']['output']>;
    linkedinUrl?: Maybe<Scalars['String']['output']>;
    locations?: Maybe<Array<Scalars['String']['output']>>;
    logoUrl?: Maybe<Scalars['String']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    size?: Maybe<Scalars['String']['output']>;
    slogan?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    website?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "Accounts" */
export type Accounts_Mutation_Response = {
    __typename?: 'Accounts_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Accounts>;
};

/** input type for inserting object relation for remote table "Accounts" */
export type Accounts_Obj_Rel_Insert_Input = {
    data: Accounts_Insert_Input;
    /** upsert condition */
    on_conflict?: InputMaybe<Accounts_On_Conflict>;
};

/** on_conflict condition type for table "Accounts" */
export type Accounts_On_Conflict = {
    constraint: Accounts_Constraint;
    update_columns?: Array<Accounts_Update_Column>;
    where?: InputMaybe<Accounts_Bool_Exp>;
};

/** Ordering options when selecting data from "Accounts". */
export type Accounts_Order_By = {
    Contacts_aggregate?: InputMaybe<Contacts_Aggregate_Order_By>;
    Resources_aggregate?: InputMaybe<Resources_Aggregate_Order_By>;
    accountIdentifier?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    embedding?: InputMaybe<Order_By>;
    embeddingLastUpdatedAt?: InputMaybe<Order_By>;
    foundedYear?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    industry?: InputMaybe<Order_By>;
    lastContactedAt?: InputMaybe<Order_By>;
    linkedinCompanyId?: InputMaybe<Order_By>;
    linkedinUrl?: InputMaybe<Order_By>;
    locations?: InputMaybe<Order_By>;
    logoUrl?: InputMaybe<Order_By>;
    metadata?: InputMaybe<Order_By>;
    metadataLastUpdatedAt?: InputMaybe<Order_By>;
    name?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    size?: InputMaybe<Order_By>;
    slogan?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Accounts */
export type Accounts_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Accounts_Prepend_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "Accounts" */
export enum Accounts_Select_Column {
    /** column name */
    AccountIdentifier = 'accountIdentifier',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Embedding = 'embedding',
    /** column name */
    EmbeddingLastUpdatedAt = 'embeddingLastUpdatedAt',
    /** column name */
    FoundedYear = 'foundedYear',
    /** column name */
    Id = 'id',
    /** column name */
    Industry = 'industry',
    /** column name */
    LastContactedAt = 'lastContactedAt',
    /** column name */
    LinkedinCompanyId = 'linkedinCompanyId',
    /** column name */
    LinkedinUrl = 'linkedinUrl',
    /** column name */
    Locations = 'locations',
    /** column name */
    LogoUrl = 'logoUrl',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    MetadataLastUpdatedAt = 'metadataLastUpdatedAt',
    /** column name */
    Name = 'name',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    Size = 'size',
    /** column name */
    Slogan = 'slogan',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
    /** column name */
    Website = 'website',
}

/** input type for updating data in table "Accounts" */
export type Accounts_Set_Input = {
    accountIdentifier?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    foundedYear?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    industry?: InputMaybe<Scalars['String']['input']>;
    lastContactedAt?: InputMaybe<Scalars['timestamp']['input']>;
    linkedinCompanyId?: InputMaybe<Scalars['String']['input']>;
    linkedinUrl?: InputMaybe<Scalars['String']['input']>;
    locations?: InputMaybe<Array<Scalars['String']['input']>>;
    logoUrl?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    size?: InputMaybe<Scalars['String']['input']>;
    slogan?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Accounts_Stddev_Fields = {
    __typename?: 'Accounts_stddev_fields';
    foundedYear?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Accounts_Stddev_Pop_Fields = {
    __typename?: 'Accounts_stddev_pop_fields';
    foundedYear?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Accounts_Stddev_Samp_Fields = {
    __typename?: 'Accounts_stddev_samp_fields';
    foundedYear?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "Accounts" */
export type Accounts_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: Accounts_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Accounts_Stream_Cursor_Value_Input = {
    accountIdentifier?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    foundedYear?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    industry?: InputMaybe<Scalars['String']['input']>;
    lastContactedAt?: InputMaybe<Scalars['timestamp']['input']>;
    linkedinCompanyId?: InputMaybe<Scalars['String']['input']>;
    linkedinUrl?: InputMaybe<Scalars['String']['input']>;
    locations?: InputMaybe<Array<Scalars['String']['input']>>;
    logoUrl?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    size?: InputMaybe<Scalars['String']['input']>;
    slogan?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Accounts_Sum_Fields = {
    __typename?: 'Accounts_sum_fields';
    foundedYear?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "Accounts" */
export enum Accounts_Update_Column {
    /** column name */
    AccountIdentifier = 'accountIdentifier',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Embedding = 'embedding',
    /** column name */
    EmbeddingLastUpdatedAt = 'embeddingLastUpdatedAt',
    /** column name */
    FoundedYear = 'foundedYear',
    /** column name */
    Id = 'id',
    /** column name */
    Industry = 'industry',
    /** column name */
    LastContactedAt = 'lastContactedAt',
    /** column name */
    LinkedinCompanyId = 'linkedinCompanyId',
    /** column name */
    LinkedinUrl = 'linkedinUrl',
    /** column name */
    Locations = 'locations',
    /** column name */
    LogoUrl = 'logoUrl',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    MetadataLastUpdatedAt = 'metadataLastUpdatedAt',
    /** column name */
    Name = 'name',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    Size = 'size',
    /** column name */
    Slogan = 'slogan',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
    /** column name */
    Website = 'website',
}

export type Accounts_Updates = {
    /** append existing jsonb value of filtered columns with new jsonb value */
    _append?: InputMaybe<Accounts_Append_Input>;
    /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
    _delete_at_path?: InputMaybe<Accounts_Delete_At_Path_Input>;
    /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
    _delete_elem?: InputMaybe<Accounts_Delete_Elem_Input>;
    /** delete key/value pair or string element. key/value pairs are matched based on their key value */
    _delete_key?: InputMaybe<Accounts_Delete_Key_Input>;
    /** increments the numeric columns with given value of the filtered values */
    _inc?: InputMaybe<Accounts_Inc_Input>;
    /** prepend existing jsonb value of filtered columns with new jsonb value */
    _prepend?: InputMaybe<Accounts_Prepend_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<Accounts_Set_Input>;
    /** filter the rows which have to be updated */
    where: Accounts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Accounts_Var_Pop_Fields = {
    __typename?: 'Accounts_var_pop_fields';
    foundedYear?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Accounts_Var_Samp_Fields = {
    __typename?: 'Accounts_var_samp_fields';
    foundedYear?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Accounts_Variance_Fields = {
    __typename?: 'Accounts_variance_fields';
    foundedYear?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "AssistantSettings" */
export type AssistantSettings = {
    __typename?: 'AssistantSettings';
    /** An array relationship */
    Groups: Array<Groups>;
    /** An aggregate relationship */
    Groups_aggregate: Groups_Aggregate;
    context?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['timestamp']['output'];
    defaultChannel: Scalars['ChannelType']['output'];
    id: Scalars['String']['output'];
    language: Scalars['String']['output'];
    languages?: Maybe<Array<Scalars['String']['output']>>;
    organizationId: Scalars['String']['output'];
    purpose: Scalars['String']['output'];
    targetGroup?: Maybe<Scalars['String']['output']>;
    tone: Scalars['String']['output'];
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
};

/** columns and relationships of "AssistantSettings" */
export type AssistantSettingsGroupsArgs = {
    distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Groups_Order_By>>;
    where?: InputMaybe<Groups_Bool_Exp>;
};

/** columns and relationships of "AssistantSettings" */
export type AssistantSettingsGroups_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Groups_Order_By>>;
    where?: InputMaybe<Groups_Bool_Exp>;
};

/** aggregated selection of "AssistantSettings" */
export type AssistantSettings_Aggregate = {
    __typename?: 'AssistantSettings_aggregate';
    aggregate?: Maybe<AssistantSettings_Aggregate_Fields>;
    nodes: Array<AssistantSettings>;
};

/** aggregate fields of "AssistantSettings" */
export type AssistantSettings_Aggregate_Fields = {
    __typename?: 'AssistantSettings_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<AssistantSettings_Max_Fields>;
    min?: Maybe<AssistantSettings_Min_Fields>;
};

/** aggregate fields of "AssistantSettings" */
export type AssistantSettings_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<AssistantSettings_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "AssistantSettings". All fields are combined with a logical 'AND'. */
export type AssistantSettings_Bool_Exp = {
    Groups?: InputMaybe<Groups_Bool_Exp>;
    Groups_aggregate?: InputMaybe<Groups_Aggregate_Bool_Exp>;
    _and?: InputMaybe<Array<AssistantSettings_Bool_Exp>>;
    _not?: InputMaybe<AssistantSettings_Bool_Exp>;
    _or?: InputMaybe<Array<AssistantSettings_Bool_Exp>>;
    context?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    defaultChannel?: InputMaybe<ChannelType_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    language?: InputMaybe<String_Comparison_Exp>;
    languages?: InputMaybe<String_Array_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    purpose?: InputMaybe<String_Comparison_Exp>;
    targetGroup?: InputMaybe<String_Comparison_Exp>;
    tone?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "AssistantSettings" */
export enum AssistantSettings_Constraint {
    /** unique or primary key constraint on columns "id" */
    AssistantSettingsPkey = 'AssistantSettings_pkey',
}

/** input type for inserting data into table "AssistantSettings" */
export type AssistantSettings_Insert_Input = {
    Groups?: InputMaybe<Groups_Arr_Rel_Insert_Input>;
    context?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    defaultChannel?: InputMaybe<Scalars['ChannelType']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    language?: InputMaybe<Scalars['String']['input']>;
    languages?: InputMaybe<Array<Scalars['String']['input']>>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    purpose?: InputMaybe<Scalars['String']['input']>;
    targetGroup?: InputMaybe<Scalars['String']['input']>;
    tone?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AssistantSettings_Max_Fields = {
    __typename?: 'AssistantSettings_max_fields';
    context?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    defaultChannel?: Maybe<Scalars['ChannelType']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    language?: Maybe<Scalars['String']['output']>;
    languages?: Maybe<Array<Scalars['String']['output']>>;
    organizationId?: Maybe<Scalars['String']['output']>;
    purpose?: Maybe<Scalars['String']['output']>;
    targetGroup?: Maybe<Scalars['String']['output']>;
    tone?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AssistantSettings_Min_Fields = {
    __typename?: 'AssistantSettings_min_fields';
    context?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    defaultChannel?: Maybe<Scalars['ChannelType']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    language?: Maybe<Scalars['String']['output']>;
    languages?: Maybe<Array<Scalars['String']['output']>>;
    organizationId?: Maybe<Scalars['String']['output']>;
    purpose?: Maybe<Scalars['String']['output']>;
    targetGroup?: Maybe<Scalars['String']['output']>;
    tone?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "AssistantSettings" */
export type AssistantSettings_Mutation_Response = {
    __typename?: 'AssistantSettings_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<AssistantSettings>;
};

/** input type for inserting object relation for remote table "AssistantSettings" */
export type AssistantSettings_Obj_Rel_Insert_Input = {
    data: AssistantSettings_Insert_Input;
    /** upsert condition */
    on_conflict?: InputMaybe<AssistantSettings_On_Conflict>;
};

/** on_conflict condition type for table "AssistantSettings" */
export type AssistantSettings_On_Conflict = {
    constraint: AssistantSettings_Constraint;
    update_columns?: Array<AssistantSettings_Update_Column>;
    where?: InputMaybe<AssistantSettings_Bool_Exp>;
};

/** Ordering options when selecting data from "AssistantSettings". */
export type AssistantSettings_Order_By = {
    Groups_aggregate?: InputMaybe<Groups_Aggregate_Order_By>;
    context?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    defaultChannel?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    language?: InputMaybe<Order_By>;
    languages?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    purpose?: InputMaybe<Order_By>;
    targetGroup?: InputMaybe<Order_By>;
    tone?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AssistantSettings */
export type AssistantSettings_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** select columns of table "AssistantSettings" */
export enum AssistantSettings_Select_Column {
    /** column name */
    Context = 'context',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    DefaultChannel = 'defaultChannel',
    /** column name */
    Id = 'id',
    /** column name */
    Language = 'language',
    /** column name */
    Languages = 'languages',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    Purpose = 'purpose',
    /** column name */
    TargetGroup = 'targetGroup',
    /** column name */
    Tone = 'tone',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

/** input type for updating data in table "AssistantSettings" */
export type AssistantSettings_Set_Input = {
    context?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    defaultChannel?: InputMaybe<Scalars['ChannelType']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    language?: InputMaybe<Scalars['String']['input']>;
    languages?: InputMaybe<Array<Scalars['String']['input']>>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    purpose?: InputMaybe<Scalars['String']['input']>;
    targetGroup?: InputMaybe<Scalars['String']['input']>;
    tone?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "AssistantSettings" */
export type AssistantSettings_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: AssistantSettings_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AssistantSettings_Stream_Cursor_Value_Input = {
    context?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    defaultChannel?: InputMaybe<Scalars['ChannelType']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    language?: InputMaybe<Scalars['String']['input']>;
    languages?: InputMaybe<Array<Scalars['String']['input']>>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    purpose?: InputMaybe<Scalars['String']['input']>;
    targetGroup?: InputMaybe<Scalars['String']['input']>;
    tone?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "AssistantSettings" */
export enum AssistantSettings_Update_Column {
    /** column name */
    Context = 'context',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    DefaultChannel = 'defaultChannel',
    /** column name */
    Id = 'id',
    /** column name */
    Language = 'language',
    /** column name */
    Languages = 'languages',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    Purpose = 'purpose',
    /** column name */
    TargetGroup = 'targetGroup',
    /** column name */
    Tone = 'tone',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

export type AssistantSettings_Updates = {
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<AssistantSettings_Set_Input>;
    /** filter the rows which have to be updated */
    where: AssistantSettings_Bool_Exp;
};

/** Boolean expression to compare columns of type "AttachmentType". All fields are combined with logical 'AND'. */
export type AttachmentType_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['AttachmentType']['input']>;
    _gt?: InputMaybe<Scalars['AttachmentType']['input']>;
    _gte?: InputMaybe<Scalars['AttachmentType']['input']>;
    _in?: InputMaybe<Array<Scalars['AttachmentType']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['AttachmentType']['input']>;
    _lte?: InputMaybe<Scalars['AttachmentType']['input']>;
    _neq?: InputMaybe<Scalars['AttachmentType']['input']>;
    _nin?: InputMaybe<Array<Scalars['AttachmentType']['input']>>;
};

/** columns and relationships of "Attachments" */
export type Attachments = {
    __typename?: 'Attachments';
    /** An object relationship */
    Message: Messages;
    createdAt: Scalars['timestamp']['output'];
    id: Scalars['String']['output'];
    messageId: Scalars['String']['output'];
    type: Scalars['AttachmentType']['output'];
    userId: Scalars['String']['output'];
    value: Scalars['String']['output'];
};

/** aggregated selection of "Attachments" */
export type Attachments_Aggregate = {
    __typename?: 'Attachments_aggregate';
    aggregate?: Maybe<Attachments_Aggregate_Fields>;
    nodes: Array<Attachments>;
};

export type Attachments_Aggregate_Bool_Exp = {
    count?: InputMaybe<Attachments_Aggregate_Bool_Exp_Count>;
};

export type Attachments_Aggregate_Bool_Exp_Count = {
    arguments?: InputMaybe<Array<Attachments_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Attachments_Bool_Exp>;
    predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Attachments" */
export type Attachments_Aggregate_Fields = {
    __typename?: 'Attachments_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<Attachments_Max_Fields>;
    min?: Maybe<Attachments_Min_Fields>;
};

/** aggregate fields of "Attachments" */
export type Attachments_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<Attachments_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Attachments" */
export type Attachments_Aggregate_Order_By = {
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<Attachments_Max_Order_By>;
    min?: InputMaybe<Attachments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "Attachments" */
export type Attachments_Arr_Rel_Insert_Input = {
    data: Array<Attachments_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<Attachments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Attachments". All fields are combined with a logical 'AND'. */
export type Attachments_Bool_Exp = {
    Message?: InputMaybe<Messages_Bool_Exp>;
    _and?: InputMaybe<Array<Attachments_Bool_Exp>>;
    _not?: InputMaybe<Attachments_Bool_Exp>;
    _or?: InputMaybe<Array<Attachments_Bool_Exp>>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    messageId?: InputMaybe<String_Comparison_Exp>;
    type?: InputMaybe<AttachmentType_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
    value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Attachments" */
export enum Attachments_Constraint {
    /** unique or primary key constraint on columns "id" */
    AttachmentsPkey = 'Attachments_pkey',
}

/** input type for inserting data into table "Attachments" */
export type Attachments_Insert_Input = {
    Message?: InputMaybe<Messages_Obj_Rel_Insert_Input>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    messageId?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<Scalars['AttachmentType']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Attachments_Max_Fields = {
    __typename?: 'Attachments_max_fields';
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    messageId?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['AttachmentType']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "Attachments" */
export type Attachments_Max_Order_By = {
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    messageId?: InputMaybe<Order_By>;
    type?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Attachments_Min_Fields = {
    __typename?: 'Attachments_min_fields';
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    messageId?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['AttachmentType']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "Attachments" */
export type Attachments_Min_Order_By = {
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    messageId?: InputMaybe<Order_By>;
    type?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Attachments" */
export type Attachments_Mutation_Response = {
    __typename?: 'Attachments_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Attachments>;
};

/** on_conflict condition type for table "Attachments" */
export type Attachments_On_Conflict = {
    constraint: Attachments_Constraint;
    update_columns?: Array<Attachments_Update_Column>;
    where?: InputMaybe<Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "Attachments". */
export type Attachments_Order_By = {
    Message?: InputMaybe<Messages_Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    messageId?: InputMaybe<Order_By>;
    type?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Attachments */
export type Attachments_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** select columns of table "Attachments" */
export enum Attachments_Select_Column {
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    MessageId = 'messageId',
    /** column name */
    Type = 'type',
    /** column name */
    UserId = 'userId',
    /** column name */
    Value = 'value',
}

/** input type for updating data in table "Attachments" */
export type Attachments_Set_Input = {
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    messageId?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<Scalars['AttachmentType']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "Attachments" */
export type Attachments_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: Attachments_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Attachments_Stream_Cursor_Value_Input = {
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    messageId?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<Scalars['AttachmentType']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "Attachments" */
export enum Attachments_Update_Column {
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    MessageId = 'messageId',
    /** column name */
    Type = 'type',
    /** column name */
    UserId = 'userId',
    /** column name */
    Value = 'value',
}

export type Attachments_Updates = {
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<Attachments_Set_Input>;
    /** filter the rows which have to be updated */
    where: Attachments_Bool_Exp;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['Boolean']['input']>;
    _gt?: InputMaybe<Scalars['Boolean']['input']>;
    _gte?: InputMaybe<Scalars['Boolean']['input']>;
    _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['Boolean']['input']>;
    _lte?: InputMaybe<Scalars['Boolean']['input']>;
    _neq?: InputMaybe<Scalars['Boolean']['input']>;
    _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "ChannelType". All fields are combined with logical 'AND'. */
export type ChannelType_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['ChannelType']['input']>;
    _gt?: InputMaybe<Scalars['ChannelType']['input']>;
    _gte?: InputMaybe<Scalars['ChannelType']['input']>;
    _in?: InputMaybe<Array<Scalars['ChannelType']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['ChannelType']['input']>;
    _lte?: InputMaybe<Scalars['ChannelType']['input']>;
    _neq?: InputMaybe<Scalars['ChannelType']['input']>;
    _nin?: InputMaybe<Array<Scalars['ChannelType']['input']>>;
};

/** Boolean expression to compare columns of type "ContactInteractionType". All fields are combined with logical 'AND'. */
export type ContactInteractionType_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['ContactInteractionType']['input']>;
    _gt?: InputMaybe<Scalars['ContactInteractionType']['input']>;
    _gte?: InputMaybe<Scalars['ContactInteractionType']['input']>;
    _in?: InputMaybe<Array<Scalars['ContactInteractionType']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['ContactInteractionType']['input']>;
    _lte?: InputMaybe<Scalars['ContactInteractionType']['input']>;
    _neq?: InputMaybe<Scalars['ContactInteractionType']['input']>;
    _nin?: InputMaybe<Array<Scalars['ContactInteractionType']['input']>>;
};

/** Boolean expression to compare columns of type "ContactSuggestionReason". All fields are combined with logical 'AND'. */
export type ContactSuggestionReason_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['ContactSuggestionReason']['input']>;
    _gt?: InputMaybe<Scalars['ContactSuggestionReason']['input']>;
    _gte?: InputMaybe<Scalars['ContactSuggestionReason']['input']>;
    _in?: InputMaybe<Array<Scalars['ContactSuggestionReason']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['ContactSuggestionReason']['input']>;
    _lte?: InputMaybe<Scalars['ContactSuggestionReason']['input']>;
    _neq?: InputMaybe<Scalars['ContactSuggestionReason']['input']>;
    _nin?: InputMaybe<Array<Scalars['ContactSuggestionReason']['input']>>;
};

/** columns and relationships of "ContactSuggestions" */
export type ContactSuggestions = {
    __typename?: 'ContactSuggestions';
    accountAboutUs?: Maybe<Scalars['String']['output']>;
    accountId?: Maybe<Scalars['String']['output']>;
    accountIndustry?: Maybe<Scalars['String']['output']>;
    accountLinkedinUrl?: Maybe<Scalars['String']['output']>;
    accountName: Scalars['String']['output'];
    accountNumberOfEmployees?: Maybe<Scalars['String']['output']>;
    accountTags?: Maybe<Array<Scalars['String']['output']>>;
    accountWebsite?: Maybe<Scalars['String']['output']>;
    approvedAt?: Maybe<Scalars['timestamp']['output']>;
    campaignId?: Maybe<Scalars['String']['output']>;
    campaignName?: Maybe<Scalars['String']['output']>;
    contactEmail?: Maybe<Scalars['String']['output']>;
    contactEmailVerified: Scalars['Boolean']['output'];
    contactImgUrl?: Maybe<Scalars['String']['output']>;
    contactLinkedinUrl?: Maybe<Scalars['String']['output']>;
    contactLocation?: Maybe<Scalars['String']['output']>;
    contactName: Scalars['String']['output'];
    contactTitle?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['timestamp']['output'];
    expiresAt: Scalars['timestamp']['output'];
    groupId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    organizationId: Scalars['String']['output'];
    personId?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    reason: Scalars['ContactSuggestionReason']['output'];
    rejectedAt?: Maybe<Scalars['timestamp']['output']>;
    suggestionMotivation?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
};

/** aggregated selection of "ContactSuggestions" */
export type ContactSuggestions_Aggregate = {
    __typename?: 'ContactSuggestions_aggregate';
    aggregate?: Maybe<ContactSuggestions_Aggregate_Fields>;
    nodes: Array<ContactSuggestions>;
};

/** aggregate fields of "ContactSuggestions" */
export type ContactSuggestions_Aggregate_Fields = {
    __typename?: 'ContactSuggestions_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<ContactSuggestions_Max_Fields>;
    min?: Maybe<ContactSuggestions_Min_Fields>;
};

/** aggregate fields of "ContactSuggestions" */
export type ContactSuggestions_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<ContactSuggestions_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "ContactSuggestions". All fields are combined with a logical 'AND'. */
export type ContactSuggestions_Bool_Exp = {
    _and?: InputMaybe<Array<ContactSuggestions_Bool_Exp>>;
    _not?: InputMaybe<ContactSuggestions_Bool_Exp>;
    _or?: InputMaybe<Array<ContactSuggestions_Bool_Exp>>;
    accountAboutUs?: InputMaybe<String_Comparison_Exp>;
    accountId?: InputMaybe<String_Comparison_Exp>;
    accountIndustry?: InputMaybe<String_Comparison_Exp>;
    accountLinkedinUrl?: InputMaybe<String_Comparison_Exp>;
    accountName?: InputMaybe<String_Comparison_Exp>;
    accountNumberOfEmployees?: InputMaybe<String_Comparison_Exp>;
    accountTags?: InputMaybe<String_Array_Comparison_Exp>;
    accountWebsite?: InputMaybe<String_Comparison_Exp>;
    approvedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    campaignId?: InputMaybe<String_Comparison_Exp>;
    campaignName?: InputMaybe<String_Comparison_Exp>;
    contactEmail?: InputMaybe<String_Comparison_Exp>;
    contactEmailVerified?: InputMaybe<Boolean_Comparison_Exp>;
    contactImgUrl?: InputMaybe<String_Comparison_Exp>;
    contactLinkedinUrl?: InputMaybe<String_Comparison_Exp>;
    contactLocation?: InputMaybe<String_Comparison_Exp>;
    contactName?: InputMaybe<String_Comparison_Exp>;
    contactTitle?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    expiresAt?: InputMaybe<Timestamp_Comparison_Exp>;
    groupId?: InputMaybe<String_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    personId?: InputMaybe<String_Comparison_Exp>;
    prospectId?: InputMaybe<String_Comparison_Exp>;
    reason?: InputMaybe<ContactSuggestionReason_Comparison_Exp>;
    rejectedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    suggestionMotivation?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ContactSuggestions" */
export enum ContactSuggestions_Constraint {
    /** unique or primary key constraint on columns "id" */
    ContactSuggestionsPkey = 'ContactSuggestions_pkey',
    /** unique or primary key constraint on columns "userId", "campaignId", "personId" */
    ContactSuggestionsUserIdPersonIdCampaignIdKey = 'ContactSuggestions_userId_personId_campaignId_key',
}

/** input type for inserting data into table "ContactSuggestions" */
export type ContactSuggestions_Insert_Input = {
    accountAboutUs?: InputMaybe<Scalars['String']['input']>;
    accountId?: InputMaybe<Scalars['String']['input']>;
    accountIndustry?: InputMaybe<Scalars['String']['input']>;
    accountLinkedinUrl?: InputMaybe<Scalars['String']['input']>;
    accountName?: InputMaybe<Scalars['String']['input']>;
    accountNumberOfEmployees?: InputMaybe<Scalars['String']['input']>;
    accountTags?: InputMaybe<Array<Scalars['String']['input']>>;
    accountWebsite?: InputMaybe<Scalars['String']['input']>;
    approvedAt?: InputMaybe<Scalars['timestamp']['input']>;
    campaignId?: InputMaybe<Scalars['String']['input']>;
    campaignName?: InputMaybe<Scalars['String']['input']>;
    contactEmail?: InputMaybe<Scalars['String']['input']>;
    contactEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
    contactImgUrl?: InputMaybe<Scalars['String']['input']>;
    contactLinkedinUrl?: InputMaybe<Scalars['String']['input']>;
    contactLocation?: InputMaybe<Scalars['String']['input']>;
    contactName?: InputMaybe<Scalars['String']['input']>;
    contactTitle?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    expiresAt?: InputMaybe<Scalars['timestamp']['input']>;
    groupId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    personId?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    reason?: InputMaybe<Scalars['ContactSuggestionReason']['input']>;
    rejectedAt?: InputMaybe<Scalars['timestamp']['input']>;
    suggestionMotivation?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ContactSuggestions_Max_Fields = {
    __typename?: 'ContactSuggestions_max_fields';
    accountAboutUs?: Maybe<Scalars['String']['output']>;
    accountId?: Maybe<Scalars['String']['output']>;
    accountIndustry?: Maybe<Scalars['String']['output']>;
    accountLinkedinUrl?: Maybe<Scalars['String']['output']>;
    accountName?: Maybe<Scalars['String']['output']>;
    accountNumberOfEmployees?: Maybe<Scalars['String']['output']>;
    accountTags?: Maybe<Array<Scalars['String']['output']>>;
    accountWebsite?: Maybe<Scalars['String']['output']>;
    approvedAt?: Maybe<Scalars['timestamp']['output']>;
    campaignId?: Maybe<Scalars['String']['output']>;
    campaignName?: Maybe<Scalars['String']['output']>;
    contactEmail?: Maybe<Scalars['String']['output']>;
    contactImgUrl?: Maybe<Scalars['String']['output']>;
    contactLinkedinUrl?: Maybe<Scalars['String']['output']>;
    contactLocation?: Maybe<Scalars['String']['output']>;
    contactName?: Maybe<Scalars['String']['output']>;
    contactTitle?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    expiresAt?: Maybe<Scalars['timestamp']['output']>;
    groupId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    personId?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    reason?: Maybe<Scalars['ContactSuggestionReason']['output']>;
    rejectedAt?: Maybe<Scalars['timestamp']['output']>;
    suggestionMotivation?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ContactSuggestions_Min_Fields = {
    __typename?: 'ContactSuggestions_min_fields';
    accountAboutUs?: Maybe<Scalars['String']['output']>;
    accountId?: Maybe<Scalars['String']['output']>;
    accountIndustry?: Maybe<Scalars['String']['output']>;
    accountLinkedinUrl?: Maybe<Scalars['String']['output']>;
    accountName?: Maybe<Scalars['String']['output']>;
    accountNumberOfEmployees?: Maybe<Scalars['String']['output']>;
    accountTags?: Maybe<Array<Scalars['String']['output']>>;
    accountWebsite?: Maybe<Scalars['String']['output']>;
    approvedAt?: Maybe<Scalars['timestamp']['output']>;
    campaignId?: Maybe<Scalars['String']['output']>;
    campaignName?: Maybe<Scalars['String']['output']>;
    contactEmail?: Maybe<Scalars['String']['output']>;
    contactImgUrl?: Maybe<Scalars['String']['output']>;
    contactLinkedinUrl?: Maybe<Scalars['String']['output']>;
    contactLocation?: Maybe<Scalars['String']['output']>;
    contactName?: Maybe<Scalars['String']['output']>;
    contactTitle?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    expiresAt?: Maybe<Scalars['timestamp']['output']>;
    groupId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    personId?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    reason?: Maybe<Scalars['ContactSuggestionReason']['output']>;
    rejectedAt?: Maybe<Scalars['timestamp']['output']>;
    suggestionMotivation?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "ContactSuggestions" */
export type ContactSuggestions_Mutation_Response = {
    __typename?: 'ContactSuggestions_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<ContactSuggestions>;
};

/** on_conflict condition type for table "ContactSuggestions" */
export type ContactSuggestions_On_Conflict = {
    constraint: ContactSuggestions_Constraint;
    update_columns?: Array<ContactSuggestions_Update_Column>;
    where?: InputMaybe<ContactSuggestions_Bool_Exp>;
};

/** Ordering options when selecting data from "ContactSuggestions". */
export type ContactSuggestions_Order_By = {
    accountAboutUs?: InputMaybe<Order_By>;
    accountId?: InputMaybe<Order_By>;
    accountIndustry?: InputMaybe<Order_By>;
    accountLinkedinUrl?: InputMaybe<Order_By>;
    accountName?: InputMaybe<Order_By>;
    accountNumberOfEmployees?: InputMaybe<Order_By>;
    accountTags?: InputMaybe<Order_By>;
    accountWebsite?: InputMaybe<Order_By>;
    approvedAt?: InputMaybe<Order_By>;
    campaignId?: InputMaybe<Order_By>;
    campaignName?: InputMaybe<Order_By>;
    contactEmail?: InputMaybe<Order_By>;
    contactEmailVerified?: InputMaybe<Order_By>;
    contactImgUrl?: InputMaybe<Order_By>;
    contactLinkedinUrl?: InputMaybe<Order_By>;
    contactLocation?: InputMaybe<Order_By>;
    contactName?: InputMaybe<Order_By>;
    contactTitle?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    expiresAt?: InputMaybe<Order_By>;
    groupId?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    personId?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    reason?: InputMaybe<Order_By>;
    rejectedAt?: InputMaybe<Order_By>;
    suggestionMotivation?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ContactSuggestions */
export type ContactSuggestions_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** select columns of table "ContactSuggestions" */
export enum ContactSuggestions_Select_Column {
    /** column name */
    AccountAboutUs = 'accountAboutUs',
    /** column name */
    AccountId = 'accountId',
    /** column name */
    AccountIndustry = 'accountIndustry',
    /** column name */
    AccountLinkedinUrl = 'accountLinkedinUrl',
    /** column name */
    AccountName = 'accountName',
    /** column name */
    AccountNumberOfEmployees = 'accountNumberOfEmployees',
    /** column name */
    AccountTags = 'accountTags',
    /** column name */
    AccountWebsite = 'accountWebsite',
    /** column name */
    ApprovedAt = 'approvedAt',
    /** column name */
    CampaignId = 'campaignId',
    /** column name */
    CampaignName = 'campaignName',
    /** column name */
    ContactEmail = 'contactEmail',
    /** column name */
    ContactEmailVerified = 'contactEmailVerified',
    /** column name */
    ContactImgUrl = 'contactImgUrl',
    /** column name */
    ContactLinkedinUrl = 'contactLinkedinUrl',
    /** column name */
    ContactLocation = 'contactLocation',
    /** column name */
    ContactName = 'contactName',
    /** column name */
    ContactTitle = 'contactTitle',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    ExpiresAt = 'expiresAt',
    /** column name */
    GroupId = 'groupId',
    /** column name */
    Id = 'id',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    PersonId = 'personId',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    Reason = 'reason',
    /** column name */
    RejectedAt = 'rejectedAt',
    /** column name */
    SuggestionMotivation = 'suggestionMotivation',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

/** input type for updating data in table "ContactSuggestions" */
export type ContactSuggestions_Set_Input = {
    accountAboutUs?: InputMaybe<Scalars['String']['input']>;
    accountId?: InputMaybe<Scalars['String']['input']>;
    accountIndustry?: InputMaybe<Scalars['String']['input']>;
    accountLinkedinUrl?: InputMaybe<Scalars['String']['input']>;
    accountName?: InputMaybe<Scalars['String']['input']>;
    accountNumberOfEmployees?: InputMaybe<Scalars['String']['input']>;
    accountTags?: InputMaybe<Array<Scalars['String']['input']>>;
    accountWebsite?: InputMaybe<Scalars['String']['input']>;
    approvedAt?: InputMaybe<Scalars['timestamp']['input']>;
    campaignId?: InputMaybe<Scalars['String']['input']>;
    campaignName?: InputMaybe<Scalars['String']['input']>;
    contactEmail?: InputMaybe<Scalars['String']['input']>;
    contactEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
    contactImgUrl?: InputMaybe<Scalars['String']['input']>;
    contactLinkedinUrl?: InputMaybe<Scalars['String']['input']>;
    contactLocation?: InputMaybe<Scalars['String']['input']>;
    contactName?: InputMaybe<Scalars['String']['input']>;
    contactTitle?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    expiresAt?: InputMaybe<Scalars['timestamp']['input']>;
    groupId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    personId?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    reason?: InputMaybe<Scalars['ContactSuggestionReason']['input']>;
    rejectedAt?: InputMaybe<Scalars['timestamp']['input']>;
    suggestionMotivation?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ContactSuggestions" */
export type ContactSuggestions_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: ContactSuggestions_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ContactSuggestions_Stream_Cursor_Value_Input = {
    accountAboutUs?: InputMaybe<Scalars['String']['input']>;
    accountId?: InputMaybe<Scalars['String']['input']>;
    accountIndustry?: InputMaybe<Scalars['String']['input']>;
    accountLinkedinUrl?: InputMaybe<Scalars['String']['input']>;
    accountName?: InputMaybe<Scalars['String']['input']>;
    accountNumberOfEmployees?: InputMaybe<Scalars['String']['input']>;
    accountTags?: InputMaybe<Array<Scalars['String']['input']>>;
    accountWebsite?: InputMaybe<Scalars['String']['input']>;
    approvedAt?: InputMaybe<Scalars['timestamp']['input']>;
    campaignId?: InputMaybe<Scalars['String']['input']>;
    campaignName?: InputMaybe<Scalars['String']['input']>;
    contactEmail?: InputMaybe<Scalars['String']['input']>;
    contactEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
    contactImgUrl?: InputMaybe<Scalars['String']['input']>;
    contactLinkedinUrl?: InputMaybe<Scalars['String']['input']>;
    contactLocation?: InputMaybe<Scalars['String']['input']>;
    contactName?: InputMaybe<Scalars['String']['input']>;
    contactTitle?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    expiresAt?: InputMaybe<Scalars['timestamp']['input']>;
    groupId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    personId?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    reason?: InputMaybe<Scalars['ContactSuggestionReason']['input']>;
    rejectedAt?: InputMaybe<Scalars['timestamp']['input']>;
    suggestionMotivation?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ContactSuggestions" */
export enum ContactSuggestions_Update_Column {
    /** column name */
    AccountAboutUs = 'accountAboutUs',
    /** column name */
    AccountId = 'accountId',
    /** column name */
    AccountIndustry = 'accountIndustry',
    /** column name */
    AccountLinkedinUrl = 'accountLinkedinUrl',
    /** column name */
    AccountName = 'accountName',
    /** column name */
    AccountNumberOfEmployees = 'accountNumberOfEmployees',
    /** column name */
    AccountTags = 'accountTags',
    /** column name */
    AccountWebsite = 'accountWebsite',
    /** column name */
    ApprovedAt = 'approvedAt',
    /** column name */
    CampaignId = 'campaignId',
    /** column name */
    CampaignName = 'campaignName',
    /** column name */
    ContactEmail = 'contactEmail',
    /** column name */
    ContactEmailVerified = 'contactEmailVerified',
    /** column name */
    ContactImgUrl = 'contactImgUrl',
    /** column name */
    ContactLinkedinUrl = 'contactLinkedinUrl',
    /** column name */
    ContactLocation = 'contactLocation',
    /** column name */
    ContactName = 'contactName',
    /** column name */
    ContactTitle = 'contactTitle',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    ExpiresAt = 'expiresAt',
    /** column name */
    GroupId = 'groupId',
    /** column name */
    Id = 'id',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    PersonId = 'personId',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    Reason = 'reason',
    /** column name */
    RejectedAt = 'rejectedAt',
    /** column name */
    SuggestionMotivation = 'suggestionMotivation',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

export type ContactSuggestions_Updates = {
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<ContactSuggestions_Set_Input>;
    /** filter the rows which have to be updated */
    where: ContactSuggestions_Bool_Exp;
};

/** columns and relationships of "Contacts" */
export type Contacts = {
    __typename?: 'Contacts';
    /** An object relationship */
    Account?: Maybe<Accounts>;
    /** An array relationship */
    ContactsInteractions: Array<ContactsInteractions>;
    /** An aggregate relationship */
    ContactsInteractions_aggregate: ContactsInteractions_Aggregate;
    /** An array relationship */
    Conversations: Array<Conversations>;
    /** An aggregate relationship */
    Conversations_aggregate: Conversations_Aggregate;
    /** An array relationship */
    MessageDrafts: Array<MessageDrafts>;
    /** An aggregate relationship */
    MessageDrafts_aggregate: MessageDrafts_Aggregate;
    /** An array relationship */
    Messages: Array<Messages>;
    /** An aggregate relationship */
    Messages_aggregate: Messages_Aggregate;
    /** An array relationship */
    Notes: Array<Notes>;
    /** An aggregate relationship */
    Notes_aggregate: Notes_Aggregate;
    /** An array relationship */
    Resources: Array<Resources>;
    /** An aggregate relationship */
    Resources_aggregate: Resources_Aggregate;
    /** An array relationship */
    _GroupToContacts: Array<_GroupToContact>;
    /** An aggregate relationship */
    _GroupToContacts_aggregate: _GroupToContact_Aggregate;
    accountId?: Maybe<Scalars['String']['output']>;
    actionsMetadata?: Maybe<Scalars['jsonb']['output']>;
    compositeScore: Scalars['float8']['output'];
    connectedAt?: Maybe<Scalars['timestamp']['output']>;
    connectionStatus?: Maybe<Scalars['LinkedinConnectionStatus']['output']>;
    createdAt: Scalars['timestamp']['output'];
    daysSinceLastMsg: Scalars['Int']['output'];
    education?: Maybe<Scalars['jsonb']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    embedding?: Maybe<Scalars['vector']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    experiences?: Maybe<Scalars['jsonb']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    fullName?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    interests?: Maybe<Array<Scalars['String']['output']>>;
    lastCompletedActionAt?: Maybe<Scalars['timestamp']['output']>;
    lastContactedAt?: Maybe<Scalars['timestamp']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    linkedinHeadline?: Maybe<Scalars['String']['output']>;
    linkedinNumberOfConnections?: Maybe<Scalars['Int']['output']>;
    linkedinProfileImgUrl?: Maybe<Scalars['String']['output']>;
    linkedinProfileUrl?: Maybe<Scalars['String']['output']>;
    linkedinUserId?: Maybe<Scalars['String']['output']>;
    linkedinVerifiedAt?: Maybe<Scalars['timestamp']['output']>;
    location?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['jsonb']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    nextActionSuggestedAt?: Maybe<Scalars['timestamp']['output']>;
    occupationTitle?: Maybe<Scalars['String']['output']>;
    organizationDomain?: Maybe<Scalars['String']['output']>;
    organizationId: Scalars['String']['output'];
    organizationIndustry?: Maybe<Scalars['String']['output']>;
    organizationLinkedinUrl?: Maybe<Scalars['String']['output']>;
    organizationName?: Maybe<Scalars['String']['output']>;
    organizationSize?: Maybe<Scalars['String']['output']>;
    personId?: Maybe<Scalars['String']['output']>;
    phoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
    priorityScore: Scalars['Int']['output'];
    prospectId: Scalars['String']['output'];
    region?: Maybe<Scalars['String']['output']>;
    skills?: Maybe<Array<Scalars['String']['output']>>;
    snoozedUntil?: Maybe<Scalars['timestamp']['output']>;
    source: Scalars['String']['output'];
    sourceId?: Maybe<Scalars['String']['output']>;
    topActionType: Scalars['String']['output'];
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
    userSetAsNotInterestedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** columns and relationships of "Contacts" */
export type ContactsContactsInteractionsArgs = {
    distinct_on?: InputMaybe<Array<ContactsInteractions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ContactsInteractions_Order_By>>;
    where?: InputMaybe<ContactsInteractions_Bool_Exp>;
};

/** columns and relationships of "Contacts" */
export type ContactsContactsInteractions_AggregateArgs = {
    distinct_on?: InputMaybe<Array<ContactsInteractions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ContactsInteractions_Order_By>>;
    where?: InputMaybe<ContactsInteractions_Bool_Exp>;
};

/** columns and relationships of "Contacts" */
export type ContactsConversationsArgs = {
    distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Conversations_Order_By>>;
    where?: InputMaybe<Conversations_Bool_Exp>;
};

/** columns and relationships of "Contacts" */
export type ContactsConversations_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Conversations_Order_By>>;
    where?: InputMaybe<Conversations_Bool_Exp>;
};

/** columns and relationships of "Contacts" */
export type ContactsMessageDraftsArgs = {
    distinct_on?: InputMaybe<Array<MessageDrafts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<MessageDrafts_Order_By>>;
    where?: InputMaybe<MessageDrafts_Bool_Exp>;
};

/** columns and relationships of "Contacts" */
export type ContactsMessageDrafts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<MessageDrafts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<MessageDrafts_Order_By>>;
    where?: InputMaybe<MessageDrafts_Bool_Exp>;
};

/** columns and relationships of "Contacts" */
export type ContactsMessagesArgs = {
    distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Messages_Order_By>>;
    where?: InputMaybe<Messages_Bool_Exp>;
};

/** columns and relationships of "Contacts" */
export type ContactsMessages_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Messages_Order_By>>;
    where?: InputMaybe<Messages_Bool_Exp>;
};

/** columns and relationships of "Contacts" */
export type ContactsNotesArgs = {
    distinct_on?: InputMaybe<Array<Notes_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Notes_Order_By>>;
    where?: InputMaybe<Notes_Bool_Exp>;
};

/** columns and relationships of "Contacts" */
export type ContactsNotes_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Notes_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Notes_Order_By>>;
    where?: InputMaybe<Notes_Bool_Exp>;
};

/** columns and relationships of "Contacts" */
export type ContactsResourcesArgs = {
    distinct_on?: InputMaybe<Array<Resources_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Resources_Order_By>>;
    where?: InputMaybe<Resources_Bool_Exp>;
};

/** columns and relationships of "Contacts" */
export type ContactsResources_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Resources_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Resources_Order_By>>;
    where?: InputMaybe<Resources_Bool_Exp>;
};

/** columns and relationships of "Contacts" */
export type Contacts_GroupToContactsArgs = {
    distinct_on?: InputMaybe<Array<_GroupToContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToContact_Order_By>>;
    where?: InputMaybe<_GroupToContact_Bool_Exp>;
};

/** columns and relationships of "Contacts" */
export type Contacts_GroupToContacts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<_GroupToContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToContact_Order_By>>;
    where?: InputMaybe<_GroupToContact_Bool_Exp>;
};

/** columns and relationships of "Contacts" */
export type ContactsActionsMetadataArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "Contacts" */
export type ContactsEducationArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "Contacts" */
export type ContactsExperiencesArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "Contacts" */
export type ContactsMetadataArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ContactsInteractions" */
export type ContactsInteractions = {
    __typename?: 'ContactsInteractions';
    /** An object relationship */
    Contact?: Maybe<Contacts>;
    contactId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['timestamp']['output'];
    id: Scalars['String']['output'];
    interactionDate: Scalars['timestamp']['output'];
    interactionType: Scalars['ContactInteractionType']['output'];
    metadata: Scalars['jsonb']['output'];
    organizationId: Scalars['String']['output'];
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
    weights: Scalars['jsonb']['output'];
};

/** columns and relationships of "ContactsInteractions" */
export type ContactsInteractionsMetadataArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ContactsInteractions" */
export type ContactsInteractionsWeightsArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "ContactsInteractions" */
export type ContactsInteractions_Aggregate = {
    __typename?: 'ContactsInteractions_aggregate';
    aggregate?: Maybe<ContactsInteractions_Aggregate_Fields>;
    nodes: Array<ContactsInteractions>;
};

export type ContactsInteractions_Aggregate_Bool_Exp = {
    count?: InputMaybe<ContactsInteractions_Aggregate_Bool_Exp_Count>;
};

export type ContactsInteractions_Aggregate_Bool_Exp_Count = {
    arguments?: InputMaybe<Array<ContactsInteractions_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<ContactsInteractions_Bool_Exp>;
    predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ContactsInteractions" */
export type ContactsInteractions_Aggregate_Fields = {
    __typename?: 'ContactsInteractions_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<ContactsInteractions_Max_Fields>;
    min?: Maybe<ContactsInteractions_Min_Fields>;
};

/** aggregate fields of "ContactsInteractions" */
export type ContactsInteractions_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<ContactsInteractions_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ContactsInteractions" */
export type ContactsInteractions_Aggregate_Order_By = {
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<ContactsInteractions_Max_Order_By>;
    min?: InputMaybe<ContactsInteractions_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ContactsInteractions_Append_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    weights?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "ContactsInteractions" */
export type ContactsInteractions_Arr_Rel_Insert_Input = {
    data: Array<ContactsInteractions_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<ContactsInteractions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ContactsInteractions". All fields are combined with a logical 'AND'. */
export type ContactsInteractions_Bool_Exp = {
    Contact?: InputMaybe<Contacts_Bool_Exp>;
    _and?: InputMaybe<Array<ContactsInteractions_Bool_Exp>>;
    _not?: InputMaybe<ContactsInteractions_Bool_Exp>;
    _or?: InputMaybe<Array<ContactsInteractions_Bool_Exp>>;
    contactId?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    interactionDate?: InputMaybe<Timestamp_Comparison_Exp>;
    interactionType?: InputMaybe<ContactInteractionType_Comparison_Exp>;
    metadata?: InputMaybe<Jsonb_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
    weights?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "ContactsInteractions" */
export enum ContactsInteractions_Constraint {
    /** unique or primary key constraint on columns "id" */
    ContactsInteractionsPkey = 'ContactsInteractions_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ContactsInteractions_Delete_At_Path_Input = {
    metadata?: InputMaybe<Array<Scalars['String']['input']>>;
    weights?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ContactsInteractions_Delete_Elem_Input = {
    metadata?: InputMaybe<Scalars['Int']['input']>;
    weights?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ContactsInteractions_Delete_Key_Input = {
    metadata?: InputMaybe<Scalars['String']['input']>;
    weights?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "ContactsInteractions" */
export type ContactsInteractions_Insert_Input = {
    Contact?: InputMaybe<Contacts_Obj_Rel_Insert_Input>;
    contactId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    interactionDate?: InputMaybe<Scalars['timestamp']['input']>;
    interactionType?: InputMaybe<Scalars['ContactInteractionType']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    weights?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type ContactsInteractions_Max_Fields = {
    __typename?: 'ContactsInteractions_max_fields';
    contactId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    interactionDate?: Maybe<Scalars['timestamp']['output']>;
    interactionType?: Maybe<Scalars['ContactInteractionType']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "ContactsInteractions" */
export type ContactsInteractions_Max_Order_By = {
    contactId?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    interactionDate?: InputMaybe<Order_By>;
    interactionType?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ContactsInteractions_Min_Fields = {
    __typename?: 'ContactsInteractions_min_fields';
    contactId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    interactionDate?: Maybe<Scalars['timestamp']['output']>;
    interactionType?: Maybe<Scalars['ContactInteractionType']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "ContactsInteractions" */
export type ContactsInteractions_Min_Order_By = {
    contactId?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    interactionDate?: InputMaybe<Order_By>;
    interactionType?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ContactsInteractions" */
export type ContactsInteractions_Mutation_Response = {
    __typename?: 'ContactsInteractions_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<ContactsInteractions>;
};

/** on_conflict condition type for table "ContactsInteractions" */
export type ContactsInteractions_On_Conflict = {
    constraint: ContactsInteractions_Constraint;
    update_columns?: Array<ContactsInteractions_Update_Column>;
    where?: InputMaybe<ContactsInteractions_Bool_Exp>;
};

/** Ordering options when selecting data from "ContactsInteractions". */
export type ContactsInteractions_Order_By = {
    Contact?: InputMaybe<Contacts_Order_By>;
    contactId?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    interactionDate?: InputMaybe<Order_By>;
    interactionType?: InputMaybe<Order_By>;
    metadata?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    weights?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ContactsInteractions */
export type ContactsInteractions_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ContactsInteractions_Prepend_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    weights?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "ContactsInteractions" */
export enum ContactsInteractions_Select_Column {
    /** column name */
    ContactId = 'contactId',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    InteractionDate = 'interactionDate',
    /** column name */
    InteractionType = 'interactionType',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
    /** column name */
    Weights = 'weights',
}

/** input type for updating data in table "ContactsInteractions" */
export type ContactsInteractions_Set_Input = {
    contactId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    interactionDate?: InputMaybe<Scalars['timestamp']['input']>;
    interactionType?: InputMaybe<Scalars['ContactInteractionType']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    weights?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "ContactsInteractions" */
export type ContactsInteractions_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: ContactsInteractions_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ContactsInteractions_Stream_Cursor_Value_Input = {
    contactId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    interactionDate?: InputMaybe<Scalars['timestamp']['input']>;
    interactionType?: InputMaybe<Scalars['ContactInteractionType']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    weights?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "ContactsInteractions" */
export enum ContactsInteractions_Update_Column {
    /** column name */
    ContactId = 'contactId',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    InteractionDate = 'interactionDate',
    /** column name */
    InteractionType = 'interactionType',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
    /** column name */
    Weights = 'weights',
}

export type ContactsInteractions_Updates = {
    /** append existing jsonb value of filtered columns with new jsonb value */
    _append?: InputMaybe<ContactsInteractions_Append_Input>;
    /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
    _delete_at_path?: InputMaybe<ContactsInteractions_Delete_At_Path_Input>;
    /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
    _delete_elem?: InputMaybe<ContactsInteractions_Delete_Elem_Input>;
    /** delete key/value pair or string element. key/value pairs are matched based on their key value */
    _delete_key?: InputMaybe<ContactsInteractions_Delete_Key_Input>;
    /** prepend existing jsonb value of filtered columns with new jsonb value */
    _prepend?: InputMaybe<ContactsInteractions_Prepend_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<ContactsInteractions_Set_Input>;
    /** filter the rows which have to be updated */
    where: ContactsInteractions_Bool_Exp;
};

/** aggregated selection of "Contacts" */
export type Contacts_Aggregate = {
    __typename?: 'Contacts_aggregate';
    aggregate?: Maybe<Contacts_Aggregate_Fields>;
    nodes: Array<Contacts>;
};

export type Contacts_Aggregate_Bool_Exp = {
    avg?: InputMaybe<Contacts_Aggregate_Bool_Exp_Avg>;
    corr?: InputMaybe<Contacts_Aggregate_Bool_Exp_Corr>;
    count?: InputMaybe<Contacts_Aggregate_Bool_Exp_Count>;
    covar_samp?: InputMaybe<Contacts_Aggregate_Bool_Exp_Covar_Samp>;
    max?: InputMaybe<Contacts_Aggregate_Bool_Exp_Max>;
    min?: InputMaybe<Contacts_Aggregate_Bool_Exp_Min>;
    stddev_samp?: InputMaybe<Contacts_Aggregate_Bool_Exp_Stddev_Samp>;
    sum?: InputMaybe<Contacts_Aggregate_Bool_Exp_Sum>;
    var_samp?: InputMaybe<Contacts_Aggregate_Bool_Exp_Var_Samp>;
};

export type Contacts_Aggregate_Bool_Exp_Avg = {
    arguments: Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Avg_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Contacts_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

export type Contacts_Aggregate_Bool_Exp_Corr = {
    arguments: Contacts_Aggregate_Bool_Exp_Corr_Arguments;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Contacts_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

export type Contacts_Aggregate_Bool_Exp_Corr_Arguments = {
    X: Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Corr_Arguments_Columns;
    Y: Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Contacts_Aggregate_Bool_Exp_Count = {
    arguments?: InputMaybe<Array<Contacts_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Contacts_Bool_Exp>;
    predicate: Int_Comparison_Exp;
};

export type Contacts_Aggregate_Bool_Exp_Covar_Samp = {
    arguments: Contacts_Aggregate_Bool_Exp_Covar_Samp_Arguments;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Contacts_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

export type Contacts_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
    X: Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
    Y: Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Contacts_Aggregate_Bool_Exp_Max = {
    arguments: Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Max_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Contacts_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

export type Contacts_Aggregate_Bool_Exp_Min = {
    arguments: Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Min_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Contacts_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

export type Contacts_Aggregate_Bool_Exp_Stddev_Samp = {
    arguments: Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Contacts_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

export type Contacts_Aggregate_Bool_Exp_Sum = {
    arguments: Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Sum_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Contacts_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

export type Contacts_Aggregate_Bool_Exp_Var_Samp = {
    arguments: Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Contacts_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "Contacts" */
export type Contacts_Aggregate_Fields = {
    __typename?: 'Contacts_aggregate_fields';
    avg?: Maybe<Contacts_Avg_Fields>;
    count: Scalars['Int']['output'];
    max?: Maybe<Contacts_Max_Fields>;
    min?: Maybe<Contacts_Min_Fields>;
    stddev?: Maybe<Contacts_Stddev_Fields>;
    stddev_pop?: Maybe<Contacts_Stddev_Pop_Fields>;
    stddev_samp?: Maybe<Contacts_Stddev_Samp_Fields>;
    sum?: Maybe<Contacts_Sum_Fields>;
    var_pop?: Maybe<Contacts_Var_Pop_Fields>;
    var_samp?: Maybe<Contacts_Var_Samp_Fields>;
    variance?: Maybe<Contacts_Variance_Fields>;
};

/** aggregate fields of "Contacts" */
export type Contacts_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<Contacts_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Contacts" */
export type Contacts_Aggregate_Order_By = {
    avg?: InputMaybe<Contacts_Avg_Order_By>;
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<Contacts_Max_Order_By>;
    min?: InputMaybe<Contacts_Min_Order_By>;
    stddev?: InputMaybe<Contacts_Stddev_Order_By>;
    stddev_pop?: InputMaybe<Contacts_Stddev_Pop_Order_By>;
    stddev_samp?: InputMaybe<Contacts_Stddev_Samp_Order_By>;
    sum?: InputMaybe<Contacts_Sum_Order_By>;
    var_pop?: InputMaybe<Contacts_Var_Pop_Order_By>;
    var_samp?: InputMaybe<Contacts_Var_Samp_Order_By>;
    variance?: InputMaybe<Contacts_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Contacts_Append_Input = {
    actionsMetadata?: InputMaybe<Scalars['jsonb']['input']>;
    education?: InputMaybe<Scalars['jsonb']['input']>;
    experiences?: InputMaybe<Scalars['jsonb']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "Contacts" */
export type Contacts_Arr_Rel_Insert_Input = {
    data: Array<Contacts_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<Contacts_On_Conflict>;
};

/** aggregate avg on columns */
export type Contacts_Avg_Fields = {
    __typename?: 'Contacts_avg_fields';
    compositeScore?: Maybe<Scalars['Float']['output']>;
    daysSinceLastMsg?: Maybe<Scalars['Float']['output']>;
    linkedinNumberOfConnections?: Maybe<Scalars['Float']['output']>;
    priorityScore?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "Contacts" */
export type Contacts_Avg_Order_By = {
    compositeScore?: InputMaybe<Order_By>;
    daysSinceLastMsg?: InputMaybe<Order_By>;
    linkedinNumberOfConnections?: InputMaybe<Order_By>;
    priorityScore?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Contacts". All fields are combined with a logical 'AND'. */
export type Contacts_Bool_Exp = {
    Account?: InputMaybe<Accounts_Bool_Exp>;
    ContactsInteractions?: InputMaybe<ContactsInteractions_Bool_Exp>;
    ContactsInteractions_aggregate?: InputMaybe<ContactsInteractions_Aggregate_Bool_Exp>;
    Conversations?: InputMaybe<Conversations_Bool_Exp>;
    Conversations_aggregate?: InputMaybe<Conversations_Aggregate_Bool_Exp>;
    MessageDrafts?: InputMaybe<MessageDrafts_Bool_Exp>;
    MessageDrafts_aggregate?: InputMaybe<MessageDrafts_Aggregate_Bool_Exp>;
    Messages?: InputMaybe<Messages_Bool_Exp>;
    Messages_aggregate?: InputMaybe<Messages_Aggregate_Bool_Exp>;
    Notes?: InputMaybe<Notes_Bool_Exp>;
    Notes_aggregate?: InputMaybe<Notes_Aggregate_Bool_Exp>;
    Resources?: InputMaybe<Resources_Bool_Exp>;
    Resources_aggregate?: InputMaybe<Resources_Aggregate_Bool_Exp>;
    _GroupToContacts?: InputMaybe<_GroupToContact_Bool_Exp>;
    _GroupToContacts_aggregate?: InputMaybe<_GroupToContact_Aggregate_Bool_Exp>;
    _and?: InputMaybe<Array<Contacts_Bool_Exp>>;
    _not?: InputMaybe<Contacts_Bool_Exp>;
    _or?: InputMaybe<Array<Contacts_Bool_Exp>>;
    accountId?: InputMaybe<String_Comparison_Exp>;
    actionsMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
    compositeScore?: InputMaybe<Float8_Comparison_Exp>;
    connectedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    connectionStatus?: InputMaybe<LinkedinConnectionStatus_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    daysSinceLastMsg?: InputMaybe<Int_Comparison_Exp>;
    education?: InputMaybe<Jsonb_Comparison_Exp>;
    email?: InputMaybe<String_Comparison_Exp>;
    embedding?: InputMaybe<Vector_Comparison_Exp>;
    embeddingLastUpdatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    experiences?: InputMaybe<Jsonb_Comparison_Exp>;
    firstName?: InputMaybe<String_Comparison_Exp>;
    fullName?: InputMaybe<String_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    interests?: InputMaybe<String_Array_Comparison_Exp>;
    lastCompletedActionAt?: InputMaybe<Timestamp_Comparison_Exp>;
    lastContactedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    lastName?: InputMaybe<String_Comparison_Exp>;
    linkedinHeadline?: InputMaybe<String_Comparison_Exp>;
    linkedinNumberOfConnections?: InputMaybe<Int_Comparison_Exp>;
    linkedinProfileImgUrl?: InputMaybe<String_Comparison_Exp>;
    linkedinProfileUrl?: InputMaybe<String_Comparison_Exp>;
    linkedinUserId?: InputMaybe<String_Comparison_Exp>;
    linkedinVerifiedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    location?: InputMaybe<String_Comparison_Exp>;
    metadata?: InputMaybe<Jsonb_Comparison_Exp>;
    metadataLastUpdatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    nextActionSuggestedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    occupationTitle?: InputMaybe<String_Comparison_Exp>;
    organizationDomain?: InputMaybe<String_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    organizationIndustry?: InputMaybe<String_Comparison_Exp>;
    organizationLinkedinUrl?: InputMaybe<String_Comparison_Exp>;
    organizationName?: InputMaybe<String_Comparison_Exp>;
    organizationSize?: InputMaybe<String_Comparison_Exp>;
    personId?: InputMaybe<String_Comparison_Exp>;
    phoneNumbers?: InputMaybe<String_Array_Comparison_Exp>;
    priorityScore?: InputMaybe<Int_Comparison_Exp>;
    prospectId?: InputMaybe<String_Comparison_Exp>;
    region?: InputMaybe<String_Comparison_Exp>;
    skills?: InputMaybe<String_Array_Comparison_Exp>;
    snoozedUntil?: InputMaybe<Timestamp_Comparison_Exp>;
    source?: InputMaybe<String_Comparison_Exp>;
    sourceId?: InputMaybe<String_Comparison_Exp>;
    topActionType?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
    userSetAsNotInterestedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "Contacts" */
export enum Contacts_Constraint {
    /** unique or primary key constraint on columns "id" */
    ContactsPkey = 'Contacts_pkey',
    /** unique or primary key constraint on columns "userId", "id" */
    ContactsUserIdIdKey = 'Contacts_userId_id_key',
    /** unique or primary key constraint on columns "userId", "prospectId" */
    ContactsUserIdProspectIdKey = 'Contacts_userId_prospectId_key',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Contacts_Delete_At_Path_Input = {
    actionsMetadata?: InputMaybe<Array<Scalars['String']['input']>>;
    education?: InputMaybe<Array<Scalars['String']['input']>>;
    experiences?: InputMaybe<Array<Scalars['String']['input']>>;
    metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Contacts_Delete_Elem_Input = {
    actionsMetadata?: InputMaybe<Scalars['Int']['input']>;
    education?: InputMaybe<Scalars['Int']['input']>;
    experiences?: InputMaybe<Scalars['Int']['input']>;
    metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Contacts_Delete_Key_Input = {
    actionsMetadata?: InputMaybe<Scalars['String']['input']>;
    education?: InputMaybe<Scalars['String']['input']>;
    experiences?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "Contacts" */
export type Contacts_Inc_Input = {
    compositeScore?: InputMaybe<Scalars['float8']['input']>;
    daysSinceLastMsg?: InputMaybe<Scalars['Int']['input']>;
    linkedinNumberOfConnections?: InputMaybe<Scalars['Int']['input']>;
    priorityScore?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "Contacts" */
export type Contacts_Insert_Input = {
    Account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
    ContactsInteractions?: InputMaybe<ContactsInteractions_Arr_Rel_Insert_Input>;
    Conversations?: InputMaybe<Conversations_Arr_Rel_Insert_Input>;
    MessageDrafts?: InputMaybe<MessageDrafts_Arr_Rel_Insert_Input>;
    Messages?: InputMaybe<Messages_Arr_Rel_Insert_Input>;
    Notes?: InputMaybe<Notes_Arr_Rel_Insert_Input>;
    Resources?: InputMaybe<Resources_Arr_Rel_Insert_Input>;
    _GroupToContacts?: InputMaybe<_GroupToContact_Arr_Rel_Insert_Input>;
    accountId?: InputMaybe<Scalars['String']['input']>;
    actionsMetadata?: InputMaybe<Scalars['jsonb']['input']>;
    compositeScore?: InputMaybe<Scalars['float8']['input']>;
    connectedAt?: InputMaybe<Scalars['timestamp']['input']>;
    connectionStatus?: InputMaybe<Scalars['LinkedinConnectionStatus']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    daysSinceLastMsg?: InputMaybe<Scalars['Int']['input']>;
    education?: InputMaybe<Scalars['jsonb']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    experiences?: InputMaybe<Scalars['jsonb']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    fullName?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    interests?: InputMaybe<Array<Scalars['String']['input']>>;
    lastCompletedActionAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastContactedAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    linkedinHeadline?: InputMaybe<Scalars['String']['input']>;
    linkedinNumberOfConnections?: InputMaybe<Scalars['Int']['input']>;
    linkedinProfileImgUrl?: InputMaybe<Scalars['String']['input']>;
    linkedinProfileUrl?: InputMaybe<Scalars['String']['input']>;
    linkedinUserId?: InputMaybe<Scalars['String']['input']>;
    linkedinVerifiedAt?: InputMaybe<Scalars['timestamp']['input']>;
    location?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    nextActionSuggestedAt?: InputMaybe<Scalars['timestamp']['input']>;
    occupationTitle?: InputMaybe<Scalars['String']['input']>;
    organizationDomain?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    organizationIndustry?: InputMaybe<Scalars['String']['input']>;
    organizationLinkedinUrl?: InputMaybe<Scalars['String']['input']>;
    organizationName?: InputMaybe<Scalars['String']['input']>;
    organizationSize?: InputMaybe<Scalars['String']['input']>;
    personId?: InputMaybe<Scalars['String']['input']>;
    phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
    priorityScore?: InputMaybe<Scalars['Int']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    region?: InputMaybe<Scalars['String']['input']>;
    skills?: InputMaybe<Array<Scalars['String']['input']>>;
    snoozedUntil?: InputMaybe<Scalars['timestamp']['input']>;
    source?: InputMaybe<Scalars['String']['input']>;
    sourceId?: InputMaybe<Scalars['String']['input']>;
    topActionType?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    userSetAsNotInterestedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Contacts_Max_Fields = {
    __typename?: 'Contacts_max_fields';
    accountId?: Maybe<Scalars['String']['output']>;
    compositeScore?: Maybe<Scalars['float8']['output']>;
    connectedAt?: Maybe<Scalars['timestamp']['output']>;
    connectionStatus?: Maybe<Scalars['LinkedinConnectionStatus']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    daysSinceLastMsg?: Maybe<Scalars['Int']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    fullName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    interests?: Maybe<Array<Scalars['String']['output']>>;
    lastCompletedActionAt?: Maybe<Scalars['timestamp']['output']>;
    lastContactedAt?: Maybe<Scalars['timestamp']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    linkedinHeadline?: Maybe<Scalars['String']['output']>;
    linkedinNumberOfConnections?: Maybe<Scalars['Int']['output']>;
    linkedinProfileImgUrl?: Maybe<Scalars['String']['output']>;
    linkedinProfileUrl?: Maybe<Scalars['String']['output']>;
    linkedinUserId?: Maybe<Scalars['String']['output']>;
    linkedinVerifiedAt?: Maybe<Scalars['timestamp']['output']>;
    location?: Maybe<Scalars['String']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    nextActionSuggestedAt?: Maybe<Scalars['timestamp']['output']>;
    occupationTitle?: Maybe<Scalars['String']['output']>;
    organizationDomain?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    organizationIndustry?: Maybe<Scalars['String']['output']>;
    organizationLinkedinUrl?: Maybe<Scalars['String']['output']>;
    organizationName?: Maybe<Scalars['String']['output']>;
    organizationSize?: Maybe<Scalars['String']['output']>;
    personId?: Maybe<Scalars['String']['output']>;
    phoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
    priorityScore?: Maybe<Scalars['Int']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    region?: Maybe<Scalars['String']['output']>;
    skills?: Maybe<Array<Scalars['String']['output']>>;
    snoozedUntil?: Maybe<Scalars['timestamp']['output']>;
    source?: Maybe<Scalars['String']['output']>;
    sourceId?: Maybe<Scalars['String']['output']>;
    topActionType?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    userSetAsNotInterestedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "Contacts" */
export type Contacts_Max_Order_By = {
    accountId?: InputMaybe<Order_By>;
    compositeScore?: InputMaybe<Order_By>;
    connectedAt?: InputMaybe<Order_By>;
    connectionStatus?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    daysSinceLastMsg?: InputMaybe<Order_By>;
    email?: InputMaybe<Order_By>;
    embeddingLastUpdatedAt?: InputMaybe<Order_By>;
    firstName?: InputMaybe<Order_By>;
    fullName?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    interests?: InputMaybe<Order_By>;
    lastCompletedActionAt?: InputMaybe<Order_By>;
    lastContactedAt?: InputMaybe<Order_By>;
    lastName?: InputMaybe<Order_By>;
    linkedinHeadline?: InputMaybe<Order_By>;
    linkedinNumberOfConnections?: InputMaybe<Order_By>;
    linkedinProfileImgUrl?: InputMaybe<Order_By>;
    linkedinProfileUrl?: InputMaybe<Order_By>;
    linkedinUserId?: InputMaybe<Order_By>;
    linkedinVerifiedAt?: InputMaybe<Order_By>;
    location?: InputMaybe<Order_By>;
    metadataLastUpdatedAt?: InputMaybe<Order_By>;
    nextActionSuggestedAt?: InputMaybe<Order_By>;
    occupationTitle?: InputMaybe<Order_By>;
    organizationDomain?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    organizationIndustry?: InputMaybe<Order_By>;
    organizationLinkedinUrl?: InputMaybe<Order_By>;
    organizationName?: InputMaybe<Order_By>;
    organizationSize?: InputMaybe<Order_By>;
    personId?: InputMaybe<Order_By>;
    phoneNumbers?: InputMaybe<Order_By>;
    priorityScore?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    region?: InputMaybe<Order_By>;
    skills?: InputMaybe<Order_By>;
    snoozedUntil?: InputMaybe<Order_By>;
    source?: InputMaybe<Order_By>;
    sourceId?: InputMaybe<Order_By>;
    topActionType?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    userSetAsNotInterestedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Contacts_Min_Fields = {
    __typename?: 'Contacts_min_fields';
    accountId?: Maybe<Scalars['String']['output']>;
    compositeScore?: Maybe<Scalars['float8']['output']>;
    connectedAt?: Maybe<Scalars['timestamp']['output']>;
    connectionStatus?: Maybe<Scalars['LinkedinConnectionStatus']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    daysSinceLastMsg?: Maybe<Scalars['Int']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    fullName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    interests?: Maybe<Array<Scalars['String']['output']>>;
    lastCompletedActionAt?: Maybe<Scalars['timestamp']['output']>;
    lastContactedAt?: Maybe<Scalars['timestamp']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    linkedinHeadline?: Maybe<Scalars['String']['output']>;
    linkedinNumberOfConnections?: Maybe<Scalars['Int']['output']>;
    linkedinProfileImgUrl?: Maybe<Scalars['String']['output']>;
    linkedinProfileUrl?: Maybe<Scalars['String']['output']>;
    linkedinUserId?: Maybe<Scalars['String']['output']>;
    linkedinVerifiedAt?: Maybe<Scalars['timestamp']['output']>;
    location?: Maybe<Scalars['String']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    nextActionSuggestedAt?: Maybe<Scalars['timestamp']['output']>;
    occupationTitle?: Maybe<Scalars['String']['output']>;
    organizationDomain?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    organizationIndustry?: Maybe<Scalars['String']['output']>;
    organizationLinkedinUrl?: Maybe<Scalars['String']['output']>;
    organizationName?: Maybe<Scalars['String']['output']>;
    organizationSize?: Maybe<Scalars['String']['output']>;
    personId?: Maybe<Scalars['String']['output']>;
    phoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
    priorityScore?: Maybe<Scalars['Int']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    region?: Maybe<Scalars['String']['output']>;
    skills?: Maybe<Array<Scalars['String']['output']>>;
    snoozedUntil?: Maybe<Scalars['timestamp']['output']>;
    source?: Maybe<Scalars['String']['output']>;
    sourceId?: Maybe<Scalars['String']['output']>;
    topActionType?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    userSetAsNotInterestedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "Contacts" */
export type Contacts_Min_Order_By = {
    accountId?: InputMaybe<Order_By>;
    compositeScore?: InputMaybe<Order_By>;
    connectedAt?: InputMaybe<Order_By>;
    connectionStatus?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    daysSinceLastMsg?: InputMaybe<Order_By>;
    email?: InputMaybe<Order_By>;
    embeddingLastUpdatedAt?: InputMaybe<Order_By>;
    firstName?: InputMaybe<Order_By>;
    fullName?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    interests?: InputMaybe<Order_By>;
    lastCompletedActionAt?: InputMaybe<Order_By>;
    lastContactedAt?: InputMaybe<Order_By>;
    lastName?: InputMaybe<Order_By>;
    linkedinHeadline?: InputMaybe<Order_By>;
    linkedinNumberOfConnections?: InputMaybe<Order_By>;
    linkedinProfileImgUrl?: InputMaybe<Order_By>;
    linkedinProfileUrl?: InputMaybe<Order_By>;
    linkedinUserId?: InputMaybe<Order_By>;
    linkedinVerifiedAt?: InputMaybe<Order_By>;
    location?: InputMaybe<Order_By>;
    metadataLastUpdatedAt?: InputMaybe<Order_By>;
    nextActionSuggestedAt?: InputMaybe<Order_By>;
    occupationTitle?: InputMaybe<Order_By>;
    organizationDomain?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    organizationIndustry?: InputMaybe<Order_By>;
    organizationLinkedinUrl?: InputMaybe<Order_By>;
    organizationName?: InputMaybe<Order_By>;
    organizationSize?: InputMaybe<Order_By>;
    personId?: InputMaybe<Order_By>;
    phoneNumbers?: InputMaybe<Order_By>;
    priorityScore?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    region?: InputMaybe<Order_By>;
    skills?: InputMaybe<Order_By>;
    snoozedUntil?: InputMaybe<Order_By>;
    source?: InputMaybe<Order_By>;
    sourceId?: InputMaybe<Order_By>;
    topActionType?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    userSetAsNotInterestedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Contacts" */
export type Contacts_Mutation_Response = {
    __typename?: 'Contacts_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Contacts>;
};

/** input type for inserting object relation for remote table "Contacts" */
export type Contacts_Obj_Rel_Insert_Input = {
    data: Contacts_Insert_Input;
    /** upsert condition */
    on_conflict?: InputMaybe<Contacts_On_Conflict>;
};

/** on_conflict condition type for table "Contacts" */
export type Contacts_On_Conflict = {
    constraint: Contacts_Constraint;
    update_columns?: Array<Contacts_Update_Column>;
    where?: InputMaybe<Contacts_Bool_Exp>;
};

/** Ordering options when selecting data from "Contacts". */
export type Contacts_Order_By = {
    Account?: InputMaybe<Accounts_Order_By>;
    ContactsInteractions_aggregate?: InputMaybe<ContactsInteractions_Aggregate_Order_By>;
    Conversations_aggregate?: InputMaybe<Conversations_Aggregate_Order_By>;
    MessageDrafts_aggregate?: InputMaybe<MessageDrafts_Aggregate_Order_By>;
    Messages_aggregate?: InputMaybe<Messages_Aggregate_Order_By>;
    Notes_aggregate?: InputMaybe<Notes_Aggregate_Order_By>;
    Resources_aggregate?: InputMaybe<Resources_Aggregate_Order_By>;
    _GroupToContacts_aggregate?: InputMaybe<_GroupToContact_Aggregate_Order_By>;
    accountId?: InputMaybe<Order_By>;
    actionsMetadata?: InputMaybe<Order_By>;
    compositeScore?: InputMaybe<Order_By>;
    connectedAt?: InputMaybe<Order_By>;
    connectionStatus?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    daysSinceLastMsg?: InputMaybe<Order_By>;
    education?: InputMaybe<Order_By>;
    email?: InputMaybe<Order_By>;
    embedding?: InputMaybe<Order_By>;
    embeddingLastUpdatedAt?: InputMaybe<Order_By>;
    experiences?: InputMaybe<Order_By>;
    firstName?: InputMaybe<Order_By>;
    fullName?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    interests?: InputMaybe<Order_By>;
    lastCompletedActionAt?: InputMaybe<Order_By>;
    lastContactedAt?: InputMaybe<Order_By>;
    lastName?: InputMaybe<Order_By>;
    linkedinHeadline?: InputMaybe<Order_By>;
    linkedinNumberOfConnections?: InputMaybe<Order_By>;
    linkedinProfileImgUrl?: InputMaybe<Order_By>;
    linkedinProfileUrl?: InputMaybe<Order_By>;
    linkedinUserId?: InputMaybe<Order_By>;
    linkedinVerifiedAt?: InputMaybe<Order_By>;
    location?: InputMaybe<Order_By>;
    metadata?: InputMaybe<Order_By>;
    metadataLastUpdatedAt?: InputMaybe<Order_By>;
    nextActionSuggestedAt?: InputMaybe<Order_By>;
    occupationTitle?: InputMaybe<Order_By>;
    organizationDomain?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    organizationIndustry?: InputMaybe<Order_By>;
    organizationLinkedinUrl?: InputMaybe<Order_By>;
    organizationName?: InputMaybe<Order_By>;
    organizationSize?: InputMaybe<Order_By>;
    personId?: InputMaybe<Order_By>;
    phoneNumbers?: InputMaybe<Order_By>;
    priorityScore?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    region?: InputMaybe<Order_By>;
    skills?: InputMaybe<Order_By>;
    snoozedUntil?: InputMaybe<Order_By>;
    source?: InputMaybe<Order_By>;
    sourceId?: InputMaybe<Order_By>;
    topActionType?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    userSetAsNotInterestedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Contacts */
export type Contacts_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Contacts_Prepend_Input = {
    actionsMetadata?: InputMaybe<Scalars['jsonb']['input']>;
    education?: InputMaybe<Scalars['jsonb']['input']>;
    experiences?: InputMaybe<Scalars['jsonb']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "Contacts" */
export enum Contacts_Select_Column {
    /** column name */
    AccountId = 'accountId',
    /** column name */
    ActionsMetadata = 'actionsMetadata',
    /** column name */
    CompositeScore = 'compositeScore',
    /** column name */
    ConnectedAt = 'connectedAt',
    /** column name */
    ConnectionStatus = 'connectionStatus',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    DaysSinceLastMsg = 'daysSinceLastMsg',
    /** column name */
    Education = 'education',
    /** column name */
    Email = 'email',
    /** column name */
    Embedding = 'embedding',
    /** column name */
    EmbeddingLastUpdatedAt = 'embeddingLastUpdatedAt',
    /** column name */
    Experiences = 'experiences',
    /** column name */
    FirstName = 'firstName',
    /** column name */
    FullName = 'fullName',
    /** column name */
    Id = 'id',
    /** column name */
    Interests = 'interests',
    /** column name */
    LastCompletedActionAt = 'lastCompletedActionAt',
    /** column name */
    LastContactedAt = 'lastContactedAt',
    /** column name */
    LastName = 'lastName',
    /** column name */
    LinkedinHeadline = 'linkedinHeadline',
    /** column name */
    LinkedinNumberOfConnections = 'linkedinNumberOfConnections',
    /** column name */
    LinkedinProfileImgUrl = 'linkedinProfileImgUrl',
    /** column name */
    LinkedinProfileUrl = 'linkedinProfileUrl',
    /** column name */
    LinkedinUserId = 'linkedinUserId',
    /** column name */
    LinkedinVerifiedAt = 'linkedinVerifiedAt',
    /** column name */
    Location = 'location',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    MetadataLastUpdatedAt = 'metadataLastUpdatedAt',
    /** column name */
    NextActionSuggestedAt = 'nextActionSuggestedAt',
    /** column name */
    OccupationTitle = 'occupationTitle',
    /** column name */
    OrganizationDomain = 'organizationDomain',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    OrganizationIndustry = 'organizationIndustry',
    /** column name */
    OrganizationLinkedinUrl = 'organizationLinkedinUrl',
    /** column name */
    OrganizationName = 'organizationName',
    /** column name */
    OrganizationSize = 'organizationSize',
    /** column name */
    PersonId = 'personId',
    /** column name */
    PhoneNumbers = 'phoneNumbers',
    /** column name */
    PriorityScore = 'priorityScore',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    Region = 'region',
    /** column name */
    Skills = 'skills',
    /** column name */
    SnoozedUntil = 'snoozedUntil',
    /** column name */
    Source = 'source',
    /** column name */
    SourceId = 'sourceId',
    /** column name */
    TopActionType = 'topActionType',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
    /** column name */
    UserSetAsNotInterestedAt = 'userSetAsNotInterestedAt',
}

/** select "Contacts_aggregate_bool_exp_avg_arguments_columns" columns of table "Contacts" */
export enum Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Avg_Arguments_Columns {
    /** column name */
    CompositeScore = 'compositeScore',
}

/** select "Contacts_aggregate_bool_exp_corr_arguments_columns" columns of table "Contacts" */
export enum Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Corr_Arguments_Columns {
    /** column name */
    CompositeScore = 'compositeScore',
}

/** select "Contacts_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "Contacts" */
export enum Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
    /** column name */
    CompositeScore = 'compositeScore',
}

/** select "Contacts_aggregate_bool_exp_max_arguments_columns" columns of table "Contacts" */
export enum Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Max_Arguments_Columns {
    /** column name */
    CompositeScore = 'compositeScore',
}

/** select "Contacts_aggregate_bool_exp_min_arguments_columns" columns of table "Contacts" */
export enum Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Min_Arguments_Columns {
    /** column name */
    CompositeScore = 'compositeScore',
}

/** select "Contacts_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "Contacts" */
export enum Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
    /** column name */
    CompositeScore = 'compositeScore',
}

/** select "Contacts_aggregate_bool_exp_sum_arguments_columns" columns of table "Contacts" */
export enum Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Sum_Arguments_Columns {
    /** column name */
    CompositeScore = 'compositeScore',
}

/** select "Contacts_aggregate_bool_exp_var_samp_arguments_columns" columns of table "Contacts" */
export enum Contacts_Select_Column_Contacts_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
    /** column name */
    CompositeScore = 'compositeScore',
}

/** input type for updating data in table "Contacts" */
export type Contacts_Set_Input = {
    accountId?: InputMaybe<Scalars['String']['input']>;
    actionsMetadata?: InputMaybe<Scalars['jsonb']['input']>;
    compositeScore?: InputMaybe<Scalars['float8']['input']>;
    connectedAt?: InputMaybe<Scalars['timestamp']['input']>;
    connectionStatus?: InputMaybe<Scalars['LinkedinConnectionStatus']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    daysSinceLastMsg?: InputMaybe<Scalars['Int']['input']>;
    education?: InputMaybe<Scalars['jsonb']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    experiences?: InputMaybe<Scalars['jsonb']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    fullName?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    interests?: InputMaybe<Array<Scalars['String']['input']>>;
    lastCompletedActionAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastContactedAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    linkedinHeadline?: InputMaybe<Scalars['String']['input']>;
    linkedinNumberOfConnections?: InputMaybe<Scalars['Int']['input']>;
    linkedinProfileImgUrl?: InputMaybe<Scalars['String']['input']>;
    linkedinProfileUrl?: InputMaybe<Scalars['String']['input']>;
    linkedinUserId?: InputMaybe<Scalars['String']['input']>;
    linkedinVerifiedAt?: InputMaybe<Scalars['timestamp']['input']>;
    location?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    nextActionSuggestedAt?: InputMaybe<Scalars['timestamp']['input']>;
    occupationTitle?: InputMaybe<Scalars['String']['input']>;
    organizationDomain?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    organizationIndustry?: InputMaybe<Scalars['String']['input']>;
    organizationLinkedinUrl?: InputMaybe<Scalars['String']['input']>;
    organizationName?: InputMaybe<Scalars['String']['input']>;
    organizationSize?: InputMaybe<Scalars['String']['input']>;
    personId?: InputMaybe<Scalars['String']['input']>;
    phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
    priorityScore?: InputMaybe<Scalars['Int']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    region?: InputMaybe<Scalars['String']['input']>;
    skills?: InputMaybe<Array<Scalars['String']['input']>>;
    snoozedUntil?: InputMaybe<Scalars['timestamp']['input']>;
    source?: InputMaybe<Scalars['String']['input']>;
    sourceId?: InputMaybe<Scalars['String']['input']>;
    topActionType?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    userSetAsNotInterestedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Contacts_Stddev_Fields = {
    __typename?: 'Contacts_stddev_fields';
    compositeScore?: Maybe<Scalars['Float']['output']>;
    daysSinceLastMsg?: Maybe<Scalars['Float']['output']>;
    linkedinNumberOfConnections?: Maybe<Scalars['Float']['output']>;
    priorityScore?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "Contacts" */
export type Contacts_Stddev_Order_By = {
    compositeScore?: InputMaybe<Order_By>;
    daysSinceLastMsg?: InputMaybe<Order_By>;
    linkedinNumberOfConnections?: InputMaybe<Order_By>;
    priorityScore?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Contacts_Stddev_Pop_Fields = {
    __typename?: 'Contacts_stddev_pop_fields';
    compositeScore?: Maybe<Scalars['Float']['output']>;
    daysSinceLastMsg?: Maybe<Scalars['Float']['output']>;
    linkedinNumberOfConnections?: Maybe<Scalars['Float']['output']>;
    priorityScore?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "Contacts" */
export type Contacts_Stddev_Pop_Order_By = {
    compositeScore?: InputMaybe<Order_By>;
    daysSinceLastMsg?: InputMaybe<Order_By>;
    linkedinNumberOfConnections?: InputMaybe<Order_By>;
    priorityScore?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Contacts_Stddev_Samp_Fields = {
    __typename?: 'Contacts_stddev_samp_fields';
    compositeScore?: Maybe<Scalars['Float']['output']>;
    daysSinceLastMsg?: Maybe<Scalars['Float']['output']>;
    linkedinNumberOfConnections?: Maybe<Scalars['Float']['output']>;
    priorityScore?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "Contacts" */
export type Contacts_Stddev_Samp_Order_By = {
    compositeScore?: InputMaybe<Order_By>;
    daysSinceLastMsg?: InputMaybe<Order_By>;
    linkedinNumberOfConnections?: InputMaybe<Order_By>;
    priorityScore?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Contacts" */
export type Contacts_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: Contacts_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contacts_Stream_Cursor_Value_Input = {
    accountId?: InputMaybe<Scalars['String']['input']>;
    actionsMetadata?: InputMaybe<Scalars['jsonb']['input']>;
    compositeScore?: InputMaybe<Scalars['float8']['input']>;
    connectedAt?: InputMaybe<Scalars['timestamp']['input']>;
    connectionStatus?: InputMaybe<Scalars['LinkedinConnectionStatus']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    daysSinceLastMsg?: InputMaybe<Scalars['Int']['input']>;
    education?: InputMaybe<Scalars['jsonb']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    experiences?: InputMaybe<Scalars['jsonb']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    fullName?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    interests?: InputMaybe<Array<Scalars['String']['input']>>;
    lastCompletedActionAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastContactedAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    linkedinHeadline?: InputMaybe<Scalars['String']['input']>;
    linkedinNumberOfConnections?: InputMaybe<Scalars['Int']['input']>;
    linkedinProfileImgUrl?: InputMaybe<Scalars['String']['input']>;
    linkedinProfileUrl?: InputMaybe<Scalars['String']['input']>;
    linkedinUserId?: InputMaybe<Scalars['String']['input']>;
    linkedinVerifiedAt?: InputMaybe<Scalars['timestamp']['input']>;
    location?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    nextActionSuggestedAt?: InputMaybe<Scalars['timestamp']['input']>;
    occupationTitle?: InputMaybe<Scalars['String']['input']>;
    organizationDomain?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    organizationIndustry?: InputMaybe<Scalars['String']['input']>;
    organizationLinkedinUrl?: InputMaybe<Scalars['String']['input']>;
    organizationName?: InputMaybe<Scalars['String']['input']>;
    organizationSize?: InputMaybe<Scalars['String']['input']>;
    personId?: InputMaybe<Scalars['String']['input']>;
    phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
    priorityScore?: InputMaybe<Scalars['Int']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    region?: InputMaybe<Scalars['String']['input']>;
    skills?: InputMaybe<Array<Scalars['String']['input']>>;
    snoozedUntil?: InputMaybe<Scalars['timestamp']['input']>;
    source?: InputMaybe<Scalars['String']['input']>;
    sourceId?: InputMaybe<Scalars['String']['input']>;
    topActionType?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    userSetAsNotInterestedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Contacts_Sum_Fields = {
    __typename?: 'Contacts_sum_fields';
    compositeScore?: Maybe<Scalars['float8']['output']>;
    daysSinceLastMsg?: Maybe<Scalars['Int']['output']>;
    linkedinNumberOfConnections?: Maybe<Scalars['Int']['output']>;
    priorityScore?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "Contacts" */
export type Contacts_Sum_Order_By = {
    compositeScore?: InputMaybe<Order_By>;
    daysSinceLastMsg?: InputMaybe<Order_By>;
    linkedinNumberOfConnections?: InputMaybe<Order_By>;
    priorityScore?: InputMaybe<Order_By>;
};

/** update columns of table "Contacts" */
export enum Contacts_Update_Column {
    /** column name */
    AccountId = 'accountId',
    /** column name */
    ActionsMetadata = 'actionsMetadata',
    /** column name */
    CompositeScore = 'compositeScore',
    /** column name */
    ConnectedAt = 'connectedAt',
    /** column name */
    ConnectionStatus = 'connectionStatus',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    DaysSinceLastMsg = 'daysSinceLastMsg',
    /** column name */
    Education = 'education',
    /** column name */
    Email = 'email',
    /** column name */
    Embedding = 'embedding',
    /** column name */
    EmbeddingLastUpdatedAt = 'embeddingLastUpdatedAt',
    /** column name */
    Experiences = 'experiences',
    /** column name */
    FirstName = 'firstName',
    /** column name */
    FullName = 'fullName',
    /** column name */
    Id = 'id',
    /** column name */
    Interests = 'interests',
    /** column name */
    LastCompletedActionAt = 'lastCompletedActionAt',
    /** column name */
    LastContactedAt = 'lastContactedAt',
    /** column name */
    LastName = 'lastName',
    /** column name */
    LinkedinHeadline = 'linkedinHeadline',
    /** column name */
    LinkedinNumberOfConnections = 'linkedinNumberOfConnections',
    /** column name */
    LinkedinProfileImgUrl = 'linkedinProfileImgUrl',
    /** column name */
    LinkedinProfileUrl = 'linkedinProfileUrl',
    /** column name */
    LinkedinUserId = 'linkedinUserId',
    /** column name */
    LinkedinVerifiedAt = 'linkedinVerifiedAt',
    /** column name */
    Location = 'location',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    MetadataLastUpdatedAt = 'metadataLastUpdatedAt',
    /** column name */
    NextActionSuggestedAt = 'nextActionSuggestedAt',
    /** column name */
    OccupationTitle = 'occupationTitle',
    /** column name */
    OrganizationDomain = 'organizationDomain',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    OrganizationIndustry = 'organizationIndustry',
    /** column name */
    OrganizationLinkedinUrl = 'organizationLinkedinUrl',
    /** column name */
    OrganizationName = 'organizationName',
    /** column name */
    OrganizationSize = 'organizationSize',
    /** column name */
    PersonId = 'personId',
    /** column name */
    PhoneNumbers = 'phoneNumbers',
    /** column name */
    PriorityScore = 'priorityScore',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    Region = 'region',
    /** column name */
    Skills = 'skills',
    /** column name */
    SnoozedUntil = 'snoozedUntil',
    /** column name */
    Source = 'source',
    /** column name */
    SourceId = 'sourceId',
    /** column name */
    TopActionType = 'topActionType',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
    /** column name */
    UserSetAsNotInterestedAt = 'userSetAsNotInterestedAt',
}

export type Contacts_Updates = {
    /** append existing jsonb value of filtered columns with new jsonb value */
    _append?: InputMaybe<Contacts_Append_Input>;
    /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
    _delete_at_path?: InputMaybe<Contacts_Delete_At_Path_Input>;
    /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
    _delete_elem?: InputMaybe<Contacts_Delete_Elem_Input>;
    /** delete key/value pair or string element. key/value pairs are matched based on their key value */
    _delete_key?: InputMaybe<Contacts_Delete_Key_Input>;
    /** increments the numeric columns with given value of the filtered values */
    _inc?: InputMaybe<Contacts_Inc_Input>;
    /** prepend existing jsonb value of filtered columns with new jsonb value */
    _prepend?: InputMaybe<Contacts_Prepend_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<Contacts_Set_Input>;
    /** filter the rows which have to be updated */
    where: Contacts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Contacts_Var_Pop_Fields = {
    __typename?: 'Contacts_var_pop_fields';
    compositeScore?: Maybe<Scalars['Float']['output']>;
    daysSinceLastMsg?: Maybe<Scalars['Float']['output']>;
    linkedinNumberOfConnections?: Maybe<Scalars['Float']['output']>;
    priorityScore?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "Contacts" */
export type Contacts_Var_Pop_Order_By = {
    compositeScore?: InputMaybe<Order_By>;
    daysSinceLastMsg?: InputMaybe<Order_By>;
    linkedinNumberOfConnections?: InputMaybe<Order_By>;
    priorityScore?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Contacts_Var_Samp_Fields = {
    __typename?: 'Contacts_var_samp_fields';
    compositeScore?: Maybe<Scalars['Float']['output']>;
    daysSinceLastMsg?: Maybe<Scalars['Float']['output']>;
    linkedinNumberOfConnections?: Maybe<Scalars['Float']['output']>;
    priorityScore?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "Contacts" */
export type Contacts_Var_Samp_Order_By = {
    compositeScore?: InputMaybe<Order_By>;
    daysSinceLastMsg?: InputMaybe<Order_By>;
    linkedinNumberOfConnections?: InputMaybe<Order_By>;
    priorityScore?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Contacts_Variance_Fields = {
    __typename?: 'Contacts_variance_fields';
    compositeScore?: Maybe<Scalars['Float']['output']>;
    daysSinceLastMsg?: Maybe<Scalars['Float']['output']>;
    linkedinNumberOfConnections?: Maybe<Scalars['Float']['output']>;
    priorityScore?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "Contacts" */
export type Contacts_Variance_Order_By = {
    compositeScore?: InputMaybe<Order_By>;
    daysSinceLastMsg?: InputMaybe<Order_By>;
    linkedinNumberOfConnections?: InputMaybe<Order_By>;
    priorityScore?: InputMaybe<Order_By>;
};

/** columns and relationships of "ConversationMetaData" */
export type ConversationMetaData = {
    __typename?: 'ConversationMetaData';
    /** An object relationship */
    OutreachSuggestion?: Maybe<OutreachSuggestions>;
    /** An array relationship */
    OutreachSuggestions: Array<OutreachSuggestions>;
    /** An aggregate relationship */
    OutreachSuggestions_aggregate: OutreachSuggestions_Aggregate;
    connectionStatus: Scalars['String']['output'];
    createdAt: Scalars['timestamp']['output'];
    hasMessagesSentFromApp: Scalars['Boolean']['output'];
    id: Scalars['String']['output'];
    isNextMessageFollowUp: Scalars['Boolean']['output'];
    lastMessageAt: Scalars['timestamp']['output'];
    lastNetworkUpdateAt: Scalars['timestamp']['output'];
    lastTimeToAnswer: Scalars['bigint']['output'];
    lastUserNoteAt: Scalars['timestamp']['output'];
    medianMessageLength: Scalars['float8']['output'];
    messagesPerDay: Scalars['float8']['output'];
    numberOfMessages: Scalars['Int']['output'];
    numberOfMessagesLastDay: Scalars['Int']['output'];
    numberOfMessagesLastWeek: Scalars['Int']['output'];
    prospectId: Scalars['String']['output'];
    topics: Scalars['String']['output'];
    updatedAt: Scalars['timestamp']['output'];
    userContactAddedAt: Scalars['timestamp']['output'];
    userContactFromOnboarding: Scalars['Boolean']['output'];
    userContactId: Scalars['String']['output'];
    userId: Scalars['String']['output'];
    youThemMessageRatio: Scalars['float8']['output'];
};

/** columns and relationships of "ConversationMetaData" */
export type ConversationMetaDataOutreachSuggestionsArgs = {
    distinct_on?: InputMaybe<Array<OutreachSuggestions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<OutreachSuggestions_Order_By>>;
    where?: InputMaybe<OutreachSuggestions_Bool_Exp>;
};

/** columns and relationships of "ConversationMetaData" */
export type ConversationMetaDataOutreachSuggestions_AggregateArgs = {
    distinct_on?: InputMaybe<Array<OutreachSuggestions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<OutreachSuggestions_Order_By>>;
    where?: InputMaybe<OutreachSuggestions_Bool_Exp>;
};

/** aggregated selection of "ConversationMetaData" */
export type ConversationMetaData_Aggregate = {
    __typename?: 'ConversationMetaData_aggregate';
    aggregate?: Maybe<ConversationMetaData_Aggregate_Fields>;
    nodes: Array<ConversationMetaData>;
};

/** aggregate fields of "ConversationMetaData" */
export type ConversationMetaData_Aggregate_Fields = {
    __typename?: 'ConversationMetaData_aggregate_fields';
    avg?: Maybe<ConversationMetaData_Avg_Fields>;
    count: Scalars['Int']['output'];
    max?: Maybe<ConversationMetaData_Max_Fields>;
    min?: Maybe<ConversationMetaData_Min_Fields>;
    stddev?: Maybe<ConversationMetaData_Stddev_Fields>;
    stddev_pop?: Maybe<ConversationMetaData_Stddev_Pop_Fields>;
    stddev_samp?: Maybe<ConversationMetaData_Stddev_Samp_Fields>;
    sum?: Maybe<ConversationMetaData_Sum_Fields>;
    var_pop?: Maybe<ConversationMetaData_Var_Pop_Fields>;
    var_samp?: Maybe<ConversationMetaData_Var_Samp_Fields>;
    variance?: Maybe<ConversationMetaData_Variance_Fields>;
};

/** aggregate fields of "ConversationMetaData" */
export type ConversationMetaData_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<ConversationMetaData_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ConversationMetaData_Avg_Fields = {
    __typename?: 'ConversationMetaData_avg_fields';
    lastTimeToAnswer?: Maybe<Scalars['Float']['output']>;
    medianMessageLength?: Maybe<Scalars['Float']['output']>;
    messagesPerDay?: Maybe<Scalars['Float']['output']>;
    numberOfMessages?: Maybe<Scalars['Float']['output']>;
    numberOfMessagesLastDay?: Maybe<Scalars['Float']['output']>;
    numberOfMessagesLastWeek?: Maybe<Scalars['Float']['output']>;
    youThemMessageRatio?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "ConversationMetaData". All fields are combined with a logical 'AND'. */
export type ConversationMetaData_Bool_Exp = {
    OutreachSuggestion?: InputMaybe<OutreachSuggestions_Bool_Exp>;
    OutreachSuggestions?: InputMaybe<OutreachSuggestions_Bool_Exp>;
    OutreachSuggestions_aggregate?: InputMaybe<OutreachSuggestions_Aggregate_Bool_Exp>;
    _and?: InputMaybe<Array<ConversationMetaData_Bool_Exp>>;
    _not?: InputMaybe<ConversationMetaData_Bool_Exp>;
    _or?: InputMaybe<Array<ConversationMetaData_Bool_Exp>>;
    connectionStatus?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    hasMessagesSentFromApp?: InputMaybe<Boolean_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    isNextMessageFollowUp?: InputMaybe<Boolean_Comparison_Exp>;
    lastMessageAt?: InputMaybe<Timestamp_Comparison_Exp>;
    lastNetworkUpdateAt?: InputMaybe<Timestamp_Comparison_Exp>;
    lastTimeToAnswer?: InputMaybe<Bigint_Comparison_Exp>;
    lastUserNoteAt?: InputMaybe<Timestamp_Comparison_Exp>;
    medianMessageLength?: InputMaybe<Float8_Comparison_Exp>;
    messagesPerDay?: InputMaybe<Float8_Comparison_Exp>;
    numberOfMessages?: InputMaybe<Int_Comparison_Exp>;
    numberOfMessagesLastDay?: InputMaybe<Int_Comparison_Exp>;
    numberOfMessagesLastWeek?: InputMaybe<Int_Comparison_Exp>;
    prospectId?: InputMaybe<String_Comparison_Exp>;
    topics?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userContactAddedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userContactFromOnboarding?: InputMaybe<Boolean_Comparison_Exp>;
    userContactId?: InputMaybe<String_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
    youThemMessageRatio?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "ConversationMetaData" */
export enum ConversationMetaData_Constraint {
    /** unique or primary key constraint on columns "id" */
    ConversationMetaDataPkey = 'ConversationMetaData_pkey',
}

/** input type for incrementing numeric columns in table "ConversationMetaData" */
export type ConversationMetaData_Inc_Input = {
    lastTimeToAnswer?: InputMaybe<Scalars['bigint']['input']>;
    medianMessageLength?: InputMaybe<Scalars['float8']['input']>;
    messagesPerDay?: InputMaybe<Scalars['float8']['input']>;
    numberOfMessages?: InputMaybe<Scalars['Int']['input']>;
    numberOfMessagesLastDay?: InputMaybe<Scalars['Int']['input']>;
    numberOfMessagesLastWeek?: InputMaybe<Scalars['Int']['input']>;
    youThemMessageRatio?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "ConversationMetaData" */
export type ConversationMetaData_Insert_Input = {
    OutreachSuggestion?: InputMaybe<OutreachSuggestions_Obj_Rel_Insert_Input>;
    OutreachSuggestions?: InputMaybe<OutreachSuggestions_Arr_Rel_Insert_Input>;
    connectionStatus?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    hasMessagesSentFromApp?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    isNextMessageFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
    lastMessageAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastNetworkUpdateAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastTimeToAnswer?: InputMaybe<Scalars['bigint']['input']>;
    lastUserNoteAt?: InputMaybe<Scalars['timestamp']['input']>;
    medianMessageLength?: InputMaybe<Scalars['float8']['input']>;
    messagesPerDay?: InputMaybe<Scalars['float8']['input']>;
    numberOfMessages?: InputMaybe<Scalars['Int']['input']>;
    numberOfMessagesLastDay?: InputMaybe<Scalars['Int']['input']>;
    numberOfMessagesLastWeek?: InputMaybe<Scalars['Int']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    topics?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userContactAddedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userContactFromOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
    userContactId?: InputMaybe<Scalars['String']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    youThemMessageRatio?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate max on columns */
export type ConversationMetaData_Max_Fields = {
    __typename?: 'ConversationMetaData_max_fields';
    connectionStatus?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastMessageAt?: Maybe<Scalars['timestamp']['output']>;
    lastNetworkUpdateAt?: Maybe<Scalars['timestamp']['output']>;
    lastTimeToAnswer?: Maybe<Scalars['bigint']['output']>;
    lastUserNoteAt?: Maybe<Scalars['timestamp']['output']>;
    medianMessageLength?: Maybe<Scalars['float8']['output']>;
    messagesPerDay?: Maybe<Scalars['float8']['output']>;
    numberOfMessages?: Maybe<Scalars['Int']['output']>;
    numberOfMessagesLastDay?: Maybe<Scalars['Int']['output']>;
    numberOfMessagesLastWeek?: Maybe<Scalars['Int']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    topics?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userContactAddedAt?: Maybe<Scalars['timestamp']['output']>;
    userContactId?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    youThemMessageRatio?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type ConversationMetaData_Min_Fields = {
    __typename?: 'ConversationMetaData_min_fields';
    connectionStatus?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastMessageAt?: Maybe<Scalars['timestamp']['output']>;
    lastNetworkUpdateAt?: Maybe<Scalars['timestamp']['output']>;
    lastTimeToAnswer?: Maybe<Scalars['bigint']['output']>;
    lastUserNoteAt?: Maybe<Scalars['timestamp']['output']>;
    medianMessageLength?: Maybe<Scalars['float8']['output']>;
    messagesPerDay?: Maybe<Scalars['float8']['output']>;
    numberOfMessages?: Maybe<Scalars['Int']['output']>;
    numberOfMessagesLastDay?: Maybe<Scalars['Int']['output']>;
    numberOfMessagesLastWeek?: Maybe<Scalars['Int']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    topics?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userContactAddedAt?: Maybe<Scalars['timestamp']['output']>;
    userContactId?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    youThemMessageRatio?: Maybe<Scalars['float8']['output']>;
};

/** response of any mutation on the table "ConversationMetaData" */
export type ConversationMetaData_Mutation_Response = {
    __typename?: 'ConversationMetaData_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<ConversationMetaData>;
};

/** input type for inserting object relation for remote table "ConversationMetaData" */
export type ConversationMetaData_Obj_Rel_Insert_Input = {
    data: ConversationMetaData_Insert_Input;
    /** upsert condition */
    on_conflict?: InputMaybe<ConversationMetaData_On_Conflict>;
};

/** on_conflict condition type for table "ConversationMetaData" */
export type ConversationMetaData_On_Conflict = {
    constraint: ConversationMetaData_Constraint;
    update_columns?: Array<ConversationMetaData_Update_Column>;
    where?: InputMaybe<ConversationMetaData_Bool_Exp>;
};

/** Ordering options when selecting data from "ConversationMetaData". */
export type ConversationMetaData_Order_By = {
    OutreachSuggestion?: InputMaybe<OutreachSuggestions_Order_By>;
    OutreachSuggestions_aggregate?: InputMaybe<OutreachSuggestions_Aggregate_Order_By>;
    connectionStatus?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    hasMessagesSentFromApp?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    isNextMessageFollowUp?: InputMaybe<Order_By>;
    lastMessageAt?: InputMaybe<Order_By>;
    lastNetworkUpdateAt?: InputMaybe<Order_By>;
    lastTimeToAnswer?: InputMaybe<Order_By>;
    lastUserNoteAt?: InputMaybe<Order_By>;
    medianMessageLength?: InputMaybe<Order_By>;
    messagesPerDay?: InputMaybe<Order_By>;
    numberOfMessages?: InputMaybe<Order_By>;
    numberOfMessagesLastDay?: InputMaybe<Order_By>;
    numberOfMessagesLastWeek?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    topics?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userContactAddedAt?: InputMaybe<Order_By>;
    userContactFromOnboarding?: InputMaybe<Order_By>;
    userContactId?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    youThemMessageRatio?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ConversationMetaData */
export type ConversationMetaData_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** select columns of table "ConversationMetaData" */
export enum ConversationMetaData_Select_Column {
    /** column name */
    ConnectionStatus = 'connectionStatus',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    HasMessagesSentFromApp = 'hasMessagesSentFromApp',
    /** column name */
    Id = 'id',
    /** column name */
    IsNextMessageFollowUp = 'isNextMessageFollowUp',
    /** column name */
    LastMessageAt = 'lastMessageAt',
    /** column name */
    LastNetworkUpdateAt = 'lastNetworkUpdateAt',
    /** column name */
    LastTimeToAnswer = 'lastTimeToAnswer',
    /** column name */
    LastUserNoteAt = 'lastUserNoteAt',
    /** column name */
    MedianMessageLength = 'medianMessageLength',
    /** column name */
    MessagesPerDay = 'messagesPerDay',
    /** column name */
    NumberOfMessages = 'numberOfMessages',
    /** column name */
    NumberOfMessagesLastDay = 'numberOfMessagesLastDay',
    /** column name */
    NumberOfMessagesLastWeek = 'numberOfMessagesLastWeek',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    Topics = 'topics',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserContactAddedAt = 'userContactAddedAt',
    /** column name */
    UserContactFromOnboarding = 'userContactFromOnboarding',
    /** column name */
    UserContactId = 'userContactId',
    /** column name */
    UserId = 'userId',
    /** column name */
    YouThemMessageRatio = 'youThemMessageRatio',
}

/** input type for updating data in table "ConversationMetaData" */
export type ConversationMetaData_Set_Input = {
    connectionStatus?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    hasMessagesSentFromApp?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    isNextMessageFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
    lastMessageAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastNetworkUpdateAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastTimeToAnswer?: InputMaybe<Scalars['bigint']['input']>;
    lastUserNoteAt?: InputMaybe<Scalars['timestamp']['input']>;
    medianMessageLength?: InputMaybe<Scalars['float8']['input']>;
    messagesPerDay?: InputMaybe<Scalars['float8']['input']>;
    numberOfMessages?: InputMaybe<Scalars['Int']['input']>;
    numberOfMessagesLastDay?: InputMaybe<Scalars['Int']['input']>;
    numberOfMessagesLastWeek?: InputMaybe<Scalars['Int']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    topics?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userContactAddedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userContactFromOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
    userContactId?: InputMaybe<Scalars['String']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    youThemMessageRatio?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate stddev on columns */
export type ConversationMetaData_Stddev_Fields = {
    __typename?: 'ConversationMetaData_stddev_fields';
    lastTimeToAnswer?: Maybe<Scalars['Float']['output']>;
    medianMessageLength?: Maybe<Scalars['Float']['output']>;
    messagesPerDay?: Maybe<Scalars['Float']['output']>;
    numberOfMessages?: Maybe<Scalars['Float']['output']>;
    numberOfMessagesLastDay?: Maybe<Scalars['Float']['output']>;
    numberOfMessagesLastWeek?: Maybe<Scalars['Float']['output']>;
    youThemMessageRatio?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ConversationMetaData_Stddev_Pop_Fields = {
    __typename?: 'ConversationMetaData_stddev_pop_fields';
    lastTimeToAnswer?: Maybe<Scalars['Float']['output']>;
    medianMessageLength?: Maybe<Scalars['Float']['output']>;
    messagesPerDay?: Maybe<Scalars['Float']['output']>;
    numberOfMessages?: Maybe<Scalars['Float']['output']>;
    numberOfMessagesLastDay?: Maybe<Scalars['Float']['output']>;
    numberOfMessagesLastWeek?: Maybe<Scalars['Float']['output']>;
    youThemMessageRatio?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ConversationMetaData_Stddev_Samp_Fields = {
    __typename?: 'ConversationMetaData_stddev_samp_fields';
    lastTimeToAnswer?: Maybe<Scalars['Float']['output']>;
    medianMessageLength?: Maybe<Scalars['Float']['output']>;
    messagesPerDay?: Maybe<Scalars['Float']['output']>;
    numberOfMessages?: Maybe<Scalars['Float']['output']>;
    numberOfMessagesLastDay?: Maybe<Scalars['Float']['output']>;
    numberOfMessagesLastWeek?: Maybe<Scalars['Float']['output']>;
    youThemMessageRatio?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "ConversationMetaData" */
export type ConversationMetaData_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: ConversationMetaData_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConversationMetaData_Stream_Cursor_Value_Input = {
    connectionStatus?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    hasMessagesSentFromApp?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    isNextMessageFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
    lastMessageAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastNetworkUpdateAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastTimeToAnswer?: InputMaybe<Scalars['bigint']['input']>;
    lastUserNoteAt?: InputMaybe<Scalars['timestamp']['input']>;
    medianMessageLength?: InputMaybe<Scalars['float8']['input']>;
    messagesPerDay?: InputMaybe<Scalars['float8']['input']>;
    numberOfMessages?: InputMaybe<Scalars['Int']['input']>;
    numberOfMessagesLastDay?: InputMaybe<Scalars['Int']['input']>;
    numberOfMessagesLastWeek?: InputMaybe<Scalars['Int']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    topics?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userContactAddedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userContactFromOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
    userContactId?: InputMaybe<Scalars['String']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    youThemMessageRatio?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type ConversationMetaData_Sum_Fields = {
    __typename?: 'ConversationMetaData_sum_fields';
    lastTimeToAnswer?: Maybe<Scalars['bigint']['output']>;
    medianMessageLength?: Maybe<Scalars['float8']['output']>;
    messagesPerDay?: Maybe<Scalars['float8']['output']>;
    numberOfMessages?: Maybe<Scalars['Int']['output']>;
    numberOfMessagesLastDay?: Maybe<Scalars['Int']['output']>;
    numberOfMessagesLastWeek?: Maybe<Scalars['Int']['output']>;
    youThemMessageRatio?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "ConversationMetaData" */
export enum ConversationMetaData_Update_Column {
    /** column name */
    ConnectionStatus = 'connectionStatus',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    HasMessagesSentFromApp = 'hasMessagesSentFromApp',
    /** column name */
    Id = 'id',
    /** column name */
    IsNextMessageFollowUp = 'isNextMessageFollowUp',
    /** column name */
    LastMessageAt = 'lastMessageAt',
    /** column name */
    LastNetworkUpdateAt = 'lastNetworkUpdateAt',
    /** column name */
    LastTimeToAnswer = 'lastTimeToAnswer',
    /** column name */
    LastUserNoteAt = 'lastUserNoteAt',
    /** column name */
    MedianMessageLength = 'medianMessageLength',
    /** column name */
    MessagesPerDay = 'messagesPerDay',
    /** column name */
    NumberOfMessages = 'numberOfMessages',
    /** column name */
    NumberOfMessagesLastDay = 'numberOfMessagesLastDay',
    /** column name */
    NumberOfMessagesLastWeek = 'numberOfMessagesLastWeek',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    Topics = 'topics',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserContactAddedAt = 'userContactAddedAt',
    /** column name */
    UserContactFromOnboarding = 'userContactFromOnboarding',
    /** column name */
    UserContactId = 'userContactId',
    /** column name */
    UserId = 'userId',
    /** column name */
    YouThemMessageRatio = 'youThemMessageRatio',
}

export type ConversationMetaData_Updates = {
    /** increments the numeric columns with given value of the filtered values */
    _inc?: InputMaybe<ConversationMetaData_Inc_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<ConversationMetaData_Set_Input>;
    /** filter the rows which have to be updated */
    where: ConversationMetaData_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ConversationMetaData_Var_Pop_Fields = {
    __typename?: 'ConversationMetaData_var_pop_fields';
    lastTimeToAnswer?: Maybe<Scalars['Float']['output']>;
    medianMessageLength?: Maybe<Scalars['Float']['output']>;
    messagesPerDay?: Maybe<Scalars['Float']['output']>;
    numberOfMessages?: Maybe<Scalars['Float']['output']>;
    numberOfMessagesLastDay?: Maybe<Scalars['Float']['output']>;
    numberOfMessagesLastWeek?: Maybe<Scalars['Float']['output']>;
    youThemMessageRatio?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ConversationMetaData_Var_Samp_Fields = {
    __typename?: 'ConversationMetaData_var_samp_fields';
    lastTimeToAnswer?: Maybe<Scalars['Float']['output']>;
    medianMessageLength?: Maybe<Scalars['Float']['output']>;
    messagesPerDay?: Maybe<Scalars['Float']['output']>;
    numberOfMessages?: Maybe<Scalars['Float']['output']>;
    numberOfMessagesLastDay?: Maybe<Scalars['Float']['output']>;
    numberOfMessagesLastWeek?: Maybe<Scalars['Float']['output']>;
    youThemMessageRatio?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ConversationMetaData_Variance_Fields = {
    __typename?: 'ConversationMetaData_variance_fields';
    lastTimeToAnswer?: Maybe<Scalars['Float']['output']>;
    medianMessageLength?: Maybe<Scalars['Float']['output']>;
    messagesPerDay?: Maybe<Scalars['Float']['output']>;
    numberOfMessages?: Maybe<Scalars['Float']['output']>;
    numberOfMessagesLastDay?: Maybe<Scalars['Float']['output']>;
    numberOfMessagesLastWeek?: Maybe<Scalars['Float']['output']>;
    youThemMessageRatio?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "Conversations" */
export type Conversations = {
    __typename?: 'Conversations';
    /** An object relationship */
    Contact?: Maybe<Contacts>;
    /** An array relationship */
    Messages: Array<Messages>;
    /** An aggregate relationship */
    Messages_aggregate: Messages_Aggregate;
    contactId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['timestamp']['output'];
    id: Scalars['String']['output'];
    metadata: Scalars['jsonb']['output'];
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    organizationId: Scalars['String']['output'];
    prospectId: Scalars['String']['output'];
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
};

/** columns and relationships of "Conversations" */
export type ConversationsMessagesArgs = {
    distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Messages_Order_By>>;
    where?: InputMaybe<Messages_Bool_Exp>;
};

/** columns and relationships of "Conversations" */
export type ConversationsMessages_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Messages_Order_By>>;
    where?: InputMaybe<Messages_Bool_Exp>;
};

/** columns and relationships of "Conversations" */
export type ConversationsMetadataArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Conversations" */
export type Conversations_Aggregate = {
    __typename?: 'Conversations_aggregate';
    aggregate?: Maybe<Conversations_Aggregate_Fields>;
    nodes: Array<Conversations>;
};

export type Conversations_Aggregate_Bool_Exp = {
    count?: InputMaybe<Conversations_Aggregate_Bool_Exp_Count>;
};

export type Conversations_Aggregate_Bool_Exp_Count = {
    arguments?: InputMaybe<Array<Conversations_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Conversations_Bool_Exp>;
    predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Conversations" */
export type Conversations_Aggregate_Fields = {
    __typename?: 'Conversations_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<Conversations_Max_Fields>;
    min?: Maybe<Conversations_Min_Fields>;
};

/** aggregate fields of "Conversations" */
export type Conversations_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<Conversations_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Conversations" */
export type Conversations_Aggregate_Order_By = {
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<Conversations_Max_Order_By>;
    min?: InputMaybe<Conversations_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Conversations_Append_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "Conversations" */
export type Conversations_Arr_Rel_Insert_Input = {
    data: Array<Conversations_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<Conversations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Conversations". All fields are combined with a logical 'AND'. */
export type Conversations_Bool_Exp = {
    Contact?: InputMaybe<Contacts_Bool_Exp>;
    Messages?: InputMaybe<Messages_Bool_Exp>;
    Messages_aggregate?: InputMaybe<Messages_Aggregate_Bool_Exp>;
    _and?: InputMaybe<Array<Conversations_Bool_Exp>>;
    _not?: InputMaybe<Conversations_Bool_Exp>;
    _or?: InputMaybe<Array<Conversations_Bool_Exp>>;
    contactId?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    metadata?: InputMaybe<Jsonb_Comparison_Exp>;
    metadataLastUpdatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    prospectId?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Conversations" */
export enum Conversations_Constraint {
    /** unique or primary key constraint on columns "id" */
    ConversationsPkey = 'Conversations_pkey',
    /** unique or primary key constraint on columns "userId", "prospectId" */
    ConversationsUserIdProspectIdKey = 'Conversations_userId_prospectId_key',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Conversations_Delete_At_Path_Input = {
    metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Conversations_Delete_Elem_Input = {
    metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Conversations_Delete_Key_Input = {
    metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "Conversations" */
export type Conversations_Insert_Input = {
    Contact?: InputMaybe<Contacts_Obj_Rel_Insert_Input>;
    Messages?: InputMaybe<Messages_Arr_Rel_Insert_Input>;
    contactId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Conversations_Max_Fields = {
    __typename?: 'Conversations_max_fields';
    contactId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "Conversations" */
export type Conversations_Max_Order_By = {
    contactId?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    metadataLastUpdatedAt?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Conversations_Min_Fields = {
    __typename?: 'Conversations_min_fields';
    contactId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "Conversations" */
export type Conversations_Min_Order_By = {
    contactId?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    metadataLastUpdatedAt?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Conversations" */
export type Conversations_Mutation_Response = {
    __typename?: 'Conversations_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Conversations>;
};

/** input type for inserting object relation for remote table "Conversations" */
export type Conversations_Obj_Rel_Insert_Input = {
    data: Conversations_Insert_Input;
    /** upsert condition */
    on_conflict?: InputMaybe<Conversations_On_Conflict>;
};

/** on_conflict condition type for table "Conversations" */
export type Conversations_On_Conflict = {
    constraint: Conversations_Constraint;
    update_columns?: Array<Conversations_Update_Column>;
    where?: InputMaybe<Conversations_Bool_Exp>;
};

/** Ordering options when selecting data from "Conversations". */
export type Conversations_Order_By = {
    Contact?: InputMaybe<Contacts_Order_By>;
    Messages_aggregate?: InputMaybe<Messages_Aggregate_Order_By>;
    contactId?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    metadata?: InputMaybe<Order_By>;
    metadataLastUpdatedAt?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Conversations */
export type Conversations_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Conversations_Prepend_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "Conversations" */
export enum Conversations_Select_Column {
    /** column name */
    ContactId = 'contactId',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    MetadataLastUpdatedAt = 'metadataLastUpdatedAt',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

/** input type for updating data in table "Conversations" */
export type Conversations_Set_Input = {
    contactId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "Conversations" */
export type Conversations_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: Conversations_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Conversations_Stream_Cursor_Value_Input = {
    contactId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "Conversations" */
export enum Conversations_Update_Column {
    /** column name */
    ContactId = 'contactId',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    MetadataLastUpdatedAt = 'metadataLastUpdatedAt',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

export type Conversations_Updates = {
    /** append existing jsonb value of filtered columns with new jsonb value */
    _append?: InputMaybe<Conversations_Append_Input>;
    /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
    _delete_at_path?: InputMaybe<Conversations_Delete_At_Path_Input>;
    /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
    _delete_elem?: InputMaybe<Conversations_Delete_Elem_Input>;
    /** delete key/value pair or string element. key/value pairs are matched based on their key value */
    _delete_key?: InputMaybe<Conversations_Delete_Key_Input>;
    /** prepend existing jsonb value of filtered columns with new jsonb value */
    _prepend?: InputMaybe<Conversations_Prepend_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<Conversations_Set_Input>;
    /** filter the rows which have to be updated */
    where: Conversations_Bool_Exp;
};

/** Boolean expression to compare columns of type "Creator". All fields are combined with logical 'AND'. */
export type Creator_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['Creator']['input']>;
    _gt?: InputMaybe<Scalars['Creator']['input']>;
    _gte?: InputMaybe<Scalars['Creator']['input']>;
    _in?: InputMaybe<Array<Scalars['Creator']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['Creator']['input']>;
    _lte?: InputMaybe<Scalars['Creator']['input']>;
    _neq?: InputMaybe<Scalars['Creator']['input']>;
    _nin?: InputMaybe<Array<Scalars['Creator']['input']>>;
};

/** Boolean expression to compare columns of type "DeliveryStatus". All fields are combined with logical 'AND'. */
export type DeliveryStatus_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['DeliveryStatus']['input']>;
    _gt?: InputMaybe<Scalars['DeliveryStatus']['input']>;
    _gte?: InputMaybe<Scalars['DeliveryStatus']['input']>;
    _in?: InputMaybe<Array<Scalars['DeliveryStatus']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['DeliveryStatus']['input']>;
    _lte?: InputMaybe<Scalars['DeliveryStatus']['input']>;
    _neq?: InputMaybe<Scalars['DeliveryStatus']['input']>;
    _nin?: InputMaybe<Array<Scalars['DeliveryStatus']['input']>>;
};

/** columns and relationships of "Groups" */
export type Groups = {
    __typename?: 'Groups';
    /** An object relationship */
    AssistantSetting: AssistantSettings;
    /** An array relationship */
    _GroupToContacts: Array<_GroupToContact>;
    /** An aggregate relationship */
    _GroupToContacts_aggregate: _GroupToContact_Aggregate;
    /** An array relationship */
    _GroupToUserContacts: Array<_GroupToUserContact>;
    /** An aggregate relationship */
    _GroupToUserContacts_aggregate: _GroupToUserContact_Aggregate;
    assistantSettingsId: Scalars['String']['output'];
    createdAt: Scalars['timestamp']['output'];
    default: Scalars['Boolean']['output'];
    id: Scalars['String']['output'];
    imgSrc?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
};

/** columns and relationships of "Groups" */
export type Groups_GroupToContactsArgs = {
    distinct_on?: InputMaybe<Array<_GroupToContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToContact_Order_By>>;
    where?: InputMaybe<_GroupToContact_Bool_Exp>;
};

/** columns and relationships of "Groups" */
export type Groups_GroupToContacts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<_GroupToContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToContact_Order_By>>;
    where?: InputMaybe<_GroupToContact_Bool_Exp>;
};

/** columns and relationships of "Groups" */
export type Groups_GroupToUserContactsArgs = {
    distinct_on?: InputMaybe<Array<_GroupToUserContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToUserContact_Order_By>>;
    where?: InputMaybe<_GroupToUserContact_Bool_Exp>;
};

/** columns and relationships of "Groups" */
export type Groups_GroupToUserContacts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<_GroupToUserContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToUserContact_Order_By>>;
    where?: InputMaybe<_GroupToUserContact_Bool_Exp>;
};

/** aggregated selection of "Groups" */
export type Groups_Aggregate = {
    __typename?: 'Groups_aggregate';
    aggregate?: Maybe<Groups_Aggregate_Fields>;
    nodes: Array<Groups>;
};

export type Groups_Aggregate_Bool_Exp = {
    bool_and?: InputMaybe<Groups_Aggregate_Bool_Exp_Bool_And>;
    bool_or?: InputMaybe<Groups_Aggregate_Bool_Exp_Bool_Or>;
    count?: InputMaybe<Groups_Aggregate_Bool_Exp_Count>;
};

export type Groups_Aggregate_Bool_Exp_Bool_And = {
    arguments: Groups_Select_Column_Groups_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Groups_Bool_Exp>;
    predicate: Boolean_Comparison_Exp;
};

export type Groups_Aggregate_Bool_Exp_Bool_Or = {
    arguments: Groups_Select_Column_Groups_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Groups_Bool_Exp>;
    predicate: Boolean_Comparison_Exp;
};

export type Groups_Aggregate_Bool_Exp_Count = {
    arguments?: InputMaybe<Array<Groups_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Groups_Bool_Exp>;
    predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Groups" */
export type Groups_Aggregate_Fields = {
    __typename?: 'Groups_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<Groups_Max_Fields>;
    min?: Maybe<Groups_Min_Fields>;
};

/** aggregate fields of "Groups" */
export type Groups_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<Groups_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Groups" */
export type Groups_Aggregate_Order_By = {
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<Groups_Max_Order_By>;
    min?: InputMaybe<Groups_Min_Order_By>;
};

/** input type for inserting array relation for remote table "Groups" */
export type Groups_Arr_Rel_Insert_Input = {
    data: Array<Groups_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<Groups_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Groups". All fields are combined with a logical 'AND'. */
export type Groups_Bool_Exp = {
    AssistantSetting?: InputMaybe<AssistantSettings_Bool_Exp>;
    _GroupToContacts?: InputMaybe<_GroupToContact_Bool_Exp>;
    _GroupToContacts_aggregate?: InputMaybe<_GroupToContact_Aggregate_Bool_Exp>;
    _GroupToUserContacts?: InputMaybe<_GroupToUserContact_Bool_Exp>;
    _GroupToUserContacts_aggregate?: InputMaybe<_GroupToUserContact_Aggregate_Bool_Exp>;
    _and?: InputMaybe<Array<Groups_Bool_Exp>>;
    _not?: InputMaybe<Groups_Bool_Exp>;
    _or?: InputMaybe<Array<Groups_Bool_Exp>>;
    assistantSettingsId?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    default?: InputMaybe<Boolean_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    imgSrc?: InputMaybe<String_Comparison_Exp>;
    name?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Groups" */
export enum Groups_Constraint {
    /** unique or primary key constraint on columns "userId", "name" */
    GroupsNameUserIdKey = 'Groups_name_userId_key',
    /** unique or primary key constraint on columns "id" */
    GroupsPkey = 'Groups_pkey',
}

/** input type for inserting data into table "Groups" */
export type Groups_Insert_Input = {
    AssistantSetting?: InputMaybe<AssistantSettings_Obj_Rel_Insert_Input>;
    _GroupToContacts?: InputMaybe<_GroupToContact_Arr_Rel_Insert_Input>;
    _GroupToUserContacts?: InputMaybe<_GroupToUserContact_Arr_Rel_Insert_Input>;
    assistantSettingsId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    default?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    imgSrc?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Groups_Max_Fields = {
    __typename?: 'Groups_max_fields';
    assistantSettingsId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    imgSrc?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "Groups" */
export type Groups_Max_Order_By = {
    assistantSettingsId?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    imgSrc?: InputMaybe<Order_By>;
    name?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Groups_Min_Fields = {
    __typename?: 'Groups_min_fields';
    assistantSettingsId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    imgSrc?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "Groups" */
export type Groups_Min_Order_By = {
    assistantSettingsId?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    imgSrc?: InputMaybe<Order_By>;
    name?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Groups" */
export type Groups_Mutation_Response = {
    __typename?: 'Groups_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Groups>;
};

/** input type for inserting object relation for remote table "Groups" */
export type Groups_Obj_Rel_Insert_Input = {
    data: Groups_Insert_Input;
    /** upsert condition */
    on_conflict?: InputMaybe<Groups_On_Conflict>;
};

/** on_conflict condition type for table "Groups" */
export type Groups_On_Conflict = {
    constraint: Groups_Constraint;
    update_columns?: Array<Groups_Update_Column>;
    where?: InputMaybe<Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "Groups". */
export type Groups_Order_By = {
    AssistantSetting?: InputMaybe<AssistantSettings_Order_By>;
    _GroupToContacts_aggregate?: InputMaybe<_GroupToContact_Aggregate_Order_By>;
    _GroupToUserContacts_aggregate?: InputMaybe<_GroupToUserContact_Aggregate_Order_By>;
    assistantSettingsId?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    default?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    imgSrc?: InputMaybe<Order_By>;
    name?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Groups */
export type Groups_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** select columns of table "Groups" */
export enum Groups_Select_Column {
    /** column name */
    AssistantSettingsId = 'assistantSettingsId',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Default = 'default',
    /** column name */
    Id = 'id',
    /** column name */
    ImgSrc = 'imgSrc',
    /** column name */
    Name = 'name',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

/** select "Groups_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Groups" */
export enum Groups_Select_Column_Groups_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
    /** column name */
    Default = 'default',
}

/** select "Groups_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Groups" */
export enum Groups_Select_Column_Groups_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
    /** column name */
    Default = 'default',
}

/** input type for updating data in table "Groups" */
export type Groups_Set_Input = {
    assistantSettingsId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    default?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    imgSrc?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "Groups" */
export type Groups_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: Groups_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Groups_Stream_Cursor_Value_Input = {
    assistantSettingsId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    default?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    imgSrc?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "Groups" */
export enum Groups_Update_Column {
    /** column name */
    AssistantSettingsId = 'assistantSettingsId',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Default = 'default',
    /** column name */
    Id = 'id',
    /** column name */
    ImgSrc = 'imgSrc',
    /** column name */
    Name = 'name',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

export type Groups_Updates = {
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<Groups_Set_Input>;
    /** filter the rows which have to be updated */
    where: Groups_Bool_Exp;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['Int']['input']>;
    _gt?: InputMaybe<Scalars['Int']['input']>;
    _gte?: InputMaybe<Scalars['Int']['input']>;
    _in?: InputMaybe<Array<Scalars['Int']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['Int']['input']>;
    _lte?: InputMaybe<Scalars['Int']['input']>;
    _neq?: InputMaybe<Scalars['Int']['input']>;
    _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "JobStatus". All fields are combined with logical 'AND'. */
export type JobStatus_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['JobStatus']['input']>;
    _gt?: InputMaybe<Scalars['JobStatus']['input']>;
    _gte?: InputMaybe<Scalars['JobStatus']['input']>;
    _in?: InputMaybe<Array<Scalars['JobStatus']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['JobStatus']['input']>;
    _lte?: InputMaybe<Scalars['JobStatus']['input']>;
    _neq?: InputMaybe<Scalars['JobStatus']['input']>;
    _nin?: InputMaybe<Array<Scalars['JobStatus']['input']>>;
};

/** columns and relationships of "Jobs" */
export type Jobs = {
    __typename?: 'Jobs';
    /** An object relationship */
    Job?: Maybe<Jobs>;
    /** An array relationship */
    Jobs: Array<Jobs>;
    /** An aggregate relationship */
    Jobs_aggregate: Jobs_Aggregate;
    arguments?: Maybe<Scalars['jsonb']['output']>;
    className?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['timestamp']['output'];
    endTime?: Maybe<Scalars['timestamp']['output']>;
    id: Scalars['String']['output'];
    jid?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    parentJobId?: Maybe<Scalars['String']['output']>;
    startTime?: Maybe<Scalars['timestamp']['output']>;
    status: Scalars['JobStatus']['output'];
    statusText?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['timestamp']['output'];
    userId?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "Jobs" */
export type JobsJobsArgs = {
    distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Jobs_Order_By>>;
    where?: InputMaybe<Jobs_Bool_Exp>;
};

/** columns and relationships of "Jobs" */
export type JobsJobs_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Jobs_Order_By>>;
    where?: InputMaybe<Jobs_Bool_Exp>;
};

/** columns and relationships of "Jobs" */
export type JobsArgumentsArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Jobs" */
export type Jobs_Aggregate = {
    __typename?: 'Jobs_aggregate';
    aggregate?: Maybe<Jobs_Aggregate_Fields>;
    nodes: Array<Jobs>;
};

export type Jobs_Aggregate_Bool_Exp = {
    count?: InputMaybe<Jobs_Aggregate_Bool_Exp_Count>;
};

export type Jobs_Aggregate_Bool_Exp_Count = {
    arguments?: InputMaybe<Array<Jobs_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Jobs_Bool_Exp>;
    predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Jobs" */
export type Jobs_Aggregate_Fields = {
    __typename?: 'Jobs_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<Jobs_Max_Fields>;
    min?: Maybe<Jobs_Min_Fields>;
};

/** aggregate fields of "Jobs" */
export type Jobs_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<Jobs_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Jobs" */
export type Jobs_Aggregate_Order_By = {
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<Jobs_Max_Order_By>;
    min?: InputMaybe<Jobs_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Jobs_Append_Input = {
    arguments?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "Jobs" */
export type Jobs_Arr_Rel_Insert_Input = {
    data: Array<Jobs_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<Jobs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Jobs". All fields are combined with a logical 'AND'. */
export type Jobs_Bool_Exp = {
    Job?: InputMaybe<Jobs_Bool_Exp>;
    Jobs?: InputMaybe<Jobs_Bool_Exp>;
    Jobs_aggregate?: InputMaybe<Jobs_Aggregate_Bool_Exp>;
    _and?: InputMaybe<Array<Jobs_Bool_Exp>>;
    _not?: InputMaybe<Jobs_Bool_Exp>;
    _or?: InputMaybe<Array<Jobs_Bool_Exp>>;
    arguments?: InputMaybe<Jsonb_Comparison_Exp>;
    className?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    endTime?: InputMaybe<Timestamp_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    jid?: InputMaybe<String_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    parentJobId?: InputMaybe<String_Comparison_Exp>;
    startTime?: InputMaybe<Timestamp_Comparison_Exp>;
    status?: InputMaybe<JobStatus_Comparison_Exp>;
    statusText?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Jobs" */
export enum Jobs_Constraint {
    /** unique or primary key constraint on columns "id" */
    JobsPkey = 'Jobs_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Jobs_Delete_At_Path_Input = {
    arguments?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Jobs_Delete_Elem_Input = {
    arguments?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Jobs_Delete_Key_Input = {
    arguments?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "Jobs" */
export type Jobs_Insert_Input = {
    Job?: InputMaybe<Jobs_Obj_Rel_Insert_Input>;
    Jobs?: InputMaybe<Jobs_Arr_Rel_Insert_Input>;
    arguments?: InputMaybe<Scalars['jsonb']['input']>;
    className?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    endTime?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    jid?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    parentJobId?: InputMaybe<Scalars['String']['input']>;
    startTime?: InputMaybe<Scalars['timestamp']['input']>;
    status?: InputMaybe<Scalars['JobStatus']['input']>;
    statusText?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Jobs_Max_Fields = {
    __typename?: 'Jobs_max_fields';
    className?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    endTime?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    jid?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    parentJobId?: Maybe<Scalars['String']['output']>;
    startTime?: Maybe<Scalars['timestamp']['output']>;
    status?: Maybe<Scalars['JobStatus']['output']>;
    statusText?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "Jobs" */
export type Jobs_Max_Order_By = {
    className?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    endTime?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    jid?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    parentJobId?: InputMaybe<Order_By>;
    startTime?: InputMaybe<Order_By>;
    status?: InputMaybe<Order_By>;
    statusText?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Jobs_Min_Fields = {
    __typename?: 'Jobs_min_fields';
    className?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    endTime?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    jid?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    parentJobId?: Maybe<Scalars['String']['output']>;
    startTime?: Maybe<Scalars['timestamp']['output']>;
    status?: Maybe<Scalars['JobStatus']['output']>;
    statusText?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "Jobs" */
export type Jobs_Min_Order_By = {
    className?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    endTime?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    jid?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    parentJobId?: InputMaybe<Order_By>;
    startTime?: InputMaybe<Order_By>;
    status?: InputMaybe<Order_By>;
    statusText?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Jobs" */
export type Jobs_Mutation_Response = {
    __typename?: 'Jobs_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Jobs>;
};

/** input type for inserting object relation for remote table "Jobs" */
export type Jobs_Obj_Rel_Insert_Input = {
    data: Jobs_Insert_Input;
    /** upsert condition */
    on_conflict?: InputMaybe<Jobs_On_Conflict>;
};

/** on_conflict condition type for table "Jobs" */
export type Jobs_On_Conflict = {
    constraint: Jobs_Constraint;
    update_columns?: Array<Jobs_Update_Column>;
    where?: InputMaybe<Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "Jobs". */
export type Jobs_Order_By = {
    Job?: InputMaybe<Jobs_Order_By>;
    Jobs_aggregate?: InputMaybe<Jobs_Aggregate_Order_By>;
    arguments?: InputMaybe<Order_By>;
    className?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    endTime?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    jid?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    parentJobId?: InputMaybe<Order_By>;
    startTime?: InputMaybe<Order_By>;
    status?: InputMaybe<Order_By>;
    statusText?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Jobs */
export type Jobs_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Jobs_Prepend_Input = {
    arguments?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "Jobs" */
export enum Jobs_Select_Column {
    /** column name */
    Arguments = 'arguments',
    /** column name */
    ClassName = 'className',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    EndTime = 'endTime',
    /** column name */
    Id = 'id',
    /** column name */
    Jid = 'jid',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    ParentJobId = 'parentJobId',
    /** column name */
    StartTime = 'startTime',
    /** column name */
    Status = 'status',
    /** column name */
    StatusText = 'statusText',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

/** input type for updating data in table "Jobs" */
export type Jobs_Set_Input = {
    arguments?: InputMaybe<Scalars['jsonb']['input']>;
    className?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    endTime?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    jid?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    parentJobId?: InputMaybe<Scalars['String']['input']>;
    startTime?: InputMaybe<Scalars['timestamp']['input']>;
    status?: InputMaybe<Scalars['JobStatus']['input']>;
    statusText?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "Jobs" */
export type Jobs_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: Jobs_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Jobs_Stream_Cursor_Value_Input = {
    arguments?: InputMaybe<Scalars['jsonb']['input']>;
    className?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    endTime?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    jid?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    parentJobId?: InputMaybe<Scalars['String']['input']>;
    startTime?: InputMaybe<Scalars['timestamp']['input']>;
    status?: InputMaybe<Scalars['JobStatus']['input']>;
    statusText?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "Jobs" */
export enum Jobs_Update_Column {
    /** column name */
    Arguments = 'arguments',
    /** column name */
    ClassName = 'className',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    EndTime = 'endTime',
    /** column name */
    Id = 'id',
    /** column name */
    Jid = 'jid',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    ParentJobId = 'parentJobId',
    /** column name */
    StartTime = 'startTime',
    /** column name */
    Status = 'status',
    /** column name */
    StatusText = 'statusText',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

export type Jobs_Updates = {
    /** append existing jsonb value of filtered columns with new jsonb value */
    _append?: InputMaybe<Jobs_Append_Input>;
    /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
    _delete_at_path?: InputMaybe<Jobs_Delete_At_Path_Input>;
    /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
    _delete_elem?: InputMaybe<Jobs_Delete_Elem_Input>;
    /** delete key/value pair or string element. key/value pairs are matched based on their key value */
    _delete_key?: InputMaybe<Jobs_Delete_Key_Input>;
    /** prepend existing jsonb value of filtered columns with new jsonb value */
    _prepend?: InputMaybe<Jobs_Prepend_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<Jobs_Set_Input>;
    /** filter the rows which have to be updated */
    where: Jobs_Bool_Exp;
};

/** Boolean expression to compare columns of type "LinkedinConnectionStatus". All fields are combined with logical 'AND'. */
export type LinkedinConnectionStatus_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['LinkedinConnectionStatus']['input']>;
    _gt?: InputMaybe<Scalars['LinkedinConnectionStatus']['input']>;
    _gte?: InputMaybe<Scalars['LinkedinConnectionStatus']['input']>;
    _in?: InputMaybe<Array<Scalars['LinkedinConnectionStatus']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['LinkedinConnectionStatus']['input']>;
    _lte?: InputMaybe<Scalars['LinkedinConnectionStatus']['input']>;
    _neq?: InputMaybe<Scalars['LinkedinConnectionStatus']['input']>;
    _nin?: InputMaybe<Array<Scalars['LinkedinConnectionStatus']['input']>>;
};

/** columns and relationships of "LinkedinConversations" */
export type LinkedinConversations = {
    __typename?: 'LinkedinConversations';
    /** An array relationship */
    Message: Array<Messages>;
    /** An aggregate relationship */
    Message_aggregate: Messages_Aggregate;
    categories?: Maybe<Array<Scalars['String']['output']>>;
    channelAccountId: Scalars['String']['output'];
    conversationId: Scalars['String']['output'];
    createdAt: Scalars['timestamp']['output'];
    groupChat?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['String']['output'];
    lastMessageSentAt?: Maybe<Scalars['timestamp']['output']>;
    lastMessageSentDirection?: Maybe<Scalars['String']['output']>;
    lastMessageText?: Maybe<Scalars['String']['output']>;
    lastMessageType?: Maybe<Scalars['MessageType']['output']>;
    metadata?: Maybe<Scalars['jsonb']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    organizationId: Scalars['String']['output'];
    participantMemberIds?: Maybe<Array<Scalars['String']['output']>>;
    prospectId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
};

/** columns and relationships of "LinkedinConversations" */
export type LinkedinConversationsMessageArgs = {
    distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Messages_Order_By>>;
    where?: InputMaybe<Messages_Bool_Exp>;
};

/** columns and relationships of "LinkedinConversations" */
export type LinkedinConversationsMessage_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Messages_Order_By>>;
    where?: InputMaybe<Messages_Bool_Exp>;
};

/** columns and relationships of "LinkedinConversations" */
export type LinkedinConversationsMetadataArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "LinkedinConversations" */
export type LinkedinConversations_Aggregate = {
    __typename?: 'LinkedinConversations_aggregate';
    aggregate?: Maybe<LinkedinConversations_Aggregate_Fields>;
    nodes: Array<LinkedinConversations>;
};

/** aggregate fields of "LinkedinConversations" */
export type LinkedinConversations_Aggregate_Fields = {
    __typename?: 'LinkedinConversations_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<LinkedinConversations_Max_Fields>;
    min?: Maybe<LinkedinConversations_Min_Fields>;
};

/** aggregate fields of "LinkedinConversations" */
export type LinkedinConversations_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<LinkedinConversations_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type LinkedinConversations_Append_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "LinkedinConversations". All fields are combined with a logical 'AND'. */
export type LinkedinConversations_Bool_Exp = {
    Message?: InputMaybe<Messages_Bool_Exp>;
    Message_aggregate?: InputMaybe<Messages_Aggregate_Bool_Exp>;
    _and?: InputMaybe<Array<LinkedinConversations_Bool_Exp>>;
    _not?: InputMaybe<LinkedinConversations_Bool_Exp>;
    _or?: InputMaybe<Array<LinkedinConversations_Bool_Exp>>;
    categories?: InputMaybe<String_Array_Comparison_Exp>;
    channelAccountId?: InputMaybe<String_Comparison_Exp>;
    conversationId?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    groupChat?: InputMaybe<Boolean_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    lastMessageSentAt?: InputMaybe<Timestamp_Comparison_Exp>;
    lastMessageSentDirection?: InputMaybe<String_Comparison_Exp>;
    lastMessageText?: InputMaybe<String_Comparison_Exp>;
    lastMessageType?: InputMaybe<MessageType_Comparison_Exp>;
    metadata?: InputMaybe<Jsonb_Comparison_Exp>;
    metadataLastUpdatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    participantMemberIds?: InputMaybe<String_Array_Comparison_Exp>;
    prospectId?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "LinkedinConversations" */
export enum LinkedinConversations_Constraint {
    /** unique or primary key constraint on columns "userId", "conversationId" */
    LinkedinConversationsConversationIdUserIdKey = 'LinkedinConversations_conversationId_userId_key',
    /** unique or primary key constraint on columns "id" */
    LinkedinConversationsPkey = 'LinkedinConversations_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type LinkedinConversations_Delete_At_Path_Input = {
    metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type LinkedinConversations_Delete_Elem_Input = {
    metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type LinkedinConversations_Delete_Key_Input = {
    metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "LinkedinConversations" */
export type LinkedinConversations_Insert_Input = {
    Message?: InputMaybe<Messages_Arr_Rel_Insert_Input>;
    categories?: InputMaybe<Array<Scalars['String']['input']>>;
    channelAccountId?: InputMaybe<Scalars['String']['input']>;
    conversationId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    groupChat?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastMessageSentAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastMessageSentDirection?: InputMaybe<Scalars['String']['input']>;
    lastMessageText?: InputMaybe<Scalars['String']['input']>;
    lastMessageType?: InputMaybe<Scalars['MessageType']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    participantMemberIds?: InputMaybe<Array<Scalars['String']['input']>>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type LinkedinConversations_Max_Fields = {
    __typename?: 'LinkedinConversations_max_fields';
    categories?: Maybe<Array<Scalars['String']['output']>>;
    channelAccountId?: Maybe<Scalars['String']['output']>;
    conversationId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastMessageSentAt?: Maybe<Scalars['timestamp']['output']>;
    lastMessageSentDirection?: Maybe<Scalars['String']['output']>;
    lastMessageText?: Maybe<Scalars['String']['output']>;
    lastMessageType?: Maybe<Scalars['MessageType']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    participantMemberIds?: Maybe<Array<Scalars['String']['output']>>;
    prospectId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type LinkedinConversations_Min_Fields = {
    __typename?: 'LinkedinConversations_min_fields';
    categories?: Maybe<Array<Scalars['String']['output']>>;
    channelAccountId?: Maybe<Scalars['String']['output']>;
    conversationId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastMessageSentAt?: Maybe<Scalars['timestamp']['output']>;
    lastMessageSentDirection?: Maybe<Scalars['String']['output']>;
    lastMessageText?: Maybe<Scalars['String']['output']>;
    lastMessageType?: Maybe<Scalars['MessageType']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    participantMemberIds?: Maybe<Array<Scalars['String']['output']>>;
    prospectId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "LinkedinConversations" */
export type LinkedinConversations_Mutation_Response = {
    __typename?: 'LinkedinConversations_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<LinkedinConversations>;
};

/** input type for inserting object relation for remote table "LinkedinConversations" */
export type LinkedinConversations_Obj_Rel_Insert_Input = {
    data: LinkedinConversations_Insert_Input;
    /** upsert condition */
    on_conflict?: InputMaybe<LinkedinConversations_On_Conflict>;
};

/** on_conflict condition type for table "LinkedinConversations" */
export type LinkedinConversations_On_Conflict = {
    constraint: LinkedinConversations_Constraint;
    update_columns?: Array<LinkedinConversations_Update_Column>;
    where?: InputMaybe<LinkedinConversations_Bool_Exp>;
};

/** Ordering options when selecting data from "LinkedinConversations". */
export type LinkedinConversations_Order_By = {
    Message_aggregate?: InputMaybe<Messages_Aggregate_Order_By>;
    categories?: InputMaybe<Order_By>;
    channelAccountId?: InputMaybe<Order_By>;
    conversationId?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    groupChat?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    lastMessageSentAt?: InputMaybe<Order_By>;
    lastMessageSentDirection?: InputMaybe<Order_By>;
    lastMessageText?: InputMaybe<Order_By>;
    lastMessageType?: InputMaybe<Order_By>;
    metadata?: InputMaybe<Order_By>;
    metadataLastUpdatedAt?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    participantMemberIds?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: LinkedinConversations */
export type LinkedinConversations_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type LinkedinConversations_Prepend_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "LinkedinConversations" */
export enum LinkedinConversations_Select_Column {
    /** column name */
    Categories = 'categories',
    /** column name */
    ChannelAccountId = 'channelAccountId',
    /** column name */
    ConversationId = 'conversationId',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    GroupChat = 'groupChat',
    /** column name */
    Id = 'id',
    /** column name */
    LastMessageSentAt = 'lastMessageSentAt',
    /** column name */
    LastMessageSentDirection = 'lastMessageSentDirection',
    /** column name */
    LastMessageText = 'lastMessageText',
    /** column name */
    LastMessageType = 'lastMessageType',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    MetadataLastUpdatedAt = 'metadataLastUpdatedAt',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    ParticipantMemberIds = 'participantMemberIds',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

/** input type for updating data in table "LinkedinConversations" */
export type LinkedinConversations_Set_Input = {
    categories?: InputMaybe<Array<Scalars['String']['input']>>;
    channelAccountId?: InputMaybe<Scalars['String']['input']>;
    conversationId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    groupChat?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastMessageSentAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastMessageSentDirection?: InputMaybe<Scalars['String']['input']>;
    lastMessageText?: InputMaybe<Scalars['String']['input']>;
    lastMessageType?: InputMaybe<Scalars['MessageType']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    participantMemberIds?: InputMaybe<Array<Scalars['String']['input']>>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "LinkedinConversations" */
export type LinkedinConversations_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: LinkedinConversations_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type LinkedinConversations_Stream_Cursor_Value_Input = {
    categories?: InputMaybe<Array<Scalars['String']['input']>>;
    channelAccountId?: InputMaybe<Scalars['String']['input']>;
    conversationId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    groupChat?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastMessageSentAt?: InputMaybe<Scalars['timestamp']['input']>;
    lastMessageSentDirection?: InputMaybe<Scalars['String']['input']>;
    lastMessageText?: InputMaybe<Scalars['String']['input']>;
    lastMessageType?: InputMaybe<Scalars['MessageType']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    participantMemberIds?: InputMaybe<Array<Scalars['String']['input']>>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "LinkedinConversations" */
export enum LinkedinConversations_Update_Column {
    /** column name */
    Categories = 'categories',
    /** column name */
    ChannelAccountId = 'channelAccountId',
    /** column name */
    ConversationId = 'conversationId',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    GroupChat = 'groupChat',
    /** column name */
    Id = 'id',
    /** column name */
    LastMessageSentAt = 'lastMessageSentAt',
    /** column name */
    LastMessageSentDirection = 'lastMessageSentDirection',
    /** column name */
    LastMessageText = 'lastMessageText',
    /** column name */
    LastMessageType = 'lastMessageType',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    MetadataLastUpdatedAt = 'metadataLastUpdatedAt',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    ParticipantMemberIds = 'participantMemberIds',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

export type LinkedinConversations_Updates = {
    /** append existing jsonb value of filtered columns with new jsonb value */
    _append?: InputMaybe<LinkedinConversations_Append_Input>;
    /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
    _delete_at_path?: InputMaybe<LinkedinConversations_Delete_At_Path_Input>;
    /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
    _delete_elem?: InputMaybe<LinkedinConversations_Delete_Elem_Input>;
    /** delete key/value pair or string element. key/value pairs are matched based on their key value */
    _delete_key?: InputMaybe<LinkedinConversations_Delete_Key_Input>;
    /** prepend existing jsonb value of filtered columns with new jsonb value */
    _prepend?: InputMaybe<LinkedinConversations_Prepend_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<LinkedinConversations_Set_Input>;
    /** filter the rows which have to be updated */
    where: LinkedinConversations_Bool_Exp;
};

/** columns and relationships of "MessageDrafts" */
export type MessageDrafts = {
    __typename?: 'MessageDrafts';
    /** An object relationship */
    Contact: Contacts;
    archivedAt?: Maybe<Scalars['timestamp']['output']>;
    channelType: Scalars['ChannelType']['output'];
    contactId: Scalars['String']['output'];
    content: Scalars['String']['output'];
    createdAt: Scalars['timestamp']['output'];
    id: Scalars['String']['output'];
    organizationId: Scalars['String']['output'];
    prospectId?: Maybe<Scalars['String']['output']>;
    source: Scalars['String']['output'];
    subjectLine: Scalars['String']['output'];
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
    userPrompt: Scalars['String']['output'];
};

/** aggregated selection of "MessageDrafts" */
export type MessageDrafts_Aggregate = {
    __typename?: 'MessageDrafts_aggregate';
    aggregate?: Maybe<MessageDrafts_Aggregate_Fields>;
    nodes: Array<MessageDrafts>;
};

export type MessageDrafts_Aggregate_Bool_Exp = {
    count?: InputMaybe<MessageDrafts_Aggregate_Bool_Exp_Count>;
};

export type MessageDrafts_Aggregate_Bool_Exp_Count = {
    arguments?: InputMaybe<Array<MessageDrafts_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<MessageDrafts_Bool_Exp>;
    predicate: Int_Comparison_Exp;
};

/** aggregate fields of "MessageDrafts" */
export type MessageDrafts_Aggregate_Fields = {
    __typename?: 'MessageDrafts_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<MessageDrafts_Max_Fields>;
    min?: Maybe<MessageDrafts_Min_Fields>;
};

/** aggregate fields of "MessageDrafts" */
export type MessageDrafts_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<MessageDrafts_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "MessageDrafts" */
export type MessageDrafts_Aggregate_Order_By = {
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<MessageDrafts_Max_Order_By>;
    min?: InputMaybe<MessageDrafts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "MessageDrafts" */
export type MessageDrafts_Arr_Rel_Insert_Input = {
    data: Array<MessageDrafts_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<MessageDrafts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "MessageDrafts". All fields are combined with a logical 'AND'. */
export type MessageDrafts_Bool_Exp = {
    Contact?: InputMaybe<Contacts_Bool_Exp>;
    _and?: InputMaybe<Array<MessageDrafts_Bool_Exp>>;
    _not?: InputMaybe<MessageDrafts_Bool_Exp>;
    _or?: InputMaybe<Array<MessageDrafts_Bool_Exp>>;
    archivedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    channelType?: InputMaybe<ChannelType_Comparison_Exp>;
    contactId?: InputMaybe<String_Comparison_Exp>;
    content?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    prospectId?: InputMaybe<String_Comparison_Exp>;
    source?: InputMaybe<String_Comparison_Exp>;
    subjectLine?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
    userPrompt?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "MessageDrafts" */
export enum MessageDrafts_Constraint {
    /** unique or primary key constraint on columns "id" */
    MessageDraftsPkey = 'MessageDrafts_pkey',
}

/** input type for inserting data into table "MessageDrafts" */
export type MessageDrafts_Insert_Input = {
    Contact?: InputMaybe<Contacts_Obj_Rel_Insert_Input>;
    archivedAt?: InputMaybe<Scalars['timestamp']['input']>;
    channelType?: InputMaybe<Scalars['ChannelType']['input']>;
    contactId?: InputMaybe<Scalars['String']['input']>;
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    source?: InputMaybe<Scalars['String']['input']>;
    subjectLine?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    userPrompt?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MessageDrafts_Max_Fields = {
    __typename?: 'MessageDrafts_max_fields';
    archivedAt?: Maybe<Scalars['timestamp']['output']>;
    channelType?: Maybe<Scalars['ChannelType']['output']>;
    contactId?: Maybe<Scalars['String']['output']>;
    content?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    source?: Maybe<Scalars['String']['output']>;
    subjectLine?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    userPrompt?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "MessageDrafts" */
export type MessageDrafts_Max_Order_By = {
    archivedAt?: InputMaybe<Order_By>;
    channelType?: InputMaybe<Order_By>;
    contactId?: InputMaybe<Order_By>;
    content?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    source?: InputMaybe<Order_By>;
    subjectLine?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    userPrompt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MessageDrafts_Min_Fields = {
    __typename?: 'MessageDrafts_min_fields';
    archivedAt?: Maybe<Scalars['timestamp']['output']>;
    channelType?: Maybe<Scalars['ChannelType']['output']>;
    contactId?: Maybe<Scalars['String']['output']>;
    content?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    source?: Maybe<Scalars['String']['output']>;
    subjectLine?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    userPrompt?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "MessageDrafts" */
export type MessageDrafts_Min_Order_By = {
    archivedAt?: InputMaybe<Order_By>;
    channelType?: InputMaybe<Order_By>;
    contactId?: InputMaybe<Order_By>;
    content?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    source?: InputMaybe<Order_By>;
    subjectLine?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    userPrompt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "MessageDrafts" */
export type MessageDrafts_Mutation_Response = {
    __typename?: 'MessageDrafts_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<MessageDrafts>;
};

/** on_conflict condition type for table "MessageDrafts" */
export type MessageDrafts_On_Conflict = {
    constraint: MessageDrafts_Constraint;
    update_columns?: Array<MessageDrafts_Update_Column>;
    where?: InputMaybe<MessageDrafts_Bool_Exp>;
};

/** Ordering options when selecting data from "MessageDrafts". */
export type MessageDrafts_Order_By = {
    Contact?: InputMaybe<Contacts_Order_By>;
    archivedAt?: InputMaybe<Order_By>;
    channelType?: InputMaybe<Order_By>;
    contactId?: InputMaybe<Order_By>;
    content?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    source?: InputMaybe<Order_By>;
    subjectLine?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    userPrompt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: MessageDrafts */
export type MessageDrafts_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** select columns of table "MessageDrafts" */
export enum MessageDrafts_Select_Column {
    /** column name */
    ArchivedAt = 'archivedAt',
    /** column name */
    ChannelType = 'channelType',
    /** column name */
    ContactId = 'contactId',
    /** column name */
    Content = 'content',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    Source = 'source',
    /** column name */
    SubjectLine = 'subjectLine',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
    /** column name */
    UserPrompt = 'userPrompt',
}

/** input type for updating data in table "MessageDrafts" */
export type MessageDrafts_Set_Input = {
    archivedAt?: InputMaybe<Scalars['timestamp']['input']>;
    channelType?: InputMaybe<Scalars['ChannelType']['input']>;
    contactId?: InputMaybe<Scalars['String']['input']>;
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    source?: InputMaybe<Scalars['String']['input']>;
    subjectLine?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    userPrompt?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "MessageDrafts" */
export type MessageDrafts_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: MessageDrafts_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MessageDrafts_Stream_Cursor_Value_Input = {
    archivedAt?: InputMaybe<Scalars['timestamp']['input']>;
    channelType?: InputMaybe<Scalars['ChannelType']['input']>;
    contactId?: InputMaybe<Scalars['String']['input']>;
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    source?: InputMaybe<Scalars['String']['input']>;
    subjectLine?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    userPrompt?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "MessageDrafts" */
export enum MessageDrafts_Update_Column {
    /** column name */
    ArchivedAt = 'archivedAt',
    /** column name */
    ChannelType = 'channelType',
    /** column name */
    ContactId = 'contactId',
    /** column name */
    Content = 'content',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    Source = 'source',
    /** column name */
    SubjectLine = 'subjectLine',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
    /** column name */
    UserPrompt = 'userPrompt',
}

export type MessageDrafts_Updates = {
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<MessageDrafts_Set_Input>;
    /** filter the rows which have to be updated */
    where: MessageDrafts_Bool_Exp;
};

/** Boolean expression to compare columns of type "MessageType". All fields are combined with logical 'AND'. */
export type MessageType_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['MessageType']['input']>;
    _gt?: InputMaybe<Scalars['MessageType']['input']>;
    _gte?: InputMaybe<Scalars['MessageType']['input']>;
    _in?: InputMaybe<Array<Scalars['MessageType']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['MessageType']['input']>;
    _lte?: InputMaybe<Scalars['MessageType']['input']>;
    _neq?: InputMaybe<Scalars['MessageType']['input']>;
    _nin?: InputMaybe<Array<Scalars['MessageType']['input']>>;
};

/** columns and relationships of "Messages" */
export type Messages = {
    __typename?: 'Messages';
    /** An array relationship */
    Attachments: Array<Attachments>;
    /** An aggregate relationship */
    Attachments_aggregate: Attachments_Aggregate;
    /** An object relationship */
    Contact?: Maybe<Contacts>;
    /** An object relationship */
    Conversation?: Maybe<Conversations>;
    /** An object relationship */
    LinkedinConversation?: Maybe<LinkedinConversations>;
    /** An object relationship */
    OutreachSuggestion?: Maybe<OutreachSuggestions>;
    /** An array relationship */
    OutreachSuggestions: Array<OutreachSuggestions>;
    /** An aggregate relationship */
    OutreachSuggestions_aggregate: OutreachSuggestions_Aggregate;
    actionType?: Maybe<Scalars['MessageType']['output']>;
    approvedAt?: Maybe<Scalars['timestamp']['output']>;
    assistantId?: Maybe<Scalars['String']['output']>;
    campaignId?: Maybe<Scalars['String']['output']>;
    channelAccountId?: Maybe<Scalars['String']['output']>;
    channelType?: Maybe<Scalars['ChannelType']['output']>;
    contactId?: Maybe<Scalars['String']['output']>;
    content?: Maybe<Scalars['String']['output']>;
    contentType?: Maybe<Scalars['String']['output']>;
    conversationId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['timestamp']['output'];
    deliveryStatus?: Maybe<Scalars['DeliveryStatus']['output']>;
    direction: Scalars['String']['output'];
    embedding?: Maybe<Scalars['vector']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    externalMessageId?: Maybe<Scalars['String']['output']>;
    fullName?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    internalConversationId?: Maybe<Scalars['String']['output']>;
    isSentFromApp?: Maybe<Scalars['Boolean']['output']>;
    linkedinConversationId?: Maybe<Scalars['String']['output']>;
    linkedinUserId?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['jsonb']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    organizationId: Scalars['String']['output'];
    personId?: Maybe<Scalars['String']['output']>;
    prospectFullName?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    sentOn?: Maybe<Scalars['timestamp']['output']>;
    stepId?: Maybe<Scalars['String']['output']>;
    subjectLine?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
};

/** columns and relationships of "Messages" */
export type MessagesAttachmentsArgs = {
    distinct_on?: InputMaybe<Array<Attachments_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Attachments_Order_By>>;
    where?: InputMaybe<Attachments_Bool_Exp>;
};

/** columns and relationships of "Messages" */
export type MessagesAttachments_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Attachments_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Attachments_Order_By>>;
    where?: InputMaybe<Attachments_Bool_Exp>;
};

/** columns and relationships of "Messages" */
export type MessagesOutreachSuggestionsArgs = {
    distinct_on?: InputMaybe<Array<OutreachSuggestions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<OutreachSuggestions_Order_By>>;
    where?: InputMaybe<OutreachSuggestions_Bool_Exp>;
};

/** columns and relationships of "Messages" */
export type MessagesOutreachSuggestions_AggregateArgs = {
    distinct_on?: InputMaybe<Array<OutreachSuggestions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<OutreachSuggestions_Order_By>>;
    where?: InputMaybe<OutreachSuggestions_Bool_Exp>;
};

/** columns and relationships of "Messages" */
export type MessagesMetadataArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Messages" */
export type Messages_Aggregate = {
    __typename?: 'Messages_aggregate';
    aggregate?: Maybe<Messages_Aggregate_Fields>;
    nodes: Array<Messages>;
};

export type Messages_Aggregate_Bool_Exp = {
    bool_and?: InputMaybe<Messages_Aggregate_Bool_Exp_Bool_And>;
    bool_or?: InputMaybe<Messages_Aggregate_Bool_Exp_Bool_Or>;
    count?: InputMaybe<Messages_Aggregate_Bool_Exp_Count>;
};

export type Messages_Aggregate_Bool_Exp_Bool_And = {
    arguments: Messages_Select_Column_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Messages_Bool_Exp>;
    predicate: Boolean_Comparison_Exp;
};

export type Messages_Aggregate_Bool_Exp_Bool_Or = {
    arguments: Messages_Select_Column_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Messages_Bool_Exp>;
    predicate: Boolean_Comparison_Exp;
};

export type Messages_Aggregate_Bool_Exp_Count = {
    arguments?: InputMaybe<Array<Messages_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Messages_Bool_Exp>;
    predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Messages" */
export type Messages_Aggregate_Fields = {
    __typename?: 'Messages_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<Messages_Max_Fields>;
    min?: Maybe<Messages_Min_Fields>;
};

/** aggregate fields of "Messages" */
export type Messages_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<Messages_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Messages" */
export type Messages_Aggregate_Order_By = {
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<Messages_Max_Order_By>;
    min?: InputMaybe<Messages_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Messages_Append_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "Messages" */
export type Messages_Arr_Rel_Insert_Input = {
    data: Array<Messages_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<Messages_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Messages". All fields are combined with a logical 'AND'. */
export type Messages_Bool_Exp = {
    Attachments?: InputMaybe<Attachments_Bool_Exp>;
    Attachments_aggregate?: InputMaybe<Attachments_Aggregate_Bool_Exp>;
    Contact?: InputMaybe<Contacts_Bool_Exp>;
    Conversation?: InputMaybe<Conversations_Bool_Exp>;
    LinkedinConversation?: InputMaybe<LinkedinConversations_Bool_Exp>;
    OutreachSuggestion?: InputMaybe<OutreachSuggestions_Bool_Exp>;
    OutreachSuggestions?: InputMaybe<OutreachSuggestions_Bool_Exp>;
    OutreachSuggestions_aggregate?: InputMaybe<OutreachSuggestions_Aggregate_Bool_Exp>;
    _and?: InputMaybe<Array<Messages_Bool_Exp>>;
    _not?: InputMaybe<Messages_Bool_Exp>;
    _or?: InputMaybe<Array<Messages_Bool_Exp>>;
    actionType?: InputMaybe<MessageType_Comparison_Exp>;
    approvedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    assistantId?: InputMaybe<String_Comparison_Exp>;
    campaignId?: InputMaybe<String_Comparison_Exp>;
    channelAccountId?: InputMaybe<String_Comparison_Exp>;
    channelType?: InputMaybe<ChannelType_Comparison_Exp>;
    contactId?: InputMaybe<String_Comparison_Exp>;
    content?: InputMaybe<String_Comparison_Exp>;
    contentType?: InputMaybe<String_Comparison_Exp>;
    conversationId?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    deliveryStatus?: InputMaybe<DeliveryStatus_Comparison_Exp>;
    direction?: InputMaybe<String_Comparison_Exp>;
    embedding?: InputMaybe<Vector_Comparison_Exp>;
    embeddingLastUpdatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    externalMessageId?: InputMaybe<String_Comparison_Exp>;
    fullName?: InputMaybe<String_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    internalConversationId?: InputMaybe<String_Comparison_Exp>;
    isSentFromApp?: InputMaybe<Boolean_Comparison_Exp>;
    linkedinConversationId?: InputMaybe<String_Comparison_Exp>;
    linkedinUserId?: InputMaybe<String_Comparison_Exp>;
    metadata?: InputMaybe<Jsonb_Comparison_Exp>;
    metadataLastUpdatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    personId?: InputMaybe<String_Comparison_Exp>;
    prospectFullName?: InputMaybe<String_Comparison_Exp>;
    prospectId?: InputMaybe<String_Comparison_Exp>;
    sentOn?: InputMaybe<Timestamp_Comparison_Exp>;
    stepId?: InputMaybe<String_Comparison_Exp>;
    subjectLine?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Messages" */
export enum Messages_Constraint {
    /** unique or primary key constraint on columns "id" */
    MessagesPkey = 'Messages_pkey',
    /** unique or primary key constraint on columns "userId", "externalMessageId", "actionType", "prospectId" */
    MessagesUserIdProspectIdActionTypeExternalMessageIdKey = 'Messages_userId_prospectId_actionType_externalMessageId_key',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Messages_Delete_At_Path_Input = {
    metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Messages_Delete_Elem_Input = {
    metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Messages_Delete_Key_Input = {
    metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "Messages" */
export type Messages_Insert_Input = {
    Attachments?: InputMaybe<Attachments_Arr_Rel_Insert_Input>;
    Contact?: InputMaybe<Contacts_Obj_Rel_Insert_Input>;
    Conversation?: InputMaybe<Conversations_Obj_Rel_Insert_Input>;
    LinkedinConversation?: InputMaybe<LinkedinConversations_Obj_Rel_Insert_Input>;
    OutreachSuggestion?: InputMaybe<OutreachSuggestions_Obj_Rel_Insert_Input>;
    OutreachSuggestions?: InputMaybe<OutreachSuggestions_Arr_Rel_Insert_Input>;
    actionType?: InputMaybe<Scalars['MessageType']['input']>;
    approvedAt?: InputMaybe<Scalars['timestamp']['input']>;
    assistantId?: InputMaybe<Scalars['String']['input']>;
    campaignId?: InputMaybe<Scalars['String']['input']>;
    channelAccountId?: InputMaybe<Scalars['String']['input']>;
    channelType?: InputMaybe<Scalars['ChannelType']['input']>;
    contactId?: InputMaybe<Scalars['String']['input']>;
    content?: InputMaybe<Scalars['String']['input']>;
    contentType?: InputMaybe<Scalars['String']['input']>;
    conversationId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    deliveryStatus?: InputMaybe<Scalars['DeliveryStatus']['input']>;
    direction?: InputMaybe<Scalars['String']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    externalMessageId?: InputMaybe<Scalars['String']['input']>;
    fullName?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    internalConversationId?: InputMaybe<Scalars['String']['input']>;
    isSentFromApp?: InputMaybe<Scalars['Boolean']['input']>;
    linkedinConversationId?: InputMaybe<Scalars['String']['input']>;
    linkedinUserId?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    personId?: InputMaybe<Scalars['String']['input']>;
    prospectFullName?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    sentOn?: InputMaybe<Scalars['timestamp']['input']>;
    stepId?: InputMaybe<Scalars['String']['input']>;
    subjectLine?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Messages_Max_Fields = {
    __typename?: 'Messages_max_fields';
    actionType?: Maybe<Scalars['MessageType']['output']>;
    approvedAt?: Maybe<Scalars['timestamp']['output']>;
    assistantId?: Maybe<Scalars['String']['output']>;
    campaignId?: Maybe<Scalars['String']['output']>;
    channelAccountId?: Maybe<Scalars['String']['output']>;
    channelType?: Maybe<Scalars['ChannelType']['output']>;
    contactId?: Maybe<Scalars['String']['output']>;
    content?: Maybe<Scalars['String']['output']>;
    contentType?: Maybe<Scalars['String']['output']>;
    conversationId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    deliveryStatus?: Maybe<Scalars['DeliveryStatus']['output']>;
    direction?: Maybe<Scalars['String']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    externalMessageId?: Maybe<Scalars['String']['output']>;
    fullName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    internalConversationId?: Maybe<Scalars['String']['output']>;
    linkedinConversationId?: Maybe<Scalars['String']['output']>;
    linkedinUserId?: Maybe<Scalars['String']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    personId?: Maybe<Scalars['String']['output']>;
    prospectFullName?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    sentOn?: Maybe<Scalars['timestamp']['output']>;
    stepId?: Maybe<Scalars['String']['output']>;
    subjectLine?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "Messages" */
export type Messages_Max_Order_By = {
    actionType?: InputMaybe<Order_By>;
    approvedAt?: InputMaybe<Order_By>;
    assistantId?: InputMaybe<Order_By>;
    campaignId?: InputMaybe<Order_By>;
    channelAccountId?: InputMaybe<Order_By>;
    channelType?: InputMaybe<Order_By>;
    contactId?: InputMaybe<Order_By>;
    content?: InputMaybe<Order_By>;
    contentType?: InputMaybe<Order_By>;
    conversationId?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    deliveryStatus?: InputMaybe<Order_By>;
    direction?: InputMaybe<Order_By>;
    embeddingLastUpdatedAt?: InputMaybe<Order_By>;
    externalMessageId?: InputMaybe<Order_By>;
    fullName?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    internalConversationId?: InputMaybe<Order_By>;
    linkedinConversationId?: InputMaybe<Order_By>;
    linkedinUserId?: InputMaybe<Order_By>;
    metadataLastUpdatedAt?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    personId?: InputMaybe<Order_By>;
    prospectFullName?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    sentOn?: InputMaybe<Order_By>;
    stepId?: InputMaybe<Order_By>;
    subjectLine?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Messages_Min_Fields = {
    __typename?: 'Messages_min_fields';
    actionType?: Maybe<Scalars['MessageType']['output']>;
    approvedAt?: Maybe<Scalars['timestamp']['output']>;
    assistantId?: Maybe<Scalars['String']['output']>;
    campaignId?: Maybe<Scalars['String']['output']>;
    channelAccountId?: Maybe<Scalars['String']['output']>;
    channelType?: Maybe<Scalars['ChannelType']['output']>;
    contactId?: Maybe<Scalars['String']['output']>;
    content?: Maybe<Scalars['String']['output']>;
    contentType?: Maybe<Scalars['String']['output']>;
    conversationId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    deliveryStatus?: Maybe<Scalars['DeliveryStatus']['output']>;
    direction?: Maybe<Scalars['String']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    externalMessageId?: Maybe<Scalars['String']['output']>;
    fullName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    internalConversationId?: Maybe<Scalars['String']['output']>;
    linkedinConversationId?: Maybe<Scalars['String']['output']>;
    linkedinUserId?: Maybe<Scalars['String']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    personId?: Maybe<Scalars['String']['output']>;
    prospectFullName?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    sentOn?: Maybe<Scalars['timestamp']['output']>;
    stepId?: Maybe<Scalars['String']['output']>;
    subjectLine?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "Messages" */
export type Messages_Min_Order_By = {
    actionType?: InputMaybe<Order_By>;
    approvedAt?: InputMaybe<Order_By>;
    assistantId?: InputMaybe<Order_By>;
    campaignId?: InputMaybe<Order_By>;
    channelAccountId?: InputMaybe<Order_By>;
    channelType?: InputMaybe<Order_By>;
    contactId?: InputMaybe<Order_By>;
    content?: InputMaybe<Order_By>;
    contentType?: InputMaybe<Order_By>;
    conversationId?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    deliveryStatus?: InputMaybe<Order_By>;
    direction?: InputMaybe<Order_By>;
    embeddingLastUpdatedAt?: InputMaybe<Order_By>;
    externalMessageId?: InputMaybe<Order_By>;
    fullName?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    internalConversationId?: InputMaybe<Order_By>;
    linkedinConversationId?: InputMaybe<Order_By>;
    linkedinUserId?: InputMaybe<Order_By>;
    metadataLastUpdatedAt?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    personId?: InputMaybe<Order_By>;
    prospectFullName?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    sentOn?: InputMaybe<Order_By>;
    stepId?: InputMaybe<Order_By>;
    subjectLine?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Messages" */
export type Messages_Mutation_Response = {
    __typename?: 'Messages_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Messages>;
};

/** input type for inserting object relation for remote table "Messages" */
export type Messages_Obj_Rel_Insert_Input = {
    data: Messages_Insert_Input;
    /** upsert condition */
    on_conflict?: InputMaybe<Messages_On_Conflict>;
};

/** on_conflict condition type for table "Messages" */
export type Messages_On_Conflict = {
    constraint: Messages_Constraint;
    update_columns?: Array<Messages_Update_Column>;
    where?: InputMaybe<Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "Messages". */
export type Messages_Order_By = {
    Attachments_aggregate?: InputMaybe<Attachments_Aggregate_Order_By>;
    Contact?: InputMaybe<Contacts_Order_By>;
    Conversation?: InputMaybe<Conversations_Order_By>;
    LinkedinConversation?: InputMaybe<LinkedinConversations_Order_By>;
    OutreachSuggestion?: InputMaybe<OutreachSuggestions_Order_By>;
    OutreachSuggestions_aggregate?: InputMaybe<OutreachSuggestions_Aggregate_Order_By>;
    actionType?: InputMaybe<Order_By>;
    approvedAt?: InputMaybe<Order_By>;
    assistantId?: InputMaybe<Order_By>;
    campaignId?: InputMaybe<Order_By>;
    channelAccountId?: InputMaybe<Order_By>;
    channelType?: InputMaybe<Order_By>;
    contactId?: InputMaybe<Order_By>;
    content?: InputMaybe<Order_By>;
    contentType?: InputMaybe<Order_By>;
    conversationId?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    deliveryStatus?: InputMaybe<Order_By>;
    direction?: InputMaybe<Order_By>;
    embedding?: InputMaybe<Order_By>;
    embeddingLastUpdatedAt?: InputMaybe<Order_By>;
    externalMessageId?: InputMaybe<Order_By>;
    fullName?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    internalConversationId?: InputMaybe<Order_By>;
    isSentFromApp?: InputMaybe<Order_By>;
    linkedinConversationId?: InputMaybe<Order_By>;
    linkedinUserId?: InputMaybe<Order_By>;
    metadata?: InputMaybe<Order_By>;
    metadataLastUpdatedAt?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    personId?: InputMaybe<Order_By>;
    prospectFullName?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    sentOn?: InputMaybe<Order_By>;
    stepId?: InputMaybe<Order_By>;
    subjectLine?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Messages */
export type Messages_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Messages_Prepend_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "Messages" */
export enum Messages_Select_Column {
    /** column name */
    ActionType = 'actionType',
    /** column name */
    ApprovedAt = 'approvedAt',
    /** column name */
    AssistantId = 'assistantId',
    /** column name */
    CampaignId = 'campaignId',
    /** column name */
    ChannelAccountId = 'channelAccountId',
    /** column name */
    ChannelType = 'channelType',
    /** column name */
    ContactId = 'contactId',
    /** column name */
    Content = 'content',
    /** column name */
    ContentType = 'contentType',
    /** column name */
    ConversationId = 'conversationId',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    DeliveryStatus = 'deliveryStatus',
    /** column name */
    Direction = 'direction',
    /** column name */
    Embedding = 'embedding',
    /** column name */
    EmbeddingLastUpdatedAt = 'embeddingLastUpdatedAt',
    /** column name */
    ExternalMessageId = 'externalMessageId',
    /** column name */
    FullName = 'fullName',
    /** column name */
    Id = 'id',
    /** column name */
    InternalConversationId = 'internalConversationId',
    /** column name */
    IsSentFromApp = 'isSentFromApp',
    /** column name */
    LinkedinConversationId = 'linkedinConversationId',
    /** column name */
    LinkedinUserId = 'linkedinUserId',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    MetadataLastUpdatedAt = 'metadataLastUpdatedAt',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    PersonId = 'personId',
    /** column name */
    ProspectFullName = 'prospectFullName',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    SentOn = 'sentOn',
    /** column name */
    StepId = 'stepId',
    /** column name */
    SubjectLine = 'subjectLine',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

/** select "Messages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Messages" */
export enum Messages_Select_Column_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
    /** column name */
    IsSentFromApp = 'isSentFromApp',
}

/** select "Messages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Messages" */
export enum Messages_Select_Column_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
    /** column name */
    IsSentFromApp = 'isSentFromApp',
}

/** input type for updating data in table "Messages" */
export type Messages_Set_Input = {
    actionType?: InputMaybe<Scalars['MessageType']['input']>;
    approvedAt?: InputMaybe<Scalars['timestamp']['input']>;
    assistantId?: InputMaybe<Scalars['String']['input']>;
    campaignId?: InputMaybe<Scalars['String']['input']>;
    channelAccountId?: InputMaybe<Scalars['String']['input']>;
    channelType?: InputMaybe<Scalars['ChannelType']['input']>;
    contactId?: InputMaybe<Scalars['String']['input']>;
    content?: InputMaybe<Scalars['String']['input']>;
    contentType?: InputMaybe<Scalars['String']['input']>;
    conversationId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    deliveryStatus?: InputMaybe<Scalars['DeliveryStatus']['input']>;
    direction?: InputMaybe<Scalars['String']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    externalMessageId?: InputMaybe<Scalars['String']['input']>;
    fullName?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    internalConversationId?: InputMaybe<Scalars['String']['input']>;
    isSentFromApp?: InputMaybe<Scalars['Boolean']['input']>;
    linkedinConversationId?: InputMaybe<Scalars['String']['input']>;
    linkedinUserId?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    personId?: InputMaybe<Scalars['String']['input']>;
    prospectFullName?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    sentOn?: InputMaybe<Scalars['timestamp']['input']>;
    stepId?: InputMaybe<Scalars['String']['input']>;
    subjectLine?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "Messages" */
export type Messages_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: Messages_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Messages_Stream_Cursor_Value_Input = {
    actionType?: InputMaybe<Scalars['MessageType']['input']>;
    approvedAt?: InputMaybe<Scalars['timestamp']['input']>;
    assistantId?: InputMaybe<Scalars['String']['input']>;
    campaignId?: InputMaybe<Scalars['String']['input']>;
    channelAccountId?: InputMaybe<Scalars['String']['input']>;
    channelType?: InputMaybe<Scalars['ChannelType']['input']>;
    contactId?: InputMaybe<Scalars['String']['input']>;
    content?: InputMaybe<Scalars['String']['input']>;
    contentType?: InputMaybe<Scalars['String']['input']>;
    conversationId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    deliveryStatus?: InputMaybe<Scalars['DeliveryStatus']['input']>;
    direction?: InputMaybe<Scalars['String']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    externalMessageId?: InputMaybe<Scalars['String']['input']>;
    fullName?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    internalConversationId?: InputMaybe<Scalars['String']['input']>;
    isSentFromApp?: InputMaybe<Scalars['Boolean']['input']>;
    linkedinConversationId?: InputMaybe<Scalars['String']['input']>;
    linkedinUserId?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    personId?: InputMaybe<Scalars['String']['input']>;
    prospectFullName?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    sentOn?: InputMaybe<Scalars['timestamp']['input']>;
    stepId?: InputMaybe<Scalars['String']['input']>;
    subjectLine?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "Messages" */
export enum Messages_Update_Column {
    /** column name */
    ActionType = 'actionType',
    /** column name */
    ApprovedAt = 'approvedAt',
    /** column name */
    AssistantId = 'assistantId',
    /** column name */
    CampaignId = 'campaignId',
    /** column name */
    ChannelAccountId = 'channelAccountId',
    /** column name */
    ChannelType = 'channelType',
    /** column name */
    ContactId = 'contactId',
    /** column name */
    Content = 'content',
    /** column name */
    ContentType = 'contentType',
    /** column name */
    ConversationId = 'conversationId',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    DeliveryStatus = 'deliveryStatus',
    /** column name */
    Direction = 'direction',
    /** column name */
    Embedding = 'embedding',
    /** column name */
    EmbeddingLastUpdatedAt = 'embeddingLastUpdatedAt',
    /** column name */
    ExternalMessageId = 'externalMessageId',
    /** column name */
    FullName = 'fullName',
    /** column name */
    Id = 'id',
    /** column name */
    InternalConversationId = 'internalConversationId',
    /** column name */
    IsSentFromApp = 'isSentFromApp',
    /** column name */
    LinkedinConversationId = 'linkedinConversationId',
    /** column name */
    LinkedinUserId = 'linkedinUserId',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    MetadataLastUpdatedAt = 'metadataLastUpdatedAt',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    PersonId = 'personId',
    /** column name */
    ProspectFullName = 'prospectFullName',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    SentOn = 'sentOn',
    /** column name */
    StepId = 'stepId',
    /** column name */
    SubjectLine = 'subjectLine',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

export type Messages_Updates = {
    /** append existing jsonb value of filtered columns with new jsonb value */
    _append?: InputMaybe<Messages_Append_Input>;
    /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
    _delete_at_path?: InputMaybe<Messages_Delete_At_Path_Input>;
    /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
    _delete_elem?: InputMaybe<Messages_Delete_Elem_Input>;
    /** delete key/value pair or string element. key/value pairs are matched based on their key value */
    _delete_key?: InputMaybe<Messages_Delete_Key_Input>;
    /** prepend existing jsonb value of filtered columns with new jsonb value */
    _prepend?: InputMaybe<Messages_Prepend_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<Messages_Set_Input>;
    /** filter the rows which have to be updated */
    where: Messages_Bool_Exp;
};

/** columns and relationships of "Notes" */
export type Notes = {
    __typename?: 'Notes';
    content: Scalars['String']['output'];
    createdAt: Scalars['timestamp']['output'];
    creator: Scalars['Creator']['output'];
    discarded: Scalars['Boolean']['output'];
    embedding?: Maybe<Scalars['vector']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    happenedOn: Scalars['timestamp']['output'];
    id: Scalars['String']['output'];
    metadata?: Maybe<Scalars['jsonb']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    prospectId: Scalars['String']['output'];
    title: Scalars['String']['output'];
    uniqueIdentifier: Scalars['String']['output'];
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
};

/** columns and relationships of "Notes" */
export type NotesMetadataArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Notes" */
export type Notes_Aggregate = {
    __typename?: 'Notes_aggregate';
    aggregate?: Maybe<Notes_Aggregate_Fields>;
    nodes: Array<Notes>;
};

export type Notes_Aggregate_Bool_Exp = {
    bool_and?: InputMaybe<Notes_Aggregate_Bool_Exp_Bool_And>;
    bool_or?: InputMaybe<Notes_Aggregate_Bool_Exp_Bool_Or>;
    count?: InputMaybe<Notes_Aggregate_Bool_Exp_Count>;
};

export type Notes_Aggregate_Bool_Exp_Bool_And = {
    arguments: Notes_Select_Column_Notes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Notes_Bool_Exp>;
    predicate: Boolean_Comparison_Exp;
};

export type Notes_Aggregate_Bool_Exp_Bool_Or = {
    arguments: Notes_Select_Column_Notes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Notes_Bool_Exp>;
    predicate: Boolean_Comparison_Exp;
};

export type Notes_Aggregate_Bool_Exp_Count = {
    arguments?: InputMaybe<Array<Notes_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Notes_Bool_Exp>;
    predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Notes" */
export type Notes_Aggregate_Fields = {
    __typename?: 'Notes_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<Notes_Max_Fields>;
    min?: Maybe<Notes_Min_Fields>;
};

/** aggregate fields of "Notes" */
export type Notes_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<Notes_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Notes" */
export type Notes_Aggregate_Order_By = {
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<Notes_Max_Order_By>;
    min?: InputMaybe<Notes_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Notes_Append_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "Notes" */
export type Notes_Arr_Rel_Insert_Input = {
    data: Array<Notes_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<Notes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Notes". All fields are combined with a logical 'AND'. */
export type Notes_Bool_Exp = {
    _and?: InputMaybe<Array<Notes_Bool_Exp>>;
    _not?: InputMaybe<Notes_Bool_Exp>;
    _or?: InputMaybe<Array<Notes_Bool_Exp>>;
    content?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    creator?: InputMaybe<Creator_Comparison_Exp>;
    discarded?: InputMaybe<Boolean_Comparison_Exp>;
    embedding?: InputMaybe<Vector_Comparison_Exp>;
    embeddingLastUpdatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    happenedOn?: InputMaybe<Timestamp_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    metadata?: InputMaybe<Jsonb_Comparison_Exp>;
    metadataLastUpdatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    prospectId?: InputMaybe<String_Comparison_Exp>;
    title?: InputMaybe<String_Comparison_Exp>;
    uniqueIdentifier?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Notes" */
export enum Notes_Constraint {
    /** unique or primary key constraint on columns "id" */
    NotesPkey = 'Notes_pkey',
    /** unique or primary key constraint on columns "userId", "uniqueIdentifier" */
    NotesUniqueIdentifierUserIdKey = 'Notes_uniqueIdentifier_userId_key',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Notes_Delete_At_Path_Input = {
    metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Notes_Delete_Elem_Input = {
    metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Notes_Delete_Key_Input = {
    metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "Notes" */
export type Notes_Insert_Input = {
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    creator?: InputMaybe<Scalars['Creator']['input']>;
    discarded?: InputMaybe<Scalars['Boolean']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    happenedOn?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    uniqueIdentifier?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Notes_Max_Fields = {
    __typename?: 'Notes_max_fields';
    content?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    creator?: Maybe<Scalars['Creator']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    happenedOn?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    uniqueIdentifier?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "Notes" */
export type Notes_Max_Order_By = {
    content?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    creator?: InputMaybe<Order_By>;
    embeddingLastUpdatedAt?: InputMaybe<Order_By>;
    happenedOn?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    metadataLastUpdatedAt?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    title?: InputMaybe<Order_By>;
    uniqueIdentifier?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notes_Min_Fields = {
    __typename?: 'Notes_min_fields';
    content?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    creator?: Maybe<Scalars['Creator']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    happenedOn?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    metadataLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    uniqueIdentifier?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "Notes" */
export type Notes_Min_Order_By = {
    content?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    creator?: InputMaybe<Order_By>;
    embeddingLastUpdatedAt?: InputMaybe<Order_By>;
    happenedOn?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    metadataLastUpdatedAt?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    title?: InputMaybe<Order_By>;
    uniqueIdentifier?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Notes" */
export type Notes_Mutation_Response = {
    __typename?: 'Notes_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Notes>;
};

/** on_conflict condition type for table "Notes" */
export type Notes_On_Conflict = {
    constraint: Notes_Constraint;
    update_columns?: Array<Notes_Update_Column>;
    where?: InputMaybe<Notes_Bool_Exp>;
};

/** Ordering options when selecting data from "Notes". */
export type Notes_Order_By = {
    content?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    creator?: InputMaybe<Order_By>;
    discarded?: InputMaybe<Order_By>;
    embedding?: InputMaybe<Order_By>;
    embeddingLastUpdatedAt?: InputMaybe<Order_By>;
    happenedOn?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    metadata?: InputMaybe<Order_By>;
    metadataLastUpdatedAt?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    title?: InputMaybe<Order_By>;
    uniqueIdentifier?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Notes */
export type Notes_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Notes_Prepend_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "Notes" */
export enum Notes_Select_Column {
    /** column name */
    Content = 'content',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Creator = 'creator',
    /** column name */
    Discarded = 'discarded',
    /** column name */
    Embedding = 'embedding',
    /** column name */
    EmbeddingLastUpdatedAt = 'embeddingLastUpdatedAt',
    /** column name */
    HappenedOn = 'happenedOn',
    /** column name */
    Id = 'id',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    MetadataLastUpdatedAt = 'metadataLastUpdatedAt',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    Title = 'title',
    /** column name */
    UniqueIdentifier = 'uniqueIdentifier',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

/** select "Notes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Notes" */
export enum Notes_Select_Column_Notes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
    /** column name */
    Discarded = 'discarded',
}

/** select "Notes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Notes" */
export enum Notes_Select_Column_Notes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
    /** column name */
    Discarded = 'discarded',
}

/** input type for updating data in table "Notes" */
export type Notes_Set_Input = {
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    creator?: InputMaybe<Scalars['Creator']['input']>;
    discarded?: InputMaybe<Scalars['Boolean']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    happenedOn?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    uniqueIdentifier?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "Notes" */
export type Notes_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: Notes_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notes_Stream_Cursor_Value_Input = {
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    creator?: InputMaybe<Scalars['Creator']['input']>;
    discarded?: InputMaybe<Scalars['Boolean']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    happenedOn?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    metadataLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    uniqueIdentifier?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "Notes" */
export enum Notes_Update_Column {
    /** column name */
    Content = 'content',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Creator = 'creator',
    /** column name */
    Discarded = 'discarded',
    /** column name */
    Embedding = 'embedding',
    /** column name */
    EmbeddingLastUpdatedAt = 'embeddingLastUpdatedAt',
    /** column name */
    HappenedOn = 'happenedOn',
    /** column name */
    Id = 'id',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    MetadataLastUpdatedAt = 'metadataLastUpdatedAt',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    Title = 'title',
    /** column name */
    UniqueIdentifier = 'uniqueIdentifier',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

export type Notes_Updates = {
    /** append existing jsonb value of filtered columns with new jsonb value */
    _append?: InputMaybe<Notes_Append_Input>;
    /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
    _delete_at_path?: InputMaybe<Notes_Delete_At_Path_Input>;
    /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
    _delete_elem?: InputMaybe<Notes_Delete_Elem_Input>;
    /** delete key/value pair or string element. key/value pairs are matched based on their key value */
    _delete_key?: InputMaybe<Notes_Delete_Key_Input>;
    /** prepend existing jsonb value of filtered columns with new jsonb value */
    _prepend?: InputMaybe<Notes_Prepend_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<Notes_Set_Input>;
    /** filter the rows which have to be updated */
    where: Notes_Bool_Exp;
};

/** columns and relationships of "OutreachCompletionMetrics" */
export type OutreachCompletionMetrics = {
    __typename?: 'OutreachCompletionMetrics';
    completedSameDay: Scalars['Int']['output'];
    completedWithin2Days: Scalars['Int']['output'];
    completedWithin3Days: Scalars['Int']['output'];
    completedWithin7Days: Scalars['Int']['output'];
    completedWithin30Days: Scalars['Int']['output'];
    date: Scalars['timestamp']['output'];
    goalsReachedSameDay: Scalars['Int']['output'];
    goalsReachedWithin2Days: Scalars['Int']['output'];
    goalsReachedWithin3Days: Scalars['Int']['output'];
    goalsReachedWithin7Days: Scalars['Int']['output'];
    goalsReachedWithin30Days: Scalars['Int']['output'];
    id: Scalars['String']['output'];
    organizationId?: Maybe<Scalars['String']['output']>;
    suggestionsSameDay: Scalars['Int']['output'];
    suggestionsWithin2Days: Scalars['Int']['output'];
    suggestionsWithin3Days: Scalars['Int']['output'];
    suggestionsWithin7Days: Scalars['Int']['output'];
    suggestionsWithin30Days: Scalars['Int']['output'];
    trailingTotalCompleted: Scalars['Int']['output'];
    trailingTotalGoalsReached: Scalars['Int']['output'];
    trailingTotalSuggestions: Scalars['Int']['output'];
    userId?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "OutreachCompletionMetrics" */
export type OutreachCompletionMetrics_Aggregate = {
    __typename?: 'OutreachCompletionMetrics_aggregate';
    aggregate?: Maybe<OutreachCompletionMetrics_Aggregate_Fields>;
    nodes: Array<OutreachCompletionMetrics>;
};

/** aggregate fields of "OutreachCompletionMetrics" */
export type OutreachCompletionMetrics_Aggregate_Fields = {
    __typename?: 'OutreachCompletionMetrics_aggregate_fields';
    avg?: Maybe<OutreachCompletionMetrics_Avg_Fields>;
    count: Scalars['Int']['output'];
    max?: Maybe<OutreachCompletionMetrics_Max_Fields>;
    min?: Maybe<OutreachCompletionMetrics_Min_Fields>;
    stddev?: Maybe<OutreachCompletionMetrics_Stddev_Fields>;
    stddev_pop?: Maybe<OutreachCompletionMetrics_Stddev_Pop_Fields>;
    stddev_samp?: Maybe<OutreachCompletionMetrics_Stddev_Samp_Fields>;
    sum?: Maybe<OutreachCompletionMetrics_Sum_Fields>;
    var_pop?: Maybe<OutreachCompletionMetrics_Var_Pop_Fields>;
    var_samp?: Maybe<OutreachCompletionMetrics_Var_Samp_Fields>;
    variance?: Maybe<OutreachCompletionMetrics_Variance_Fields>;
};

/** aggregate fields of "OutreachCompletionMetrics" */
export type OutreachCompletionMetrics_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<OutreachCompletionMetrics_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type OutreachCompletionMetrics_Avg_Fields = {
    __typename?: 'OutreachCompletionMetrics_avg_fields';
    completedSameDay?: Maybe<Scalars['Float']['output']>;
    completedWithin2Days?: Maybe<Scalars['Float']['output']>;
    completedWithin3Days?: Maybe<Scalars['Float']['output']>;
    completedWithin7Days?: Maybe<Scalars['Float']['output']>;
    completedWithin30Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedSameDay?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin2Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin3Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin7Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin30Days?: Maybe<Scalars['Float']['output']>;
    suggestionsSameDay?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin2Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin3Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin7Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin30Days?: Maybe<Scalars['Float']['output']>;
    trailingTotalCompleted?: Maybe<Scalars['Float']['output']>;
    trailingTotalGoalsReached?: Maybe<Scalars['Float']['output']>;
    trailingTotalSuggestions?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "OutreachCompletionMetrics". All fields are combined with a logical 'AND'. */
export type OutreachCompletionMetrics_Bool_Exp = {
    _and?: InputMaybe<Array<OutreachCompletionMetrics_Bool_Exp>>;
    _not?: InputMaybe<OutreachCompletionMetrics_Bool_Exp>;
    _or?: InputMaybe<Array<OutreachCompletionMetrics_Bool_Exp>>;
    completedSameDay?: InputMaybe<Int_Comparison_Exp>;
    completedWithin2Days?: InputMaybe<Int_Comparison_Exp>;
    completedWithin3Days?: InputMaybe<Int_Comparison_Exp>;
    completedWithin7Days?: InputMaybe<Int_Comparison_Exp>;
    completedWithin30Days?: InputMaybe<Int_Comparison_Exp>;
    date?: InputMaybe<Timestamp_Comparison_Exp>;
    goalsReachedSameDay?: InputMaybe<Int_Comparison_Exp>;
    goalsReachedWithin2Days?: InputMaybe<Int_Comparison_Exp>;
    goalsReachedWithin3Days?: InputMaybe<Int_Comparison_Exp>;
    goalsReachedWithin7Days?: InputMaybe<Int_Comparison_Exp>;
    goalsReachedWithin30Days?: InputMaybe<Int_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    suggestionsSameDay?: InputMaybe<Int_Comparison_Exp>;
    suggestionsWithin2Days?: InputMaybe<Int_Comparison_Exp>;
    suggestionsWithin3Days?: InputMaybe<Int_Comparison_Exp>;
    suggestionsWithin7Days?: InputMaybe<Int_Comparison_Exp>;
    suggestionsWithin30Days?: InputMaybe<Int_Comparison_Exp>;
    trailingTotalCompleted?: InputMaybe<Int_Comparison_Exp>;
    trailingTotalGoalsReached?: InputMaybe<Int_Comparison_Exp>;
    trailingTotalSuggestions?: InputMaybe<Int_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "OutreachCompletionMetrics" */
export enum OutreachCompletionMetrics_Constraint {
    /** unique or primary key constraint on columns "organizationId", "userId", "date" */
    OutreachCompletionMetricsDateUserIdOrganizationIdKey = 'OutreachCompletionMetrics_date_userId_organizationId_key',
    /** unique or primary key constraint on columns "id" */
    OutreachCompletionMetricsPkey = 'OutreachCompletionMetrics_pkey',
    /** unique or primary key constraint on columns "date" */
    UniqueDateNullUserOrg = 'unique_date_null_user_org',
}

/** input type for incrementing numeric columns in table "OutreachCompletionMetrics" */
export type OutreachCompletionMetrics_Inc_Input = {
    completedSameDay?: InputMaybe<Scalars['Int']['input']>;
    completedWithin2Days?: InputMaybe<Scalars['Int']['input']>;
    completedWithin3Days?: InputMaybe<Scalars['Int']['input']>;
    completedWithin7Days?: InputMaybe<Scalars['Int']['input']>;
    completedWithin30Days?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedSameDay?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin2Days?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin3Days?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin7Days?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin30Days?: InputMaybe<Scalars['Int']['input']>;
    suggestionsSameDay?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin2Days?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin3Days?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin7Days?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin30Days?: InputMaybe<Scalars['Int']['input']>;
    trailingTotalCompleted?: InputMaybe<Scalars['Int']['input']>;
    trailingTotalGoalsReached?: InputMaybe<Scalars['Int']['input']>;
    trailingTotalSuggestions?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "OutreachCompletionMetrics" */
export type OutreachCompletionMetrics_Insert_Input = {
    completedSameDay?: InputMaybe<Scalars['Int']['input']>;
    completedWithin2Days?: InputMaybe<Scalars['Int']['input']>;
    completedWithin3Days?: InputMaybe<Scalars['Int']['input']>;
    completedWithin7Days?: InputMaybe<Scalars['Int']['input']>;
    completedWithin30Days?: InputMaybe<Scalars['Int']['input']>;
    date?: InputMaybe<Scalars['timestamp']['input']>;
    goalsReachedSameDay?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin2Days?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin3Days?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin7Days?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin30Days?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    suggestionsSameDay?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin2Days?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin3Days?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin7Days?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin30Days?: InputMaybe<Scalars['Int']['input']>;
    trailingTotalCompleted?: InputMaybe<Scalars['Int']['input']>;
    trailingTotalGoalsReached?: InputMaybe<Scalars['Int']['input']>;
    trailingTotalSuggestions?: InputMaybe<Scalars['Int']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type OutreachCompletionMetrics_Max_Fields = {
    __typename?: 'OutreachCompletionMetrics_max_fields';
    completedSameDay?: Maybe<Scalars['Int']['output']>;
    completedWithin2Days?: Maybe<Scalars['Int']['output']>;
    completedWithin3Days?: Maybe<Scalars['Int']['output']>;
    completedWithin7Days?: Maybe<Scalars['Int']['output']>;
    completedWithin30Days?: Maybe<Scalars['Int']['output']>;
    date?: Maybe<Scalars['timestamp']['output']>;
    goalsReachedSameDay?: Maybe<Scalars['Int']['output']>;
    goalsReachedWithin2Days?: Maybe<Scalars['Int']['output']>;
    goalsReachedWithin3Days?: Maybe<Scalars['Int']['output']>;
    goalsReachedWithin7Days?: Maybe<Scalars['Int']['output']>;
    goalsReachedWithin30Days?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    suggestionsSameDay?: Maybe<Scalars['Int']['output']>;
    suggestionsWithin2Days?: Maybe<Scalars['Int']['output']>;
    suggestionsWithin3Days?: Maybe<Scalars['Int']['output']>;
    suggestionsWithin7Days?: Maybe<Scalars['Int']['output']>;
    suggestionsWithin30Days?: Maybe<Scalars['Int']['output']>;
    trailingTotalCompleted?: Maybe<Scalars['Int']['output']>;
    trailingTotalGoalsReached?: Maybe<Scalars['Int']['output']>;
    trailingTotalSuggestions?: Maybe<Scalars['Int']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type OutreachCompletionMetrics_Min_Fields = {
    __typename?: 'OutreachCompletionMetrics_min_fields';
    completedSameDay?: Maybe<Scalars['Int']['output']>;
    completedWithin2Days?: Maybe<Scalars['Int']['output']>;
    completedWithin3Days?: Maybe<Scalars['Int']['output']>;
    completedWithin7Days?: Maybe<Scalars['Int']['output']>;
    completedWithin30Days?: Maybe<Scalars['Int']['output']>;
    date?: Maybe<Scalars['timestamp']['output']>;
    goalsReachedSameDay?: Maybe<Scalars['Int']['output']>;
    goalsReachedWithin2Days?: Maybe<Scalars['Int']['output']>;
    goalsReachedWithin3Days?: Maybe<Scalars['Int']['output']>;
    goalsReachedWithin7Days?: Maybe<Scalars['Int']['output']>;
    goalsReachedWithin30Days?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    suggestionsSameDay?: Maybe<Scalars['Int']['output']>;
    suggestionsWithin2Days?: Maybe<Scalars['Int']['output']>;
    suggestionsWithin3Days?: Maybe<Scalars['Int']['output']>;
    suggestionsWithin7Days?: Maybe<Scalars['Int']['output']>;
    suggestionsWithin30Days?: Maybe<Scalars['Int']['output']>;
    trailingTotalCompleted?: Maybe<Scalars['Int']['output']>;
    trailingTotalGoalsReached?: Maybe<Scalars['Int']['output']>;
    trailingTotalSuggestions?: Maybe<Scalars['Int']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "OutreachCompletionMetrics" */
export type OutreachCompletionMetrics_Mutation_Response = {
    __typename?: 'OutreachCompletionMetrics_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<OutreachCompletionMetrics>;
};

/** on_conflict condition type for table "OutreachCompletionMetrics" */
export type OutreachCompletionMetrics_On_Conflict = {
    constraint: OutreachCompletionMetrics_Constraint;
    update_columns?: Array<OutreachCompletionMetrics_Update_Column>;
    where?: InputMaybe<OutreachCompletionMetrics_Bool_Exp>;
};

/** Ordering options when selecting data from "OutreachCompletionMetrics". */
export type OutreachCompletionMetrics_Order_By = {
    completedSameDay?: InputMaybe<Order_By>;
    completedWithin2Days?: InputMaybe<Order_By>;
    completedWithin3Days?: InputMaybe<Order_By>;
    completedWithin7Days?: InputMaybe<Order_By>;
    completedWithin30Days?: InputMaybe<Order_By>;
    date?: InputMaybe<Order_By>;
    goalsReachedSameDay?: InputMaybe<Order_By>;
    goalsReachedWithin2Days?: InputMaybe<Order_By>;
    goalsReachedWithin3Days?: InputMaybe<Order_By>;
    goalsReachedWithin7Days?: InputMaybe<Order_By>;
    goalsReachedWithin30Days?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    suggestionsSameDay?: InputMaybe<Order_By>;
    suggestionsWithin2Days?: InputMaybe<Order_By>;
    suggestionsWithin3Days?: InputMaybe<Order_By>;
    suggestionsWithin7Days?: InputMaybe<Order_By>;
    suggestionsWithin30Days?: InputMaybe<Order_By>;
    trailingTotalCompleted?: InputMaybe<Order_By>;
    trailingTotalGoalsReached?: InputMaybe<Order_By>;
    trailingTotalSuggestions?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: OutreachCompletionMetrics */
export type OutreachCompletionMetrics_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** select columns of table "OutreachCompletionMetrics" */
export enum OutreachCompletionMetrics_Select_Column {
    /** column name */
    CompletedSameDay = 'completedSameDay',
    /** column name */
    CompletedWithin2Days = 'completedWithin2Days',
    /** column name */
    CompletedWithin3Days = 'completedWithin3Days',
    /** column name */
    CompletedWithin7Days = 'completedWithin7Days',
    /** column name */
    CompletedWithin30Days = 'completedWithin30Days',
    /** column name */
    Date = 'date',
    /** column name */
    GoalsReachedSameDay = 'goalsReachedSameDay',
    /** column name */
    GoalsReachedWithin2Days = 'goalsReachedWithin2Days',
    /** column name */
    GoalsReachedWithin3Days = 'goalsReachedWithin3Days',
    /** column name */
    GoalsReachedWithin7Days = 'goalsReachedWithin7Days',
    /** column name */
    GoalsReachedWithin30Days = 'goalsReachedWithin30Days',
    /** column name */
    Id = 'id',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    SuggestionsSameDay = 'suggestionsSameDay',
    /** column name */
    SuggestionsWithin2Days = 'suggestionsWithin2Days',
    /** column name */
    SuggestionsWithin3Days = 'suggestionsWithin3Days',
    /** column name */
    SuggestionsWithin7Days = 'suggestionsWithin7Days',
    /** column name */
    SuggestionsWithin30Days = 'suggestionsWithin30Days',
    /** column name */
    TrailingTotalCompleted = 'trailingTotalCompleted',
    /** column name */
    TrailingTotalGoalsReached = 'trailingTotalGoalsReached',
    /** column name */
    TrailingTotalSuggestions = 'trailingTotalSuggestions',
    /** column name */
    UserId = 'userId',
}

/** input type for updating data in table "OutreachCompletionMetrics" */
export type OutreachCompletionMetrics_Set_Input = {
    completedSameDay?: InputMaybe<Scalars['Int']['input']>;
    completedWithin2Days?: InputMaybe<Scalars['Int']['input']>;
    completedWithin3Days?: InputMaybe<Scalars['Int']['input']>;
    completedWithin7Days?: InputMaybe<Scalars['Int']['input']>;
    completedWithin30Days?: InputMaybe<Scalars['Int']['input']>;
    date?: InputMaybe<Scalars['timestamp']['input']>;
    goalsReachedSameDay?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin2Days?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin3Days?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin7Days?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin30Days?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    suggestionsSameDay?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin2Days?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin3Days?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin7Days?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin30Days?: InputMaybe<Scalars['Int']['input']>;
    trailingTotalCompleted?: InputMaybe<Scalars['Int']['input']>;
    trailingTotalGoalsReached?: InputMaybe<Scalars['Int']['input']>;
    trailingTotalSuggestions?: InputMaybe<Scalars['Int']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type OutreachCompletionMetrics_Stddev_Fields = {
    __typename?: 'OutreachCompletionMetrics_stddev_fields';
    completedSameDay?: Maybe<Scalars['Float']['output']>;
    completedWithin2Days?: Maybe<Scalars['Float']['output']>;
    completedWithin3Days?: Maybe<Scalars['Float']['output']>;
    completedWithin7Days?: Maybe<Scalars['Float']['output']>;
    completedWithin30Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedSameDay?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin2Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin3Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin7Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin30Days?: Maybe<Scalars['Float']['output']>;
    suggestionsSameDay?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin2Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin3Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin7Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin30Days?: Maybe<Scalars['Float']['output']>;
    trailingTotalCompleted?: Maybe<Scalars['Float']['output']>;
    trailingTotalGoalsReached?: Maybe<Scalars['Float']['output']>;
    trailingTotalSuggestions?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type OutreachCompletionMetrics_Stddev_Pop_Fields = {
    __typename?: 'OutreachCompletionMetrics_stddev_pop_fields';
    completedSameDay?: Maybe<Scalars['Float']['output']>;
    completedWithin2Days?: Maybe<Scalars['Float']['output']>;
    completedWithin3Days?: Maybe<Scalars['Float']['output']>;
    completedWithin7Days?: Maybe<Scalars['Float']['output']>;
    completedWithin30Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedSameDay?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin2Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin3Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin7Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin30Days?: Maybe<Scalars['Float']['output']>;
    suggestionsSameDay?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin2Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin3Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin7Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin30Days?: Maybe<Scalars['Float']['output']>;
    trailingTotalCompleted?: Maybe<Scalars['Float']['output']>;
    trailingTotalGoalsReached?: Maybe<Scalars['Float']['output']>;
    trailingTotalSuggestions?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type OutreachCompletionMetrics_Stddev_Samp_Fields = {
    __typename?: 'OutreachCompletionMetrics_stddev_samp_fields';
    completedSameDay?: Maybe<Scalars['Float']['output']>;
    completedWithin2Days?: Maybe<Scalars['Float']['output']>;
    completedWithin3Days?: Maybe<Scalars['Float']['output']>;
    completedWithin7Days?: Maybe<Scalars['Float']['output']>;
    completedWithin30Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedSameDay?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin2Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin3Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin7Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin30Days?: Maybe<Scalars['Float']['output']>;
    suggestionsSameDay?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin2Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin3Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin7Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin30Days?: Maybe<Scalars['Float']['output']>;
    trailingTotalCompleted?: Maybe<Scalars['Float']['output']>;
    trailingTotalGoalsReached?: Maybe<Scalars['Float']['output']>;
    trailingTotalSuggestions?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "OutreachCompletionMetrics" */
export type OutreachCompletionMetrics_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: OutreachCompletionMetrics_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type OutreachCompletionMetrics_Stream_Cursor_Value_Input = {
    completedSameDay?: InputMaybe<Scalars['Int']['input']>;
    completedWithin2Days?: InputMaybe<Scalars['Int']['input']>;
    completedWithin3Days?: InputMaybe<Scalars['Int']['input']>;
    completedWithin7Days?: InputMaybe<Scalars['Int']['input']>;
    completedWithin30Days?: InputMaybe<Scalars['Int']['input']>;
    date?: InputMaybe<Scalars['timestamp']['input']>;
    goalsReachedSameDay?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin2Days?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin3Days?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin7Days?: InputMaybe<Scalars['Int']['input']>;
    goalsReachedWithin30Days?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    suggestionsSameDay?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin2Days?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin3Days?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin7Days?: InputMaybe<Scalars['Int']['input']>;
    suggestionsWithin30Days?: InputMaybe<Scalars['Int']['input']>;
    trailingTotalCompleted?: InputMaybe<Scalars['Int']['input']>;
    trailingTotalGoalsReached?: InputMaybe<Scalars['Int']['input']>;
    trailingTotalSuggestions?: InputMaybe<Scalars['Int']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type OutreachCompletionMetrics_Sum_Fields = {
    __typename?: 'OutreachCompletionMetrics_sum_fields';
    completedSameDay?: Maybe<Scalars['Int']['output']>;
    completedWithin2Days?: Maybe<Scalars['Int']['output']>;
    completedWithin3Days?: Maybe<Scalars['Int']['output']>;
    completedWithin7Days?: Maybe<Scalars['Int']['output']>;
    completedWithin30Days?: Maybe<Scalars['Int']['output']>;
    goalsReachedSameDay?: Maybe<Scalars['Int']['output']>;
    goalsReachedWithin2Days?: Maybe<Scalars['Int']['output']>;
    goalsReachedWithin3Days?: Maybe<Scalars['Int']['output']>;
    goalsReachedWithin7Days?: Maybe<Scalars['Int']['output']>;
    goalsReachedWithin30Days?: Maybe<Scalars['Int']['output']>;
    suggestionsSameDay?: Maybe<Scalars['Int']['output']>;
    suggestionsWithin2Days?: Maybe<Scalars['Int']['output']>;
    suggestionsWithin3Days?: Maybe<Scalars['Int']['output']>;
    suggestionsWithin7Days?: Maybe<Scalars['Int']['output']>;
    suggestionsWithin30Days?: Maybe<Scalars['Int']['output']>;
    trailingTotalCompleted?: Maybe<Scalars['Int']['output']>;
    trailingTotalGoalsReached?: Maybe<Scalars['Int']['output']>;
    trailingTotalSuggestions?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "OutreachCompletionMetrics" */
export enum OutreachCompletionMetrics_Update_Column {
    /** column name */
    CompletedSameDay = 'completedSameDay',
    /** column name */
    CompletedWithin2Days = 'completedWithin2Days',
    /** column name */
    CompletedWithin3Days = 'completedWithin3Days',
    /** column name */
    CompletedWithin7Days = 'completedWithin7Days',
    /** column name */
    CompletedWithin30Days = 'completedWithin30Days',
    /** column name */
    Date = 'date',
    /** column name */
    GoalsReachedSameDay = 'goalsReachedSameDay',
    /** column name */
    GoalsReachedWithin2Days = 'goalsReachedWithin2Days',
    /** column name */
    GoalsReachedWithin3Days = 'goalsReachedWithin3Days',
    /** column name */
    GoalsReachedWithin7Days = 'goalsReachedWithin7Days',
    /** column name */
    GoalsReachedWithin30Days = 'goalsReachedWithin30Days',
    /** column name */
    Id = 'id',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    SuggestionsSameDay = 'suggestionsSameDay',
    /** column name */
    SuggestionsWithin2Days = 'suggestionsWithin2Days',
    /** column name */
    SuggestionsWithin3Days = 'suggestionsWithin3Days',
    /** column name */
    SuggestionsWithin7Days = 'suggestionsWithin7Days',
    /** column name */
    SuggestionsWithin30Days = 'suggestionsWithin30Days',
    /** column name */
    TrailingTotalCompleted = 'trailingTotalCompleted',
    /** column name */
    TrailingTotalGoalsReached = 'trailingTotalGoalsReached',
    /** column name */
    TrailingTotalSuggestions = 'trailingTotalSuggestions',
    /** column name */
    UserId = 'userId',
}

export type OutreachCompletionMetrics_Updates = {
    /** increments the numeric columns with given value of the filtered values */
    _inc?: InputMaybe<OutreachCompletionMetrics_Inc_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<OutreachCompletionMetrics_Set_Input>;
    /** filter the rows which have to be updated */
    where: OutreachCompletionMetrics_Bool_Exp;
};

/** aggregate var_pop on columns */
export type OutreachCompletionMetrics_Var_Pop_Fields = {
    __typename?: 'OutreachCompletionMetrics_var_pop_fields';
    completedSameDay?: Maybe<Scalars['Float']['output']>;
    completedWithin2Days?: Maybe<Scalars['Float']['output']>;
    completedWithin3Days?: Maybe<Scalars['Float']['output']>;
    completedWithin7Days?: Maybe<Scalars['Float']['output']>;
    completedWithin30Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedSameDay?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin2Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin3Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin7Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin30Days?: Maybe<Scalars['Float']['output']>;
    suggestionsSameDay?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin2Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin3Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin7Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin30Days?: Maybe<Scalars['Float']['output']>;
    trailingTotalCompleted?: Maybe<Scalars['Float']['output']>;
    trailingTotalGoalsReached?: Maybe<Scalars['Float']['output']>;
    trailingTotalSuggestions?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type OutreachCompletionMetrics_Var_Samp_Fields = {
    __typename?: 'OutreachCompletionMetrics_var_samp_fields';
    completedSameDay?: Maybe<Scalars['Float']['output']>;
    completedWithin2Days?: Maybe<Scalars['Float']['output']>;
    completedWithin3Days?: Maybe<Scalars['Float']['output']>;
    completedWithin7Days?: Maybe<Scalars['Float']['output']>;
    completedWithin30Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedSameDay?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin2Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin3Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin7Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin30Days?: Maybe<Scalars['Float']['output']>;
    suggestionsSameDay?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin2Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin3Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin7Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin30Days?: Maybe<Scalars['Float']['output']>;
    trailingTotalCompleted?: Maybe<Scalars['Float']['output']>;
    trailingTotalGoalsReached?: Maybe<Scalars['Float']['output']>;
    trailingTotalSuggestions?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type OutreachCompletionMetrics_Variance_Fields = {
    __typename?: 'OutreachCompletionMetrics_variance_fields';
    completedSameDay?: Maybe<Scalars['Float']['output']>;
    completedWithin2Days?: Maybe<Scalars['Float']['output']>;
    completedWithin3Days?: Maybe<Scalars['Float']['output']>;
    completedWithin7Days?: Maybe<Scalars['Float']['output']>;
    completedWithin30Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedSameDay?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin2Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin3Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin7Days?: Maybe<Scalars['Float']['output']>;
    goalsReachedWithin30Days?: Maybe<Scalars['Float']['output']>;
    suggestionsSameDay?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin2Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin3Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin7Days?: Maybe<Scalars['Float']['output']>;
    suggestionsWithin30Days?: Maybe<Scalars['Float']['output']>;
    trailingTotalCompleted?: Maybe<Scalars['Float']['output']>;
    trailingTotalGoalsReached?: Maybe<Scalars['Float']['output']>;
    trailingTotalSuggestions?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "OutreachSuggestions" */
export type OutreachSuggestions = {
    __typename?: 'OutreachSuggestions';
    /** An object relationship */
    ConversationMetaData?: Maybe<ConversationMetaData>;
    /** An object relationship */
    Message: Messages;
    accountId?: Maybe<Scalars['String']['output']>;
    accountName: Scalars['String']['output'];
    accountWebsite?: Maybe<Scalars['String']['output']>;
    campaignId?: Maybe<Scalars['String']['output']>;
    campaignName?: Maybe<Scalars['String']['output']>;
    campaignType?: Maybe<Scalars['String']['output']>;
    contactLocation?: Maybe<Scalars['String']['output']>;
    conversationMetaDataId?: Maybe<Scalars['String']['output']>;
    conversationPaths?: Maybe<Array<Scalars['String']['output']>>;
    createdAt: Scalars['timestamp']['output'];
    email?: Maybe<Scalars['String']['output']>;
    goal?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    industry?: Maybe<Scalars['String']['output']>;
    isGenerating: Scalars['Boolean']['output'];
    linkedinUrl?: Maybe<Scalars['String']['output']>;
    messageId: Scalars['String']['output'];
    name: Scalars['String']['output'];
    numberOfEmployees?: Maybe<Scalars['String']['output']>;
    organizationId: Scalars['String']['output'];
    personId?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    scheduledOn?: Maybe<Scalars['timestamp']['output']>;
    scheduledOnMotivation?: Maybe<Scalars['String']['output']>;
    score: Scalars['Int']['output'];
    title: Scalars['String']['output'];
    unread: Scalars['Boolean']['output'];
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
};

/** aggregated selection of "OutreachSuggestions" */
export type OutreachSuggestions_Aggregate = {
    __typename?: 'OutreachSuggestions_aggregate';
    aggregate?: Maybe<OutreachSuggestions_Aggregate_Fields>;
    nodes: Array<OutreachSuggestions>;
};

export type OutreachSuggestions_Aggregate_Bool_Exp = {
    bool_and?: InputMaybe<OutreachSuggestions_Aggregate_Bool_Exp_Bool_And>;
    bool_or?: InputMaybe<OutreachSuggestions_Aggregate_Bool_Exp_Bool_Or>;
    count?: InputMaybe<OutreachSuggestions_Aggregate_Bool_Exp_Count>;
};

export type OutreachSuggestions_Aggregate_Bool_Exp_Bool_And = {
    arguments: OutreachSuggestions_Select_Column_OutreachSuggestions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<OutreachSuggestions_Bool_Exp>;
    predicate: Boolean_Comparison_Exp;
};

export type OutreachSuggestions_Aggregate_Bool_Exp_Bool_Or = {
    arguments: OutreachSuggestions_Select_Column_OutreachSuggestions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<OutreachSuggestions_Bool_Exp>;
    predicate: Boolean_Comparison_Exp;
};

export type OutreachSuggestions_Aggregate_Bool_Exp_Count = {
    arguments?: InputMaybe<Array<OutreachSuggestions_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<OutreachSuggestions_Bool_Exp>;
    predicate: Int_Comparison_Exp;
};

/** aggregate fields of "OutreachSuggestions" */
export type OutreachSuggestions_Aggregate_Fields = {
    __typename?: 'OutreachSuggestions_aggregate_fields';
    avg?: Maybe<OutreachSuggestions_Avg_Fields>;
    count: Scalars['Int']['output'];
    max?: Maybe<OutreachSuggestions_Max_Fields>;
    min?: Maybe<OutreachSuggestions_Min_Fields>;
    stddev?: Maybe<OutreachSuggestions_Stddev_Fields>;
    stddev_pop?: Maybe<OutreachSuggestions_Stddev_Pop_Fields>;
    stddev_samp?: Maybe<OutreachSuggestions_Stddev_Samp_Fields>;
    sum?: Maybe<OutreachSuggestions_Sum_Fields>;
    var_pop?: Maybe<OutreachSuggestions_Var_Pop_Fields>;
    var_samp?: Maybe<OutreachSuggestions_Var_Samp_Fields>;
    variance?: Maybe<OutreachSuggestions_Variance_Fields>;
};

/** aggregate fields of "OutreachSuggestions" */
export type OutreachSuggestions_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<OutreachSuggestions_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "OutreachSuggestions" */
export type OutreachSuggestions_Aggregate_Order_By = {
    avg?: InputMaybe<OutreachSuggestions_Avg_Order_By>;
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<OutreachSuggestions_Max_Order_By>;
    min?: InputMaybe<OutreachSuggestions_Min_Order_By>;
    stddev?: InputMaybe<OutreachSuggestions_Stddev_Order_By>;
    stddev_pop?: InputMaybe<OutreachSuggestions_Stddev_Pop_Order_By>;
    stddev_samp?: InputMaybe<OutreachSuggestions_Stddev_Samp_Order_By>;
    sum?: InputMaybe<OutreachSuggestions_Sum_Order_By>;
    var_pop?: InputMaybe<OutreachSuggestions_Var_Pop_Order_By>;
    var_samp?: InputMaybe<OutreachSuggestions_Var_Samp_Order_By>;
    variance?: InputMaybe<OutreachSuggestions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "OutreachSuggestions" */
export type OutreachSuggestions_Arr_Rel_Insert_Input = {
    data: Array<OutreachSuggestions_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<OutreachSuggestions_On_Conflict>;
};

/** aggregate avg on columns */
export type OutreachSuggestions_Avg_Fields = {
    __typename?: 'OutreachSuggestions_avg_fields';
    score?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "OutreachSuggestions" */
export type OutreachSuggestions_Avg_Order_By = {
    score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "OutreachSuggestions". All fields are combined with a logical 'AND'. */
export type OutreachSuggestions_Bool_Exp = {
    ConversationMetaData?: InputMaybe<ConversationMetaData_Bool_Exp>;
    Message?: InputMaybe<Messages_Bool_Exp>;
    _and?: InputMaybe<Array<OutreachSuggestions_Bool_Exp>>;
    _not?: InputMaybe<OutreachSuggestions_Bool_Exp>;
    _or?: InputMaybe<Array<OutreachSuggestions_Bool_Exp>>;
    accountId?: InputMaybe<String_Comparison_Exp>;
    accountName?: InputMaybe<String_Comparison_Exp>;
    accountWebsite?: InputMaybe<String_Comparison_Exp>;
    campaignId?: InputMaybe<String_Comparison_Exp>;
    campaignName?: InputMaybe<String_Comparison_Exp>;
    campaignType?: InputMaybe<String_Comparison_Exp>;
    contactLocation?: InputMaybe<String_Comparison_Exp>;
    conversationMetaDataId?: InputMaybe<String_Comparison_Exp>;
    conversationPaths?: InputMaybe<String_Array_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    email?: InputMaybe<String_Comparison_Exp>;
    goal?: InputMaybe<String_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    industry?: InputMaybe<String_Comparison_Exp>;
    isGenerating?: InputMaybe<Boolean_Comparison_Exp>;
    linkedinUrl?: InputMaybe<String_Comparison_Exp>;
    messageId?: InputMaybe<String_Comparison_Exp>;
    name?: InputMaybe<String_Comparison_Exp>;
    numberOfEmployees?: InputMaybe<String_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    personId?: InputMaybe<String_Comparison_Exp>;
    prospectId?: InputMaybe<String_Comparison_Exp>;
    scheduledOn?: InputMaybe<Timestamp_Comparison_Exp>;
    scheduledOnMotivation?: InputMaybe<String_Comparison_Exp>;
    score?: InputMaybe<Int_Comparison_Exp>;
    title?: InputMaybe<String_Comparison_Exp>;
    unread?: InputMaybe<Boolean_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "OutreachSuggestions" */
export enum OutreachSuggestions_Constraint {
    /** unique or primary key constraint on columns "conversationMetaDataId" */
    OutreachSuggestionsConversationMetaDataIdKey = 'OutreachSuggestions_conversationMetaDataId_key',
    /** unique or primary key constraint on columns "messageId" */
    OutreachSuggestionsMessageIdKey = 'OutreachSuggestions_messageId_key',
    /** unique or primary key constraint on columns "id" */
    OutreachSuggestionsPkey = 'OutreachSuggestions_pkey',
}

/** input type for incrementing numeric columns in table "OutreachSuggestions" */
export type OutreachSuggestions_Inc_Input = {
    score?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "OutreachSuggestions" */
export type OutreachSuggestions_Insert_Input = {
    ConversationMetaData?: InputMaybe<ConversationMetaData_Obj_Rel_Insert_Input>;
    Message?: InputMaybe<Messages_Obj_Rel_Insert_Input>;
    accountId?: InputMaybe<Scalars['String']['input']>;
    accountName?: InputMaybe<Scalars['String']['input']>;
    accountWebsite?: InputMaybe<Scalars['String']['input']>;
    campaignId?: InputMaybe<Scalars['String']['input']>;
    campaignName?: InputMaybe<Scalars['String']['input']>;
    campaignType?: InputMaybe<Scalars['String']['input']>;
    contactLocation?: InputMaybe<Scalars['String']['input']>;
    conversationMetaDataId?: InputMaybe<Scalars['String']['input']>;
    conversationPaths?: InputMaybe<Array<Scalars['String']['input']>>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    goal?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    industry?: InputMaybe<Scalars['String']['input']>;
    isGenerating?: InputMaybe<Scalars['Boolean']['input']>;
    linkedinUrl?: InputMaybe<Scalars['String']['input']>;
    messageId?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    numberOfEmployees?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    personId?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    scheduledOn?: InputMaybe<Scalars['timestamp']['input']>;
    scheduledOnMotivation?: InputMaybe<Scalars['String']['input']>;
    score?: InputMaybe<Scalars['Int']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    unread?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type OutreachSuggestions_Max_Fields = {
    __typename?: 'OutreachSuggestions_max_fields';
    accountId?: Maybe<Scalars['String']['output']>;
    accountName?: Maybe<Scalars['String']['output']>;
    accountWebsite?: Maybe<Scalars['String']['output']>;
    campaignId?: Maybe<Scalars['String']['output']>;
    campaignName?: Maybe<Scalars['String']['output']>;
    campaignType?: Maybe<Scalars['String']['output']>;
    contactLocation?: Maybe<Scalars['String']['output']>;
    conversationMetaDataId?: Maybe<Scalars['String']['output']>;
    conversationPaths?: Maybe<Array<Scalars['String']['output']>>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    goal?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    industry?: Maybe<Scalars['String']['output']>;
    linkedinUrl?: Maybe<Scalars['String']['output']>;
    messageId?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    numberOfEmployees?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    personId?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    scheduledOn?: Maybe<Scalars['timestamp']['output']>;
    scheduledOnMotivation?: Maybe<Scalars['String']['output']>;
    score?: Maybe<Scalars['Int']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "OutreachSuggestions" */
export type OutreachSuggestions_Max_Order_By = {
    accountId?: InputMaybe<Order_By>;
    accountName?: InputMaybe<Order_By>;
    accountWebsite?: InputMaybe<Order_By>;
    campaignId?: InputMaybe<Order_By>;
    campaignName?: InputMaybe<Order_By>;
    campaignType?: InputMaybe<Order_By>;
    contactLocation?: InputMaybe<Order_By>;
    conversationMetaDataId?: InputMaybe<Order_By>;
    conversationPaths?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    email?: InputMaybe<Order_By>;
    goal?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    industry?: InputMaybe<Order_By>;
    linkedinUrl?: InputMaybe<Order_By>;
    messageId?: InputMaybe<Order_By>;
    name?: InputMaybe<Order_By>;
    numberOfEmployees?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    personId?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    scheduledOn?: InputMaybe<Order_By>;
    scheduledOnMotivation?: InputMaybe<Order_By>;
    score?: InputMaybe<Order_By>;
    title?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type OutreachSuggestions_Min_Fields = {
    __typename?: 'OutreachSuggestions_min_fields';
    accountId?: Maybe<Scalars['String']['output']>;
    accountName?: Maybe<Scalars['String']['output']>;
    accountWebsite?: Maybe<Scalars['String']['output']>;
    campaignId?: Maybe<Scalars['String']['output']>;
    campaignName?: Maybe<Scalars['String']['output']>;
    campaignType?: Maybe<Scalars['String']['output']>;
    contactLocation?: Maybe<Scalars['String']['output']>;
    conversationMetaDataId?: Maybe<Scalars['String']['output']>;
    conversationPaths?: Maybe<Array<Scalars['String']['output']>>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    goal?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    industry?: Maybe<Scalars['String']['output']>;
    linkedinUrl?: Maybe<Scalars['String']['output']>;
    messageId?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    numberOfEmployees?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    personId?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    scheduledOn?: Maybe<Scalars['timestamp']['output']>;
    scheduledOnMotivation?: Maybe<Scalars['String']['output']>;
    score?: Maybe<Scalars['Int']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "OutreachSuggestions" */
export type OutreachSuggestions_Min_Order_By = {
    accountId?: InputMaybe<Order_By>;
    accountName?: InputMaybe<Order_By>;
    accountWebsite?: InputMaybe<Order_By>;
    campaignId?: InputMaybe<Order_By>;
    campaignName?: InputMaybe<Order_By>;
    campaignType?: InputMaybe<Order_By>;
    contactLocation?: InputMaybe<Order_By>;
    conversationMetaDataId?: InputMaybe<Order_By>;
    conversationPaths?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    email?: InputMaybe<Order_By>;
    goal?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    industry?: InputMaybe<Order_By>;
    linkedinUrl?: InputMaybe<Order_By>;
    messageId?: InputMaybe<Order_By>;
    name?: InputMaybe<Order_By>;
    numberOfEmployees?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    personId?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    scheduledOn?: InputMaybe<Order_By>;
    scheduledOnMotivation?: InputMaybe<Order_By>;
    score?: InputMaybe<Order_By>;
    title?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "OutreachSuggestions" */
export type OutreachSuggestions_Mutation_Response = {
    __typename?: 'OutreachSuggestions_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<OutreachSuggestions>;
};

/** input type for inserting object relation for remote table "OutreachSuggestions" */
export type OutreachSuggestions_Obj_Rel_Insert_Input = {
    data: OutreachSuggestions_Insert_Input;
    /** upsert condition */
    on_conflict?: InputMaybe<OutreachSuggestions_On_Conflict>;
};

/** on_conflict condition type for table "OutreachSuggestions" */
export type OutreachSuggestions_On_Conflict = {
    constraint: OutreachSuggestions_Constraint;
    update_columns?: Array<OutreachSuggestions_Update_Column>;
    where?: InputMaybe<OutreachSuggestions_Bool_Exp>;
};

/** Ordering options when selecting data from "OutreachSuggestions". */
export type OutreachSuggestions_Order_By = {
    ConversationMetaData?: InputMaybe<ConversationMetaData_Order_By>;
    Message?: InputMaybe<Messages_Order_By>;
    accountId?: InputMaybe<Order_By>;
    accountName?: InputMaybe<Order_By>;
    accountWebsite?: InputMaybe<Order_By>;
    campaignId?: InputMaybe<Order_By>;
    campaignName?: InputMaybe<Order_By>;
    campaignType?: InputMaybe<Order_By>;
    contactLocation?: InputMaybe<Order_By>;
    conversationMetaDataId?: InputMaybe<Order_By>;
    conversationPaths?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    email?: InputMaybe<Order_By>;
    goal?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    industry?: InputMaybe<Order_By>;
    isGenerating?: InputMaybe<Order_By>;
    linkedinUrl?: InputMaybe<Order_By>;
    messageId?: InputMaybe<Order_By>;
    name?: InputMaybe<Order_By>;
    numberOfEmployees?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    personId?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    scheduledOn?: InputMaybe<Order_By>;
    scheduledOnMotivation?: InputMaybe<Order_By>;
    score?: InputMaybe<Order_By>;
    title?: InputMaybe<Order_By>;
    unread?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: OutreachSuggestions */
export type OutreachSuggestions_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** select columns of table "OutreachSuggestions" */
export enum OutreachSuggestions_Select_Column {
    /** column name */
    AccountId = 'accountId',
    /** column name */
    AccountName = 'accountName',
    /** column name */
    AccountWebsite = 'accountWebsite',
    /** column name */
    CampaignId = 'campaignId',
    /** column name */
    CampaignName = 'campaignName',
    /** column name */
    CampaignType = 'campaignType',
    /** column name */
    ContactLocation = 'contactLocation',
    /** column name */
    ConversationMetaDataId = 'conversationMetaDataId',
    /** column name */
    ConversationPaths = 'conversationPaths',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Email = 'email',
    /** column name */
    Goal = 'goal',
    /** column name */
    Id = 'id',
    /** column name */
    Industry = 'industry',
    /** column name */
    IsGenerating = 'isGenerating',
    /** column name */
    LinkedinUrl = 'linkedinUrl',
    /** column name */
    MessageId = 'messageId',
    /** column name */
    Name = 'name',
    /** column name */
    NumberOfEmployees = 'numberOfEmployees',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    PersonId = 'personId',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    ScheduledOn = 'scheduledOn',
    /** column name */
    ScheduledOnMotivation = 'scheduledOnMotivation',
    /** column name */
    Score = 'score',
    /** column name */
    Title = 'title',
    /** column name */
    Unread = 'unread',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

/** select "OutreachSuggestions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "OutreachSuggestions" */
export enum OutreachSuggestions_Select_Column_OutreachSuggestions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
    /** column name */
    IsGenerating = 'isGenerating',
    /** column name */
    Unread = 'unread',
}

/** select "OutreachSuggestions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "OutreachSuggestions" */
export enum OutreachSuggestions_Select_Column_OutreachSuggestions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
    /** column name */
    IsGenerating = 'isGenerating',
    /** column name */
    Unread = 'unread',
}

/** input type for updating data in table "OutreachSuggestions" */
export type OutreachSuggestions_Set_Input = {
    accountId?: InputMaybe<Scalars['String']['input']>;
    accountName?: InputMaybe<Scalars['String']['input']>;
    accountWebsite?: InputMaybe<Scalars['String']['input']>;
    campaignId?: InputMaybe<Scalars['String']['input']>;
    campaignName?: InputMaybe<Scalars['String']['input']>;
    campaignType?: InputMaybe<Scalars['String']['input']>;
    contactLocation?: InputMaybe<Scalars['String']['input']>;
    conversationMetaDataId?: InputMaybe<Scalars['String']['input']>;
    conversationPaths?: InputMaybe<Array<Scalars['String']['input']>>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    goal?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    industry?: InputMaybe<Scalars['String']['input']>;
    isGenerating?: InputMaybe<Scalars['Boolean']['input']>;
    linkedinUrl?: InputMaybe<Scalars['String']['input']>;
    messageId?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    numberOfEmployees?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    personId?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    scheduledOn?: InputMaybe<Scalars['timestamp']['input']>;
    scheduledOnMotivation?: InputMaybe<Scalars['String']['input']>;
    score?: InputMaybe<Scalars['Int']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    unread?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type OutreachSuggestions_Stddev_Fields = {
    __typename?: 'OutreachSuggestions_stddev_fields';
    score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "OutreachSuggestions" */
export type OutreachSuggestions_Stddev_Order_By = {
    score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type OutreachSuggestions_Stddev_Pop_Fields = {
    __typename?: 'OutreachSuggestions_stddev_pop_fields';
    score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "OutreachSuggestions" */
export type OutreachSuggestions_Stddev_Pop_Order_By = {
    score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type OutreachSuggestions_Stddev_Samp_Fields = {
    __typename?: 'OutreachSuggestions_stddev_samp_fields';
    score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "OutreachSuggestions" */
export type OutreachSuggestions_Stddev_Samp_Order_By = {
    score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "OutreachSuggestions" */
export type OutreachSuggestions_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: OutreachSuggestions_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type OutreachSuggestions_Stream_Cursor_Value_Input = {
    accountId?: InputMaybe<Scalars['String']['input']>;
    accountName?: InputMaybe<Scalars['String']['input']>;
    accountWebsite?: InputMaybe<Scalars['String']['input']>;
    campaignId?: InputMaybe<Scalars['String']['input']>;
    campaignName?: InputMaybe<Scalars['String']['input']>;
    campaignType?: InputMaybe<Scalars['String']['input']>;
    contactLocation?: InputMaybe<Scalars['String']['input']>;
    conversationMetaDataId?: InputMaybe<Scalars['String']['input']>;
    conversationPaths?: InputMaybe<Array<Scalars['String']['input']>>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    goal?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    industry?: InputMaybe<Scalars['String']['input']>;
    isGenerating?: InputMaybe<Scalars['Boolean']['input']>;
    linkedinUrl?: InputMaybe<Scalars['String']['input']>;
    messageId?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    numberOfEmployees?: InputMaybe<Scalars['String']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    personId?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    scheduledOn?: InputMaybe<Scalars['timestamp']['input']>;
    scheduledOnMotivation?: InputMaybe<Scalars['String']['input']>;
    score?: InputMaybe<Scalars['Int']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    unread?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type OutreachSuggestions_Sum_Fields = {
    __typename?: 'OutreachSuggestions_sum_fields';
    score?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "OutreachSuggestions" */
export type OutreachSuggestions_Sum_Order_By = {
    score?: InputMaybe<Order_By>;
};

/** update columns of table "OutreachSuggestions" */
export enum OutreachSuggestions_Update_Column {
    /** column name */
    AccountId = 'accountId',
    /** column name */
    AccountName = 'accountName',
    /** column name */
    AccountWebsite = 'accountWebsite',
    /** column name */
    CampaignId = 'campaignId',
    /** column name */
    CampaignName = 'campaignName',
    /** column name */
    CampaignType = 'campaignType',
    /** column name */
    ContactLocation = 'contactLocation',
    /** column name */
    ConversationMetaDataId = 'conversationMetaDataId',
    /** column name */
    ConversationPaths = 'conversationPaths',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Email = 'email',
    /** column name */
    Goal = 'goal',
    /** column name */
    Id = 'id',
    /** column name */
    Industry = 'industry',
    /** column name */
    IsGenerating = 'isGenerating',
    /** column name */
    LinkedinUrl = 'linkedinUrl',
    /** column name */
    MessageId = 'messageId',
    /** column name */
    Name = 'name',
    /** column name */
    NumberOfEmployees = 'numberOfEmployees',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    PersonId = 'personId',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    ScheduledOn = 'scheduledOn',
    /** column name */
    ScheduledOnMotivation = 'scheduledOnMotivation',
    /** column name */
    Score = 'score',
    /** column name */
    Title = 'title',
    /** column name */
    Unread = 'unread',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

export type OutreachSuggestions_Updates = {
    /** increments the numeric columns with given value of the filtered values */
    _inc?: InputMaybe<OutreachSuggestions_Inc_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<OutreachSuggestions_Set_Input>;
    /** filter the rows which have to be updated */
    where: OutreachSuggestions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type OutreachSuggestions_Var_Pop_Fields = {
    __typename?: 'OutreachSuggestions_var_pop_fields';
    score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "OutreachSuggestions" */
export type OutreachSuggestions_Var_Pop_Order_By = {
    score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type OutreachSuggestions_Var_Samp_Fields = {
    __typename?: 'OutreachSuggestions_var_samp_fields';
    score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "OutreachSuggestions" */
export type OutreachSuggestions_Var_Samp_Order_By = {
    score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type OutreachSuggestions_Variance_Fields = {
    __typename?: 'OutreachSuggestions_variance_fields';
    score?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "OutreachSuggestions" */
export type OutreachSuggestions_Variance_Order_By = {
    score?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "PromptCategory". All fields are combined with logical 'AND'. */
export type PromptCategory_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['PromptCategory']['input']>;
    _gt?: InputMaybe<Scalars['PromptCategory']['input']>;
    _gte?: InputMaybe<Scalars['PromptCategory']['input']>;
    _in?: InputMaybe<Array<Scalars['PromptCategory']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['PromptCategory']['input']>;
    _lte?: InputMaybe<Scalars['PromptCategory']['input']>;
    _neq?: InputMaybe<Scalars['PromptCategory']['input']>;
    _nin?: InputMaybe<Array<Scalars['PromptCategory']['input']>>;
};

/** columns and relationships of "ResourceEmbeddings" */
export type ResourceEmbeddings = {
    __typename?: 'ResourceEmbeddings';
    /** An object relationship */
    Resource: Resources;
    content: Scalars['String']['output'];
    createdAt: Scalars['timestamp']['output'];
    id: Scalars['String']['output'];
    metadata?: Maybe<Scalars['jsonb']['output']>;
    organizationId: Scalars['String']['output'];
    resourceId: Scalars['String']['output'];
    userId: Scalars['String']['output'];
    vector: Scalars['vector']['output'];
};

/** columns and relationships of "ResourceEmbeddings" */
export type ResourceEmbeddingsMetadataArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "ResourceEmbeddings" */
export type ResourceEmbeddings_Aggregate = {
    __typename?: 'ResourceEmbeddings_aggregate';
    aggregate?: Maybe<ResourceEmbeddings_Aggregate_Fields>;
    nodes: Array<ResourceEmbeddings>;
};

export type ResourceEmbeddings_Aggregate_Bool_Exp = {
    count?: InputMaybe<ResourceEmbeddings_Aggregate_Bool_Exp_Count>;
};

export type ResourceEmbeddings_Aggregate_Bool_Exp_Count = {
    arguments?: InputMaybe<Array<ResourceEmbeddings_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<ResourceEmbeddings_Bool_Exp>;
    predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ResourceEmbeddings" */
export type ResourceEmbeddings_Aggregate_Fields = {
    __typename?: 'ResourceEmbeddings_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<ResourceEmbeddings_Max_Fields>;
    min?: Maybe<ResourceEmbeddings_Min_Fields>;
};

/** aggregate fields of "ResourceEmbeddings" */
export type ResourceEmbeddings_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<ResourceEmbeddings_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ResourceEmbeddings" */
export type ResourceEmbeddings_Aggregate_Order_By = {
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<ResourceEmbeddings_Max_Order_By>;
    min?: InputMaybe<ResourceEmbeddings_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ResourceEmbeddings_Append_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "ResourceEmbeddings" */
export type ResourceEmbeddings_Arr_Rel_Insert_Input = {
    data: Array<ResourceEmbeddings_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<ResourceEmbeddings_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ResourceEmbeddings". All fields are combined with a logical 'AND'. */
export type ResourceEmbeddings_Bool_Exp = {
    Resource?: InputMaybe<Resources_Bool_Exp>;
    _and?: InputMaybe<Array<ResourceEmbeddings_Bool_Exp>>;
    _not?: InputMaybe<ResourceEmbeddings_Bool_Exp>;
    _or?: InputMaybe<Array<ResourceEmbeddings_Bool_Exp>>;
    content?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    metadata?: InputMaybe<Jsonb_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    resourceId?: InputMaybe<String_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
    vector?: InputMaybe<Vector_Comparison_Exp>;
};

/** unique or primary key constraints on table "ResourceEmbeddings" */
export enum ResourceEmbeddings_Constraint {
    /** unique or primary key constraint on columns "id" */
    ResourceEmbeddingsPkey = 'ResourceEmbeddings_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ResourceEmbeddings_Delete_At_Path_Input = {
    metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ResourceEmbeddings_Delete_Elem_Input = {
    metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ResourceEmbeddings_Delete_Key_Input = {
    metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "ResourceEmbeddings" */
export type ResourceEmbeddings_Insert_Input = {
    Resource?: InputMaybe<Resources_Obj_Rel_Insert_Input>;
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    resourceId?: InputMaybe<Scalars['String']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    vector?: InputMaybe<Scalars['vector']['input']>;
};

/** aggregate max on columns */
export type ResourceEmbeddings_Max_Fields = {
    __typename?: 'ResourceEmbeddings_max_fields';
    content?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    resourceId?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "ResourceEmbeddings" */
export type ResourceEmbeddings_Max_Order_By = {
    content?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    resourceId?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ResourceEmbeddings_Min_Fields = {
    __typename?: 'ResourceEmbeddings_min_fields';
    content?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    resourceId?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "ResourceEmbeddings" */
export type ResourceEmbeddings_Min_Order_By = {
    content?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    resourceId?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ResourceEmbeddings" */
export type ResourceEmbeddings_Mutation_Response = {
    __typename?: 'ResourceEmbeddings_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<ResourceEmbeddings>;
};

/** on_conflict condition type for table "ResourceEmbeddings" */
export type ResourceEmbeddings_On_Conflict = {
    constraint: ResourceEmbeddings_Constraint;
    update_columns?: Array<ResourceEmbeddings_Update_Column>;
    where?: InputMaybe<ResourceEmbeddings_Bool_Exp>;
};

/** Ordering options when selecting data from "ResourceEmbeddings". */
export type ResourceEmbeddings_Order_By = {
    Resource?: InputMaybe<Resources_Order_By>;
    content?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    metadata?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    resourceId?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    vector?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ResourceEmbeddings */
export type ResourceEmbeddings_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ResourceEmbeddings_Prepend_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "ResourceEmbeddings" */
export enum ResourceEmbeddings_Select_Column {
    /** column name */
    Content = 'content',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    ResourceId = 'resourceId',
    /** column name */
    UserId = 'userId',
    /** column name */
    Vector = 'vector',
}

/** input type for updating data in table "ResourceEmbeddings" */
export type ResourceEmbeddings_Set_Input = {
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    resourceId?: InputMaybe<Scalars['String']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    vector?: InputMaybe<Scalars['vector']['input']>;
};

/** Streaming cursor of the table "ResourceEmbeddings" */
export type ResourceEmbeddings_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: ResourceEmbeddings_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ResourceEmbeddings_Stream_Cursor_Value_Input = {
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    resourceId?: InputMaybe<Scalars['String']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    vector?: InputMaybe<Scalars['vector']['input']>;
};

/** update columns of table "ResourceEmbeddings" */
export enum ResourceEmbeddings_Update_Column {
    /** column name */
    Content = 'content',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    ResourceId = 'resourceId',
    /** column name */
    UserId = 'userId',
    /** column name */
    Vector = 'vector',
}

export type ResourceEmbeddings_Updates = {
    /** append existing jsonb value of filtered columns with new jsonb value */
    _append?: InputMaybe<ResourceEmbeddings_Append_Input>;
    /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
    _delete_at_path?: InputMaybe<ResourceEmbeddings_Delete_At_Path_Input>;
    /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
    _delete_elem?: InputMaybe<ResourceEmbeddings_Delete_Elem_Input>;
    /** delete key/value pair or string element. key/value pairs are matched based on their key value */
    _delete_key?: InputMaybe<ResourceEmbeddings_Delete_Key_Input>;
    /** prepend existing jsonb value of filtered columns with new jsonb value */
    _prepend?: InputMaybe<ResourceEmbeddings_Prepend_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<ResourceEmbeddings_Set_Input>;
    /** filter the rows which have to be updated */
    where: ResourceEmbeddings_Bool_Exp;
};

/** Boolean expression to compare columns of type "ResourceType". All fields are combined with logical 'AND'. */
export type ResourceType_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['ResourceType']['input']>;
    _gt?: InputMaybe<Scalars['ResourceType']['input']>;
    _gte?: InputMaybe<Scalars['ResourceType']['input']>;
    _in?: InputMaybe<Array<Scalars['ResourceType']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['ResourceType']['input']>;
    _lte?: InputMaybe<Scalars['ResourceType']['input']>;
    _neq?: InputMaybe<Scalars['ResourceType']['input']>;
    _nin?: InputMaybe<Array<Scalars['ResourceType']['input']>>;
};

/** columns and relationships of "Resources" */
export type Resources = {
    __typename?: 'Resources';
    /** An object relationship */
    Account?: Maybe<Accounts>;
    /** An object relationship */
    Contact?: Maybe<Contacts>;
    /** An array relationship */
    ResourceEmbeddings: Array<ResourceEmbeddings>;
    /** An aggregate relationship */
    ResourceEmbeddings_aggregate: ResourceEmbeddings_Aggregate;
    accountId?: Maybe<Scalars['String']['output']>;
    contactId?: Maybe<Scalars['String']['output']>;
    content: Scalars['String']['output'];
    createdAt: Scalars['timestamp']['output'];
    decayRate?: Maybe<Scalars['float8']['output']>;
    id: Scalars['String']['output'];
    lastUsed?: Maybe<Scalars['timestamp']['output']>;
    metadata?: Maybe<Scalars['jsonb']['output']>;
    organizationId: Scalars['String']['output'];
    type: Scalars['ResourceType']['output'];
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
    validUntil?: Maybe<Scalars['timestamp']['output']>;
};

/** columns and relationships of "Resources" */
export type ResourcesResourceEmbeddingsArgs = {
    distinct_on?: InputMaybe<Array<ResourceEmbeddings_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ResourceEmbeddings_Order_By>>;
    where?: InputMaybe<ResourceEmbeddings_Bool_Exp>;
};

/** columns and relationships of "Resources" */
export type ResourcesResourceEmbeddings_AggregateArgs = {
    distinct_on?: InputMaybe<Array<ResourceEmbeddings_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ResourceEmbeddings_Order_By>>;
    where?: InputMaybe<ResourceEmbeddings_Bool_Exp>;
};

/** columns and relationships of "Resources" */
export type ResourcesMetadataArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Resources" */
export type Resources_Aggregate = {
    __typename?: 'Resources_aggregate';
    aggregate?: Maybe<Resources_Aggregate_Fields>;
    nodes: Array<Resources>;
};

export type Resources_Aggregate_Bool_Exp = {
    avg?: InputMaybe<Resources_Aggregate_Bool_Exp_Avg>;
    corr?: InputMaybe<Resources_Aggregate_Bool_Exp_Corr>;
    count?: InputMaybe<Resources_Aggregate_Bool_Exp_Count>;
    covar_samp?: InputMaybe<Resources_Aggregate_Bool_Exp_Covar_Samp>;
    max?: InputMaybe<Resources_Aggregate_Bool_Exp_Max>;
    min?: InputMaybe<Resources_Aggregate_Bool_Exp_Min>;
    stddev_samp?: InputMaybe<Resources_Aggregate_Bool_Exp_Stddev_Samp>;
    sum?: InputMaybe<Resources_Aggregate_Bool_Exp_Sum>;
    var_samp?: InputMaybe<Resources_Aggregate_Bool_Exp_Var_Samp>;
};

export type Resources_Aggregate_Bool_Exp_Avg = {
    arguments: Resources_Select_Column_Resources_Aggregate_Bool_Exp_Avg_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Resources_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

export type Resources_Aggregate_Bool_Exp_Corr = {
    arguments: Resources_Aggregate_Bool_Exp_Corr_Arguments;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Resources_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

export type Resources_Aggregate_Bool_Exp_Corr_Arguments = {
    X: Resources_Select_Column_Resources_Aggregate_Bool_Exp_Corr_Arguments_Columns;
    Y: Resources_Select_Column_Resources_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Resources_Aggregate_Bool_Exp_Count = {
    arguments?: InputMaybe<Array<Resources_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Resources_Bool_Exp>;
    predicate: Int_Comparison_Exp;
};

export type Resources_Aggregate_Bool_Exp_Covar_Samp = {
    arguments: Resources_Aggregate_Bool_Exp_Covar_Samp_Arguments;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Resources_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

export type Resources_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
    X: Resources_Select_Column_Resources_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
    Y: Resources_Select_Column_Resources_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Resources_Aggregate_Bool_Exp_Max = {
    arguments: Resources_Select_Column_Resources_Aggregate_Bool_Exp_Max_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Resources_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

export type Resources_Aggregate_Bool_Exp_Min = {
    arguments: Resources_Select_Column_Resources_Aggregate_Bool_Exp_Min_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Resources_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

export type Resources_Aggregate_Bool_Exp_Stddev_Samp = {
    arguments: Resources_Select_Column_Resources_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Resources_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

export type Resources_Aggregate_Bool_Exp_Sum = {
    arguments: Resources_Select_Column_Resources_Aggregate_Bool_Exp_Sum_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Resources_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

export type Resources_Aggregate_Bool_Exp_Var_Samp = {
    arguments: Resources_Select_Column_Resources_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Resources_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "Resources" */
export type Resources_Aggregate_Fields = {
    __typename?: 'Resources_aggregate_fields';
    avg?: Maybe<Resources_Avg_Fields>;
    count: Scalars['Int']['output'];
    max?: Maybe<Resources_Max_Fields>;
    min?: Maybe<Resources_Min_Fields>;
    stddev?: Maybe<Resources_Stddev_Fields>;
    stddev_pop?: Maybe<Resources_Stddev_Pop_Fields>;
    stddev_samp?: Maybe<Resources_Stddev_Samp_Fields>;
    sum?: Maybe<Resources_Sum_Fields>;
    var_pop?: Maybe<Resources_Var_Pop_Fields>;
    var_samp?: Maybe<Resources_Var_Samp_Fields>;
    variance?: Maybe<Resources_Variance_Fields>;
};

/** aggregate fields of "Resources" */
export type Resources_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<Resources_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Resources" */
export type Resources_Aggregate_Order_By = {
    avg?: InputMaybe<Resources_Avg_Order_By>;
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<Resources_Max_Order_By>;
    min?: InputMaybe<Resources_Min_Order_By>;
    stddev?: InputMaybe<Resources_Stddev_Order_By>;
    stddev_pop?: InputMaybe<Resources_Stddev_Pop_Order_By>;
    stddev_samp?: InputMaybe<Resources_Stddev_Samp_Order_By>;
    sum?: InputMaybe<Resources_Sum_Order_By>;
    var_pop?: InputMaybe<Resources_Var_Pop_Order_By>;
    var_samp?: InputMaybe<Resources_Var_Samp_Order_By>;
    variance?: InputMaybe<Resources_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Resources_Append_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "Resources" */
export type Resources_Arr_Rel_Insert_Input = {
    data: Array<Resources_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<Resources_On_Conflict>;
};

/** aggregate avg on columns */
export type Resources_Avg_Fields = {
    __typename?: 'Resources_avg_fields';
    decayRate?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "Resources" */
export type Resources_Avg_Order_By = {
    decayRate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Resources". All fields are combined with a logical 'AND'. */
export type Resources_Bool_Exp = {
    Account?: InputMaybe<Accounts_Bool_Exp>;
    Contact?: InputMaybe<Contacts_Bool_Exp>;
    ResourceEmbeddings?: InputMaybe<ResourceEmbeddings_Bool_Exp>;
    ResourceEmbeddings_aggregate?: InputMaybe<ResourceEmbeddings_Aggregate_Bool_Exp>;
    _and?: InputMaybe<Array<Resources_Bool_Exp>>;
    _not?: InputMaybe<Resources_Bool_Exp>;
    _or?: InputMaybe<Array<Resources_Bool_Exp>>;
    accountId?: InputMaybe<String_Comparison_Exp>;
    contactId?: InputMaybe<String_Comparison_Exp>;
    content?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    decayRate?: InputMaybe<Float8_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    lastUsed?: InputMaybe<Timestamp_Comparison_Exp>;
    metadata?: InputMaybe<Jsonb_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    type?: InputMaybe<ResourceType_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
    validUntil?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "Resources" */
export enum Resources_Constraint {
    /** unique or primary key constraint on columns "id" */
    ResourcesPkey = 'Resources_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Resources_Delete_At_Path_Input = {
    metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Resources_Delete_Elem_Input = {
    metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Resources_Delete_Key_Input = {
    metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "Resources" */
export type Resources_Inc_Input = {
    decayRate?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "Resources" */
export type Resources_Insert_Input = {
    Account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
    Contact?: InputMaybe<Contacts_Obj_Rel_Insert_Input>;
    ResourceEmbeddings?: InputMaybe<ResourceEmbeddings_Arr_Rel_Insert_Input>;
    accountId?: InputMaybe<Scalars['String']['input']>;
    contactId?: InputMaybe<Scalars['String']['input']>;
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    decayRate?: InputMaybe<Scalars['float8']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUsed?: InputMaybe<Scalars['timestamp']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<Scalars['ResourceType']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    validUntil?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Resources_Max_Fields = {
    __typename?: 'Resources_max_fields';
    accountId?: Maybe<Scalars['String']['output']>;
    contactId?: Maybe<Scalars['String']['output']>;
    content?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    decayRate?: Maybe<Scalars['float8']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUsed?: Maybe<Scalars['timestamp']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['ResourceType']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    validUntil?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "Resources" */
export type Resources_Max_Order_By = {
    accountId?: InputMaybe<Order_By>;
    contactId?: InputMaybe<Order_By>;
    content?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    decayRate?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    lastUsed?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    type?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    validUntil?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Resources_Min_Fields = {
    __typename?: 'Resources_min_fields';
    accountId?: Maybe<Scalars['String']['output']>;
    contactId?: Maybe<Scalars['String']['output']>;
    content?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    decayRate?: Maybe<Scalars['float8']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUsed?: Maybe<Scalars['timestamp']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['ResourceType']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    validUntil?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "Resources" */
export type Resources_Min_Order_By = {
    accountId?: InputMaybe<Order_By>;
    contactId?: InputMaybe<Order_By>;
    content?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    decayRate?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    lastUsed?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    type?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    validUntil?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Resources" */
export type Resources_Mutation_Response = {
    __typename?: 'Resources_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Resources>;
};

/** input type for inserting object relation for remote table "Resources" */
export type Resources_Obj_Rel_Insert_Input = {
    data: Resources_Insert_Input;
    /** upsert condition */
    on_conflict?: InputMaybe<Resources_On_Conflict>;
};

/** on_conflict condition type for table "Resources" */
export type Resources_On_Conflict = {
    constraint: Resources_Constraint;
    update_columns?: Array<Resources_Update_Column>;
    where?: InputMaybe<Resources_Bool_Exp>;
};

/** Ordering options when selecting data from "Resources". */
export type Resources_Order_By = {
    Account?: InputMaybe<Accounts_Order_By>;
    Contact?: InputMaybe<Contacts_Order_By>;
    ResourceEmbeddings_aggregate?: InputMaybe<ResourceEmbeddings_Aggregate_Order_By>;
    accountId?: InputMaybe<Order_By>;
    contactId?: InputMaybe<Order_By>;
    content?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    decayRate?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    lastUsed?: InputMaybe<Order_By>;
    metadata?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    type?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
    validUntil?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Resources */
export type Resources_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Resources_Prepend_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "Resources" */
export enum Resources_Select_Column {
    /** column name */
    AccountId = 'accountId',
    /** column name */
    ContactId = 'contactId',
    /** column name */
    Content = 'content',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    DecayRate = 'decayRate',
    /** column name */
    Id = 'id',
    /** column name */
    LastUsed = 'lastUsed',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    Type = 'type',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
    /** column name */
    ValidUntil = 'validUntil',
}

/** select "Resources_aggregate_bool_exp_avg_arguments_columns" columns of table "Resources" */
export enum Resources_Select_Column_Resources_Aggregate_Bool_Exp_Avg_Arguments_Columns {
    /** column name */
    DecayRate = 'decayRate',
}

/** select "Resources_aggregate_bool_exp_corr_arguments_columns" columns of table "Resources" */
export enum Resources_Select_Column_Resources_Aggregate_Bool_Exp_Corr_Arguments_Columns {
    /** column name */
    DecayRate = 'decayRate',
}

/** select "Resources_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "Resources" */
export enum Resources_Select_Column_Resources_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
    /** column name */
    DecayRate = 'decayRate',
}

/** select "Resources_aggregate_bool_exp_max_arguments_columns" columns of table "Resources" */
export enum Resources_Select_Column_Resources_Aggregate_Bool_Exp_Max_Arguments_Columns {
    /** column name */
    DecayRate = 'decayRate',
}

/** select "Resources_aggregate_bool_exp_min_arguments_columns" columns of table "Resources" */
export enum Resources_Select_Column_Resources_Aggregate_Bool_Exp_Min_Arguments_Columns {
    /** column name */
    DecayRate = 'decayRate',
}

/** select "Resources_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "Resources" */
export enum Resources_Select_Column_Resources_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
    /** column name */
    DecayRate = 'decayRate',
}

/** select "Resources_aggregate_bool_exp_sum_arguments_columns" columns of table "Resources" */
export enum Resources_Select_Column_Resources_Aggregate_Bool_Exp_Sum_Arguments_Columns {
    /** column name */
    DecayRate = 'decayRate',
}

/** select "Resources_aggregate_bool_exp_var_samp_arguments_columns" columns of table "Resources" */
export enum Resources_Select_Column_Resources_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
    /** column name */
    DecayRate = 'decayRate',
}

/** input type for updating data in table "Resources" */
export type Resources_Set_Input = {
    accountId?: InputMaybe<Scalars['String']['input']>;
    contactId?: InputMaybe<Scalars['String']['input']>;
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    decayRate?: InputMaybe<Scalars['float8']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUsed?: InputMaybe<Scalars['timestamp']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<Scalars['ResourceType']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    validUntil?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Resources_Stddev_Fields = {
    __typename?: 'Resources_stddev_fields';
    decayRate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "Resources" */
export type Resources_Stddev_Order_By = {
    decayRate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Resources_Stddev_Pop_Fields = {
    __typename?: 'Resources_stddev_pop_fields';
    decayRate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "Resources" */
export type Resources_Stddev_Pop_Order_By = {
    decayRate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Resources_Stddev_Samp_Fields = {
    __typename?: 'Resources_stddev_samp_fields';
    decayRate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "Resources" */
export type Resources_Stddev_Samp_Order_By = {
    decayRate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Resources" */
export type Resources_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: Resources_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Resources_Stream_Cursor_Value_Input = {
    accountId?: InputMaybe<Scalars['String']['input']>;
    contactId?: InputMaybe<Scalars['String']['input']>;
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    decayRate?: InputMaybe<Scalars['float8']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUsed?: InputMaybe<Scalars['timestamp']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<Scalars['ResourceType']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    validUntil?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Resources_Sum_Fields = {
    __typename?: 'Resources_sum_fields';
    decayRate?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "Resources" */
export type Resources_Sum_Order_By = {
    decayRate?: InputMaybe<Order_By>;
};

/** update columns of table "Resources" */
export enum Resources_Update_Column {
    /** column name */
    AccountId = 'accountId',
    /** column name */
    ContactId = 'contactId',
    /** column name */
    Content = 'content',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    DecayRate = 'decayRate',
    /** column name */
    Id = 'id',
    /** column name */
    LastUsed = 'lastUsed',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    Type = 'type',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
    /** column name */
    ValidUntil = 'validUntil',
}

export type Resources_Updates = {
    /** append existing jsonb value of filtered columns with new jsonb value */
    _append?: InputMaybe<Resources_Append_Input>;
    /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
    _delete_at_path?: InputMaybe<Resources_Delete_At_Path_Input>;
    /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
    _delete_elem?: InputMaybe<Resources_Delete_Elem_Input>;
    /** delete key/value pair or string element. key/value pairs are matched based on their key value */
    _delete_key?: InputMaybe<Resources_Delete_Key_Input>;
    /** increments the numeric columns with given value of the filtered values */
    _inc?: InputMaybe<Resources_Inc_Input>;
    /** prepend existing jsonb value of filtered columns with new jsonb value */
    _prepend?: InputMaybe<Resources_Prepend_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<Resources_Set_Input>;
    /** filter the rows which have to be updated */
    where: Resources_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Resources_Var_Pop_Fields = {
    __typename?: 'Resources_var_pop_fields';
    decayRate?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "Resources" */
export type Resources_Var_Pop_Order_By = {
    decayRate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Resources_Var_Samp_Fields = {
    __typename?: 'Resources_var_samp_fields';
    decayRate?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "Resources" */
export type Resources_Var_Samp_Order_By = {
    decayRate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Resources_Variance_Fields = {
    __typename?: 'Resources_variance_fields';
    decayRate?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "Resources" */
export type Resources_Variance_Order_By = {
    decayRate?: InputMaybe<Order_By>;
};

/** columns and relationships of "SampleContacts" */
export type SampleContacts = {
    __typename?: 'SampleContacts';
    contact: Scalars['jsonb']['output'];
    conversation?: Maybe<Scalars['jsonb']['output']>;
    createdAt: Scalars['timestamp']['output'];
    id: Scalars['String']['output'];
    updatedAt: Scalars['timestamp']['output'];
};

/** columns and relationships of "SampleContacts" */
export type SampleContactsContactArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "SampleContacts" */
export type SampleContactsConversationArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "SampleContacts" */
export type SampleContacts_Aggregate = {
    __typename?: 'SampleContacts_aggregate';
    aggregate?: Maybe<SampleContacts_Aggregate_Fields>;
    nodes: Array<SampleContacts>;
};

/** aggregate fields of "SampleContacts" */
export type SampleContacts_Aggregate_Fields = {
    __typename?: 'SampleContacts_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<SampleContacts_Max_Fields>;
    min?: Maybe<SampleContacts_Min_Fields>;
};

/** aggregate fields of "SampleContacts" */
export type SampleContacts_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<SampleContacts_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SampleContacts_Append_Input = {
    contact?: InputMaybe<Scalars['jsonb']['input']>;
    conversation?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "SampleContacts". All fields are combined with a logical 'AND'. */
export type SampleContacts_Bool_Exp = {
    _and?: InputMaybe<Array<SampleContacts_Bool_Exp>>;
    _not?: InputMaybe<SampleContacts_Bool_Exp>;
    _or?: InputMaybe<Array<SampleContacts_Bool_Exp>>;
    contact?: InputMaybe<Jsonb_Comparison_Exp>;
    conversation?: InputMaybe<Jsonb_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "SampleContacts" */
export enum SampleContacts_Constraint {
    /** unique or primary key constraint on columns "id" */
    SampleContactsPkey = 'SampleContacts_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SampleContacts_Delete_At_Path_Input = {
    contact?: InputMaybe<Array<Scalars['String']['input']>>;
    conversation?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SampleContacts_Delete_Elem_Input = {
    contact?: InputMaybe<Scalars['Int']['input']>;
    conversation?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SampleContacts_Delete_Key_Input = {
    contact?: InputMaybe<Scalars['String']['input']>;
    conversation?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "SampleContacts" */
export type SampleContacts_Insert_Input = {
    contact?: InputMaybe<Scalars['jsonb']['input']>;
    conversation?: InputMaybe<Scalars['jsonb']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type SampleContacts_Max_Fields = {
    __typename?: 'SampleContacts_max_fields';
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type SampleContacts_Min_Fields = {
    __typename?: 'SampleContacts_min_fields';
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "SampleContacts" */
export type SampleContacts_Mutation_Response = {
    __typename?: 'SampleContacts_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<SampleContacts>;
};

/** on_conflict condition type for table "SampleContacts" */
export type SampleContacts_On_Conflict = {
    constraint: SampleContacts_Constraint;
    update_columns?: Array<SampleContacts_Update_Column>;
    where?: InputMaybe<SampleContacts_Bool_Exp>;
};

/** Ordering options when selecting data from "SampleContacts". */
export type SampleContacts_Order_By = {
    contact?: InputMaybe<Order_By>;
    conversation?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: SampleContacts */
export type SampleContacts_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SampleContacts_Prepend_Input = {
    contact?: InputMaybe<Scalars['jsonb']['input']>;
    conversation?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "SampleContacts" */
export enum SampleContacts_Select_Column {
    /** column name */
    Contact = 'contact',
    /** column name */
    Conversation = 'conversation',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    UpdatedAt = 'updatedAt',
}

/** input type for updating data in table "SampleContacts" */
export type SampleContacts_Set_Input = {
    contact?: InputMaybe<Scalars['jsonb']['input']>;
    conversation?: InputMaybe<Scalars['jsonb']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "SampleContacts" */
export type SampleContacts_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: SampleContacts_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SampleContacts_Stream_Cursor_Value_Input = {
    contact?: InputMaybe<Scalars['jsonb']['input']>;
    conversation?: InputMaybe<Scalars['jsonb']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "SampleContacts" */
export enum SampleContacts_Update_Column {
    /** column name */
    Contact = 'contact',
    /** column name */
    Conversation = 'conversation',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    UpdatedAt = 'updatedAt',
}

export type SampleContacts_Updates = {
    /** append existing jsonb value of filtered columns with new jsonb value */
    _append?: InputMaybe<SampleContacts_Append_Input>;
    /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
    _delete_at_path?: InputMaybe<SampleContacts_Delete_At_Path_Input>;
    /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
    _delete_elem?: InputMaybe<SampleContacts_Delete_Elem_Input>;
    /** delete key/value pair or string element. key/value pairs are matched based on their key value */
    _delete_key?: InputMaybe<SampleContacts_Delete_Key_Input>;
    /** prepend existing jsonb value of filtered columns with new jsonb value */
    _prepend?: InputMaybe<SampleContacts_Prepend_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<SampleContacts_Set_Input>;
    /** filter the rows which have to be updated */
    where: SampleContacts_Bool_Exp;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
    /** is the array contained in the given array value */
    _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
    /** does the array contain the given value */
    _contains?: InputMaybe<Array<Scalars['String']['input']>>;
    _eq?: InputMaybe<Array<Scalars['String']['input']>>;
    _gt?: InputMaybe<Array<Scalars['String']['input']>>;
    _gte?: InputMaybe<Array<Scalars['String']['input']>>;
    _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Array<Scalars['String']['input']>>;
    _lte?: InputMaybe<Array<Scalars['String']['input']>>;
    _neq?: InputMaybe<Array<Scalars['String']['input']>>;
    _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['String']['input']>;
    _gt?: InputMaybe<Scalars['String']['input']>;
    _gte?: InputMaybe<Scalars['String']['input']>;
    /** does the column match the given case-insensitive pattern */
    _ilike?: InputMaybe<Scalars['String']['input']>;
    _in?: InputMaybe<Array<Scalars['String']['input']>>;
    /** does the column match the given POSIX regular expression, case insensitive */
    _iregex?: InputMaybe<Scalars['String']['input']>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    /** does the column match the given pattern */
    _like?: InputMaybe<Scalars['String']['input']>;
    _lt?: InputMaybe<Scalars['String']['input']>;
    _lte?: InputMaybe<Scalars['String']['input']>;
    _neq?: InputMaybe<Scalars['String']['input']>;
    /** does the column NOT match the given case-insensitive pattern */
    _nilike?: InputMaybe<Scalars['String']['input']>;
    _nin?: InputMaybe<Array<Scalars['String']['input']>>;
    /** does the column NOT match the given POSIX regular expression, case insensitive */
    _niregex?: InputMaybe<Scalars['String']['input']>;
    /** does the column NOT match the given pattern */
    _nlike?: InputMaybe<Scalars['String']['input']>;
    /** does the column NOT match the given POSIX regular expression, case sensitive */
    _nregex?: InputMaybe<Scalars['String']['input']>;
    /** does the column NOT match the given SQL regular expression */
    _nsimilar?: InputMaybe<Scalars['String']['input']>;
    /** does the column match the given POSIX regular expression, case sensitive */
    _regex?: InputMaybe<Scalars['String']['input']>;
    /** does the column match the given SQL regular expression */
    _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "UserAgentInstructions" */
export type UserAgentInstructions = {
    __typename?: 'UserAgentInstructions';
    category: Scalars['PromptCategory']['output'];
    content: Scalars['String']['output'];
    createdAt: Scalars['timestamp']['output'];
    embedding?: Maybe<Scalars['vector']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    id: Scalars['String']['output'];
    metadata?: Maybe<Scalars['jsonb']['output']>;
    organizationId: Scalars['String']['output'];
    topic: Scalars['String']['output'];
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
};

/** columns and relationships of "UserAgentInstructions" */
export type UserAgentInstructionsMetadataArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "UserAgentInstructions" */
export type UserAgentInstructions_Aggregate = {
    __typename?: 'UserAgentInstructions_aggregate';
    aggregate?: Maybe<UserAgentInstructions_Aggregate_Fields>;
    nodes: Array<UserAgentInstructions>;
};

/** aggregate fields of "UserAgentInstructions" */
export type UserAgentInstructions_Aggregate_Fields = {
    __typename?: 'UserAgentInstructions_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<UserAgentInstructions_Max_Fields>;
    min?: Maybe<UserAgentInstructions_Min_Fields>;
};

/** aggregate fields of "UserAgentInstructions" */
export type UserAgentInstructions_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<UserAgentInstructions_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type UserAgentInstructions_Append_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "UserAgentInstructions". All fields are combined with a logical 'AND'. */
export type UserAgentInstructions_Bool_Exp = {
    _and?: InputMaybe<Array<UserAgentInstructions_Bool_Exp>>;
    _not?: InputMaybe<UserAgentInstructions_Bool_Exp>;
    _or?: InputMaybe<Array<UserAgentInstructions_Bool_Exp>>;
    category?: InputMaybe<PromptCategory_Comparison_Exp>;
    content?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    embedding?: InputMaybe<Vector_Comparison_Exp>;
    embeddingLastUpdatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    metadata?: InputMaybe<Jsonb_Comparison_Exp>;
    organizationId?: InputMaybe<String_Comparison_Exp>;
    topic?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "UserAgentInstructions" */
export enum UserAgentInstructions_Constraint {
    /** unique or primary key constraint on columns "id" */
    UserAgentInstructionsPkey = 'UserAgentInstructions_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type UserAgentInstructions_Delete_At_Path_Input = {
    metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type UserAgentInstructions_Delete_Elem_Input = {
    metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type UserAgentInstructions_Delete_Key_Input = {
    metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "UserAgentInstructions" */
export type UserAgentInstructions_Insert_Input = {
    category?: InputMaybe<Scalars['PromptCategory']['input']>;
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    topic?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type UserAgentInstructions_Max_Fields = {
    __typename?: 'UserAgentInstructions_max_fields';
    category?: Maybe<Scalars['PromptCategory']['output']>;
    content?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    topic?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UserAgentInstructions_Min_Fields = {
    __typename?: 'UserAgentInstructions_min_fields';
    category?: Maybe<Scalars['PromptCategory']['output']>;
    content?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    embeddingLastUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    organizationId?: Maybe<Scalars['String']['output']>;
    topic?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "UserAgentInstructions" */
export type UserAgentInstructions_Mutation_Response = {
    __typename?: 'UserAgentInstructions_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<UserAgentInstructions>;
};

/** on_conflict condition type for table "UserAgentInstructions" */
export type UserAgentInstructions_On_Conflict = {
    constraint: UserAgentInstructions_Constraint;
    update_columns?: Array<UserAgentInstructions_Update_Column>;
    where?: InputMaybe<UserAgentInstructions_Bool_Exp>;
};

/** Ordering options when selecting data from "UserAgentInstructions". */
export type UserAgentInstructions_Order_By = {
    category?: InputMaybe<Order_By>;
    content?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    embedding?: InputMaybe<Order_By>;
    embeddingLastUpdatedAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    metadata?: InputMaybe<Order_By>;
    organizationId?: InputMaybe<Order_By>;
    topic?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: UserAgentInstructions */
export type UserAgentInstructions_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type UserAgentInstructions_Prepend_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "UserAgentInstructions" */
export enum UserAgentInstructions_Select_Column {
    /** column name */
    Category = 'category',
    /** column name */
    Content = 'content',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Embedding = 'embedding',
    /** column name */
    EmbeddingLastUpdatedAt = 'embeddingLastUpdatedAt',
    /** column name */
    Id = 'id',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    Topic = 'topic',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

/** input type for updating data in table "UserAgentInstructions" */
export type UserAgentInstructions_Set_Input = {
    category?: InputMaybe<Scalars['PromptCategory']['input']>;
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    topic?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "UserAgentInstructions" */
export type UserAgentInstructions_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: UserAgentInstructions_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserAgentInstructions_Stream_Cursor_Value_Input = {
    category?: InputMaybe<Scalars['PromptCategory']['input']>;
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    embedding?: InputMaybe<Scalars['vector']['input']>;
    embeddingLastUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    organizationId?: InputMaybe<Scalars['String']['input']>;
    topic?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "UserAgentInstructions" */
export enum UserAgentInstructions_Update_Column {
    /** column name */
    Category = 'category',
    /** column name */
    Content = 'content',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Embedding = 'embedding',
    /** column name */
    EmbeddingLastUpdatedAt = 'embeddingLastUpdatedAt',
    /** column name */
    Id = 'id',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    OrganizationId = 'organizationId',
    /** column name */
    Topic = 'topic',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

export type UserAgentInstructions_Updates = {
    /** append existing jsonb value of filtered columns with new jsonb value */
    _append?: InputMaybe<UserAgentInstructions_Append_Input>;
    /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
    _delete_at_path?: InputMaybe<UserAgentInstructions_Delete_At_Path_Input>;
    /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
    _delete_elem?: InputMaybe<UserAgentInstructions_Delete_Elem_Input>;
    /** delete key/value pair or string element. key/value pairs are matched based on their key value */
    _delete_key?: InputMaybe<UserAgentInstructions_Delete_Key_Input>;
    /** prepend existing jsonb value of filtered columns with new jsonb value */
    _prepend?: InputMaybe<UserAgentInstructions_Prepend_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<UserAgentInstructions_Set_Input>;
    /** filter the rows which have to be updated */
    where: UserAgentInstructions_Bool_Exp;
};

/** Boolean expression to compare columns of type "UserContactStatus". All fields are combined with logical 'AND'. */
export type UserContactStatus_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['UserContactStatus']['input']>;
    _gt?: InputMaybe<Scalars['UserContactStatus']['input']>;
    _gte?: InputMaybe<Scalars['UserContactStatus']['input']>;
    _in?: InputMaybe<Array<Scalars['UserContactStatus']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['UserContactStatus']['input']>;
    _lte?: InputMaybe<Scalars['UserContactStatus']['input']>;
    _neq?: InputMaybe<Scalars['UserContactStatus']['input']>;
    _nin?: InputMaybe<Array<Scalars['UserContactStatus']['input']>>;
};

/** columns and relationships of "UserContacts" */
export type UserContacts = {
    __typename?: 'UserContacts';
    /** An array relationship */
    _GroupToUserContacts: Array<_GroupToUserContact>;
    /** An aggregate relationship */
    _GroupToUserContacts_aggregate: _GroupToUserContact_Aggregate;
    createdAt: Scalars['timestamp']['output'];
    id: Scalars['String']['output'];
    prospectId: Scalars['String']['output'];
    source?: Maybe<Scalars['String']['output']>;
    status: Scalars['UserContactStatus']['output'];
    updatedAt: Scalars['timestamp']['output'];
    userId: Scalars['String']['output'];
};

/** columns and relationships of "UserContacts" */
export type UserContacts_GroupToUserContactsArgs = {
    distinct_on?: InputMaybe<Array<_GroupToUserContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToUserContact_Order_By>>;
    where?: InputMaybe<_GroupToUserContact_Bool_Exp>;
};

/** columns and relationships of "UserContacts" */
export type UserContacts_GroupToUserContacts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<_GroupToUserContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToUserContact_Order_By>>;
    where?: InputMaybe<_GroupToUserContact_Bool_Exp>;
};

/** aggregated selection of "UserContacts" */
export type UserContacts_Aggregate = {
    __typename?: 'UserContacts_aggregate';
    aggregate?: Maybe<UserContacts_Aggregate_Fields>;
    nodes: Array<UserContacts>;
};

/** aggregate fields of "UserContacts" */
export type UserContacts_Aggregate_Fields = {
    __typename?: 'UserContacts_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<UserContacts_Max_Fields>;
    min?: Maybe<UserContacts_Min_Fields>;
};

/** aggregate fields of "UserContacts" */
export type UserContacts_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<UserContacts_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "UserContacts". All fields are combined with a logical 'AND'. */
export type UserContacts_Bool_Exp = {
    _GroupToUserContacts?: InputMaybe<_GroupToUserContact_Bool_Exp>;
    _GroupToUserContacts_aggregate?: InputMaybe<_GroupToUserContact_Aggregate_Bool_Exp>;
    _and?: InputMaybe<Array<UserContacts_Bool_Exp>>;
    _not?: InputMaybe<UserContacts_Bool_Exp>;
    _or?: InputMaybe<Array<UserContacts_Bool_Exp>>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    prospectId?: InputMaybe<String_Comparison_Exp>;
    source?: InputMaybe<String_Comparison_Exp>;
    status?: InputMaybe<UserContactStatus_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "UserContacts" */
export enum UserContacts_Constraint {
    /** unique or primary key constraint on columns "id" */
    UserContactsPkey = 'UserContacts_pkey',
    /** unique or primary key constraint on columns "userId", "prospectId" */
    UserContactsProspectIdUserIdKey = 'UserContacts_prospectId_userId_key',
}

/** input type for inserting data into table "UserContacts" */
export type UserContacts_Insert_Input = {
    _GroupToUserContacts?: InputMaybe<_GroupToUserContact_Arr_Rel_Insert_Input>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    source?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<Scalars['UserContactStatus']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type UserContacts_Max_Fields = {
    __typename?: 'UserContacts_max_fields';
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    source?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['UserContactStatus']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UserContacts_Min_Fields = {
    __typename?: 'UserContacts_min_fields';
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    prospectId?: Maybe<Scalars['String']['output']>;
    source?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['UserContactStatus']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "UserContacts" */
export type UserContacts_Mutation_Response = {
    __typename?: 'UserContacts_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<UserContacts>;
};

/** input type for inserting object relation for remote table "UserContacts" */
export type UserContacts_Obj_Rel_Insert_Input = {
    data: UserContacts_Insert_Input;
    /** upsert condition */
    on_conflict?: InputMaybe<UserContacts_On_Conflict>;
};

/** on_conflict condition type for table "UserContacts" */
export type UserContacts_On_Conflict = {
    constraint: UserContacts_Constraint;
    update_columns?: Array<UserContacts_Update_Column>;
    where?: InputMaybe<UserContacts_Bool_Exp>;
};

/** Ordering options when selecting data from "UserContacts". */
export type UserContacts_Order_By = {
    _GroupToUserContacts_aggregate?: InputMaybe<_GroupToUserContact_Aggregate_Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    prospectId?: InputMaybe<Order_By>;
    source?: InputMaybe<Order_By>;
    status?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: UserContacts */
export type UserContacts_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** select columns of table "UserContacts" */
export enum UserContacts_Select_Column {
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    Source = 'source',
    /** column name */
    Status = 'status',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

/** input type for updating data in table "UserContacts" */
export type UserContacts_Set_Input = {
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    source?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<Scalars['UserContactStatus']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "UserContacts" */
export type UserContacts_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: UserContacts_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserContacts_Stream_Cursor_Value_Input = {
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    prospectId?: InputMaybe<Scalars['String']['input']>;
    source?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<Scalars['UserContactStatus']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "UserContacts" */
export enum UserContacts_Update_Column {
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    ProspectId = 'prospectId',
    /** column name */
    Source = 'source',
    /** column name */
    Status = 'status',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    UserId = 'userId',
}

export type UserContacts_Updates = {
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<UserContacts_Set_Input>;
    /** filter the rows which have to be updated */
    where: UserContacts_Bool_Exp;
};

/** columns and relationships of "_GroupToContact" */
export type _GroupToContact = {
    __typename?: '_GroupToContact';
    A: Scalars['String']['output'];
    B: Scalars['String']['output'];
    /** An object relationship */
    Contact: Contacts;
    /** An object relationship */
    Group: Groups;
};

/** aggregated selection of "_GroupToContact" */
export type _GroupToContact_Aggregate = {
    __typename?: '_GroupToContact_aggregate';
    aggregate?: Maybe<_GroupToContact_Aggregate_Fields>;
    nodes: Array<_GroupToContact>;
};

export type _GroupToContact_Aggregate_Bool_Exp = {
    count?: InputMaybe<_GroupToContact_Aggregate_Bool_Exp_Count>;
};

export type _GroupToContact_Aggregate_Bool_Exp_Count = {
    arguments?: InputMaybe<Array<_GroupToContact_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<_GroupToContact_Bool_Exp>;
    predicate: Int_Comparison_Exp;
};

/** aggregate fields of "_GroupToContact" */
export type _GroupToContact_Aggregate_Fields = {
    __typename?: '_GroupToContact_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<_GroupToContact_Max_Fields>;
    min?: Maybe<_GroupToContact_Min_Fields>;
};

/** aggregate fields of "_GroupToContact" */
export type _GroupToContact_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<_GroupToContact_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "_GroupToContact" */
export type _GroupToContact_Aggregate_Order_By = {
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<_GroupToContact_Max_Order_By>;
    min?: InputMaybe<_GroupToContact_Min_Order_By>;
};

/** input type for inserting array relation for remote table "_GroupToContact" */
export type _GroupToContact_Arr_Rel_Insert_Input = {
    data: Array<_GroupToContact_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<_GroupToContact_On_Conflict>;
};

/** Boolean expression to filter rows from the table "_GroupToContact". All fields are combined with a logical 'AND'. */
export type _GroupToContact_Bool_Exp = {
    A?: InputMaybe<String_Comparison_Exp>;
    B?: InputMaybe<String_Comparison_Exp>;
    Contact?: InputMaybe<Contacts_Bool_Exp>;
    Group?: InputMaybe<Groups_Bool_Exp>;
    _and?: InputMaybe<Array<_GroupToContact_Bool_Exp>>;
    _not?: InputMaybe<_GroupToContact_Bool_Exp>;
    _or?: InputMaybe<Array<_GroupToContact_Bool_Exp>>;
};

/** unique or primary key constraints on table "_GroupToContact" */
export enum _GroupToContact_Constraint {
    /** unique or primary key constraint on columns "B", "A" */
    GroupToContactAbPkey = '_GroupToContact_AB_pkey',
}

/** input type for inserting data into table "_GroupToContact" */
export type _GroupToContact_Insert_Input = {
    A?: InputMaybe<Scalars['String']['input']>;
    B?: InputMaybe<Scalars['String']['input']>;
    Contact?: InputMaybe<Contacts_Obj_Rel_Insert_Input>;
    Group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type _GroupToContact_Max_Fields = {
    __typename?: '_GroupToContact_max_fields';
    A?: Maybe<Scalars['String']['output']>;
    B?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "_GroupToContact" */
export type _GroupToContact_Max_Order_By = {
    A?: InputMaybe<Order_By>;
    B?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type _GroupToContact_Min_Fields = {
    __typename?: '_GroupToContact_min_fields';
    A?: Maybe<Scalars['String']['output']>;
    B?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "_GroupToContact" */
export type _GroupToContact_Min_Order_By = {
    A?: InputMaybe<Order_By>;
    B?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "_GroupToContact" */
export type _GroupToContact_Mutation_Response = {
    __typename?: '_GroupToContact_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<_GroupToContact>;
};

/** on_conflict condition type for table "_GroupToContact" */
export type _GroupToContact_On_Conflict = {
    constraint: _GroupToContact_Constraint;
    update_columns?: Array<_GroupToContact_Update_Column>;
    where?: InputMaybe<_GroupToContact_Bool_Exp>;
};

/** Ordering options when selecting data from "_GroupToContact". */
export type _GroupToContact_Order_By = {
    A?: InputMaybe<Order_By>;
    B?: InputMaybe<Order_By>;
    Contact?: InputMaybe<Contacts_Order_By>;
    Group?: InputMaybe<Groups_Order_By>;
};

/** primary key columns input for table: _GroupToContact */
export type _GroupToContact_Pk_Columns_Input = {
    A: Scalars['String']['input'];
    B: Scalars['String']['input'];
};

/** select columns of table "_GroupToContact" */
export enum _GroupToContact_Select_Column {
    /** column name */
    A = 'A',
    /** column name */
    B = 'B',
}

/** input type for updating data in table "_GroupToContact" */
export type _GroupToContact_Set_Input = {
    A?: InputMaybe<Scalars['String']['input']>;
    B?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "_GroupToContact" */
export type _GroupToContact_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: _GroupToContact_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _GroupToContact_Stream_Cursor_Value_Input = {
    A?: InputMaybe<Scalars['String']['input']>;
    B?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "_GroupToContact" */
export enum _GroupToContact_Update_Column {
    /** column name */
    A = 'A',
    /** column name */
    B = 'B',
}

export type _GroupToContact_Updates = {
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<_GroupToContact_Set_Input>;
    /** filter the rows which have to be updated */
    where: _GroupToContact_Bool_Exp;
};

/** columns and relationships of "_GroupToUserContact" */
export type _GroupToUserContact = {
    __typename?: '_GroupToUserContact';
    A: Scalars['String']['output'];
    B: Scalars['String']['output'];
    /** An object relationship */
    Group: Groups;
    /** An object relationship */
    UserContact: UserContacts;
};

/** aggregated selection of "_GroupToUserContact" */
export type _GroupToUserContact_Aggregate = {
    __typename?: '_GroupToUserContact_aggregate';
    aggregate?: Maybe<_GroupToUserContact_Aggregate_Fields>;
    nodes: Array<_GroupToUserContact>;
};

export type _GroupToUserContact_Aggregate_Bool_Exp = {
    count?: InputMaybe<_GroupToUserContact_Aggregate_Bool_Exp_Count>;
};

export type _GroupToUserContact_Aggregate_Bool_Exp_Count = {
    arguments?: InputMaybe<Array<_GroupToUserContact_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<_GroupToUserContact_Bool_Exp>;
    predicate: Int_Comparison_Exp;
};

/** aggregate fields of "_GroupToUserContact" */
export type _GroupToUserContact_Aggregate_Fields = {
    __typename?: '_GroupToUserContact_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<_GroupToUserContact_Max_Fields>;
    min?: Maybe<_GroupToUserContact_Min_Fields>;
};

/** aggregate fields of "_GroupToUserContact" */
export type _GroupToUserContact_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<_GroupToUserContact_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "_GroupToUserContact" */
export type _GroupToUserContact_Aggregate_Order_By = {
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<_GroupToUserContact_Max_Order_By>;
    min?: InputMaybe<_GroupToUserContact_Min_Order_By>;
};

/** input type for inserting array relation for remote table "_GroupToUserContact" */
export type _GroupToUserContact_Arr_Rel_Insert_Input = {
    data: Array<_GroupToUserContact_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<_GroupToUserContact_On_Conflict>;
};

/** Boolean expression to filter rows from the table "_GroupToUserContact". All fields are combined with a logical 'AND'. */
export type _GroupToUserContact_Bool_Exp = {
    A?: InputMaybe<String_Comparison_Exp>;
    B?: InputMaybe<String_Comparison_Exp>;
    Group?: InputMaybe<Groups_Bool_Exp>;
    UserContact?: InputMaybe<UserContacts_Bool_Exp>;
    _and?: InputMaybe<Array<_GroupToUserContact_Bool_Exp>>;
    _not?: InputMaybe<_GroupToUserContact_Bool_Exp>;
    _or?: InputMaybe<Array<_GroupToUserContact_Bool_Exp>>;
};

/** unique or primary key constraints on table "_GroupToUserContact" */
export enum _GroupToUserContact_Constraint {
    /** unique or primary key constraint on columns "B", "A" */
    GroupToUserContactAbPkey = '_GroupToUserContact_AB_pkey',
}

/** input type for inserting data into table "_GroupToUserContact" */
export type _GroupToUserContact_Insert_Input = {
    A?: InputMaybe<Scalars['String']['input']>;
    B?: InputMaybe<Scalars['String']['input']>;
    Group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
    UserContact?: InputMaybe<UserContacts_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type _GroupToUserContact_Max_Fields = {
    __typename?: '_GroupToUserContact_max_fields';
    A?: Maybe<Scalars['String']['output']>;
    B?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "_GroupToUserContact" */
export type _GroupToUserContact_Max_Order_By = {
    A?: InputMaybe<Order_By>;
    B?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type _GroupToUserContact_Min_Fields = {
    __typename?: '_GroupToUserContact_min_fields';
    A?: Maybe<Scalars['String']['output']>;
    B?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "_GroupToUserContact" */
export type _GroupToUserContact_Min_Order_By = {
    A?: InputMaybe<Order_By>;
    B?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "_GroupToUserContact" */
export type _GroupToUserContact_Mutation_Response = {
    __typename?: '_GroupToUserContact_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<_GroupToUserContact>;
};

/** on_conflict condition type for table "_GroupToUserContact" */
export type _GroupToUserContact_On_Conflict = {
    constraint: _GroupToUserContact_Constraint;
    update_columns?: Array<_GroupToUserContact_Update_Column>;
    where?: InputMaybe<_GroupToUserContact_Bool_Exp>;
};

/** Ordering options when selecting data from "_GroupToUserContact". */
export type _GroupToUserContact_Order_By = {
    A?: InputMaybe<Order_By>;
    B?: InputMaybe<Order_By>;
    Group?: InputMaybe<Groups_Order_By>;
    UserContact?: InputMaybe<UserContacts_Order_By>;
};

/** primary key columns input for table: _GroupToUserContact */
export type _GroupToUserContact_Pk_Columns_Input = {
    A: Scalars['String']['input'];
    B: Scalars['String']['input'];
};

/** select columns of table "_GroupToUserContact" */
export enum _GroupToUserContact_Select_Column {
    /** column name */
    A = 'A',
    /** column name */
    B = 'B',
}

/** input type for updating data in table "_GroupToUserContact" */
export type _GroupToUserContact_Set_Input = {
    A?: InputMaybe<Scalars['String']['input']>;
    B?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "_GroupToUserContact" */
export type _GroupToUserContact_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: _GroupToUserContact_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _GroupToUserContact_Stream_Cursor_Value_Input = {
    A?: InputMaybe<Scalars['String']['input']>;
    B?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "_GroupToUserContact" */
export enum _GroupToUserContact_Update_Column {
    /** column name */
    A = 'A',
    /** column name */
    B = 'B',
}

export type _GroupToUserContact_Updates = {
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<_GroupToUserContact_Set_Input>;
    /** filter the rows which have to be updated */
    where: _GroupToUserContact_Bool_Exp;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['bigint']['input']>;
    _gt?: InputMaybe<Scalars['bigint']['input']>;
    _gte?: InputMaybe<Scalars['bigint']['input']>;
    _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['bigint']['input']>;
    _lte?: InputMaybe<Scalars['bigint']['input']>;
    _neq?: InputMaybe<Scalars['bigint']['input']>;
    _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

export type Contacts_Weighted_Scores_Args = {
    customer_success_objective_weight?: InputMaybe<Scalars['numeric']['input']>;
    due_curve_width?: InputMaybe<Scalars['numeric']['input']>;
    due_today_boost?: InputMaybe<Scalars['numeric']['input']>;
    fundraising_objective_weight?: InputMaybe<Scalars['numeric']['input']>;
    future_decay_rate?: InputMaybe<Scalars['numeric']['input']>;
    future_penalty?: InputMaybe<Scalars['numeric']['input']>;
    internal_objective_weight?: InputMaybe<Scalars['numeric']['input']>;
    networking_objective_weight?: InputMaybe<Scalars['numeric']['input']>;
    no_action_penalty?: InputMaybe<Scalars['numeric']['input']>;
    recruiting_objective_weight?: InputMaybe<Scalars['numeric']['input']>;
    sales_objective_weight?: InputMaybe<Scalars['numeric']['input']>;
    shelf_base_boost?: InputMaybe<Scalars['numeric']['input']>;
    shelf_period_days?: InputMaybe<Scalars['numeric']['input']>;
    timing_urgency_max_boost?: InputMaybe<Scalars['numeric']['input']>;
    urgent_followup_boost?: InputMaybe<Scalars['numeric']['input']>;
    very_old_decay_rate?: InputMaybe<Scalars['numeric']['input']>;
    very_old_overdue_base_boost?: InputMaybe<Scalars['numeric']['input']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
    /** ascending ordering of the cursor */
    Asc = 'ASC',
    /** descending ordering of the cursor */
    Desc = 'DESC',
}

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['float8']['input']>;
    _gt?: InputMaybe<Scalars['float8']['input']>;
    _gte?: InputMaybe<Scalars['float8']['input']>;
    _in?: InputMaybe<Array<Scalars['float8']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['float8']['input']>;
    _lte?: InputMaybe<Scalars['float8']['input']>;
    _neq?: InputMaybe<Scalars['float8']['input']>;
    _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

export type Jsonb_Cast_Exp = {
    String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
    _cast?: InputMaybe<Jsonb_Cast_Exp>;
    /** is the column contained in the given json value */
    _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
    /** does the column contain the given json value at the top level */
    _contains?: InputMaybe<Scalars['jsonb']['input']>;
    _eq?: InputMaybe<Scalars['jsonb']['input']>;
    _gt?: InputMaybe<Scalars['jsonb']['input']>;
    _gte?: InputMaybe<Scalars['jsonb']['input']>;
    /** does the string exist as a top-level key in the column */
    _has_key?: InputMaybe<Scalars['String']['input']>;
    /** do all of these strings exist as top-level keys in the column */
    _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
    /** do any of these strings exist as top-level keys in the column */
    _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
    _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['jsonb']['input']>;
    _lte?: InputMaybe<Scalars['jsonb']['input']>;
    _neq?: InputMaybe<Scalars['jsonb']['input']>;
    _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "mastra.mastra_messages" */
export type Mastra_Mastra_Messages = {
    __typename?: 'mastra_mastra_messages';
    content: Scalars['String']['output'];
    createdAt: Scalars['timestamp']['output'];
    id: Scalars['String']['output'];
    resourceId?: Maybe<Scalars['String']['output']>;
    role: Scalars['String']['output'];
    thread_id: Scalars['String']['output'];
    type: Scalars['String']['output'];
};

/** aggregated selection of "mastra.mastra_messages" */
export type Mastra_Mastra_Messages_Aggregate = {
    __typename?: 'mastra_mastra_messages_aggregate';
    aggregate?: Maybe<Mastra_Mastra_Messages_Aggregate_Fields>;
    nodes: Array<Mastra_Mastra_Messages>;
};

/** aggregate fields of "mastra.mastra_messages" */
export type Mastra_Mastra_Messages_Aggregate_Fields = {
    __typename?: 'mastra_mastra_messages_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<Mastra_Mastra_Messages_Max_Fields>;
    min?: Maybe<Mastra_Mastra_Messages_Min_Fields>;
};

/** aggregate fields of "mastra.mastra_messages" */
export type Mastra_Mastra_Messages_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<Mastra_Mastra_Messages_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mastra.mastra_messages". All fields are combined with a logical 'AND'. */
export type Mastra_Mastra_Messages_Bool_Exp = {
    _and?: InputMaybe<Array<Mastra_Mastra_Messages_Bool_Exp>>;
    _not?: InputMaybe<Mastra_Mastra_Messages_Bool_Exp>;
    _or?: InputMaybe<Array<Mastra_Mastra_Messages_Bool_Exp>>;
    content?: InputMaybe<String_Comparison_Exp>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    resourceId?: InputMaybe<String_Comparison_Exp>;
    role?: InputMaybe<String_Comparison_Exp>;
    thread_id?: InputMaybe<String_Comparison_Exp>;
    type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mastra.mastra_messages" */
export enum Mastra_Mastra_Messages_Constraint {
    /** unique or primary key constraint on columns "id" */
    MastraMessagesPkey = 'mastra_messages_pkey',
}

/** input type for inserting data into table "mastra.mastra_messages" */
export type Mastra_Mastra_Messages_Insert_Input = {
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    resourceId?: InputMaybe<Scalars['String']['input']>;
    role?: InputMaybe<Scalars['String']['input']>;
    thread_id?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Mastra_Mastra_Messages_Max_Fields = {
    __typename?: 'mastra_mastra_messages_max_fields';
    content?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    resourceId?: Maybe<Scalars['String']['output']>;
    role?: Maybe<Scalars['String']['output']>;
    thread_id?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mastra_Mastra_Messages_Min_Fields = {
    __typename?: 'mastra_mastra_messages_min_fields';
    content?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    resourceId?: Maybe<Scalars['String']['output']>;
    role?: Maybe<Scalars['String']['output']>;
    thread_id?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mastra.mastra_messages" */
export type Mastra_Mastra_Messages_Mutation_Response = {
    __typename?: 'mastra_mastra_messages_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Mastra_Mastra_Messages>;
};

/** on_conflict condition type for table "mastra.mastra_messages" */
export type Mastra_Mastra_Messages_On_Conflict = {
    constraint: Mastra_Mastra_Messages_Constraint;
    update_columns?: Array<Mastra_Mastra_Messages_Update_Column>;
    where?: InputMaybe<Mastra_Mastra_Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "mastra.mastra_messages". */
export type Mastra_Mastra_Messages_Order_By = {
    content?: InputMaybe<Order_By>;
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    resourceId?: InputMaybe<Order_By>;
    role?: InputMaybe<Order_By>;
    thread_id?: InputMaybe<Order_By>;
    type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mastra.mastra_messages */
export type Mastra_Mastra_Messages_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** select columns of table "mastra.mastra_messages" */
export enum Mastra_Mastra_Messages_Select_Column {
    /** column name */
    Content = 'content',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    ResourceId = 'resourceId',
    /** column name */
    Role = 'role',
    /** column name */
    ThreadId = 'thread_id',
    /** column name */
    Type = 'type',
}

/** input type for updating data in table "mastra.mastra_messages" */
export type Mastra_Mastra_Messages_Set_Input = {
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    resourceId?: InputMaybe<Scalars['String']['input']>;
    role?: InputMaybe<Scalars['String']['input']>;
    thread_id?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "mastra_mastra_messages" */
export type Mastra_Mastra_Messages_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: Mastra_Mastra_Messages_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mastra_Mastra_Messages_Stream_Cursor_Value_Input = {
    content?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    resourceId?: InputMaybe<Scalars['String']['input']>;
    role?: InputMaybe<Scalars['String']['input']>;
    thread_id?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "mastra.mastra_messages" */
export enum Mastra_Mastra_Messages_Update_Column {
    /** column name */
    Content = 'content',
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    ResourceId = 'resourceId',
    /** column name */
    Role = 'role',
    /** column name */
    ThreadId = 'thread_id',
    /** column name */
    Type = 'type',
}

export type Mastra_Mastra_Messages_Updates = {
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<Mastra_Mastra_Messages_Set_Input>;
    /** filter the rows which have to be updated */
    where: Mastra_Mastra_Messages_Bool_Exp;
};

/** columns and relationships of "mastra.mastra_resources" */
export type Mastra_Mastra_Resources = {
    __typename?: 'mastra_mastra_resources';
    createdAt: Scalars['timestamp']['output'];
    id: Scalars['String']['output'];
    metadata?: Maybe<Scalars['jsonb']['output']>;
    updatedAt: Scalars['timestamp']['output'];
    workingMemory?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "mastra.mastra_resources" */
export type Mastra_Mastra_ResourcesMetadataArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "mastra.mastra_resources" */
export type Mastra_Mastra_Resources_Aggregate = {
    __typename?: 'mastra_mastra_resources_aggregate';
    aggregate?: Maybe<Mastra_Mastra_Resources_Aggregate_Fields>;
    nodes: Array<Mastra_Mastra_Resources>;
};

/** aggregate fields of "mastra.mastra_resources" */
export type Mastra_Mastra_Resources_Aggregate_Fields = {
    __typename?: 'mastra_mastra_resources_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<Mastra_Mastra_Resources_Max_Fields>;
    min?: Maybe<Mastra_Mastra_Resources_Min_Fields>;
};

/** aggregate fields of "mastra.mastra_resources" */
export type Mastra_Mastra_Resources_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<Mastra_Mastra_Resources_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Mastra_Mastra_Resources_Append_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "mastra.mastra_resources". All fields are combined with a logical 'AND'. */
export type Mastra_Mastra_Resources_Bool_Exp = {
    _and?: InputMaybe<Array<Mastra_Mastra_Resources_Bool_Exp>>;
    _not?: InputMaybe<Mastra_Mastra_Resources_Bool_Exp>;
    _or?: InputMaybe<Array<Mastra_Mastra_Resources_Bool_Exp>>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    metadata?: InputMaybe<Jsonb_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    workingMemory?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mastra.mastra_resources" */
export enum Mastra_Mastra_Resources_Constraint {
    /** unique or primary key constraint on columns "id" */
    MastraResourcesPkey = 'mastra_resources_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Mastra_Mastra_Resources_Delete_At_Path_Input = {
    metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Mastra_Mastra_Resources_Delete_Elem_Input = {
    metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Mastra_Mastra_Resources_Delete_Key_Input = {
    metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "mastra.mastra_resources" */
export type Mastra_Mastra_Resources_Insert_Input = {
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    workingMemory?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Mastra_Mastra_Resources_Max_Fields = {
    __typename?: 'mastra_mastra_resources_max_fields';
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    workingMemory?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mastra_Mastra_Resources_Min_Fields = {
    __typename?: 'mastra_mastra_resources_min_fields';
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    workingMemory?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mastra.mastra_resources" */
export type Mastra_Mastra_Resources_Mutation_Response = {
    __typename?: 'mastra_mastra_resources_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Mastra_Mastra_Resources>;
};

/** on_conflict condition type for table "mastra.mastra_resources" */
export type Mastra_Mastra_Resources_On_Conflict = {
    constraint: Mastra_Mastra_Resources_Constraint;
    update_columns?: Array<Mastra_Mastra_Resources_Update_Column>;
    where?: InputMaybe<Mastra_Mastra_Resources_Bool_Exp>;
};

/** Ordering options when selecting data from "mastra.mastra_resources". */
export type Mastra_Mastra_Resources_Order_By = {
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    metadata?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    workingMemory?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mastra.mastra_resources */
export type Mastra_Mastra_Resources_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Mastra_Mastra_Resources_Prepend_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "mastra.mastra_resources" */
export enum Mastra_Mastra_Resources_Select_Column {
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    WorkingMemory = 'workingMemory',
}

/** input type for updating data in table "mastra.mastra_resources" */
export type Mastra_Mastra_Resources_Set_Input = {
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    workingMemory?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "mastra_mastra_resources" */
export type Mastra_Mastra_Resources_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: Mastra_Mastra_Resources_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mastra_Mastra_Resources_Stream_Cursor_Value_Input = {
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    workingMemory?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "mastra.mastra_resources" */
export enum Mastra_Mastra_Resources_Update_Column {
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    WorkingMemory = 'workingMemory',
}

export type Mastra_Mastra_Resources_Updates = {
    /** append existing jsonb value of filtered columns with new jsonb value */
    _append?: InputMaybe<Mastra_Mastra_Resources_Append_Input>;
    /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
    _delete_at_path?: InputMaybe<Mastra_Mastra_Resources_Delete_At_Path_Input>;
    /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
    _delete_elem?: InputMaybe<Mastra_Mastra_Resources_Delete_Elem_Input>;
    /** delete key/value pair or string element. key/value pairs are matched based on their key value */
    _delete_key?: InputMaybe<Mastra_Mastra_Resources_Delete_Key_Input>;
    /** prepend existing jsonb value of filtered columns with new jsonb value */
    _prepend?: InputMaybe<Mastra_Mastra_Resources_Prepend_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<Mastra_Mastra_Resources_Set_Input>;
    /** filter the rows which have to be updated */
    where: Mastra_Mastra_Resources_Bool_Exp;
};

/** columns and relationships of "mastra.mastra_threads" */
export type Mastra_Mastra_Threads = {
    __typename?: 'mastra_mastra_threads';
    createdAt: Scalars['timestamp']['output'];
    id: Scalars['String']['output'];
    metadata?: Maybe<Scalars['String']['output']>;
    resourceId: Scalars['String']['output'];
    title: Scalars['String']['output'];
    updatedAt: Scalars['timestamp']['output'];
};

/** aggregated selection of "mastra.mastra_threads" */
export type Mastra_Mastra_Threads_Aggregate = {
    __typename?: 'mastra_mastra_threads_aggregate';
    aggregate?: Maybe<Mastra_Mastra_Threads_Aggregate_Fields>;
    nodes: Array<Mastra_Mastra_Threads>;
};

/** aggregate fields of "mastra.mastra_threads" */
export type Mastra_Mastra_Threads_Aggregate_Fields = {
    __typename?: 'mastra_mastra_threads_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<Mastra_Mastra_Threads_Max_Fields>;
    min?: Maybe<Mastra_Mastra_Threads_Min_Fields>;
};

/** aggregate fields of "mastra.mastra_threads" */
export type Mastra_Mastra_Threads_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<Mastra_Mastra_Threads_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mastra.mastra_threads". All fields are combined with a logical 'AND'. */
export type Mastra_Mastra_Threads_Bool_Exp = {
    _and?: InputMaybe<Array<Mastra_Mastra_Threads_Bool_Exp>>;
    _not?: InputMaybe<Mastra_Mastra_Threads_Bool_Exp>;
    _or?: InputMaybe<Array<Mastra_Mastra_Threads_Bool_Exp>>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    id?: InputMaybe<String_Comparison_Exp>;
    metadata?: InputMaybe<String_Comparison_Exp>;
    resourceId?: InputMaybe<String_Comparison_Exp>;
    title?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "mastra.mastra_threads" */
export enum Mastra_Mastra_Threads_Constraint {
    /** unique or primary key constraint on columns "id" */
    MastraThreadsPkey = 'mastra_threads_pkey',
}

/** input type for inserting data into table "mastra.mastra_threads" */
export type Mastra_Mastra_Threads_Insert_Input = {
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['String']['input']>;
    resourceId?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Mastra_Mastra_Threads_Max_Fields = {
    __typename?: 'mastra_mastra_threads_max_fields';
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['String']['output']>;
    resourceId?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Mastra_Mastra_Threads_Min_Fields = {
    __typename?: 'mastra_mastra_threads_min_fields';
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['String']['output']>;
    resourceId?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "mastra.mastra_threads" */
export type Mastra_Mastra_Threads_Mutation_Response = {
    __typename?: 'mastra_mastra_threads_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Mastra_Mastra_Threads>;
};

/** on_conflict condition type for table "mastra.mastra_threads" */
export type Mastra_Mastra_Threads_On_Conflict = {
    constraint: Mastra_Mastra_Threads_Constraint;
    update_columns?: Array<Mastra_Mastra_Threads_Update_Column>;
    where?: InputMaybe<Mastra_Mastra_Threads_Bool_Exp>;
};

/** Ordering options when selecting data from "mastra.mastra_threads". */
export type Mastra_Mastra_Threads_Order_By = {
    createdAt?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    metadata?: InputMaybe<Order_By>;
    resourceId?: InputMaybe<Order_By>;
    title?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mastra.mastra_threads */
export type Mastra_Mastra_Threads_Pk_Columns_Input = {
    id: Scalars['String']['input'];
};

/** select columns of table "mastra.mastra_threads" */
export enum Mastra_Mastra_Threads_Select_Column {
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    ResourceId = 'resourceId',
    /** column name */
    Title = 'title',
    /** column name */
    UpdatedAt = 'updatedAt',
}

/** input type for updating data in table "mastra.mastra_threads" */
export type Mastra_Mastra_Threads_Set_Input = {
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['String']['input']>;
    resourceId?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "mastra_mastra_threads" */
export type Mastra_Mastra_Threads_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: Mastra_Mastra_Threads_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mastra_Mastra_Threads_Stream_Cursor_Value_Input = {
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['String']['input']>;
    resourceId?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "mastra.mastra_threads" */
export enum Mastra_Mastra_Threads_Update_Column {
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    Id = 'id',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    ResourceId = 'resourceId',
    /** column name */
    Title = 'title',
    /** column name */
    UpdatedAt = 'updatedAt',
}

export type Mastra_Mastra_Threads_Updates = {
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<Mastra_Mastra_Threads_Set_Input>;
    /** filter the rows which have to be updated */
    where: Mastra_Mastra_Threads_Bool_Exp;
};

/** columns and relationships of "mastra.mastra_workflow_snapshot" */
export type Mastra_Mastra_Workflow_Snapshot = {
    __typename?: 'mastra_mastra_workflow_snapshot';
    createdAt: Scalars['timestamp']['output'];
    run_id: Scalars['String']['output'];
    snapshot: Scalars['String']['output'];
    updatedAt: Scalars['timestamp']['output'];
    workflow_name: Scalars['String']['output'];
};

/** aggregated selection of "mastra.mastra_workflow_snapshot" */
export type Mastra_Mastra_Workflow_Snapshot_Aggregate = {
    __typename?: 'mastra_mastra_workflow_snapshot_aggregate';
    aggregate?: Maybe<Mastra_Mastra_Workflow_Snapshot_Aggregate_Fields>;
    nodes: Array<Mastra_Mastra_Workflow_Snapshot>;
};

/** aggregate fields of "mastra.mastra_workflow_snapshot" */
export type Mastra_Mastra_Workflow_Snapshot_Aggregate_Fields = {
    __typename?: 'mastra_mastra_workflow_snapshot_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<Mastra_Mastra_Workflow_Snapshot_Max_Fields>;
    min?: Maybe<Mastra_Mastra_Workflow_Snapshot_Min_Fields>;
};

/** aggregate fields of "mastra.mastra_workflow_snapshot" */
export type Mastra_Mastra_Workflow_Snapshot_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<Mastra_Mastra_Workflow_Snapshot_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mastra.mastra_workflow_snapshot". All fields are combined with a logical 'AND'. */
export type Mastra_Mastra_Workflow_Snapshot_Bool_Exp = {
    _and?: InputMaybe<Array<Mastra_Mastra_Workflow_Snapshot_Bool_Exp>>;
    _not?: InputMaybe<Mastra_Mastra_Workflow_Snapshot_Bool_Exp>;
    _or?: InputMaybe<Array<Mastra_Mastra_Workflow_Snapshot_Bool_Exp>>;
    createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
    run_id?: InputMaybe<String_Comparison_Exp>;
    snapshot?: InputMaybe<String_Comparison_Exp>;
    updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
    workflow_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mastra.mastra_workflow_snapshot" */
export enum Mastra_Mastra_Workflow_Snapshot_Constraint {
    /** unique or primary key constraint on columns "run_id", "workflow_name" */
    MastraWorkflowSnapshotWorkflowNameRunIdKey = 'mastra_workflow_snapshot_workflow_name_run_id_key',
}

/** input type for inserting data into table "mastra.mastra_workflow_snapshot" */
export type Mastra_Mastra_Workflow_Snapshot_Insert_Input = {
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    run_id?: InputMaybe<Scalars['String']['input']>;
    snapshot?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    workflow_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Mastra_Mastra_Workflow_Snapshot_Max_Fields = {
    __typename?: 'mastra_mastra_workflow_snapshot_max_fields';
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    run_id?: Maybe<Scalars['String']['output']>;
    snapshot?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    workflow_name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mastra_Mastra_Workflow_Snapshot_Min_Fields = {
    __typename?: 'mastra_mastra_workflow_snapshot_min_fields';
    createdAt?: Maybe<Scalars['timestamp']['output']>;
    run_id?: Maybe<Scalars['String']['output']>;
    snapshot?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['timestamp']['output']>;
    workflow_name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mastra.mastra_workflow_snapshot" */
export type Mastra_Mastra_Workflow_Snapshot_Mutation_Response = {
    __typename?: 'mastra_mastra_workflow_snapshot_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Mastra_Mastra_Workflow_Snapshot>;
};

/** on_conflict condition type for table "mastra.mastra_workflow_snapshot" */
export type Mastra_Mastra_Workflow_Snapshot_On_Conflict = {
    constraint: Mastra_Mastra_Workflow_Snapshot_Constraint;
    update_columns?: Array<Mastra_Mastra_Workflow_Snapshot_Update_Column>;
    where?: InputMaybe<Mastra_Mastra_Workflow_Snapshot_Bool_Exp>;
};

/** Ordering options when selecting data from "mastra.mastra_workflow_snapshot". */
export type Mastra_Mastra_Workflow_Snapshot_Order_By = {
    createdAt?: InputMaybe<Order_By>;
    run_id?: InputMaybe<Order_By>;
    snapshot?: InputMaybe<Order_By>;
    updatedAt?: InputMaybe<Order_By>;
    workflow_name?: InputMaybe<Order_By>;
};

/** select columns of table "mastra.mastra_workflow_snapshot" */
export enum Mastra_Mastra_Workflow_Snapshot_Select_Column {
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    RunId = 'run_id',
    /** column name */
    Snapshot = 'snapshot',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    WorkflowName = 'workflow_name',
}

/** input type for updating data in table "mastra.mastra_workflow_snapshot" */
export type Mastra_Mastra_Workflow_Snapshot_Set_Input = {
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    run_id?: InputMaybe<Scalars['String']['input']>;
    snapshot?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    workflow_name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "mastra_mastra_workflow_snapshot" */
export type Mastra_Mastra_Workflow_Snapshot_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: Mastra_Mastra_Workflow_Snapshot_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mastra_Mastra_Workflow_Snapshot_Stream_Cursor_Value_Input = {
    createdAt?: InputMaybe<Scalars['timestamp']['input']>;
    run_id?: InputMaybe<Scalars['String']['input']>;
    snapshot?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
    workflow_name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "mastra.mastra_workflow_snapshot" */
export enum Mastra_Mastra_Workflow_Snapshot_Update_Column {
    /** column name */
    CreatedAt = 'createdAt',
    /** column name */
    RunId = 'run_id',
    /** column name */
    Snapshot = 'snapshot',
    /** column name */
    UpdatedAt = 'updatedAt',
    /** column name */
    WorkflowName = 'workflow_name',
}

export type Mastra_Mastra_Workflow_Snapshot_Updates = {
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<Mastra_Mastra_Workflow_Snapshot_Set_Input>;
    /** filter the rows which have to be updated */
    where: Mastra_Mastra_Workflow_Snapshot_Bool_Exp;
};

/** columns and relationships of "mastra.memory_messages" */
export type Mastra_Memory_Messages = {
    __typename?: 'mastra_memory_messages';
    embedding?: Maybe<Scalars['vector']['output']>;
    id: Scalars['Int']['output'];
    metadata?: Maybe<Scalars['jsonb']['output']>;
    vector_id: Scalars['String']['output'];
};

/** columns and relationships of "mastra.memory_messages" */
export type Mastra_Memory_MessagesMetadataArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "mastra.memory_messages" */
export type Mastra_Memory_Messages_Aggregate = {
    __typename?: 'mastra_memory_messages_aggregate';
    aggregate?: Maybe<Mastra_Memory_Messages_Aggregate_Fields>;
    nodes: Array<Mastra_Memory_Messages>;
};

/** aggregate fields of "mastra.memory_messages" */
export type Mastra_Memory_Messages_Aggregate_Fields = {
    __typename?: 'mastra_memory_messages_aggregate_fields';
    avg?: Maybe<Mastra_Memory_Messages_Avg_Fields>;
    count: Scalars['Int']['output'];
    max?: Maybe<Mastra_Memory_Messages_Max_Fields>;
    min?: Maybe<Mastra_Memory_Messages_Min_Fields>;
    stddev?: Maybe<Mastra_Memory_Messages_Stddev_Fields>;
    stddev_pop?: Maybe<Mastra_Memory_Messages_Stddev_Pop_Fields>;
    stddev_samp?: Maybe<Mastra_Memory_Messages_Stddev_Samp_Fields>;
    sum?: Maybe<Mastra_Memory_Messages_Sum_Fields>;
    var_pop?: Maybe<Mastra_Memory_Messages_Var_Pop_Fields>;
    var_samp?: Maybe<Mastra_Memory_Messages_Var_Samp_Fields>;
    variance?: Maybe<Mastra_Memory_Messages_Variance_Fields>;
};

/** aggregate fields of "mastra.memory_messages" */
export type Mastra_Memory_Messages_Aggregate_FieldsCountArgs = {
    columns?: InputMaybe<Array<Mastra_Memory_Messages_Select_Column>>;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Mastra_Memory_Messages_Append_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Mastra_Memory_Messages_Avg_Fields = {
    __typename?: 'mastra_memory_messages_avg_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mastra.memory_messages". All fields are combined with a logical 'AND'. */
export type Mastra_Memory_Messages_Bool_Exp = {
    _and?: InputMaybe<Array<Mastra_Memory_Messages_Bool_Exp>>;
    _not?: InputMaybe<Mastra_Memory_Messages_Bool_Exp>;
    _or?: InputMaybe<Array<Mastra_Memory_Messages_Bool_Exp>>;
    embedding?: InputMaybe<Vector_Comparison_Exp>;
    id?: InputMaybe<Int_Comparison_Exp>;
    metadata?: InputMaybe<Jsonb_Comparison_Exp>;
    vector_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mastra.memory_messages" */
export enum Mastra_Memory_Messages_Constraint {
    /** unique or primary key constraint on columns "id" */
    MemoryMessagesPkey = 'memory_messages_pkey',
    /** unique or primary key constraint on columns "vector_id" */
    MemoryMessagesVectorIdKey = 'memory_messages_vector_id_key',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Mastra_Memory_Messages_Delete_At_Path_Input = {
    metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Mastra_Memory_Messages_Delete_Elem_Input = {
    metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Mastra_Memory_Messages_Delete_Key_Input = {
    metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "mastra.memory_messages" */
export type Mastra_Memory_Messages_Inc_Input = {
    id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mastra.memory_messages" */
export type Mastra_Memory_Messages_Insert_Input = {
    embedding?: InputMaybe<Scalars['vector']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    vector_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Mastra_Memory_Messages_Max_Fields = {
    __typename?: 'mastra_memory_messages_max_fields';
    id?: Maybe<Scalars['Int']['output']>;
    vector_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mastra_Memory_Messages_Min_Fields = {
    __typename?: 'mastra_memory_messages_min_fields';
    id?: Maybe<Scalars['Int']['output']>;
    vector_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mastra.memory_messages" */
export type Mastra_Memory_Messages_Mutation_Response = {
    __typename?: 'mastra_memory_messages_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Mastra_Memory_Messages>;
};

/** on_conflict condition type for table "mastra.memory_messages" */
export type Mastra_Memory_Messages_On_Conflict = {
    constraint: Mastra_Memory_Messages_Constraint;
    update_columns?: Array<Mastra_Memory_Messages_Update_Column>;
    where?: InputMaybe<Mastra_Memory_Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "mastra.memory_messages". */
export type Mastra_Memory_Messages_Order_By = {
    embedding?: InputMaybe<Order_By>;
    id?: InputMaybe<Order_By>;
    metadata?: InputMaybe<Order_By>;
    vector_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mastra.memory_messages */
export type Mastra_Memory_Messages_Pk_Columns_Input = {
    id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Mastra_Memory_Messages_Prepend_Input = {
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "mastra.memory_messages" */
export enum Mastra_Memory_Messages_Select_Column {
    /** column name */
    Embedding = 'embedding',
    /** column name */
    Id = 'id',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    VectorId = 'vector_id',
}

/** input type for updating data in table "mastra.memory_messages" */
export type Mastra_Memory_Messages_Set_Input = {
    embedding?: InputMaybe<Scalars['vector']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    vector_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Mastra_Memory_Messages_Stddev_Fields = {
    __typename?: 'mastra_memory_messages_stddev_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mastra_Memory_Messages_Stddev_Pop_Fields = {
    __typename?: 'mastra_memory_messages_stddev_pop_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mastra_Memory_Messages_Stddev_Samp_Fields = {
    __typename?: 'mastra_memory_messages_stddev_samp_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mastra_memory_messages" */
export type Mastra_Memory_Messages_Stream_Cursor_Input = {
    /** Stream column input with initial value */
    initial_value: Mastra_Memory_Messages_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mastra_Memory_Messages_Stream_Cursor_Value_Input = {
    embedding?: InputMaybe<Scalars['vector']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
    vector_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Mastra_Memory_Messages_Sum_Fields = {
    __typename?: 'mastra_memory_messages_sum_fields';
    id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "mastra.memory_messages" */
export enum Mastra_Memory_Messages_Update_Column {
    /** column name */
    Embedding = 'embedding',
    /** column name */
    Id = 'id',
    /** column name */
    Metadata = 'metadata',
    /** column name */
    VectorId = 'vector_id',
}

export type Mastra_Memory_Messages_Updates = {
    /** append existing jsonb value of filtered columns with new jsonb value */
    _append?: InputMaybe<Mastra_Memory_Messages_Append_Input>;
    /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
    _delete_at_path?: InputMaybe<Mastra_Memory_Messages_Delete_At_Path_Input>;
    /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
    _delete_elem?: InputMaybe<Mastra_Memory_Messages_Delete_Elem_Input>;
    /** delete key/value pair or string element. key/value pairs are matched based on their key value */
    _delete_key?: InputMaybe<Mastra_Memory_Messages_Delete_Key_Input>;
    /** increments the numeric columns with given value of the filtered values */
    _inc?: InputMaybe<Mastra_Memory_Messages_Inc_Input>;
    /** prepend existing jsonb value of filtered columns with new jsonb value */
    _prepend?: InputMaybe<Mastra_Memory_Messages_Prepend_Input>;
    /** sets the columns of the filtered rows to the given values */
    _set?: InputMaybe<Mastra_Memory_Messages_Set_Input>;
    /** filter the rows which have to be updated */
    where: Mastra_Memory_Messages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mastra_Memory_Messages_Var_Pop_Fields = {
    __typename?: 'mastra_memory_messages_var_pop_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mastra_Memory_Messages_Var_Samp_Fields = {
    __typename?: 'mastra_memory_messages_var_samp_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mastra_Memory_Messages_Variance_Fields = {
    __typename?: 'mastra_memory_messages_variance_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

/** mutation root */
export type Mutation_Root = {
    __typename?: 'mutation_root';
    /** delete data from the table: "Accounts" */
    delete_Accounts?: Maybe<Accounts_Mutation_Response>;
    /** delete single row from the table: "Accounts" */
    delete_Accounts_by_pk?: Maybe<Accounts>;
    /** delete data from the table: "AssistantSettings" */
    delete_AssistantSettings?: Maybe<AssistantSettings_Mutation_Response>;
    /** delete single row from the table: "AssistantSettings" */
    delete_AssistantSettings_by_pk?: Maybe<AssistantSettings>;
    /** delete data from the table: "Attachments" */
    delete_Attachments?: Maybe<Attachments_Mutation_Response>;
    /** delete single row from the table: "Attachments" */
    delete_Attachments_by_pk?: Maybe<Attachments>;
    /** delete data from the table: "ContactSuggestions" */
    delete_ContactSuggestions?: Maybe<ContactSuggestions_Mutation_Response>;
    /** delete single row from the table: "ContactSuggestions" */
    delete_ContactSuggestions_by_pk?: Maybe<ContactSuggestions>;
    /** delete data from the table: "Contacts" */
    delete_Contacts?: Maybe<Contacts_Mutation_Response>;
    /** delete data from the table: "ContactsInteractions" */
    delete_ContactsInteractions?: Maybe<ContactsInteractions_Mutation_Response>;
    /** delete single row from the table: "ContactsInteractions" */
    delete_ContactsInteractions_by_pk?: Maybe<ContactsInteractions>;
    /** delete single row from the table: "Contacts" */
    delete_Contacts_by_pk?: Maybe<Contacts>;
    /** delete data from the table: "ConversationMetaData" */
    delete_ConversationMetaData?: Maybe<ConversationMetaData_Mutation_Response>;
    /** delete single row from the table: "ConversationMetaData" */
    delete_ConversationMetaData_by_pk?: Maybe<ConversationMetaData>;
    /** delete data from the table: "Conversations" */
    delete_Conversations?: Maybe<Conversations_Mutation_Response>;
    /** delete single row from the table: "Conversations" */
    delete_Conversations_by_pk?: Maybe<Conversations>;
    /** delete data from the table: "Groups" */
    delete_Groups?: Maybe<Groups_Mutation_Response>;
    /** delete single row from the table: "Groups" */
    delete_Groups_by_pk?: Maybe<Groups>;
    /** delete data from the table: "Jobs" */
    delete_Jobs?: Maybe<Jobs_Mutation_Response>;
    /** delete single row from the table: "Jobs" */
    delete_Jobs_by_pk?: Maybe<Jobs>;
    /** delete data from the table: "LinkedinConversations" */
    delete_LinkedinConversations?: Maybe<LinkedinConversations_Mutation_Response>;
    /** delete single row from the table: "LinkedinConversations" */
    delete_LinkedinConversations_by_pk?: Maybe<LinkedinConversations>;
    /** delete data from the table: "MessageDrafts" */
    delete_MessageDrafts?: Maybe<MessageDrafts_Mutation_Response>;
    /** delete single row from the table: "MessageDrafts" */
    delete_MessageDrafts_by_pk?: Maybe<MessageDrafts>;
    /** delete data from the table: "Messages" */
    delete_Messages?: Maybe<Messages_Mutation_Response>;
    /** delete single row from the table: "Messages" */
    delete_Messages_by_pk?: Maybe<Messages>;
    /** delete data from the table: "Notes" */
    delete_Notes?: Maybe<Notes_Mutation_Response>;
    /** delete single row from the table: "Notes" */
    delete_Notes_by_pk?: Maybe<Notes>;
    /** delete data from the table: "OutreachCompletionMetrics" */
    delete_OutreachCompletionMetrics?: Maybe<OutreachCompletionMetrics_Mutation_Response>;
    /** delete single row from the table: "OutreachCompletionMetrics" */
    delete_OutreachCompletionMetrics_by_pk?: Maybe<OutreachCompletionMetrics>;
    /** delete data from the table: "OutreachSuggestions" */
    delete_OutreachSuggestions?: Maybe<OutreachSuggestions_Mutation_Response>;
    /** delete single row from the table: "OutreachSuggestions" */
    delete_OutreachSuggestions_by_pk?: Maybe<OutreachSuggestions>;
    /** delete data from the table: "ResourceEmbeddings" */
    delete_ResourceEmbeddings?: Maybe<ResourceEmbeddings_Mutation_Response>;
    /** delete single row from the table: "ResourceEmbeddings" */
    delete_ResourceEmbeddings_by_pk?: Maybe<ResourceEmbeddings>;
    /** delete data from the table: "Resources" */
    delete_Resources?: Maybe<Resources_Mutation_Response>;
    /** delete single row from the table: "Resources" */
    delete_Resources_by_pk?: Maybe<Resources>;
    /** delete data from the table: "SampleContacts" */
    delete_SampleContacts?: Maybe<SampleContacts_Mutation_Response>;
    /** delete single row from the table: "SampleContacts" */
    delete_SampleContacts_by_pk?: Maybe<SampleContacts>;
    /** delete data from the table: "UserAgentInstructions" */
    delete_UserAgentInstructions?: Maybe<UserAgentInstructions_Mutation_Response>;
    /** delete single row from the table: "UserAgentInstructions" */
    delete_UserAgentInstructions_by_pk?: Maybe<UserAgentInstructions>;
    /** delete data from the table: "UserContacts" */
    delete_UserContacts?: Maybe<UserContacts_Mutation_Response>;
    /** delete single row from the table: "UserContacts" */
    delete_UserContacts_by_pk?: Maybe<UserContacts>;
    /** delete data from the table: "_GroupToContact" */
    delete__GroupToContact?: Maybe<_GroupToContact_Mutation_Response>;
    /** delete single row from the table: "_GroupToContact" */
    delete__GroupToContact_by_pk?: Maybe<_GroupToContact>;
    /** delete data from the table: "_GroupToUserContact" */
    delete__GroupToUserContact?: Maybe<_GroupToUserContact_Mutation_Response>;
    /** delete single row from the table: "_GroupToUserContact" */
    delete__GroupToUserContact_by_pk?: Maybe<_GroupToUserContact>;
    /** delete data from the table: "mastra.mastra_messages" */
    delete_mastra_mastra_messages?: Maybe<Mastra_Mastra_Messages_Mutation_Response>;
    /** delete single row from the table: "mastra.mastra_messages" */
    delete_mastra_mastra_messages_by_pk?: Maybe<Mastra_Mastra_Messages>;
    /** delete data from the table: "mastra.mastra_resources" */
    delete_mastra_mastra_resources?: Maybe<Mastra_Mastra_Resources_Mutation_Response>;
    /** delete single row from the table: "mastra.mastra_resources" */
    delete_mastra_mastra_resources_by_pk?: Maybe<Mastra_Mastra_Resources>;
    /** delete data from the table: "mastra.mastra_threads" */
    delete_mastra_mastra_threads?: Maybe<Mastra_Mastra_Threads_Mutation_Response>;
    /** delete single row from the table: "mastra.mastra_threads" */
    delete_mastra_mastra_threads_by_pk?: Maybe<Mastra_Mastra_Threads>;
    /** delete data from the table: "mastra.mastra_workflow_snapshot" */
    delete_mastra_mastra_workflow_snapshot?: Maybe<Mastra_Mastra_Workflow_Snapshot_Mutation_Response>;
    /** delete data from the table: "mastra.memory_messages" */
    delete_mastra_memory_messages?: Maybe<Mastra_Memory_Messages_Mutation_Response>;
    /** delete single row from the table: "mastra.memory_messages" */
    delete_mastra_memory_messages_by_pk?: Maybe<Mastra_Memory_Messages>;
    /** insert data into the table: "Accounts" */
    insert_Accounts?: Maybe<Accounts_Mutation_Response>;
    /** insert a single row into the table: "Accounts" */
    insert_Accounts_one?: Maybe<Accounts>;
    /** insert data into the table: "AssistantSettings" */
    insert_AssistantSettings?: Maybe<AssistantSettings_Mutation_Response>;
    /** insert a single row into the table: "AssistantSettings" */
    insert_AssistantSettings_one?: Maybe<AssistantSettings>;
    /** insert data into the table: "Attachments" */
    insert_Attachments?: Maybe<Attachments_Mutation_Response>;
    /** insert a single row into the table: "Attachments" */
    insert_Attachments_one?: Maybe<Attachments>;
    /** insert data into the table: "ContactSuggestions" */
    insert_ContactSuggestions?: Maybe<ContactSuggestions_Mutation_Response>;
    /** insert a single row into the table: "ContactSuggestions" */
    insert_ContactSuggestions_one?: Maybe<ContactSuggestions>;
    /** insert data into the table: "Contacts" */
    insert_Contacts?: Maybe<Contacts_Mutation_Response>;
    /** insert data into the table: "ContactsInteractions" */
    insert_ContactsInteractions?: Maybe<ContactsInteractions_Mutation_Response>;
    /** insert a single row into the table: "ContactsInteractions" */
    insert_ContactsInteractions_one?: Maybe<ContactsInteractions>;
    /** insert a single row into the table: "Contacts" */
    insert_Contacts_one?: Maybe<Contacts>;
    /** insert data into the table: "ConversationMetaData" */
    insert_ConversationMetaData?: Maybe<ConversationMetaData_Mutation_Response>;
    /** insert a single row into the table: "ConversationMetaData" */
    insert_ConversationMetaData_one?: Maybe<ConversationMetaData>;
    /** insert data into the table: "Conversations" */
    insert_Conversations?: Maybe<Conversations_Mutation_Response>;
    /** insert a single row into the table: "Conversations" */
    insert_Conversations_one?: Maybe<Conversations>;
    /** insert data into the table: "Groups" */
    insert_Groups?: Maybe<Groups_Mutation_Response>;
    /** insert a single row into the table: "Groups" */
    insert_Groups_one?: Maybe<Groups>;
    /** insert data into the table: "Jobs" */
    insert_Jobs?: Maybe<Jobs_Mutation_Response>;
    /** insert a single row into the table: "Jobs" */
    insert_Jobs_one?: Maybe<Jobs>;
    /** insert data into the table: "LinkedinConversations" */
    insert_LinkedinConversations?: Maybe<LinkedinConversations_Mutation_Response>;
    /** insert a single row into the table: "LinkedinConversations" */
    insert_LinkedinConversations_one?: Maybe<LinkedinConversations>;
    /** insert data into the table: "MessageDrafts" */
    insert_MessageDrafts?: Maybe<MessageDrafts_Mutation_Response>;
    /** insert a single row into the table: "MessageDrafts" */
    insert_MessageDrafts_one?: Maybe<MessageDrafts>;
    /** insert data into the table: "Messages" */
    insert_Messages?: Maybe<Messages_Mutation_Response>;
    /** insert a single row into the table: "Messages" */
    insert_Messages_one?: Maybe<Messages>;
    /** insert data into the table: "Notes" */
    insert_Notes?: Maybe<Notes_Mutation_Response>;
    /** insert a single row into the table: "Notes" */
    insert_Notes_one?: Maybe<Notes>;
    /** insert data into the table: "OutreachCompletionMetrics" */
    insert_OutreachCompletionMetrics?: Maybe<OutreachCompletionMetrics_Mutation_Response>;
    /** insert a single row into the table: "OutreachCompletionMetrics" */
    insert_OutreachCompletionMetrics_one?: Maybe<OutreachCompletionMetrics>;
    /** insert data into the table: "OutreachSuggestions" */
    insert_OutreachSuggestions?: Maybe<OutreachSuggestions_Mutation_Response>;
    /** insert a single row into the table: "OutreachSuggestions" */
    insert_OutreachSuggestions_one?: Maybe<OutreachSuggestions>;
    /** insert data into the table: "ResourceEmbeddings" */
    insert_ResourceEmbeddings?: Maybe<ResourceEmbeddings_Mutation_Response>;
    /** insert a single row into the table: "ResourceEmbeddings" */
    insert_ResourceEmbeddings_one?: Maybe<ResourceEmbeddings>;
    /** insert data into the table: "Resources" */
    insert_Resources?: Maybe<Resources_Mutation_Response>;
    /** insert a single row into the table: "Resources" */
    insert_Resources_one?: Maybe<Resources>;
    /** insert data into the table: "SampleContacts" */
    insert_SampleContacts?: Maybe<SampleContacts_Mutation_Response>;
    /** insert a single row into the table: "SampleContacts" */
    insert_SampleContacts_one?: Maybe<SampleContacts>;
    /** insert data into the table: "UserAgentInstructions" */
    insert_UserAgentInstructions?: Maybe<UserAgentInstructions_Mutation_Response>;
    /** insert a single row into the table: "UserAgentInstructions" */
    insert_UserAgentInstructions_one?: Maybe<UserAgentInstructions>;
    /** insert data into the table: "UserContacts" */
    insert_UserContacts?: Maybe<UserContacts_Mutation_Response>;
    /** insert a single row into the table: "UserContacts" */
    insert_UserContacts_one?: Maybe<UserContacts>;
    /** insert data into the table: "_GroupToContact" */
    insert__GroupToContact?: Maybe<_GroupToContact_Mutation_Response>;
    /** insert a single row into the table: "_GroupToContact" */
    insert__GroupToContact_one?: Maybe<_GroupToContact>;
    /** insert data into the table: "_GroupToUserContact" */
    insert__GroupToUserContact?: Maybe<_GroupToUserContact_Mutation_Response>;
    /** insert a single row into the table: "_GroupToUserContact" */
    insert__GroupToUserContact_one?: Maybe<_GroupToUserContact>;
    /** insert data into the table: "mastra.mastra_messages" */
    insert_mastra_mastra_messages?: Maybe<Mastra_Mastra_Messages_Mutation_Response>;
    /** insert a single row into the table: "mastra.mastra_messages" */
    insert_mastra_mastra_messages_one?: Maybe<Mastra_Mastra_Messages>;
    /** insert data into the table: "mastra.mastra_resources" */
    insert_mastra_mastra_resources?: Maybe<Mastra_Mastra_Resources_Mutation_Response>;
    /** insert a single row into the table: "mastra.mastra_resources" */
    insert_mastra_mastra_resources_one?: Maybe<Mastra_Mastra_Resources>;
    /** insert data into the table: "mastra.mastra_threads" */
    insert_mastra_mastra_threads?: Maybe<Mastra_Mastra_Threads_Mutation_Response>;
    /** insert a single row into the table: "mastra.mastra_threads" */
    insert_mastra_mastra_threads_one?: Maybe<Mastra_Mastra_Threads>;
    /** insert data into the table: "mastra.mastra_workflow_snapshot" */
    insert_mastra_mastra_workflow_snapshot?: Maybe<Mastra_Mastra_Workflow_Snapshot_Mutation_Response>;
    /** insert a single row into the table: "mastra.mastra_workflow_snapshot" */
    insert_mastra_mastra_workflow_snapshot_one?: Maybe<Mastra_Mastra_Workflow_Snapshot>;
    /** insert data into the table: "mastra.memory_messages" */
    insert_mastra_memory_messages?: Maybe<Mastra_Memory_Messages_Mutation_Response>;
    /** insert a single row into the table: "mastra.memory_messages" */
    insert_mastra_memory_messages_one?: Maybe<Mastra_Memory_Messages>;
    /** update data of the table: "Accounts" */
    update_Accounts?: Maybe<Accounts_Mutation_Response>;
    /** update single row of the table: "Accounts" */
    update_Accounts_by_pk?: Maybe<Accounts>;
    /** update multiples rows of table: "Accounts" */
    update_Accounts_many?: Maybe<Array<Maybe<Accounts_Mutation_Response>>>;
    /** update data of the table: "AssistantSettings" */
    update_AssistantSettings?: Maybe<AssistantSettings_Mutation_Response>;
    /** update single row of the table: "AssistantSettings" */
    update_AssistantSettings_by_pk?: Maybe<AssistantSettings>;
    /** update multiples rows of table: "AssistantSettings" */
    update_AssistantSettings_many?: Maybe<Array<Maybe<AssistantSettings_Mutation_Response>>>;
    /** update data of the table: "Attachments" */
    update_Attachments?: Maybe<Attachments_Mutation_Response>;
    /** update single row of the table: "Attachments" */
    update_Attachments_by_pk?: Maybe<Attachments>;
    /** update multiples rows of table: "Attachments" */
    update_Attachments_many?: Maybe<Array<Maybe<Attachments_Mutation_Response>>>;
    /** update data of the table: "ContactSuggestions" */
    update_ContactSuggestions?: Maybe<ContactSuggestions_Mutation_Response>;
    /** update single row of the table: "ContactSuggestions" */
    update_ContactSuggestions_by_pk?: Maybe<ContactSuggestions>;
    /** update multiples rows of table: "ContactSuggestions" */
    update_ContactSuggestions_many?: Maybe<Array<Maybe<ContactSuggestions_Mutation_Response>>>;
    /** update data of the table: "Contacts" */
    update_Contacts?: Maybe<Contacts_Mutation_Response>;
    /** update data of the table: "ContactsInteractions" */
    update_ContactsInteractions?: Maybe<ContactsInteractions_Mutation_Response>;
    /** update single row of the table: "ContactsInteractions" */
    update_ContactsInteractions_by_pk?: Maybe<ContactsInteractions>;
    /** update multiples rows of table: "ContactsInteractions" */
    update_ContactsInteractions_many?: Maybe<Array<Maybe<ContactsInteractions_Mutation_Response>>>;
    /** update single row of the table: "Contacts" */
    update_Contacts_by_pk?: Maybe<Contacts>;
    /** update multiples rows of table: "Contacts" */
    update_Contacts_many?: Maybe<Array<Maybe<Contacts_Mutation_Response>>>;
    /** update data of the table: "ConversationMetaData" */
    update_ConversationMetaData?: Maybe<ConversationMetaData_Mutation_Response>;
    /** update single row of the table: "ConversationMetaData" */
    update_ConversationMetaData_by_pk?: Maybe<ConversationMetaData>;
    /** update multiples rows of table: "ConversationMetaData" */
    update_ConversationMetaData_many?: Maybe<Array<Maybe<ConversationMetaData_Mutation_Response>>>;
    /** update data of the table: "Conversations" */
    update_Conversations?: Maybe<Conversations_Mutation_Response>;
    /** update single row of the table: "Conversations" */
    update_Conversations_by_pk?: Maybe<Conversations>;
    /** update multiples rows of table: "Conversations" */
    update_Conversations_many?: Maybe<Array<Maybe<Conversations_Mutation_Response>>>;
    /** update data of the table: "Groups" */
    update_Groups?: Maybe<Groups_Mutation_Response>;
    /** update single row of the table: "Groups" */
    update_Groups_by_pk?: Maybe<Groups>;
    /** update multiples rows of table: "Groups" */
    update_Groups_many?: Maybe<Array<Maybe<Groups_Mutation_Response>>>;
    /** update data of the table: "Jobs" */
    update_Jobs?: Maybe<Jobs_Mutation_Response>;
    /** update single row of the table: "Jobs" */
    update_Jobs_by_pk?: Maybe<Jobs>;
    /** update multiples rows of table: "Jobs" */
    update_Jobs_many?: Maybe<Array<Maybe<Jobs_Mutation_Response>>>;
    /** update data of the table: "LinkedinConversations" */
    update_LinkedinConversations?: Maybe<LinkedinConversations_Mutation_Response>;
    /** update single row of the table: "LinkedinConversations" */
    update_LinkedinConversations_by_pk?: Maybe<LinkedinConversations>;
    /** update multiples rows of table: "LinkedinConversations" */
    update_LinkedinConversations_many?: Maybe<Array<Maybe<LinkedinConversations_Mutation_Response>>>;
    /** update data of the table: "MessageDrafts" */
    update_MessageDrafts?: Maybe<MessageDrafts_Mutation_Response>;
    /** update single row of the table: "MessageDrafts" */
    update_MessageDrafts_by_pk?: Maybe<MessageDrafts>;
    /** update multiples rows of table: "MessageDrafts" */
    update_MessageDrafts_many?: Maybe<Array<Maybe<MessageDrafts_Mutation_Response>>>;
    /** update data of the table: "Messages" */
    update_Messages?: Maybe<Messages_Mutation_Response>;
    /** update single row of the table: "Messages" */
    update_Messages_by_pk?: Maybe<Messages>;
    /** update multiples rows of table: "Messages" */
    update_Messages_many?: Maybe<Array<Maybe<Messages_Mutation_Response>>>;
    /** update data of the table: "Notes" */
    update_Notes?: Maybe<Notes_Mutation_Response>;
    /** update single row of the table: "Notes" */
    update_Notes_by_pk?: Maybe<Notes>;
    /** update multiples rows of table: "Notes" */
    update_Notes_many?: Maybe<Array<Maybe<Notes_Mutation_Response>>>;
    /** update data of the table: "OutreachCompletionMetrics" */
    update_OutreachCompletionMetrics?: Maybe<OutreachCompletionMetrics_Mutation_Response>;
    /** update single row of the table: "OutreachCompletionMetrics" */
    update_OutreachCompletionMetrics_by_pk?: Maybe<OutreachCompletionMetrics>;
    /** update multiples rows of table: "OutreachCompletionMetrics" */
    update_OutreachCompletionMetrics_many?: Maybe<Array<Maybe<OutreachCompletionMetrics_Mutation_Response>>>;
    /** update data of the table: "OutreachSuggestions" */
    update_OutreachSuggestions?: Maybe<OutreachSuggestions_Mutation_Response>;
    /** update single row of the table: "OutreachSuggestions" */
    update_OutreachSuggestions_by_pk?: Maybe<OutreachSuggestions>;
    /** update multiples rows of table: "OutreachSuggestions" */
    update_OutreachSuggestions_many?: Maybe<Array<Maybe<OutreachSuggestions_Mutation_Response>>>;
    /** update data of the table: "ResourceEmbeddings" */
    update_ResourceEmbeddings?: Maybe<ResourceEmbeddings_Mutation_Response>;
    /** update single row of the table: "ResourceEmbeddings" */
    update_ResourceEmbeddings_by_pk?: Maybe<ResourceEmbeddings>;
    /** update multiples rows of table: "ResourceEmbeddings" */
    update_ResourceEmbeddings_many?: Maybe<Array<Maybe<ResourceEmbeddings_Mutation_Response>>>;
    /** update data of the table: "Resources" */
    update_Resources?: Maybe<Resources_Mutation_Response>;
    /** update single row of the table: "Resources" */
    update_Resources_by_pk?: Maybe<Resources>;
    /** update multiples rows of table: "Resources" */
    update_Resources_many?: Maybe<Array<Maybe<Resources_Mutation_Response>>>;
    /** update data of the table: "SampleContacts" */
    update_SampleContacts?: Maybe<SampleContacts_Mutation_Response>;
    /** update single row of the table: "SampleContacts" */
    update_SampleContacts_by_pk?: Maybe<SampleContacts>;
    /** update multiples rows of table: "SampleContacts" */
    update_SampleContacts_many?: Maybe<Array<Maybe<SampleContacts_Mutation_Response>>>;
    /** update data of the table: "UserAgentInstructions" */
    update_UserAgentInstructions?: Maybe<UserAgentInstructions_Mutation_Response>;
    /** update single row of the table: "UserAgentInstructions" */
    update_UserAgentInstructions_by_pk?: Maybe<UserAgentInstructions>;
    /** update multiples rows of table: "UserAgentInstructions" */
    update_UserAgentInstructions_many?: Maybe<Array<Maybe<UserAgentInstructions_Mutation_Response>>>;
    /** update data of the table: "UserContacts" */
    update_UserContacts?: Maybe<UserContacts_Mutation_Response>;
    /** update single row of the table: "UserContacts" */
    update_UserContacts_by_pk?: Maybe<UserContacts>;
    /** update multiples rows of table: "UserContacts" */
    update_UserContacts_many?: Maybe<Array<Maybe<UserContacts_Mutation_Response>>>;
    /** update data of the table: "_GroupToContact" */
    update__GroupToContact?: Maybe<_GroupToContact_Mutation_Response>;
    /** update single row of the table: "_GroupToContact" */
    update__GroupToContact_by_pk?: Maybe<_GroupToContact>;
    /** update multiples rows of table: "_GroupToContact" */
    update__GroupToContact_many?: Maybe<Array<Maybe<_GroupToContact_Mutation_Response>>>;
    /** update data of the table: "_GroupToUserContact" */
    update__GroupToUserContact?: Maybe<_GroupToUserContact_Mutation_Response>;
    /** update single row of the table: "_GroupToUserContact" */
    update__GroupToUserContact_by_pk?: Maybe<_GroupToUserContact>;
    /** update multiples rows of table: "_GroupToUserContact" */
    update__GroupToUserContact_many?: Maybe<Array<Maybe<_GroupToUserContact_Mutation_Response>>>;
    /** update data of the table: "mastra.mastra_messages" */
    update_mastra_mastra_messages?: Maybe<Mastra_Mastra_Messages_Mutation_Response>;
    /** update single row of the table: "mastra.mastra_messages" */
    update_mastra_mastra_messages_by_pk?: Maybe<Mastra_Mastra_Messages>;
    /** update multiples rows of table: "mastra.mastra_messages" */
    update_mastra_mastra_messages_many?: Maybe<Array<Maybe<Mastra_Mastra_Messages_Mutation_Response>>>;
    /** update data of the table: "mastra.mastra_resources" */
    update_mastra_mastra_resources?: Maybe<Mastra_Mastra_Resources_Mutation_Response>;
    /** update single row of the table: "mastra.mastra_resources" */
    update_mastra_mastra_resources_by_pk?: Maybe<Mastra_Mastra_Resources>;
    /** update multiples rows of table: "mastra.mastra_resources" */
    update_mastra_mastra_resources_many?: Maybe<Array<Maybe<Mastra_Mastra_Resources_Mutation_Response>>>;
    /** update data of the table: "mastra.mastra_threads" */
    update_mastra_mastra_threads?: Maybe<Mastra_Mastra_Threads_Mutation_Response>;
    /** update single row of the table: "mastra.mastra_threads" */
    update_mastra_mastra_threads_by_pk?: Maybe<Mastra_Mastra_Threads>;
    /** update multiples rows of table: "mastra.mastra_threads" */
    update_mastra_mastra_threads_many?: Maybe<Array<Maybe<Mastra_Mastra_Threads_Mutation_Response>>>;
    /** update data of the table: "mastra.mastra_workflow_snapshot" */
    update_mastra_mastra_workflow_snapshot?: Maybe<Mastra_Mastra_Workflow_Snapshot_Mutation_Response>;
    /** update multiples rows of table: "mastra.mastra_workflow_snapshot" */
    update_mastra_mastra_workflow_snapshot_many?: Maybe<
        Array<Maybe<Mastra_Mastra_Workflow_Snapshot_Mutation_Response>>
    >;
    /** update data of the table: "mastra.memory_messages" */
    update_mastra_memory_messages?: Maybe<Mastra_Memory_Messages_Mutation_Response>;
    /** update single row of the table: "mastra.memory_messages" */
    update_mastra_memory_messages_by_pk?: Maybe<Mastra_Memory_Messages>;
    /** update multiples rows of table: "mastra.memory_messages" */
    update_mastra_memory_messages_many?: Maybe<Array<Maybe<Mastra_Memory_Messages_Mutation_Response>>>;
};

/** mutation root */
export type Mutation_RootDelete_AccountsArgs = {
    where: Accounts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Accounts_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_AssistantSettingsArgs = {
    where: AssistantSettings_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_AssistantSettings_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_AttachmentsArgs = {
    where: Attachments_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Attachments_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_ContactSuggestionsArgs = {
    where: ContactSuggestions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_ContactSuggestions_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_ContactsArgs = {
    where: Contacts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_ContactsInteractionsArgs = {
    where: ContactsInteractions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_ContactsInteractions_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Contacts_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_ConversationMetaDataArgs = {
    where: ConversationMetaData_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_ConversationMetaData_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_ConversationsArgs = {
    where: Conversations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Conversations_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_GroupsArgs = {
    where: Groups_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Groups_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_JobsArgs = {
    where: Jobs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Jobs_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_LinkedinConversationsArgs = {
    where: LinkedinConversations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_LinkedinConversations_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_MessageDraftsArgs = {
    where: MessageDrafts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_MessageDrafts_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_MessagesArgs = {
    where: Messages_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Messages_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_NotesArgs = {
    where: Notes_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Notes_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_OutreachCompletionMetricsArgs = {
    where: OutreachCompletionMetrics_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_OutreachCompletionMetrics_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_OutreachSuggestionsArgs = {
    where: OutreachSuggestions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_OutreachSuggestions_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_ResourceEmbeddingsArgs = {
    where: ResourceEmbeddings_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_ResourceEmbeddings_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_ResourcesArgs = {
    where: Resources_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Resources_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_SampleContactsArgs = {
    where: SampleContacts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_SampleContacts_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_UserAgentInstructionsArgs = {
    where: UserAgentInstructions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_UserAgentInstructions_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_UserContactsArgs = {
    where: UserContacts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_UserContacts_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete__GroupToContactArgs = {
    where: _GroupToContact_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete__GroupToContact_By_PkArgs = {
    A: Scalars['String']['input'];
    B: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete__GroupToUserContactArgs = {
    where: _GroupToUserContact_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete__GroupToUserContact_By_PkArgs = {
    A: Scalars['String']['input'];
    B: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mastra_Mastra_MessagesArgs = {
    where: Mastra_Mastra_Messages_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mastra_Mastra_Messages_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mastra_Mastra_ResourcesArgs = {
    where: Mastra_Mastra_Resources_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mastra_Mastra_Resources_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mastra_Mastra_ThreadsArgs = {
    where: Mastra_Mastra_Threads_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mastra_Mastra_Threads_By_PkArgs = {
    id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mastra_Mastra_Workflow_SnapshotArgs = {
    where: Mastra_Mastra_Workflow_Snapshot_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mastra_Memory_MessagesArgs = {
    where: Mastra_Memory_Messages_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mastra_Memory_Messages_By_PkArgs = {
    id: Scalars['Int']['input'];
};

/** mutation root */
export type Mutation_RootInsert_AccountsArgs = {
    objects: Array<Accounts_Insert_Input>;
    on_conflict?: InputMaybe<Accounts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Accounts_OneArgs = {
    object: Accounts_Insert_Input;
    on_conflict?: InputMaybe<Accounts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_AssistantSettingsArgs = {
    objects: Array<AssistantSettings_Insert_Input>;
    on_conflict?: InputMaybe<AssistantSettings_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_AssistantSettings_OneArgs = {
    object: AssistantSettings_Insert_Input;
    on_conflict?: InputMaybe<AssistantSettings_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_AttachmentsArgs = {
    objects: Array<Attachments_Insert_Input>;
    on_conflict?: InputMaybe<Attachments_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Attachments_OneArgs = {
    object: Attachments_Insert_Input;
    on_conflict?: InputMaybe<Attachments_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ContactSuggestionsArgs = {
    objects: Array<ContactSuggestions_Insert_Input>;
    on_conflict?: InputMaybe<ContactSuggestions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ContactSuggestions_OneArgs = {
    object: ContactSuggestions_Insert_Input;
    on_conflict?: InputMaybe<ContactSuggestions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ContactsArgs = {
    objects: Array<Contacts_Insert_Input>;
    on_conflict?: InputMaybe<Contacts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ContactsInteractionsArgs = {
    objects: Array<ContactsInteractions_Insert_Input>;
    on_conflict?: InputMaybe<ContactsInteractions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ContactsInteractions_OneArgs = {
    object: ContactsInteractions_Insert_Input;
    on_conflict?: InputMaybe<ContactsInteractions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Contacts_OneArgs = {
    object: Contacts_Insert_Input;
    on_conflict?: InputMaybe<Contacts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ConversationMetaDataArgs = {
    objects: Array<ConversationMetaData_Insert_Input>;
    on_conflict?: InputMaybe<ConversationMetaData_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ConversationMetaData_OneArgs = {
    object: ConversationMetaData_Insert_Input;
    on_conflict?: InputMaybe<ConversationMetaData_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ConversationsArgs = {
    objects: Array<Conversations_Insert_Input>;
    on_conflict?: InputMaybe<Conversations_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Conversations_OneArgs = {
    object: Conversations_Insert_Input;
    on_conflict?: InputMaybe<Conversations_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_GroupsArgs = {
    objects: Array<Groups_Insert_Input>;
    on_conflict?: InputMaybe<Groups_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Groups_OneArgs = {
    object: Groups_Insert_Input;
    on_conflict?: InputMaybe<Groups_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_JobsArgs = {
    objects: Array<Jobs_Insert_Input>;
    on_conflict?: InputMaybe<Jobs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Jobs_OneArgs = {
    object: Jobs_Insert_Input;
    on_conflict?: InputMaybe<Jobs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_LinkedinConversationsArgs = {
    objects: Array<LinkedinConversations_Insert_Input>;
    on_conflict?: InputMaybe<LinkedinConversations_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_LinkedinConversations_OneArgs = {
    object: LinkedinConversations_Insert_Input;
    on_conflict?: InputMaybe<LinkedinConversations_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_MessageDraftsArgs = {
    objects: Array<MessageDrafts_Insert_Input>;
    on_conflict?: InputMaybe<MessageDrafts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_MessageDrafts_OneArgs = {
    object: MessageDrafts_Insert_Input;
    on_conflict?: InputMaybe<MessageDrafts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_MessagesArgs = {
    objects: Array<Messages_Insert_Input>;
    on_conflict?: InputMaybe<Messages_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Messages_OneArgs = {
    object: Messages_Insert_Input;
    on_conflict?: InputMaybe<Messages_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_NotesArgs = {
    objects: Array<Notes_Insert_Input>;
    on_conflict?: InputMaybe<Notes_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Notes_OneArgs = {
    object: Notes_Insert_Input;
    on_conflict?: InputMaybe<Notes_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_OutreachCompletionMetricsArgs = {
    objects: Array<OutreachCompletionMetrics_Insert_Input>;
    on_conflict?: InputMaybe<OutreachCompletionMetrics_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_OutreachCompletionMetrics_OneArgs = {
    object: OutreachCompletionMetrics_Insert_Input;
    on_conflict?: InputMaybe<OutreachCompletionMetrics_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_OutreachSuggestionsArgs = {
    objects: Array<OutreachSuggestions_Insert_Input>;
    on_conflict?: InputMaybe<OutreachSuggestions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_OutreachSuggestions_OneArgs = {
    object: OutreachSuggestions_Insert_Input;
    on_conflict?: InputMaybe<OutreachSuggestions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ResourceEmbeddingsArgs = {
    objects: Array<ResourceEmbeddings_Insert_Input>;
    on_conflict?: InputMaybe<ResourceEmbeddings_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ResourceEmbeddings_OneArgs = {
    object: ResourceEmbeddings_Insert_Input;
    on_conflict?: InputMaybe<ResourceEmbeddings_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ResourcesArgs = {
    objects: Array<Resources_Insert_Input>;
    on_conflict?: InputMaybe<Resources_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Resources_OneArgs = {
    object: Resources_Insert_Input;
    on_conflict?: InputMaybe<Resources_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_SampleContactsArgs = {
    objects: Array<SampleContacts_Insert_Input>;
    on_conflict?: InputMaybe<SampleContacts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_SampleContacts_OneArgs = {
    object: SampleContacts_Insert_Input;
    on_conflict?: InputMaybe<SampleContacts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_UserAgentInstructionsArgs = {
    objects: Array<UserAgentInstructions_Insert_Input>;
    on_conflict?: InputMaybe<UserAgentInstructions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_UserAgentInstructions_OneArgs = {
    object: UserAgentInstructions_Insert_Input;
    on_conflict?: InputMaybe<UserAgentInstructions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_UserContactsArgs = {
    objects: Array<UserContacts_Insert_Input>;
    on_conflict?: InputMaybe<UserContacts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_UserContacts_OneArgs = {
    object: UserContacts_Insert_Input;
    on_conflict?: InputMaybe<UserContacts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert__GroupToContactArgs = {
    objects: Array<_GroupToContact_Insert_Input>;
    on_conflict?: InputMaybe<_GroupToContact_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert__GroupToContact_OneArgs = {
    object: _GroupToContact_Insert_Input;
    on_conflict?: InputMaybe<_GroupToContact_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert__GroupToUserContactArgs = {
    objects: Array<_GroupToUserContact_Insert_Input>;
    on_conflict?: InputMaybe<_GroupToUserContact_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert__GroupToUserContact_OneArgs = {
    object: _GroupToUserContact_Insert_Input;
    on_conflict?: InputMaybe<_GroupToUserContact_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mastra_Mastra_MessagesArgs = {
    objects: Array<Mastra_Mastra_Messages_Insert_Input>;
    on_conflict?: InputMaybe<Mastra_Mastra_Messages_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mastra_Mastra_Messages_OneArgs = {
    object: Mastra_Mastra_Messages_Insert_Input;
    on_conflict?: InputMaybe<Mastra_Mastra_Messages_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mastra_Mastra_ResourcesArgs = {
    objects: Array<Mastra_Mastra_Resources_Insert_Input>;
    on_conflict?: InputMaybe<Mastra_Mastra_Resources_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mastra_Mastra_Resources_OneArgs = {
    object: Mastra_Mastra_Resources_Insert_Input;
    on_conflict?: InputMaybe<Mastra_Mastra_Resources_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mastra_Mastra_ThreadsArgs = {
    objects: Array<Mastra_Mastra_Threads_Insert_Input>;
    on_conflict?: InputMaybe<Mastra_Mastra_Threads_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mastra_Mastra_Threads_OneArgs = {
    object: Mastra_Mastra_Threads_Insert_Input;
    on_conflict?: InputMaybe<Mastra_Mastra_Threads_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mastra_Mastra_Workflow_SnapshotArgs = {
    objects: Array<Mastra_Mastra_Workflow_Snapshot_Insert_Input>;
    on_conflict?: InputMaybe<Mastra_Mastra_Workflow_Snapshot_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mastra_Mastra_Workflow_Snapshot_OneArgs = {
    object: Mastra_Mastra_Workflow_Snapshot_Insert_Input;
    on_conflict?: InputMaybe<Mastra_Mastra_Workflow_Snapshot_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mastra_Memory_MessagesArgs = {
    objects: Array<Mastra_Memory_Messages_Insert_Input>;
    on_conflict?: InputMaybe<Mastra_Memory_Messages_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mastra_Memory_Messages_OneArgs = {
    object: Mastra_Memory_Messages_Insert_Input;
    on_conflict?: InputMaybe<Mastra_Memory_Messages_On_Conflict>;
};

/** mutation root */
export type Mutation_RootUpdate_AccountsArgs = {
    _append?: InputMaybe<Accounts_Append_Input>;
    _delete_at_path?: InputMaybe<Accounts_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Accounts_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Accounts_Delete_Key_Input>;
    _inc?: InputMaybe<Accounts_Inc_Input>;
    _prepend?: InputMaybe<Accounts_Prepend_Input>;
    _set?: InputMaybe<Accounts_Set_Input>;
    where: Accounts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Accounts_By_PkArgs = {
    _append?: InputMaybe<Accounts_Append_Input>;
    _delete_at_path?: InputMaybe<Accounts_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Accounts_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Accounts_Delete_Key_Input>;
    _inc?: InputMaybe<Accounts_Inc_Input>;
    _prepend?: InputMaybe<Accounts_Prepend_Input>;
    _set?: InputMaybe<Accounts_Set_Input>;
    pk_columns: Accounts_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Accounts_ManyArgs = {
    updates: Array<Accounts_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_AssistantSettingsArgs = {
    _set?: InputMaybe<AssistantSettings_Set_Input>;
    where: AssistantSettings_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_AssistantSettings_By_PkArgs = {
    _set?: InputMaybe<AssistantSettings_Set_Input>;
    pk_columns: AssistantSettings_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_AssistantSettings_ManyArgs = {
    updates: Array<AssistantSettings_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_AttachmentsArgs = {
    _set?: InputMaybe<Attachments_Set_Input>;
    where: Attachments_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Attachments_By_PkArgs = {
    _set?: InputMaybe<Attachments_Set_Input>;
    pk_columns: Attachments_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Attachments_ManyArgs = {
    updates: Array<Attachments_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_ContactSuggestionsArgs = {
    _set?: InputMaybe<ContactSuggestions_Set_Input>;
    where: ContactSuggestions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_ContactSuggestions_By_PkArgs = {
    _set?: InputMaybe<ContactSuggestions_Set_Input>;
    pk_columns: ContactSuggestions_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_ContactSuggestions_ManyArgs = {
    updates: Array<ContactSuggestions_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_ContactsArgs = {
    _append?: InputMaybe<Contacts_Append_Input>;
    _delete_at_path?: InputMaybe<Contacts_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Contacts_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Contacts_Delete_Key_Input>;
    _inc?: InputMaybe<Contacts_Inc_Input>;
    _prepend?: InputMaybe<Contacts_Prepend_Input>;
    _set?: InputMaybe<Contacts_Set_Input>;
    where: Contacts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_ContactsInteractionsArgs = {
    _append?: InputMaybe<ContactsInteractions_Append_Input>;
    _delete_at_path?: InputMaybe<ContactsInteractions_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<ContactsInteractions_Delete_Elem_Input>;
    _delete_key?: InputMaybe<ContactsInteractions_Delete_Key_Input>;
    _prepend?: InputMaybe<ContactsInteractions_Prepend_Input>;
    _set?: InputMaybe<ContactsInteractions_Set_Input>;
    where: ContactsInteractions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_ContactsInteractions_By_PkArgs = {
    _append?: InputMaybe<ContactsInteractions_Append_Input>;
    _delete_at_path?: InputMaybe<ContactsInteractions_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<ContactsInteractions_Delete_Elem_Input>;
    _delete_key?: InputMaybe<ContactsInteractions_Delete_Key_Input>;
    _prepend?: InputMaybe<ContactsInteractions_Prepend_Input>;
    _set?: InputMaybe<ContactsInteractions_Set_Input>;
    pk_columns: ContactsInteractions_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_ContactsInteractions_ManyArgs = {
    updates: Array<ContactsInteractions_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Contacts_By_PkArgs = {
    _append?: InputMaybe<Contacts_Append_Input>;
    _delete_at_path?: InputMaybe<Contacts_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Contacts_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Contacts_Delete_Key_Input>;
    _inc?: InputMaybe<Contacts_Inc_Input>;
    _prepend?: InputMaybe<Contacts_Prepend_Input>;
    _set?: InputMaybe<Contacts_Set_Input>;
    pk_columns: Contacts_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Contacts_ManyArgs = {
    updates: Array<Contacts_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_ConversationMetaDataArgs = {
    _inc?: InputMaybe<ConversationMetaData_Inc_Input>;
    _set?: InputMaybe<ConversationMetaData_Set_Input>;
    where: ConversationMetaData_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_ConversationMetaData_By_PkArgs = {
    _inc?: InputMaybe<ConversationMetaData_Inc_Input>;
    _set?: InputMaybe<ConversationMetaData_Set_Input>;
    pk_columns: ConversationMetaData_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_ConversationMetaData_ManyArgs = {
    updates: Array<ConversationMetaData_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_ConversationsArgs = {
    _append?: InputMaybe<Conversations_Append_Input>;
    _delete_at_path?: InputMaybe<Conversations_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Conversations_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Conversations_Delete_Key_Input>;
    _prepend?: InputMaybe<Conversations_Prepend_Input>;
    _set?: InputMaybe<Conversations_Set_Input>;
    where: Conversations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Conversations_By_PkArgs = {
    _append?: InputMaybe<Conversations_Append_Input>;
    _delete_at_path?: InputMaybe<Conversations_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Conversations_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Conversations_Delete_Key_Input>;
    _prepend?: InputMaybe<Conversations_Prepend_Input>;
    _set?: InputMaybe<Conversations_Set_Input>;
    pk_columns: Conversations_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Conversations_ManyArgs = {
    updates: Array<Conversations_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_GroupsArgs = {
    _set?: InputMaybe<Groups_Set_Input>;
    where: Groups_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Groups_By_PkArgs = {
    _set?: InputMaybe<Groups_Set_Input>;
    pk_columns: Groups_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Groups_ManyArgs = {
    updates: Array<Groups_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_JobsArgs = {
    _append?: InputMaybe<Jobs_Append_Input>;
    _delete_at_path?: InputMaybe<Jobs_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Jobs_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Jobs_Delete_Key_Input>;
    _prepend?: InputMaybe<Jobs_Prepend_Input>;
    _set?: InputMaybe<Jobs_Set_Input>;
    where: Jobs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Jobs_By_PkArgs = {
    _append?: InputMaybe<Jobs_Append_Input>;
    _delete_at_path?: InputMaybe<Jobs_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Jobs_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Jobs_Delete_Key_Input>;
    _prepend?: InputMaybe<Jobs_Prepend_Input>;
    _set?: InputMaybe<Jobs_Set_Input>;
    pk_columns: Jobs_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Jobs_ManyArgs = {
    updates: Array<Jobs_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_LinkedinConversationsArgs = {
    _append?: InputMaybe<LinkedinConversations_Append_Input>;
    _delete_at_path?: InputMaybe<LinkedinConversations_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<LinkedinConversations_Delete_Elem_Input>;
    _delete_key?: InputMaybe<LinkedinConversations_Delete_Key_Input>;
    _prepend?: InputMaybe<LinkedinConversations_Prepend_Input>;
    _set?: InputMaybe<LinkedinConversations_Set_Input>;
    where: LinkedinConversations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_LinkedinConversations_By_PkArgs = {
    _append?: InputMaybe<LinkedinConversations_Append_Input>;
    _delete_at_path?: InputMaybe<LinkedinConversations_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<LinkedinConversations_Delete_Elem_Input>;
    _delete_key?: InputMaybe<LinkedinConversations_Delete_Key_Input>;
    _prepend?: InputMaybe<LinkedinConversations_Prepend_Input>;
    _set?: InputMaybe<LinkedinConversations_Set_Input>;
    pk_columns: LinkedinConversations_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_LinkedinConversations_ManyArgs = {
    updates: Array<LinkedinConversations_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_MessageDraftsArgs = {
    _set?: InputMaybe<MessageDrafts_Set_Input>;
    where: MessageDrafts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_MessageDrafts_By_PkArgs = {
    _set?: InputMaybe<MessageDrafts_Set_Input>;
    pk_columns: MessageDrafts_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_MessageDrafts_ManyArgs = {
    updates: Array<MessageDrafts_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_MessagesArgs = {
    _append?: InputMaybe<Messages_Append_Input>;
    _delete_at_path?: InputMaybe<Messages_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Messages_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Messages_Delete_Key_Input>;
    _prepend?: InputMaybe<Messages_Prepend_Input>;
    _set?: InputMaybe<Messages_Set_Input>;
    where: Messages_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Messages_By_PkArgs = {
    _append?: InputMaybe<Messages_Append_Input>;
    _delete_at_path?: InputMaybe<Messages_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Messages_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Messages_Delete_Key_Input>;
    _prepend?: InputMaybe<Messages_Prepend_Input>;
    _set?: InputMaybe<Messages_Set_Input>;
    pk_columns: Messages_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Messages_ManyArgs = {
    updates: Array<Messages_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_NotesArgs = {
    _append?: InputMaybe<Notes_Append_Input>;
    _delete_at_path?: InputMaybe<Notes_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Notes_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Notes_Delete_Key_Input>;
    _prepend?: InputMaybe<Notes_Prepend_Input>;
    _set?: InputMaybe<Notes_Set_Input>;
    where: Notes_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Notes_By_PkArgs = {
    _append?: InputMaybe<Notes_Append_Input>;
    _delete_at_path?: InputMaybe<Notes_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Notes_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Notes_Delete_Key_Input>;
    _prepend?: InputMaybe<Notes_Prepend_Input>;
    _set?: InputMaybe<Notes_Set_Input>;
    pk_columns: Notes_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Notes_ManyArgs = {
    updates: Array<Notes_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_OutreachCompletionMetricsArgs = {
    _inc?: InputMaybe<OutreachCompletionMetrics_Inc_Input>;
    _set?: InputMaybe<OutreachCompletionMetrics_Set_Input>;
    where: OutreachCompletionMetrics_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_OutreachCompletionMetrics_By_PkArgs = {
    _inc?: InputMaybe<OutreachCompletionMetrics_Inc_Input>;
    _set?: InputMaybe<OutreachCompletionMetrics_Set_Input>;
    pk_columns: OutreachCompletionMetrics_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_OutreachCompletionMetrics_ManyArgs = {
    updates: Array<OutreachCompletionMetrics_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_OutreachSuggestionsArgs = {
    _inc?: InputMaybe<OutreachSuggestions_Inc_Input>;
    _set?: InputMaybe<OutreachSuggestions_Set_Input>;
    where: OutreachSuggestions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_OutreachSuggestions_By_PkArgs = {
    _inc?: InputMaybe<OutreachSuggestions_Inc_Input>;
    _set?: InputMaybe<OutreachSuggestions_Set_Input>;
    pk_columns: OutreachSuggestions_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_OutreachSuggestions_ManyArgs = {
    updates: Array<OutreachSuggestions_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_ResourceEmbeddingsArgs = {
    _append?: InputMaybe<ResourceEmbeddings_Append_Input>;
    _delete_at_path?: InputMaybe<ResourceEmbeddings_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<ResourceEmbeddings_Delete_Elem_Input>;
    _delete_key?: InputMaybe<ResourceEmbeddings_Delete_Key_Input>;
    _prepend?: InputMaybe<ResourceEmbeddings_Prepend_Input>;
    _set?: InputMaybe<ResourceEmbeddings_Set_Input>;
    where: ResourceEmbeddings_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_ResourceEmbeddings_By_PkArgs = {
    _append?: InputMaybe<ResourceEmbeddings_Append_Input>;
    _delete_at_path?: InputMaybe<ResourceEmbeddings_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<ResourceEmbeddings_Delete_Elem_Input>;
    _delete_key?: InputMaybe<ResourceEmbeddings_Delete_Key_Input>;
    _prepend?: InputMaybe<ResourceEmbeddings_Prepend_Input>;
    _set?: InputMaybe<ResourceEmbeddings_Set_Input>;
    pk_columns: ResourceEmbeddings_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_ResourceEmbeddings_ManyArgs = {
    updates: Array<ResourceEmbeddings_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_ResourcesArgs = {
    _append?: InputMaybe<Resources_Append_Input>;
    _delete_at_path?: InputMaybe<Resources_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Resources_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Resources_Delete_Key_Input>;
    _inc?: InputMaybe<Resources_Inc_Input>;
    _prepend?: InputMaybe<Resources_Prepend_Input>;
    _set?: InputMaybe<Resources_Set_Input>;
    where: Resources_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Resources_By_PkArgs = {
    _append?: InputMaybe<Resources_Append_Input>;
    _delete_at_path?: InputMaybe<Resources_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Resources_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Resources_Delete_Key_Input>;
    _inc?: InputMaybe<Resources_Inc_Input>;
    _prepend?: InputMaybe<Resources_Prepend_Input>;
    _set?: InputMaybe<Resources_Set_Input>;
    pk_columns: Resources_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Resources_ManyArgs = {
    updates: Array<Resources_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_SampleContactsArgs = {
    _append?: InputMaybe<SampleContacts_Append_Input>;
    _delete_at_path?: InputMaybe<SampleContacts_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<SampleContacts_Delete_Elem_Input>;
    _delete_key?: InputMaybe<SampleContacts_Delete_Key_Input>;
    _prepend?: InputMaybe<SampleContacts_Prepend_Input>;
    _set?: InputMaybe<SampleContacts_Set_Input>;
    where: SampleContacts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_SampleContacts_By_PkArgs = {
    _append?: InputMaybe<SampleContacts_Append_Input>;
    _delete_at_path?: InputMaybe<SampleContacts_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<SampleContacts_Delete_Elem_Input>;
    _delete_key?: InputMaybe<SampleContacts_Delete_Key_Input>;
    _prepend?: InputMaybe<SampleContacts_Prepend_Input>;
    _set?: InputMaybe<SampleContacts_Set_Input>;
    pk_columns: SampleContacts_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_SampleContacts_ManyArgs = {
    updates: Array<SampleContacts_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_UserAgentInstructionsArgs = {
    _append?: InputMaybe<UserAgentInstructions_Append_Input>;
    _delete_at_path?: InputMaybe<UserAgentInstructions_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<UserAgentInstructions_Delete_Elem_Input>;
    _delete_key?: InputMaybe<UserAgentInstructions_Delete_Key_Input>;
    _prepend?: InputMaybe<UserAgentInstructions_Prepend_Input>;
    _set?: InputMaybe<UserAgentInstructions_Set_Input>;
    where: UserAgentInstructions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_UserAgentInstructions_By_PkArgs = {
    _append?: InputMaybe<UserAgentInstructions_Append_Input>;
    _delete_at_path?: InputMaybe<UserAgentInstructions_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<UserAgentInstructions_Delete_Elem_Input>;
    _delete_key?: InputMaybe<UserAgentInstructions_Delete_Key_Input>;
    _prepend?: InputMaybe<UserAgentInstructions_Prepend_Input>;
    _set?: InputMaybe<UserAgentInstructions_Set_Input>;
    pk_columns: UserAgentInstructions_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_UserAgentInstructions_ManyArgs = {
    updates: Array<UserAgentInstructions_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_UserContactsArgs = {
    _set?: InputMaybe<UserContacts_Set_Input>;
    where: UserContacts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_UserContacts_By_PkArgs = {
    _set?: InputMaybe<UserContacts_Set_Input>;
    pk_columns: UserContacts_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_UserContacts_ManyArgs = {
    updates: Array<UserContacts_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate__GroupToContactArgs = {
    _set?: InputMaybe<_GroupToContact_Set_Input>;
    where: _GroupToContact_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate__GroupToContact_By_PkArgs = {
    _set?: InputMaybe<_GroupToContact_Set_Input>;
    pk_columns: _GroupToContact_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate__GroupToContact_ManyArgs = {
    updates: Array<_GroupToContact_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate__GroupToUserContactArgs = {
    _set?: InputMaybe<_GroupToUserContact_Set_Input>;
    where: _GroupToUserContact_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate__GroupToUserContact_By_PkArgs = {
    _set?: InputMaybe<_GroupToUserContact_Set_Input>;
    pk_columns: _GroupToUserContact_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate__GroupToUserContact_ManyArgs = {
    updates: Array<_GroupToUserContact_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mastra_Mastra_MessagesArgs = {
    _set?: InputMaybe<Mastra_Mastra_Messages_Set_Input>;
    where: Mastra_Mastra_Messages_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mastra_Mastra_Messages_By_PkArgs = {
    _set?: InputMaybe<Mastra_Mastra_Messages_Set_Input>;
    pk_columns: Mastra_Mastra_Messages_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mastra_Mastra_Messages_ManyArgs = {
    updates: Array<Mastra_Mastra_Messages_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mastra_Mastra_ResourcesArgs = {
    _append?: InputMaybe<Mastra_Mastra_Resources_Append_Input>;
    _delete_at_path?: InputMaybe<Mastra_Mastra_Resources_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Mastra_Mastra_Resources_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Mastra_Mastra_Resources_Delete_Key_Input>;
    _prepend?: InputMaybe<Mastra_Mastra_Resources_Prepend_Input>;
    _set?: InputMaybe<Mastra_Mastra_Resources_Set_Input>;
    where: Mastra_Mastra_Resources_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mastra_Mastra_Resources_By_PkArgs = {
    _append?: InputMaybe<Mastra_Mastra_Resources_Append_Input>;
    _delete_at_path?: InputMaybe<Mastra_Mastra_Resources_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Mastra_Mastra_Resources_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Mastra_Mastra_Resources_Delete_Key_Input>;
    _prepend?: InputMaybe<Mastra_Mastra_Resources_Prepend_Input>;
    _set?: InputMaybe<Mastra_Mastra_Resources_Set_Input>;
    pk_columns: Mastra_Mastra_Resources_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mastra_Mastra_Resources_ManyArgs = {
    updates: Array<Mastra_Mastra_Resources_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mastra_Mastra_ThreadsArgs = {
    _set?: InputMaybe<Mastra_Mastra_Threads_Set_Input>;
    where: Mastra_Mastra_Threads_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mastra_Mastra_Threads_By_PkArgs = {
    _set?: InputMaybe<Mastra_Mastra_Threads_Set_Input>;
    pk_columns: Mastra_Mastra_Threads_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mastra_Mastra_Threads_ManyArgs = {
    updates: Array<Mastra_Mastra_Threads_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mastra_Mastra_Workflow_SnapshotArgs = {
    _set?: InputMaybe<Mastra_Mastra_Workflow_Snapshot_Set_Input>;
    where: Mastra_Mastra_Workflow_Snapshot_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mastra_Mastra_Workflow_Snapshot_ManyArgs = {
    updates: Array<Mastra_Mastra_Workflow_Snapshot_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mastra_Memory_MessagesArgs = {
    _append?: InputMaybe<Mastra_Memory_Messages_Append_Input>;
    _delete_at_path?: InputMaybe<Mastra_Memory_Messages_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Mastra_Memory_Messages_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Mastra_Memory_Messages_Delete_Key_Input>;
    _inc?: InputMaybe<Mastra_Memory_Messages_Inc_Input>;
    _prepend?: InputMaybe<Mastra_Memory_Messages_Prepend_Input>;
    _set?: InputMaybe<Mastra_Memory_Messages_Set_Input>;
    where: Mastra_Memory_Messages_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mastra_Memory_Messages_By_PkArgs = {
    _append?: InputMaybe<Mastra_Memory_Messages_Append_Input>;
    _delete_at_path?: InputMaybe<Mastra_Memory_Messages_Delete_At_Path_Input>;
    _delete_elem?: InputMaybe<Mastra_Memory_Messages_Delete_Elem_Input>;
    _delete_key?: InputMaybe<Mastra_Memory_Messages_Delete_Key_Input>;
    _inc?: InputMaybe<Mastra_Memory_Messages_Inc_Input>;
    _prepend?: InputMaybe<Mastra_Memory_Messages_Prepend_Input>;
    _set?: InputMaybe<Mastra_Memory_Messages_Set_Input>;
    pk_columns: Mastra_Memory_Messages_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mastra_Memory_Messages_ManyArgs = {
    updates: Array<Mastra_Memory_Messages_Updates>;
};

/** column ordering options */
export enum Order_By {
    /** in ascending order, nulls last */
    Asc = 'asc',
    /** in ascending order, nulls first */
    AscNullsFirst = 'asc_nulls_first',
    /** in ascending order, nulls last */
    AscNullsLast = 'asc_nulls_last',
    /** in descending order, nulls first */
    Desc = 'desc',
    /** in descending order, nulls first */
    DescNullsFirst = 'desc_nulls_first',
    /** in descending order, nulls last */
    DescNullsLast = 'desc_nulls_last',
}

export type Query_Root = {
    __typename?: 'query_root';
    /** fetch data from the table: "Accounts" */
    Accounts: Array<Accounts>;
    /** fetch aggregated fields from the table: "Accounts" */
    Accounts_aggregate: Accounts_Aggregate;
    /** fetch data from the table: "Accounts" using primary key columns */
    Accounts_by_pk?: Maybe<Accounts>;
    /** fetch data from the table: "AssistantSettings" */
    AssistantSettings: Array<AssistantSettings>;
    /** fetch aggregated fields from the table: "AssistantSettings" */
    AssistantSettings_aggregate: AssistantSettings_Aggregate;
    /** fetch data from the table: "AssistantSettings" using primary key columns */
    AssistantSettings_by_pk?: Maybe<AssistantSettings>;
    /** An array relationship */
    Attachments: Array<Attachments>;
    /** An aggregate relationship */
    Attachments_aggregate: Attachments_Aggregate;
    /** fetch data from the table: "Attachments" using primary key columns */
    Attachments_by_pk?: Maybe<Attachments>;
    /** fetch data from the table: "ContactSuggestions" */
    ContactSuggestions: Array<ContactSuggestions>;
    /** fetch aggregated fields from the table: "ContactSuggestions" */
    ContactSuggestions_aggregate: ContactSuggestions_Aggregate;
    /** fetch data from the table: "ContactSuggestions" using primary key columns */
    ContactSuggestions_by_pk?: Maybe<ContactSuggestions>;
    /** An array relationship */
    Contacts: Array<Contacts>;
    /** An array relationship */
    ContactsInteractions: Array<ContactsInteractions>;
    /** An aggregate relationship */
    ContactsInteractions_aggregate: ContactsInteractions_Aggregate;
    /** fetch data from the table: "ContactsInteractions" using primary key columns */
    ContactsInteractions_by_pk?: Maybe<ContactsInteractions>;
    /** An aggregate relationship */
    Contacts_aggregate: Contacts_Aggregate;
    /** fetch data from the table: "Contacts" using primary key columns */
    Contacts_by_pk?: Maybe<Contacts>;
    /** fetch data from the table: "ConversationMetaData" */
    ConversationMetaData: Array<ConversationMetaData>;
    /** fetch aggregated fields from the table: "ConversationMetaData" */
    ConversationMetaData_aggregate: ConversationMetaData_Aggregate;
    /** fetch data from the table: "ConversationMetaData" using primary key columns */
    ConversationMetaData_by_pk?: Maybe<ConversationMetaData>;
    /** An array relationship */
    Conversations: Array<Conversations>;
    /** An aggregate relationship */
    Conversations_aggregate: Conversations_Aggregate;
    /** fetch data from the table: "Conversations" using primary key columns */
    Conversations_by_pk?: Maybe<Conversations>;
    /** An array relationship */
    Groups: Array<Groups>;
    /** An aggregate relationship */
    Groups_aggregate: Groups_Aggregate;
    /** fetch data from the table: "Groups" using primary key columns */
    Groups_by_pk?: Maybe<Groups>;
    /** An array relationship */
    Jobs: Array<Jobs>;
    /** An aggregate relationship */
    Jobs_aggregate: Jobs_Aggregate;
    /** fetch data from the table: "Jobs" using primary key columns */
    Jobs_by_pk?: Maybe<Jobs>;
    /** fetch data from the table: "LinkedinConversations" */
    LinkedinConversations: Array<LinkedinConversations>;
    /** fetch aggregated fields from the table: "LinkedinConversations" */
    LinkedinConversations_aggregate: LinkedinConversations_Aggregate;
    /** fetch data from the table: "LinkedinConversations" using primary key columns */
    LinkedinConversations_by_pk?: Maybe<LinkedinConversations>;
    /** An array relationship */
    MessageDrafts: Array<MessageDrafts>;
    /** An aggregate relationship */
    MessageDrafts_aggregate: MessageDrafts_Aggregate;
    /** fetch data from the table: "MessageDrafts" using primary key columns */
    MessageDrafts_by_pk?: Maybe<MessageDrafts>;
    /** An array relationship */
    Messages: Array<Messages>;
    /** An aggregate relationship */
    Messages_aggregate: Messages_Aggregate;
    /** fetch data from the table: "Messages" using primary key columns */
    Messages_by_pk?: Maybe<Messages>;
    /** An array relationship */
    Notes: Array<Notes>;
    /** An aggregate relationship */
    Notes_aggregate: Notes_Aggregate;
    /** fetch data from the table: "Notes" using primary key columns */
    Notes_by_pk?: Maybe<Notes>;
    /** fetch data from the table: "OutreachCompletionMetrics" */
    OutreachCompletionMetrics: Array<OutreachCompletionMetrics>;
    /** fetch aggregated fields from the table: "OutreachCompletionMetrics" */
    OutreachCompletionMetrics_aggregate: OutreachCompletionMetrics_Aggregate;
    /** fetch data from the table: "OutreachCompletionMetrics" using primary key columns */
    OutreachCompletionMetrics_by_pk?: Maybe<OutreachCompletionMetrics>;
    /** An array relationship */
    OutreachSuggestions: Array<OutreachSuggestions>;
    /** An aggregate relationship */
    OutreachSuggestions_aggregate: OutreachSuggestions_Aggregate;
    /** fetch data from the table: "OutreachSuggestions" using primary key columns */
    OutreachSuggestions_by_pk?: Maybe<OutreachSuggestions>;
    /** An array relationship */
    ResourceEmbeddings: Array<ResourceEmbeddings>;
    /** An aggregate relationship */
    ResourceEmbeddings_aggregate: ResourceEmbeddings_Aggregate;
    /** fetch data from the table: "ResourceEmbeddings" using primary key columns */
    ResourceEmbeddings_by_pk?: Maybe<ResourceEmbeddings>;
    /** An array relationship */
    Resources: Array<Resources>;
    /** An aggregate relationship */
    Resources_aggregate: Resources_Aggregate;
    /** fetch data from the table: "Resources" using primary key columns */
    Resources_by_pk?: Maybe<Resources>;
    /** fetch data from the table: "SampleContacts" */
    SampleContacts: Array<SampleContacts>;
    /** fetch aggregated fields from the table: "SampleContacts" */
    SampleContacts_aggregate: SampleContacts_Aggregate;
    /** fetch data from the table: "SampleContacts" using primary key columns */
    SampleContacts_by_pk?: Maybe<SampleContacts>;
    /** fetch data from the table: "UserAgentInstructions" */
    UserAgentInstructions: Array<UserAgentInstructions>;
    /** fetch aggregated fields from the table: "UserAgentInstructions" */
    UserAgentInstructions_aggregate: UserAgentInstructions_Aggregate;
    /** fetch data from the table: "UserAgentInstructions" using primary key columns */
    UserAgentInstructions_by_pk?: Maybe<UserAgentInstructions>;
    /** fetch data from the table: "UserContacts" */
    UserContacts: Array<UserContacts>;
    /** fetch aggregated fields from the table: "UserContacts" */
    UserContacts_aggregate: UserContacts_Aggregate;
    /** fetch data from the table: "UserContacts" using primary key columns */
    UserContacts_by_pk?: Maybe<UserContacts>;
    /** fetch data from the table: "_GroupToContact" */
    _GroupToContact: Array<_GroupToContact>;
    /** fetch aggregated fields from the table: "_GroupToContact" */
    _GroupToContact_aggregate: _GroupToContact_Aggregate;
    /** fetch data from the table: "_GroupToContact" using primary key columns */
    _GroupToContact_by_pk?: Maybe<_GroupToContact>;
    /** fetch data from the table: "_GroupToUserContact" */
    _GroupToUserContact: Array<_GroupToUserContact>;
    /** fetch aggregated fields from the table: "_GroupToUserContact" */
    _GroupToUserContact_aggregate: _GroupToUserContact_Aggregate;
    /** fetch data from the table: "_GroupToUserContact" using primary key columns */
    _GroupToUserContact_by_pk?: Maybe<_GroupToUserContact>;
    /** execute function "contacts_weighted_scores" which returns "Contacts" */
    contacts_weighted_scores: Array<Contacts>;
    /** execute function "contacts_weighted_scores" and query aggregates on result of table type "Contacts" */
    contacts_weighted_scores_aggregate: Contacts_Aggregate;
    /** fetch data from the table: "mastra.mastra_messages" */
    mastra_mastra_messages: Array<Mastra_Mastra_Messages>;
    /** fetch aggregated fields from the table: "mastra.mastra_messages" */
    mastra_mastra_messages_aggregate: Mastra_Mastra_Messages_Aggregate;
    /** fetch data from the table: "mastra.mastra_messages" using primary key columns */
    mastra_mastra_messages_by_pk?: Maybe<Mastra_Mastra_Messages>;
    /** fetch data from the table: "mastra.mastra_resources" */
    mastra_mastra_resources: Array<Mastra_Mastra_Resources>;
    /** fetch aggregated fields from the table: "mastra.mastra_resources" */
    mastra_mastra_resources_aggregate: Mastra_Mastra_Resources_Aggregate;
    /** fetch data from the table: "mastra.mastra_resources" using primary key columns */
    mastra_mastra_resources_by_pk?: Maybe<Mastra_Mastra_Resources>;
    /** fetch data from the table: "mastra.mastra_threads" */
    mastra_mastra_threads: Array<Mastra_Mastra_Threads>;
    /** fetch aggregated fields from the table: "mastra.mastra_threads" */
    mastra_mastra_threads_aggregate: Mastra_Mastra_Threads_Aggregate;
    /** fetch data from the table: "mastra.mastra_threads" using primary key columns */
    mastra_mastra_threads_by_pk?: Maybe<Mastra_Mastra_Threads>;
    /** fetch data from the table: "mastra.mastra_workflow_snapshot" */
    mastra_mastra_workflow_snapshot: Array<Mastra_Mastra_Workflow_Snapshot>;
    /** fetch aggregated fields from the table: "mastra.mastra_workflow_snapshot" */
    mastra_mastra_workflow_snapshot_aggregate: Mastra_Mastra_Workflow_Snapshot_Aggregate;
    /** fetch data from the table: "mastra.memory_messages" */
    mastra_memory_messages: Array<Mastra_Memory_Messages>;
    /** fetch aggregated fields from the table: "mastra.memory_messages" */
    mastra_memory_messages_aggregate: Mastra_Memory_Messages_Aggregate;
    /** fetch data from the table: "mastra.memory_messages" using primary key columns */
    mastra_memory_messages_by_pk?: Maybe<Mastra_Memory_Messages>;
};

export type Query_RootAccountsArgs = {
    distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Accounts_Order_By>>;
    where?: InputMaybe<Accounts_Bool_Exp>;
};

export type Query_RootAccounts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Accounts_Order_By>>;
    where?: InputMaybe<Accounts_Bool_Exp>;
};

export type Query_RootAccounts_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootAssistantSettingsArgs = {
    distinct_on?: InputMaybe<Array<AssistantSettings_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<AssistantSettings_Order_By>>;
    where?: InputMaybe<AssistantSettings_Bool_Exp>;
};

export type Query_RootAssistantSettings_AggregateArgs = {
    distinct_on?: InputMaybe<Array<AssistantSettings_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<AssistantSettings_Order_By>>;
    where?: InputMaybe<AssistantSettings_Bool_Exp>;
};

export type Query_RootAssistantSettings_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootAttachmentsArgs = {
    distinct_on?: InputMaybe<Array<Attachments_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Attachments_Order_By>>;
    where?: InputMaybe<Attachments_Bool_Exp>;
};

export type Query_RootAttachments_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Attachments_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Attachments_Order_By>>;
    where?: InputMaybe<Attachments_Bool_Exp>;
};

export type Query_RootAttachments_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootContactSuggestionsArgs = {
    distinct_on?: InputMaybe<Array<ContactSuggestions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ContactSuggestions_Order_By>>;
    where?: InputMaybe<ContactSuggestions_Bool_Exp>;
};

export type Query_RootContactSuggestions_AggregateArgs = {
    distinct_on?: InputMaybe<Array<ContactSuggestions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ContactSuggestions_Order_By>>;
    where?: InputMaybe<ContactSuggestions_Bool_Exp>;
};

export type Query_RootContactSuggestions_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootContactsArgs = {
    distinct_on?: InputMaybe<Array<Contacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Contacts_Order_By>>;
    where?: InputMaybe<Contacts_Bool_Exp>;
};

export type Query_RootContactsInteractionsArgs = {
    distinct_on?: InputMaybe<Array<ContactsInteractions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ContactsInteractions_Order_By>>;
    where?: InputMaybe<ContactsInteractions_Bool_Exp>;
};

export type Query_RootContactsInteractions_AggregateArgs = {
    distinct_on?: InputMaybe<Array<ContactsInteractions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ContactsInteractions_Order_By>>;
    where?: InputMaybe<ContactsInteractions_Bool_Exp>;
};

export type Query_RootContactsInteractions_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootContacts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Contacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Contacts_Order_By>>;
    where?: InputMaybe<Contacts_Bool_Exp>;
};

export type Query_RootContacts_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootConversationMetaDataArgs = {
    distinct_on?: InputMaybe<Array<ConversationMetaData_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ConversationMetaData_Order_By>>;
    where?: InputMaybe<ConversationMetaData_Bool_Exp>;
};

export type Query_RootConversationMetaData_AggregateArgs = {
    distinct_on?: InputMaybe<Array<ConversationMetaData_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ConversationMetaData_Order_By>>;
    where?: InputMaybe<ConversationMetaData_Bool_Exp>;
};

export type Query_RootConversationMetaData_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootConversationsArgs = {
    distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Conversations_Order_By>>;
    where?: InputMaybe<Conversations_Bool_Exp>;
};

export type Query_RootConversations_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Conversations_Order_By>>;
    where?: InputMaybe<Conversations_Bool_Exp>;
};

export type Query_RootConversations_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootGroupsArgs = {
    distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Groups_Order_By>>;
    where?: InputMaybe<Groups_Bool_Exp>;
};

export type Query_RootGroups_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Groups_Order_By>>;
    where?: InputMaybe<Groups_Bool_Exp>;
};

export type Query_RootGroups_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootJobsArgs = {
    distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Jobs_Order_By>>;
    where?: InputMaybe<Jobs_Bool_Exp>;
};

export type Query_RootJobs_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Jobs_Order_By>>;
    where?: InputMaybe<Jobs_Bool_Exp>;
};

export type Query_RootJobs_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootLinkedinConversationsArgs = {
    distinct_on?: InputMaybe<Array<LinkedinConversations_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<LinkedinConversations_Order_By>>;
    where?: InputMaybe<LinkedinConversations_Bool_Exp>;
};

export type Query_RootLinkedinConversations_AggregateArgs = {
    distinct_on?: InputMaybe<Array<LinkedinConversations_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<LinkedinConversations_Order_By>>;
    where?: InputMaybe<LinkedinConversations_Bool_Exp>;
};

export type Query_RootLinkedinConversations_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootMessageDraftsArgs = {
    distinct_on?: InputMaybe<Array<MessageDrafts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<MessageDrafts_Order_By>>;
    where?: InputMaybe<MessageDrafts_Bool_Exp>;
};

export type Query_RootMessageDrafts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<MessageDrafts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<MessageDrafts_Order_By>>;
    where?: InputMaybe<MessageDrafts_Bool_Exp>;
};

export type Query_RootMessageDrafts_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootMessagesArgs = {
    distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Messages_Order_By>>;
    where?: InputMaybe<Messages_Bool_Exp>;
};

export type Query_RootMessages_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Messages_Order_By>>;
    where?: InputMaybe<Messages_Bool_Exp>;
};

export type Query_RootMessages_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootNotesArgs = {
    distinct_on?: InputMaybe<Array<Notes_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Notes_Order_By>>;
    where?: InputMaybe<Notes_Bool_Exp>;
};

export type Query_RootNotes_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Notes_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Notes_Order_By>>;
    where?: InputMaybe<Notes_Bool_Exp>;
};

export type Query_RootNotes_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootOutreachCompletionMetricsArgs = {
    distinct_on?: InputMaybe<Array<OutreachCompletionMetrics_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<OutreachCompletionMetrics_Order_By>>;
    where?: InputMaybe<OutreachCompletionMetrics_Bool_Exp>;
};

export type Query_RootOutreachCompletionMetrics_AggregateArgs = {
    distinct_on?: InputMaybe<Array<OutreachCompletionMetrics_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<OutreachCompletionMetrics_Order_By>>;
    where?: InputMaybe<OutreachCompletionMetrics_Bool_Exp>;
};

export type Query_RootOutreachCompletionMetrics_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootOutreachSuggestionsArgs = {
    distinct_on?: InputMaybe<Array<OutreachSuggestions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<OutreachSuggestions_Order_By>>;
    where?: InputMaybe<OutreachSuggestions_Bool_Exp>;
};

export type Query_RootOutreachSuggestions_AggregateArgs = {
    distinct_on?: InputMaybe<Array<OutreachSuggestions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<OutreachSuggestions_Order_By>>;
    where?: InputMaybe<OutreachSuggestions_Bool_Exp>;
};

export type Query_RootOutreachSuggestions_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootResourceEmbeddingsArgs = {
    distinct_on?: InputMaybe<Array<ResourceEmbeddings_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ResourceEmbeddings_Order_By>>;
    where?: InputMaybe<ResourceEmbeddings_Bool_Exp>;
};

export type Query_RootResourceEmbeddings_AggregateArgs = {
    distinct_on?: InputMaybe<Array<ResourceEmbeddings_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ResourceEmbeddings_Order_By>>;
    where?: InputMaybe<ResourceEmbeddings_Bool_Exp>;
};

export type Query_RootResourceEmbeddings_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootResourcesArgs = {
    distinct_on?: InputMaybe<Array<Resources_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Resources_Order_By>>;
    where?: InputMaybe<Resources_Bool_Exp>;
};

export type Query_RootResources_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Resources_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Resources_Order_By>>;
    where?: InputMaybe<Resources_Bool_Exp>;
};

export type Query_RootResources_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootSampleContactsArgs = {
    distinct_on?: InputMaybe<Array<SampleContacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<SampleContacts_Order_By>>;
    where?: InputMaybe<SampleContacts_Bool_Exp>;
};

export type Query_RootSampleContacts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<SampleContacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<SampleContacts_Order_By>>;
    where?: InputMaybe<SampleContacts_Bool_Exp>;
};

export type Query_RootSampleContacts_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootUserAgentInstructionsArgs = {
    distinct_on?: InputMaybe<Array<UserAgentInstructions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<UserAgentInstructions_Order_By>>;
    where?: InputMaybe<UserAgentInstructions_Bool_Exp>;
};

export type Query_RootUserAgentInstructions_AggregateArgs = {
    distinct_on?: InputMaybe<Array<UserAgentInstructions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<UserAgentInstructions_Order_By>>;
    where?: InputMaybe<UserAgentInstructions_Bool_Exp>;
};

export type Query_RootUserAgentInstructions_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootUserContactsArgs = {
    distinct_on?: InputMaybe<Array<UserContacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<UserContacts_Order_By>>;
    where?: InputMaybe<UserContacts_Bool_Exp>;
};

export type Query_RootUserContacts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<UserContacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<UserContacts_Order_By>>;
    where?: InputMaybe<UserContacts_Bool_Exp>;
};

export type Query_RootUserContacts_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_Root_GroupToContactArgs = {
    distinct_on?: InputMaybe<Array<_GroupToContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToContact_Order_By>>;
    where?: InputMaybe<_GroupToContact_Bool_Exp>;
};

export type Query_Root_GroupToContact_AggregateArgs = {
    distinct_on?: InputMaybe<Array<_GroupToContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToContact_Order_By>>;
    where?: InputMaybe<_GroupToContact_Bool_Exp>;
};

export type Query_Root_GroupToContact_By_PkArgs = {
    A: Scalars['String']['input'];
    B: Scalars['String']['input'];
};

export type Query_Root_GroupToUserContactArgs = {
    distinct_on?: InputMaybe<Array<_GroupToUserContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToUserContact_Order_By>>;
    where?: InputMaybe<_GroupToUserContact_Bool_Exp>;
};

export type Query_Root_GroupToUserContact_AggregateArgs = {
    distinct_on?: InputMaybe<Array<_GroupToUserContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToUserContact_Order_By>>;
    where?: InputMaybe<_GroupToUserContact_Bool_Exp>;
};

export type Query_Root_GroupToUserContact_By_PkArgs = {
    A: Scalars['String']['input'];
    B: Scalars['String']['input'];
};

export type Query_RootContacts_Weighted_ScoresArgs = {
    args?: InputMaybe<Contacts_Weighted_Scores_Args>;
    distinct_on?: InputMaybe<Array<Contacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Contacts_Order_By>>;
    where?: InputMaybe<Contacts_Bool_Exp>;
};

export type Query_RootContacts_Weighted_Scores_AggregateArgs = {
    args?: InputMaybe<Contacts_Weighted_Scores_Args>;
    distinct_on?: InputMaybe<Array<Contacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Contacts_Order_By>>;
    where?: InputMaybe<Contacts_Bool_Exp>;
};

export type Query_RootMastra_Mastra_MessagesArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Messages_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Messages_Bool_Exp>;
};

export type Query_RootMastra_Mastra_Messages_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Messages_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Messages_Bool_Exp>;
};

export type Query_RootMastra_Mastra_Messages_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootMastra_Mastra_ResourcesArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Resources_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Resources_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Resources_Bool_Exp>;
};

export type Query_RootMastra_Mastra_Resources_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Resources_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Resources_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Resources_Bool_Exp>;
};

export type Query_RootMastra_Mastra_Resources_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootMastra_Mastra_ThreadsArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Threads_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Threads_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Threads_Bool_Exp>;
};

export type Query_RootMastra_Mastra_Threads_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Threads_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Threads_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Threads_Bool_Exp>;
};

export type Query_RootMastra_Mastra_Threads_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Query_RootMastra_Mastra_Workflow_SnapshotArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Workflow_Snapshot_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Workflow_Snapshot_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Workflow_Snapshot_Bool_Exp>;
};

export type Query_RootMastra_Mastra_Workflow_Snapshot_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Workflow_Snapshot_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Workflow_Snapshot_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Workflow_Snapshot_Bool_Exp>;
};

export type Query_RootMastra_Memory_MessagesArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Memory_Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Memory_Messages_Order_By>>;
    where?: InputMaybe<Mastra_Memory_Messages_Bool_Exp>;
};

export type Query_RootMastra_Memory_Messages_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Memory_Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Memory_Messages_Order_By>>;
    where?: InputMaybe<Mastra_Memory_Messages_Bool_Exp>;
};

export type Query_RootMastra_Memory_Messages_By_PkArgs = {
    id: Scalars['Int']['input'];
};

export type Subscription_Root = {
    __typename?: 'subscription_root';
    /** fetch data from the table: "Accounts" */
    Accounts: Array<Accounts>;
    /** fetch aggregated fields from the table: "Accounts" */
    Accounts_aggregate: Accounts_Aggregate;
    /** fetch data from the table: "Accounts" using primary key columns */
    Accounts_by_pk?: Maybe<Accounts>;
    /** fetch data from the table in a streaming manner: "Accounts" */
    Accounts_stream: Array<Accounts>;
    /** fetch data from the table: "AssistantSettings" */
    AssistantSettings: Array<AssistantSettings>;
    /** fetch aggregated fields from the table: "AssistantSettings" */
    AssistantSettings_aggregate: AssistantSettings_Aggregate;
    /** fetch data from the table: "AssistantSettings" using primary key columns */
    AssistantSettings_by_pk?: Maybe<AssistantSettings>;
    /** fetch data from the table in a streaming manner: "AssistantSettings" */
    AssistantSettings_stream: Array<AssistantSettings>;
    /** An array relationship */
    Attachments: Array<Attachments>;
    /** An aggregate relationship */
    Attachments_aggregate: Attachments_Aggregate;
    /** fetch data from the table: "Attachments" using primary key columns */
    Attachments_by_pk?: Maybe<Attachments>;
    /** fetch data from the table in a streaming manner: "Attachments" */
    Attachments_stream: Array<Attachments>;
    /** fetch data from the table: "ContactSuggestions" */
    ContactSuggestions: Array<ContactSuggestions>;
    /** fetch aggregated fields from the table: "ContactSuggestions" */
    ContactSuggestions_aggregate: ContactSuggestions_Aggregate;
    /** fetch data from the table: "ContactSuggestions" using primary key columns */
    ContactSuggestions_by_pk?: Maybe<ContactSuggestions>;
    /** fetch data from the table in a streaming manner: "ContactSuggestions" */
    ContactSuggestions_stream: Array<ContactSuggestions>;
    /** An array relationship */
    Contacts: Array<Contacts>;
    /** An array relationship */
    ContactsInteractions: Array<ContactsInteractions>;
    /** An aggregate relationship */
    ContactsInteractions_aggregate: ContactsInteractions_Aggregate;
    /** fetch data from the table: "ContactsInteractions" using primary key columns */
    ContactsInteractions_by_pk?: Maybe<ContactsInteractions>;
    /** fetch data from the table in a streaming manner: "ContactsInteractions" */
    ContactsInteractions_stream: Array<ContactsInteractions>;
    /** An aggregate relationship */
    Contacts_aggregate: Contacts_Aggregate;
    /** fetch data from the table: "Contacts" using primary key columns */
    Contacts_by_pk?: Maybe<Contacts>;
    /** fetch data from the table in a streaming manner: "Contacts" */
    Contacts_stream: Array<Contacts>;
    /** fetch data from the table: "ConversationMetaData" */
    ConversationMetaData: Array<ConversationMetaData>;
    /** fetch aggregated fields from the table: "ConversationMetaData" */
    ConversationMetaData_aggregate: ConversationMetaData_Aggregate;
    /** fetch data from the table: "ConversationMetaData" using primary key columns */
    ConversationMetaData_by_pk?: Maybe<ConversationMetaData>;
    /** fetch data from the table in a streaming manner: "ConversationMetaData" */
    ConversationMetaData_stream: Array<ConversationMetaData>;
    /** An array relationship */
    Conversations: Array<Conversations>;
    /** An aggregate relationship */
    Conversations_aggregate: Conversations_Aggregate;
    /** fetch data from the table: "Conversations" using primary key columns */
    Conversations_by_pk?: Maybe<Conversations>;
    /** fetch data from the table in a streaming manner: "Conversations" */
    Conversations_stream: Array<Conversations>;
    /** An array relationship */
    Groups: Array<Groups>;
    /** An aggregate relationship */
    Groups_aggregate: Groups_Aggregate;
    /** fetch data from the table: "Groups" using primary key columns */
    Groups_by_pk?: Maybe<Groups>;
    /** fetch data from the table in a streaming manner: "Groups" */
    Groups_stream: Array<Groups>;
    /** An array relationship */
    Jobs: Array<Jobs>;
    /** An aggregate relationship */
    Jobs_aggregate: Jobs_Aggregate;
    /** fetch data from the table: "Jobs" using primary key columns */
    Jobs_by_pk?: Maybe<Jobs>;
    /** fetch data from the table in a streaming manner: "Jobs" */
    Jobs_stream: Array<Jobs>;
    /** fetch data from the table: "LinkedinConversations" */
    LinkedinConversations: Array<LinkedinConversations>;
    /** fetch aggregated fields from the table: "LinkedinConversations" */
    LinkedinConversations_aggregate: LinkedinConversations_Aggregate;
    /** fetch data from the table: "LinkedinConversations" using primary key columns */
    LinkedinConversations_by_pk?: Maybe<LinkedinConversations>;
    /** fetch data from the table in a streaming manner: "LinkedinConversations" */
    LinkedinConversations_stream: Array<LinkedinConversations>;
    /** An array relationship */
    MessageDrafts: Array<MessageDrafts>;
    /** An aggregate relationship */
    MessageDrafts_aggregate: MessageDrafts_Aggregate;
    /** fetch data from the table: "MessageDrafts" using primary key columns */
    MessageDrafts_by_pk?: Maybe<MessageDrafts>;
    /** fetch data from the table in a streaming manner: "MessageDrafts" */
    MessageDrafts_stream: Array<MessageDrafts>;
    /** An array relationship */
    Messages: Array<Messages>;
    /** An aggregate relationship */
    Messages_aggregate: Messages_Aggregate;
    /** fetch data from the table: "Messages" using primary key columns */
    Messages_by_pk?: Maybe<Messages>;
    /** fetch data from the table in a streaming manner: "Messages" */
    Messages_stream: Array<Messages>;
    /** An array relationship */
    Notes: Array<Notes>;
    /** An aggregate relationship */
    Notes_aggregate: Notes_Aggregate;
    /** fetch data from the table: "Notes" using primary key columns */
    Notes_by_pk?: Maybe<Notes>;
    /** fetch data from the table in a streaming manner: "Notes" */
    Notes_stream: Array<Notes>;
    /** fetch data from the table: "OutreachCompletionMetrics" */
    OutreachCompletionMetrics: Array<OutreachCompletionMetrics>;
    /** fetch aggregated fields from the table: "OutreachCompletionMetrics" */
    OutreachCompletionMetrics_aggregate: OutreachCompletionMetrics_Aggregate;
    /** fetch data from the table: "OutreachCompletionMetrics" using primary key columns */
    OutreachCompletionMetrics_by_pk?: Maybe<OutreachCompletionMetrics>;
    /** fetch data from the table in a streaming manner: "OutreachCompletionMetrics" */
    OutreachCompletionMetrics_stream: Array<OutreachCompletionMetrics>;
    /** An array relationship */
    OutreachSuggestions: Array<OutreachSuggestions>;
    /** An aggregate relationship */
    OutreachSuggestions_aggregate: OutreachSuggestions_Aggregate;
    /** fetch data from the table: "OutreachSuggestions" using primary key columns */
    OutreachSuggestions_by_pk?: Maybe<OutreachSuggestions>;
    /** fetch data from the table in a streaming manner: "OutreachSuggestions" */
    OutreachSuggestions_stream: Array<OutreachSuggestions>;
    /** An array relationship */
    ResourceEmbeddings: Array<ResourceEmbeddings>;
    /** An aggregate relationship */
    ResourceEmbeddings_aggregate: ResourceEmbeddings_Aggregate;
    /** fetch data from the table: "ResourceEmbeddings" using primary key columns */
    ResourceEmbeddings_by_pk?: Maybe<ResourceEmbeddings>;
    /** fetch data from the table in a streaming manner: "ResourceEmbeddings" */
    ResourceEmbeddings_stream: Array<ResourceEmbeddings>;
    /** An array relationship */
    Resources: Array<Resources>;
    /** An aggregate relationship */
    Resources_aggregate: Resources_Aggregate;
    /** fetch data from the table: "Resources" using primary key columns */
    Resources_by_pk?: Maybe<Resources>;
    /** fetch data from the table in a streaming manner: "Resources" */
    Resources_stream: Array<Resources>;
    /** fetch data from the table: "SampleContacts" */
    SampleContacts: Array<SampleContacts>;
    /** fetch aggregated fields from the table: "SampleContacts" */
    SampleContacts_aggregate: SampleContacts_Aggregate;
    /** fetch data from the table: "SampleContacts" using primary key columns */
    SampleContacts_by_pk?: Maybe<SampleContacts>;
    /** fetch data from the table in a streaming manner: "SampleContacts" */
    SampleContacts_stream: Array<SampleContacts>;
    /** fetch data from the table: "UserAgentInstructions" */
    UserAgentInstructions: Array<UserAgentInstructions>;
    /** fetch aggregated fields from the table: "UserAgentInstructions" */
    UserAgentInstructions_aggregate: UserAgentInstructions_Aggregate;
    /** fetch data from the table: "UserAgentInstructions" using primary key columns */
    UserAgentInstructions_by_pk?: Maybe<UserAgentInstructions>;
    /** fetch data from the table in a streaming manner: "UserAgentInstructions" */
    UserAgentInstructions_stream: Array<UserAgentInstructions>;
    /** fetch data from the table: "UserContacts" */
    UserContacts: Array<UserContacts>;
    /** fetch aggregated fields from the table: "UserContacts" */
    UserContacts_aggregate: UserContacts_Aggregate;
    /** fetch data from the table: "UserContacts" using primary key columns */
    UserContacts_by_pk?: Maybe<UserContacts>;
    /** fetch data from the table in a streaming manner: "UserContacts" */
    UserContacts_stream: Array<UserContacts>;
    /** fetch data from the table: "_GroupToContact" */
    _GroupToContact: Array<_GroupToContact>;
    /** fetch aggregated fields from the table: "_GroupToContact" */
    _GroupToContact_aggregate: _GroupToContact_Aggregate;
    /** fetch data from the table: "_GroupToContact" using primary key columns */
    _GroupToContact_by_pk?: Maybe<_GroupToContact>;
    /** fetch data from the table in a streaming manner: "_GroupToContact" */
    _GroupToContact_stream: Array<_GroupToContact>;
    /** fetch data from the table: "_GroupToUserContact" */
    _GroupToUserContact: Array<_GroupToUserContact>;
    /** fetch aggregated fields from the table: "_GroupToUserContact" */
    _GroupToUserContact_aggregate: _GroupToUserContact_Aggregate;
    /** fetch data from the table: "_GroupToUserContact" using primary key columns */
    _GroupToUserContact_by_pk?: Maybe<_GroupToUserContact>;
    /** fetch data from the table in a streaming manner: "_GroupToUserContact" */
    _GroupToUserContact_stream: Array<_GroupToUserContact>;
    /** execute function "contacts_weighted_scores" which returns "Contacts" */
    contacts_weighted_scores: Array<Contacts>;
    /** execute function "contacts_weighted_scores" and query aggregates on result of table type "Contacts" */
    contacts_weighted_scores_aggregate: Contacts_Aggregate;
    /** fetch data from the table: "mastra.mastra_messages" */
    mastra_mastra_messages: Array<Mastra_Mastra_Messages>;
    /** fetch aggregated fields from the table: "mastra.mastra_messages" */
    mastra_mastra_messages_aggregate: Mastra_Mastra_Messages_Aggregate;
    /** fetch data from the table: "mastra.mastra_messages" using primary key columns */
    mastra_mastra_messages_by_pk?: Maybe<Mastra_Mastra_Messages>;
    /** fetch data from the table in a streaming manner: "mastra.mastra_messages" */
    mastra_mastra_messages_stream: Array<Mastra_Mastra_Messages>;
    /** fetch data from the table: "mastra.mastra_resources" */
    mastra_mastra_resources: Array<Mastra_Mastra_Resources>;
    /** fetch aggregated fields from the table: "mastra.mastra_resources" */
    mastra_mastra_resources_aggregate: Mastra_Mastra_Resources_Aggregate;
    /** fetch data from the table: "mastra.mastra_resources" using primary key columns */
    mastra_mastra_resources_by_pk?: Maybe<Mastra_Mastra_Resources>;
    /** fetch data from the table in a streaming manner: "mastra.mastra_resources" */
    mastra_mastra_resources_stream: Array<Mastra_Mastra_Resources>;
    /** fetch data from the table: "mastra.mastra_threads" */
    mastra_mastra_threads: Array<Mastra_Mastra_Threads>;
    /** fetch aggregated fields from the table: "mastra.mastra_threads" */
    mastra_mastra_threads_aggregate: Mastra_Mastra_Threads_Aggregate;
    /** fetch data from the table: "mastra.mastra_threads" using primary key columns */
    mastra_mastra_threads_by_pk?: Maybe<Mastra_Mastra_Threads>;
    /** fetch data from the table in a streaming manner: "mastra.mastra_threads" */
    mastra_mastra_threads_stream: Array<Mastra_Mastra_Threads>;
    /** fetch data from the table: "mastra.mastra_workflow_snapshot" */
    mastra_mastra_workflow_snapshot: Array<Mastra_Mastra_Workflow_Snapshot>;
    /** fetch aggregated fields from the table: "mastra.mastra_workflow_snapshot" */
    mastra_mastra_workflow_snapshot_aggregate: Mastra_Mastra_Workflow_Snapshot_Aggregate;
    /** fetch data from the table in a streaming manner: "mastra.mastra_workflow_snapshot" */
    mastra_mastra_workflow_snapshot_stream: Array<Mastra_Mastra_Workflow_Snapshot>;
    /** fetch data from the table: "mastra.memory_messages" */
    mastra_memory_messages: Array<Mastra_Memory_Messages>;
    /** fetch aggregated fields from the table: "mastra.memory_messages" */
    mastra_memory_messages_aggregate: Mastra_Memory_Messages_Aggregate;
    /** fetch data from the table: "mastra.memory_messages" using primary key columns */
    mastra_memory_messages_by_pk?: Maybe<Mastra_Memory_Messages>;
    /** fetch data from the table in a streaming manner: "mastra.memory_messages" */
    mastra_memory_messages_stream: Array<Mastra_Memory_Messages>;
};

export type Subscription_RootAccountsArgs = {
    distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Accounts_Order_By>>;
    where?: InputMaybe<Accounts_Bool_Exp>;
};

export type Subscription_RootAccounts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Accounts_Order_By>>;
    where?: InputMaybe<Accounts_Bool_Exp>;
};

export type Subscription_RootAccounts_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootAccounts_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<Accounts_Stream_Cursor_Input>>;
    where?: InputMaybe<Accounts_Bool_Exp>;
};

export type Subscription_RootAssistantSettingsArgs = {
    distinct_on?: InputMaybe<Array<AssistantSettings_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<AssistantSettings_Order_By>>;
    where?: InputMaybe<AssistantSettings_Bool_Exp>;
};

export type Subscription_RootAssistantSettings_AggregateArgs = {
    distinct_on?: InputMaybe<Array<AssistantSettings_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<AssistantSettings_Order_By>>;
    where?: InputMaybe<AssistantSettings_Bool_Exp>;
};

export type Subscription_RootAssistantSettings_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootAssistantSettings_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<AssistantSettings_Stream_Cursor_Input>>;
    where?: InputMaybe<AssistantSettings_Bool_Exp>;
};

export type Subscription_RootAttachmentsArgs = {
    distinct_on?: InputMaybe<Array<Attachments_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Attachments_Order_By>>;
    where?: InputMaybe<Attachments_Bool_Exp>;
};

export type Subscription_RootAttachments_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Attachments_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Attachments_Order_By>>;
    where?: InputMaybe<Attachments_Bool_Exp>;
};

export type Subscription_RootAttachments_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootAttachments_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<Attachments_Stream_Cursor_Input>>;
    where?: InputMaybe<Attachments_Bool_Exp>;
};

export type Subscription_RootContactSuggestionsArgs = {
    distinct_on?: InputMaybe<Array<ContactSuggestions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ContactSuggestions_Order_By>>;
    where?: InputMaybe<ContactSuggestions_Bool_Exp>;
};

export type Subscription_RootContactSuggestions_AggregateArgs = {
    distinct_on?: InputMaybe<Array<ContactSuggestions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ContactSuggestions_Order_By>>;
    where?: InputMaybe<ContactSuggestions_Bool_Exp>;
};

export type Subscription_RootContactSuggestions_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootContactSuggestions_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<ContactSuggestions_Stream_Cursor_Input>>;
    where?: InputMaybe<ContactSuggestions_Bool_Exp>;
};

export type Subscription_RootContactsArgs = {
    distinct_on?: InputMaybe<Array<Contacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Contacts_Order_By>>;
    where?: InputMaybe<Contacts_Bool_Exp>;
};

export type Subscription_RootContactsInteractionsArgs = {
    distinct_on?: InputMaybe<Array<ContactsInteractions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ContactsInteractions_Order_By>>;
    where?: InputMaybe<ContactsInteractions_Bool_Exp>;
};

export type Subscription_RootContactsInteractions_AggregateArgs = {
    distinct_on?: InputMaybe<Array<ContactsInteractions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ContactsInteractions_Order_By>>;
    where?: InputMaybe<ContactsInteractions_Bool_Exp>;
};

export type Subscription_RootContactsInteractions_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootContactsInteractions_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<ContactsInteractions_Stream_Cursor_Input>>;
    where?: InputMaybe<ContactsInteractions_Bool_Exp>;
};

export type Subscription_RootContacts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Contacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Contacts_Order_By>>;
    where?: InputMaybe<Contacts_Bool_Exp>;
};

export type Subscription_RootContacts_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootContacts_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<Contacts_Stream_Cursor_Input>>;
    where?: InputMaybe<Contacts_Bool_Exp>;
};

export type Subscription_RootConversationMetaDataArgs = {
    distinct_on?: InputMaybe<Array<ConversationMetaData_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ConversationMetaData_Order_By>>;
    where?: InputMaybe<ConversationMetaData_Bool_Exp>;
};

export type Subscription_RootConversationMetaData_AggregateArgs = {
    distinct_on?: InputMaybe<Array<ConversationMetaData_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ConversationMetaData_Order_By>>;
    where?: InputMaybe<ConversationMetaData_Bool_Exp>;
};

export type Subscription_RootConversationMetaData_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootConversationMetaData_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<ConversationMetaData_Stream_Cursor_Input>>;
    where?: InputMaybe<ConversationMetaData_Bool_Exp>;
};

export type Subscription_RootConversationsArgs = {
    distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Conversations_Order_By>>;
    where?: InputMaybe<Conversations_Bool_Exp>;
};

export type Subscription_RootConversations_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Conversations_Order_By>>;
    where?: InputMaybe<Conversations_Bool_Exp>;
};

export type Subscription_RootConversations_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootConversations_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<Conversations_Stream_Cursor_Input>>;
    where?: InputMaybe<Conversations_Bool_Exp>;
};

export type Subscription_RootGroupsArgs = {
    distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Groups_Order_By>>;
    where?: InputMaybe<Groups_Bool_Exp>;
};

export type Subscription_RootGroups_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Groups_Order_By>>;
    where?: InputMaybe<Groups_Bool_Exp>;
};

export type Subscription_RootGroups_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootGroups_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<Groups_Stream_Cursor_Input>>;
    where?: InputMaybe<Groups_Bool_Exp>;
};

export type Subscription_RootJobsArgs = {
    distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Jobs_Order_By>>;
    where?: InputMaybe<Jobs_Bool_Exp>;
};

export type Subscription_RootJobs_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Jobs_Order_By>>;
    where?: InputMaybe<Jobs_Bool_Exp>;
};

export type Subscription_RootJobs_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootJobs_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<Jobs_Stream_Cursor_Input>>;
    where?: InputMaybe<Jobs_Bool_Exp>;
};

export type Subscription_RootLinkedinConversationsArgs = {
    distinct_on?: InputMaybe<Array<LinkedinConversations_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<LinkedinConversations_Order_By>>;
    where?: InputMaybe<LinkedinConversations_Bool_Exp>;
};

export type Subscription_RootLinkedinConversations_AggregateArgs = {
    distinct_on?: InputMaybe<Array<LinkedinConversations_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<LinkedinConversations_Order_By>>;
    where?: InputMaybe<LinkedinConversations_Bool_Exp>;
};

export type Subscription_RootLinkedinConversations_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootLinkedinConversations_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<LinkedinConversations_Stream_Cursor_Input>>;
    where?: InputMaybe<LinkedinConversations_Bool_Exp>;
};

export type Subscription_RootMessageDraftsArgs = {
    distinct_on?: InputMaybe<Array<MessageDrafts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<MessageDrafts_Order_By>>;
    where?: InputMaybe<MessageDrafts_Bool_Exp>;
};

export type Subscription_RootMessageDrafts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<MessageDrafts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<MessageDrafts_Order_By>>;
    where?: InputMaybe<MessageDrafts_Bool_Exp>;
};

export type Subscription_RootMessageDrafts_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootMessageDrafts_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<MessageDrafts_Stream_Cursor_Input>>;
    where?: InputMaybe<MessageDrafts_Bool_Exp>;
};

export type Subscription_RootMessagesArgs = {
    distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Messages_Order_By>>;
    where?: InputMaybe<Messages_Bool_Exp>;
};

export type Subscription_RootMessages_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Messages_Order_By>>;
    where?: InputMaybe<Messages_Bool_Exp>;
};

export type Subscription_RootMessages_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootMessages_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<Messages_Stream_Cursor_Input>>;
    where?: InputMaybe<Messages_Bool_Exp>;
};

export type Subscription_RootNotesArgs = {
    distinct_on?: InputMaybe<Array<Notes_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Notes_Order_By>>;
    where?: InputMaybe<Notes_Bool_Exp>;
};

export type Subscription_RootNotes_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Notes_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Notes_Order_By>>;
    where?: InputMaybe<Notes_Bool_Exp>;
};

export type Subscription_RootNotes_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootNotes_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<Notes_Stream_Cursor_Input>>;
    where?: InputMaybe<Notes_Bool_Exp>;
};

export type Subscription_RootOutreachCompletionMetricsArgs = {
    distinct_on?: InputMaybe<Array<OutreachCompletionMetrics_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<OutreachCompletionMetrics_Order_By>>;
    where?: InputMaybe<OutreachCompletionMetrics_Bool_Exp>;
};

export type Subscription_RootOutreachCompletionMetrics_AggregateArgs = {
    distinct_on?: InputMaybe<Array<OutreachCompletionMetrics_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<OutreachCompletionMetrics_Order_By>>;
    where?: InputMaybe<OutreachCompletionMetrics_Bool_Exp>;
};

export type Subscription_RootOutreachCompletionMetrics_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootOutreachCompletionMetrics_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<OutreachCompletionMetrics_Stream_Cursor_Input>>;
    where?: InputMaybe<OutreachCompletionMetrics_Bool_Exp>;
};

export type Subscription_RootOutreachSuggestionsArgs = {
    distinct_on?: InputMaybe<Array<OutreachSuggestions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<OutreachSuggestions_Order_By>>;
    where?: InputMaybe<OutreachSuggestions_Bool_Exp>;
};

export type Subscription_RootOutreachSuggestions_AggregateArgs = {
    distinct_on?: InputMaybe<Array<OutreachSuggestions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<OutreachSuggestions_Order_By>>;
    where?: InputMaybe<OutreachSuggestions_Bool_Exp>;
};

export type Subscription_RootOutreachSuggestions_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootOutreachSuggestions_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<OutreachSuggestions_Stream_Cursor_Input>>;
    where?: InputMaybe<OutreachSuggestions_Bool_Exp>;
};

export type Subscription_RootResourceEmbeddingsArgs = {
    distinct_on?: InputMaybe<Array<ResourceEmbeddings_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ResourceEmbeddings_Order_By>>;
    where?: InputMaybe<ResourceEmbeddings_Bool_Exp>;
};

export type Subscription_RootResourceEmbeddings_AggregateArgs = {
    distinct_on?: InputMaybe<Array<ResourceEmbeddings_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<ResourceEmbeddings_Order_By>>;
    where?: InputMaybe<ResourceEmbeddings_Bool_Exp>;
};

export type Subscription_RootResourceEmbeddings_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootResourceEmbeddings_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<ResourceEmbeddings_Stream_Cursor_Input>>;
    where?: InputMaybe<ResourceEmbeddings_Bool_Exp>;
};

export type Subscription_RootResourcesArgs = {
    distinct_on?: InputMaybe<Array<Resources_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Resources_Order_By>>;
    where?: InputMaybe<Resources_Bool_Exp>;
};

export type Subscription_RootResources_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Resources_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Resources_Order_By>>;
    where?: InputMaybe<Resources_Bool_Exp>;
};

export type Subscription_RootResources_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootResources_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<Resources_Stream_Cursor_Input>>;
    where?: InputMaybe<Resources_Bool_Exp>;
};

export type Subscription_RootSampleContactsArgs = {
    distinct_on?: InputMaybe<Array<SampleContacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<SampleContacts_Order_By>>;
    where?: InputMaybe<SampleContacts_Bool_Exp>;
};

export type Subscription_RootSampleContacts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<SampleContacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<SampleContacts_Order_By>>;
    where?: InputMaybe<SampleContacts_Bool_Exp>;
};

export type Subscription_RootSampleContacts_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootSampleContacts_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<SampleContacts_Stream_Cursor_Input>>;
    where?: InputMaybe<SampleContacts_Bool_Exp>;
};

export type Subscription_RootUserAgentInstructionsArgs = {
    distinct_on?: InputMaybe<Array<UserAgentInstructions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<UserAgentInstructions_Order_By>>;
    where?: InputMaybe<UserAgentInstructions_Bool_Exp>;
};

export type Subscription_RootUserAgentInstructions_AggregateArgs = {
    distinct_on?: InputMaybe<Array<UserAgentInstructions_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<UserAgentInstructions_Order_By>>;
    where?: InputMaybe<UserAgentInstructions_Bool_Exp>;
};

export type Subscription_RootUserAgentInstructions_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootUserAgentInstructions_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<UserAgentInstructions_Stream_Cursor_Input>>;
    where?: InputMaybe<UserAgentInstructions_Bool_Exp>;
};

export type Subscription_RootUserContactsArgs = {
    distinct_on?: InputMaybe<Array<UserContacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<UserContacts_Order_By>>;
    where?: InputMaybe<UserContacts_Bool_Exp>;
};

export type Subscription_RootUserContacts_AggregateArgs = {
    distinct_on?: InputMaybe<Array<UserContacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<UserContacts_Order_By>>;
    where?: InputMaybe<UserContacts_Bool_Exp>;
};

export type Subscription_RootUserContacts_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootUserContacts_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<UserContacts_Stream_Cursor_Input>>;
    where?: InputMaybe<UserContacts_Bool_Exp>;
};

export type Subscription_Root_GroupToContactArgs = {
    distinct_on?: InputMaybe<Array<_GroupToContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToContact_Order_By>>;
    where?: InputMaybe<_GroupToContact_Bool_Exp>;
};

export type Subscription_Root_GroupToContact_AggregateArgs = {
    distinct_on?: InputMaybe<Array<_GroupToContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToContact_Order_By>>;
    where?: InputMaybe<_GroupToContact_Bool_Exp>;
};

export type Subscription_Root_GroupToContact_By_PkArgs = {
    A: Scalars['String']['input'];
    B: Scalars['String']['input'];
};

export type Subscription_Root_GroupToContact_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<_GroupToContact_Stream_Cursor_Input>>;
    where?: InputMaybe<_GroupToContact_Bool_Exp>;
};

export type Subscription_Root_GroupToUserContactArgs = {
    distinct_on?: InputMaybe<Array<_GroupToUserContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToUserContact_Order_By>>;
    where?: InputMaybe<_GroupToUserContact_Bool_Exp>;
};

export type Subscription_Root_GroupToUserContact_AggregateArgs = {
    distinct_on?: InputMaybe<Array<_GroupToUserContact_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<_GroupToUserContact_Order_By>>;
    where?: InputMaybe<_GroupToUserContact_Bool_Exp>;
};

export type Subscription_Root_GroupToUserContact_By_PkArgs = {
    A: Scalars['String']['input'];
    B: Scalars['String']['input'];
};

export type Subscription_Root_GroupToUserContact_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<_GroupToUserContact_Stream_Cursor_Input>>;
    where?: InputMaybe<_GroupToUserContact_Bool_Exp>;
};

export type Subscription_RootContacts_Weighted_ScoresArgs = {
    args?: InputMaybe<Contacts_Weighted_Scores_Args>;
    distinct_on?: InputMaybe<Array<Contacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Contacts_Order_By>>;
    where?: InputMaybe<Contacts_Bool_Exp>;
};

export type Subscription_RootContacts_Weighted_Scores_AggregateArgs = {
    args?: InputMaybe<Contacts_Weighted_Scores_Args>;
    distinct_on?: InputMaybe<Array<Contacts_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Contacts_Order_By>>;
    where?: InputMaybe<Contacts_Bool_Exp>;
};

export type Subscription_RootMastra_Mastra_MessagesArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Messages_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Messages_Bool_Exp>;
};

export type Subscription_RootMastra_Mastra_Messages_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Messages_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Messages_Bool_Exp>;
};

export type Subscription_RootMastra_Mastra_Messages_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootMastra_Mastra_Messages_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<Mastra_Mastra_Messages_Stream_Cursor_Input>>;
    where?: InputMaybe<Mastra_Mastra_Messages_Bool_Exp>;
};

export type Subscription_RootMastra_Mastra_ResourcesArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Resources_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Resources_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Resources_Bool_Exp>;
};

export type Subscription_RootMastra_Mastra_Resources_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Resources_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Resources_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Resources_Bool_Exp>;
};

export type Subscription_RootMastra_Mastra_Resources_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootMastra_Mastra_Resources_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<Mastra_Mastra_Resources_Stream_Cursor_Input>>;
    where?: InputMaybe<Mastra_Mastra_Resources_Bool_Exp>;
};

export type Subscription_RootMastra_Mastra_ThreadsArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Threads_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Threads_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Threads_Bool_Exp>;
};

export type Subscription_RootMastra_Mastra_Threads_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Threads_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Threads_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Threads_Bool_Exp>;
};

export type Subscription_RootMastra_Mastra_Threads_By_PkArgs = {
    id: Scalars['String']['input'];
};

export type Subscription_RootMastra_Mastra_Threads_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<Mastra_Mastra_Threads_Stream_Cursor_Input>>;
    where?: InputMaybe<Mastra_Mastra_Threads_Bool_Exp>;
};

export type Subscription_RootMastra_Mastra_Workflow_SnapshotArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Workflow_Snapshot_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Workflow_Snapshot_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Workflow_Snapshot_Bool_Exp>;
};

export type Subscription_RootMastra_Mastra_Workflow_Snapshot_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Mastra_Workflow_Snapshot_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Mastra_Workflow_Snapshot_Order_By>>;
    where?: InputMaybe<Mastra_Mastra_Workflow_Snapshot_Bool_Exp>;
};

export type Subscription_RootMastra_Mastra_Workflow_Snapshot_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<Mastra_Mastra_Workflow_Snapshot_Stream_Cursor_Input>>;
    where?: InputMaybe<Mastra_Mastra_Workflow_Snapshot_Bool_Exp>;
};

export type Subscription_RootMastra_Memory_MessagesArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Memory_Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Memory_Messages_Order_By>>;
    where?: InputMaybe<Mastra_Memory_Messages_Bool_Exp>;
};

export type Subscription_RootMastra_Memory_Messages_AggregateArgs = {
    distinct_on?: InputMaybe<Array<Mastra_Memory_Messages_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Mastra_Memory_Messages_Order_By>>;
    where?: InputMaybe<Mastra_Memory_Messages_Bool_Exp>;
};

export type Subscription_RootMastra_Memory_Messages_By_PkArgs = {
    id: Scalars['Int']['input'];
};

export type Subscription_RootMastra_Memory_Messages_StreamArgs = {
    batch_size: Scalars['Int']['input'];
    cursor: Array<InputMaybe<Mastra_Memory_Messages_Stream_Cursor_Input>>;
    where?: InputMaybe<Mastra_Memory_Messages_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['timestamp']['input']>;
    _gt?: InputMaybe<Scalars['timestamp']['input']>;
    _gte?: InputMaybe<Scalars['timestamp']['input']>;
    _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['timestamp']['input']>;
    _lte?: InputMaybe<Scalars['timestamp']['input']>;
    _neq?: InputMaybe<Scalars['timestamp']['input']>;
    _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "vector". All fields are combined with logical 'AND'. */
export type Vector_Comparison_Exp = {
    _eq?: InputMaybe<Scalars['vector']['input']>;
    _gt?: InputMaybe<Scalars['vector']['input']>;
    _gte?: InputMaybe<Scalars['vector']['input']>;
    _in?: InputMaybe<Array<Scalars['vector']['input']>>;
    _is_null?: InputMaybe<Scalars['Boolean']['input']>;
    _lt?: InputMaybe<Scalars['vector']['input']>;
    _lte?: InputMaybe<Scalars['vector']['input']>;
    _neq?: InputMaybe<Scalars['vector']['input']>;
    _nin?: InputMaybe<Array<Scalars['vector']['input']>>;
};

export type MarkActionAsNotInterestedMutationVariables = Exact<{
    contactId: Scalars['String']['input'];
}>;

export type MarkActionAsNotInterestedMutation = {
    __typename?: 'mutation_root';
    update_Contacts_by_pk?: { __typename?: 'Contacts'; id: string } | null;
};

export type UndoMarkActionAsNotInterestedMutationVariables = Exact<{
    contactId: Scalars['String']['input'];
}>;

export type UndoMarkActionAsNotInterestedMutation = {
    __typename?: 'mutation_root';
    update_Contacts_by_pk?: { __typename?: 'Contacts'; id: string } | null;
};

export type MarkActionAsCompletedMutationVariables = Exact<{
    contactId: Scalars['String']['input'];
}>;

export type MarkActionAsCompletedMutation = {
    __typename?: 'mutation_root';
    update_Contacts_by_pk?: { __typename?: 'Contacts'; id: string } | null;
};

export type UpdateSampleContactConversationMutationVariables = Exact<{
    id: Scalars['String']['input'];
    conversation: Scalars['jsonb']['input'];
}>;

export type UpdateSampleContactConversationMutation = {
    __typename?: 'mutation_root';
    update_SampleContacts_by_pk?: {
        __typename?: 'SampleContacts';
        id: string;
        conversation?: any | null;
        updatedAt: any;
    } | null;
};

export type CreateSampleContactMutationVariables = Exact<{
    contact: Scalars['jsonb']['input'];
    conversation?: InputMaybe<Scalars['jsonb']['input']>;
}>;

export type CreateSampleContactMutation = {
    __typename?: 'mutation_root';
    insert_SampleContacts_one?: {
        __typename?: 'SampleContacts';
        id: string;
        contact: any;
        conversation?: any | null;
        createdAt: any;
        updatedAt: any;
    } | null;
};

export type DeleteSampleContactMutationVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type DeleteSampleContactMutation = {
    __typename?: 'mutation_root';
    delete_SampleContacts_by_pk?: { __typename?: 'SampleContacts'; id: string } | null;
};

export type SnoozeActionMutationVariables = Exact<{
    contactId: Scalars['String']['input'];
    snoozedUntil: Scalars['timestamp']['input'];
}>;

export type SnoozeActionMutation = {
    __typename?: 'mutation_root';
    update_Contacts_by_pk?: { __typename?: 'Contacts'; id: string } | null;
};

export type SnoozeActionByProspectIdMutationVariables = Exact<{
    prospectId: Scalars['String']['input'];
    snoozedUntil: Scalars['timestamp']['input'];
}>;

export type SnoozeActionByProspectIdMutation = {
    __typename?: 'mutation_root';
    update_Contacts?: { __typename?: 'Contacts_mutation_response'; affected_rows: number } | null;
};

export type InsertMessageDraftMutationVariables = Exact<{
    userId: Scalars['String']['input'];
    organizationId: Scalars['String']['input'];
    contactId: Scalars['String']['input'];
    prospectId?: InputMaybe<Scalars['String']['input']>;
    source: Scalars['String']['input'];
    content: Scalars['String']['input'];
    subjectLine: Scalars['String']['input'];
    channelType: Scalars['ChannelType']['input'];
    userPrompt: Scalars['String']['input'];
}>;

export type InsertMessageDraftMutation = {
    __typename?: 'mutation_root';
    insert_MessageDrafts_one?: {
        __typename?: 'MessageDrafts';
        id: string;
        content: string;
        subjectLine: string;
    } | null;
};

export type UpdateMessageDraftMutationVariables = Exact<{
    id: Scalars['String']['input'];
    content: Scalars['String']['input'];
    subjectLine: Scalars['String']['input'];
    channelType: Scalars['ChannelType']['input'];
    userPrompt: Scalars['String']['input'];
}>;

export type UpdateMessageDraftMutation = {
    __typename?: 'mutation_root';
    update_MessageDrafts_by_pk?: {
        __typename?: 'MessageDrafts';
        id: string;
        content: string;
        subjectLine: string;
    } | null;
};

export type ArchiveMessageDraftsMutationVariables = Exact<{
    userId: Scalars['String']['input'];
    contactId: Scalars['String']['input'];
}>;

export type ArchiveMessageDraftsMutation = {
    __typename?: 'mutation_root';
    update_MessageDrafts?: {
        __typename?: 'MessageDrafts_mutation_response';
        affected_rows: number;
        returning: Array<{
            __typename?: 'MessageDrafts';
            id: string;
            source: string;
            content: string;
            subjectLine: string;
            archivedAt?: any | null;
        }>;
    } | null;
};

export type CreateContactsInteractionsMutationVariables = Exact<{
    userId: Scalars['String']['input'];
    organizationId: Scalars['String']['input'];
    contactId: Scalars['String']['input'];
    contactMetadata: Scalars['jsonb']['input'];
    weights: Scalars['jsonb']['input'];
    interactionType: Scalars['ContactInteractionType']['input'];
}>;

export type CreateContactsInteractionsMutation = {
    __typename?: 'mutation_root';
    insert_ContactsInteractions_one?: { __typename?: 'ContactsInteractions'; id: string } | null;
};

export type CreateSearchResultInteractionsMutationVariables = Exact<{
    userId: Scalars['String']['input'];
    organizationId: Scalars['String']['input'];
    metadata: Scalars['jsonb']['input'];
    weights: Scalars['jsonb']['input'];
    interactionType: Scalars['ContactInteractionType']['input'];
}>;

export type CreateSearchResultInteractionsMutation = {
    __typename?: 'mutation_root';
    insert_ContactsInteractions_one?: { __typename?: 'ContactsInteractions'; id: string } | null;
};

export type UpdateContactTypeMutationVariables = Exact<{
    contactId: Scalars['String']['input'];
    contactType: Scalars['String']['input'];
}>;

export type UpdateContactTypeMutation = {
    __typename?: 'mutation_root';
    update_Contacts_by_pk?: {
        __typename?: 'Contacts';
        id: string;
        metadata?: any | null;
        contactType?: any | null;
    } | null;
};

export type GetMessagesByProspectIdQueryVariables = Exact<{ [key: string]: never }>;

export type GetMessagesByProspectIdQuery = {
    __typename?: 'query_root';
    Messages: Array<{
        __typename?: 'Messages';
        prospectId?: string | null;
        sentOn?: any | null;
        fullName?: string | null;
        content?: string | null;
        id: string;
        actionType?: any | null;
        linkedinUserId?: string | null;
        prospectFullName?: string | null;
        deliveryStatus?: any | null;
        Attachments: Array<{ __typename?: 'Attachments'; type: any; value: string }>;
        OutreachSuggestion?: { __typename?: 'OutreachSuggestions'; id: string } | null;
    }>;
};

export type GetActionsByProspectIdsQueryVariables = Exact<{
    limit?: InputMaybe<Scalars['Int']['input']>;
    scheduledOnLt?: InputMaybe<Scalars['timestamp']['input']>;
    prospectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type GetActionsByProspectIdsQuery = {
    __typename?: 'query_root';
    OutreachSuggestions: Array<{
        __typename?: 'OutreachSuggestions';
        id: string;
        createdAt: any;
        prospectId?: string | null;
        accountName: string;
        name: string;
        unread: boolean;
        isGenerating: boolean;
        goal?: string | null;
        conversationPaths?: Array<string> | null;
        Message: { __typename?: 'Messages'; content?: string | null; subjectLine?: string | null };
        ConversationMetaData?: {
            __typename?: 'ConversationMetaData';
            id: string;
            numberOfMessages: number;
            isNextMessageFollowUp: boolean;
            messagesPerDay: any;
            lastNetworkUpdateAt: any;
            youThemMessageRatio: any;
            lastUserNoteAt: any;
            hasMessagesSentFromApp: boolean;
            medianMessageLength: any;
            connectionStatus: string;
            lastTimeToAnswer: any;
            userContactAddedAt: any;
            lastMessageAt: any;
            numberOfMessagesLastDay: number;
            numberOfMessagesLastWeek: number;
            userContactFromOnboarding: boolean;
            createdAt: any;
            updatedAt: any;
            topics: string;
        } | null;
    }>;
};

export type GetActionsQueryVariables = Exact<{
    limit?: InputMaybe<Scalars['Int']['input']>;
    scheduledOnLt?: InputMaybe<Scalars['timestamp']['input']>;
}>;

export type GetActionsQuery = {
    __typename?: 'query_root';
    OutreachSuggestions: Array<{
        __typename?: 'OutreachSuggestions';
        id: string;
        createdAt: any;
        prospectId?: string | null;
        accountName: string;
        name: string;
        unread: boolean;
        isGenerating: boolean;
        goal?: string | null;
        conversationPaths?: Array<string> | null;
        Message: { __typename?: 'Messages'; content?: string | null; subjectLine?: string | null };
        ConversationMetaData?: {
            __typename?: 'ConversationMetaData';
            id: string;
            numberOfMessages: number;
            isNextMessageFollowUp: boolean;
            messagesPerDay: any;
            lastNetworkUpdateAt: any;
            youThemMessageRatio: any;
            lastUserNoteAt: any;
            hasMessagesSentFromApp: boolean;
            medianMessageLength: any;
            connectionStatus: string;
            lastTimeToAnswer: any;
            userContactAddedAt: any;
            lastMessageAt: any;
            numberOfMessagesLastDay: number;
            numberOfMessagesLastWeek: number;
            userContactFromOnboarding: boolean;
            createdAt: any;
            updatedAt: any;
            topics: string;
        } | null;
    }>;
};

export type GetCompletedActionsQueryVariables = Exact<{
    limit?: InputMaybe<Scalars['Int']['input']>;
    scheduledOnLt?: InputMaybe<Scalars['timestamp']['input']>;
    completedOnGte?: InputMaybe<Scalars['timestamp']['input']>;
}>;

export type GetCompletedActionsQuery = {
    __typename?: 'query_root';
    OutreachSuggestions: Array<{
        __typename?: 'OutreachSuggestions';
        id: string;
        createdAt: any;
        prospectId?: string | null;
        accountName: string;
        name: string;
        goal?: string | null;
        Message: {
            __typename?: 'Messages';
            content?: string | null;
            subjectLine?: string | null;
            actionType?: any | null;
        };
        ConversationMetaData?: { __typename?: 'ConversationMetaData'; topics: string } | null;
    }>;
};

export type GetOutreachSuggestionPathsByProspectIdQueryVariables = Exact<{
    prospectId: Scalars['String']['input'];
    scheduledOnLt?: InputMaybe<Scalars['timestamp']['input']>;
}>;

export type GetOutreachSuggestionPathsByProspectIdQuery = {
    __typename?: 'query_root';
    OutreachSuggestions: Array<{ __typename?: 'OutreachSuggestions'; conversationPaths?: Array<string> | null }>;
};

export type GetOutreachSuggestionsQueryVariables = Exact<{
    limit?: InputMaybe<Scalars['Int']['input']>;
    notYetSent?: Scalars['Boolean']['input'];
    scheduledOnLt: Scalars['timestamp']['input'];
    sentOnGte: Scalars['timestamp']['input'];
}>;

export type GetOutreachSuggestionsQuery = {
    __typename?: 'query_root';
    focus: Array<{
        __typename?: 'OutreachSuggestions';
        accountName: string;
        accountWebsite?: string | null;
        email?: string | null;
        linkedinUrl?: string | null;
        numberOfEmployees?: string | null;
        title: string;
        name: string;
        industry?: string | null;
        contactLocation?: string | null;
        id: string;
        updatedAt: any;
        createdAt: any;
        prospectId?: string | null;
        unread: boolean;
        Message: {
            __typename?: 'Messages';
            id: string;
            subjectLine?: string | null;
            content?: string | null;
            actionType?: any | null;
            channelType?: any | null;
        };
        ConversationMetaData?: {
            __typename?: 'ConversationMetaData';
            id: string;
            numberOfMessages: number;
            isNextMessageFollowUp: boolean;
            messagesPerDay: any;
            lastNetworkUpdateAt: any;
            youThemMessageRatio: any;
            lastUserNoteAt: any;
            hasMessagesSentFromApp: boolean;
            medianMessageLength: any;
            connectionStatus: string;
            lastTimeToAnswer: any;
            userContactAddedAt: any;
            userContactFromOnboarding: boolean;
            lastMessageAt: any;
            numberOfMessagesLastDay: number;
            numberOfMessagesLastWeek: number;
            createdAt: any;
            updatedAt: any;
        } | null;
    }>;
    completed: Array<{
        __typename?: 'OutreachSuggestions';
        accountName: string;
        accountWebsite?: string | null;
        email?: string | null;
        linkedinUrl?: string | null;
        numberOfEmployees?: string | null;
        title: string;
        name: string;
        industry?: string | null;
        contactLocation?: string | null;
        id: string;
        updatedAt: any;
        createdAt: any;
        prospectId?: string | null;
        unread: boolean;
        Message: {
            __typename?: 'Messages';
            id: string;
            subjectLine?: string | null;
            content?: string | null;
            actionType?: any | null;
            channelType?: any | null;
        };
        ConversationMetaData?: {
            __typename?: 'ConversationMetaData';
            id: string;
            numberOfMessages: number;
            isNextMessageFollowUp: boolean;
            messagesPerDay: any;
            lastNetworkUpdateAt: any;
            youThemMessageRatio: any;
            lastUserNoteAt: any;
            hasMessagesSentFromApp: boolean;
            medianMessageLength: any;
            connectionStatus: string;
            lastTimeToAnswer: any;
            userContactAddedAt: any;
            createdAt: any;
            updatedAt: any;
        } | null;
    }>;
    focusCount: {
        __typename?: 'OutreachSuggestions_aggregate';
        aggregate?: { __typename?: 'OutreachSuggestions_aggregate_fields'; count: number } | null;
    };
    completedCount: {
        __typename?: 'OutreachSuggestions_aggregate';
        aggregate?: { __typename?: 'OutreachSuggestions_aggregate_fields'; count: number } | null;
    };
};

export type GetOutreachSuggestionsByProspectIdQueryVariables = Exact<{
    prospectId: Scalars['String']['input'];
    scheduledOnBefore: Scalars['timestamp']['input'];
}>;

export type GetOutreachSuggestionsByProspectIdQuery = {
    __typename?: 'query_root';
    focus: Array<{
        __typename?: 'OutreachSuggestions';
        id: string;
        updatedAt: any;
        createdAt: any;
        Message: {
            __typename?: 'Messages';
            id: string;
            subjectLine?: string | null;
            content?: string | null;
            actionType?: any | null;
            channelType?: any | null;
        };
    }>;
    completed: Array<{ __typename?: 'OutreachSuggestions'; id: string }>;
    future: Array<{
        __typename?: 'OutreachSuggestions';
        id: string;
        scheduledOn?: any | null;
        scheduledOnMotivation?: string | null;
    }>;
    unscheduled: Array<{ __typename?: 'OutreachSuggestions'; id: string }>;
};

export type GetActiveOutreachSuggestionByProspectIdsQueryVariables = Exact<{
    prospectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type GetActiveOutreachSuggestionByProspectIdsQuery = {
    __typename?: 'query_root';
    OutreachSuggestions: Array<{ __typename?: 'OutreachSuggestions'; id: string; prospectId?: string | null }>;
};

export type GetContactSuggestionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetContactSuggestionsQuery = {
    __typename?: 'query_root';
    ContactSuggestions: Array<{
        __typename?: 'ContactSuggestions';
        id: string;
        contactName: string;
        reason: any;
        personId?: string | null;
        organizationId: string;
        contactEmailVerified: boolean;
        contactLinkedinUrl?: string | null;
        contactEmail?: string | null;
        contactTitle?: string | null;
        contactLocation?: string | null;
        campaignId?: string | null;
        campaignName?: string | null;
        accountIndustry?: string | null;
        accountWebsite?: string | null;
        accountTags?: Array<string> | null;
        accountName: string;
        accountId?: string | null;
        accountAboutUs?: string | null;
        accountNumberOfEmployees?: string | null;
        userId: string;
        groupId?: string | null;
        prospectId?: string | null;
        suggestionMotivation?: string | null;
        contactImgUrl?: string | null;
    }>;
};

export type GetContactSuggestionByIdQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetContactSuggestionByIdQuery = {
    __typename?: 'query_root';
    ContactSuggestions: Array<{
        __typename?: 'ContactSuggestions';
        id: string;
        contactName: string;
        reason: any;
        personId?: string | null;
        organizationId: string;
        contactEmailVerified: boolean;
        contactLinkedinUrl?: string | null;
        contactEmail?: string | null;
        contactTitle?: string | null;
        contactLocation?: string | null;
        campaignId?: string | null;
        campaignName?: string | null;
        accountIndustry?: string | null;
        accountWebsite?: string | null;
        accountTags?: Array<string> | null;
        accountName: string;
        accountId?: string | null;
        accountAboutUs?: string | null;
        accountNumberOfEmployees?: string | null;
        userId: string;
        groupId?: string | null;
        prospectId?: string | null;
        suggestionMotivation?: string | null;
        contactImgUrl?: string | null;
    }>;
};

export type GetContactSuggestionsByGroupIdQueryVariables = Exact<{
    groupId: Scalars['String']['input'];
}>;

export type GetContactSuggestionsByGroupIdQuery = {
    __typename?: 'query_root';
    ContactSuggestions: Array<{
        __typename?: 'ContactSuggestions';
        id: string;
        contactName: string;
        reason: any;
        personId?: string | null;
        organizationId: string;
        contactEmailVerified: boolean;
        contactLinkedinUrl?: string | null;
        contactEmail?: string | null;
        contactTitle?: string | null;
        contactLocation?: string | null;
        campaignId?: string | null;
        campaignName?: string | null;
        accountIndustry?: string | null;
        accountWebsite?: string | null;
        accountTags?: Array<string> | null;
        accountName: string;
        accountId?: string | null;
        accountAboutUs?: string | null;
        accountNumberOfEmployees?: string | null;
        userId: string;
        groupId?: string | null;
        prospectId?: string | null;
        suggestionMotivation?: string | null;
        contactImgUrl?: string | null;
    }>;
};

export type GetContactSuggestionsCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetContactSuggestionsCountQuery = {
    __typename?: 'query_root';
    ContactSuggestions_aggregate: {
        __typename?: 'ContactSuggestions_aggregate';
        aggregate?: { __typename?: 'ContactSuggestions_aggregate_fields'; count: number } | null;
    };
};

export type GetOutreachSuggestionByIdQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetOutreachSuggestionByIdQuery = {
    __typename?: 'query_root';
    OutreachSuggestions_by_pk?: {
        __typename?: 'OutreachSuggestions';
        id: string;
        email?: string | null;
        name: string;
        accountName: string;
        unread: boolean;
        industry?: string | null;
        contactLocation?: string | null;
        prospectId?: string | null;
        linkedinUrl?: string | null;
        Message: {
            __typename?: 'Messages';
            id: string;
            direction: string;
            conversationId?: string | null;
            prospectId?: string | null;
            channelType?: any | null;
            actionType?: any | null;
            contentType?: string | null;
            subjectLine?: string | null;
            content?: string | null;
            sentOn?: any | null;
            fullName?: string | null;
            approvedAt?: any | null;
            linkedinUserId?: string | null;
            prospectFullName?: string | null;
        };
    } | null;
};

export type GetProspectMessagesHistoryQueryVariables = Exact<{
    prospectId: Scalars['String']['input'];
}>;

export type GetProspectMessagesHistoryQuery = {
    __typename?: 'query_root';
    Messages: Array<{
        __typename?: 'Messages';
        id: string;
        direction: string;
        conversationId?: string | null;
        prospectId?: string | null;
        channelType?: any | null;
        actionType?: any | null;
        contentType?: string | null;
        subjectLine?: string | null;
        content?: string | null;
        sentOn?: any | null;
        fullName?: string | null;
        linkedinUserId?: string | null;
        externalMessageId?: string | null;
        prospectFullName?: string | null;
        deliveryStatus?: any | null;
        Attachments: Array<{ __typename?: 'Attachments'; type: any; value: string }>;
    }>;
};

export type GetProspectNotesQueryVariables = Exact<{
    prospectId: Scalars['String']['input'];
}>;

export type GetProspectNotesQuery = {
    __typename?: 'query_root';
    Notes: Array<{
        __typename?: 'Notes';
        id: string;
        content: string;
        prospectId: string;
        title: string;
        userId: string;
        createdAt: any;
        updatedAt: any;
        creator: any;
        happenedOn: any;
    }>;
};

export type GetNoteByIdQueryVariables = Exact<{
    noteId: Scalars['String']['input'];
}>;

export type GetNoteByIdQuery = {
    __typename?: 'query_root';
    Notes: Array<{
        __typename?: 'Notes';
        id: string;
        content: string;
        prospectId: string;
        title: string;
        userId: string;
        createdAt: any;
        updatedAt: any;
        creator: any;
    }>;
};

export type GetAllProspectSubjectLinesQueryVariables = Exact<{
    prospectId: Scalars['String']['input'];
}>;

export type GetAllProspectSubjectLinesQuery = {
    __typename?: 'query_root';
    Messages: Array<{ __typename?: 'Messages'; id: string; subjectLine?: string | null }>;
};

export type GetLastProspectMessageQueryVariables = Exact<{
    prospectId: Scalars['String']['input'];
}>;

export type GetLastProspectMessageQuery = {
    __typename?: 'query_root';
    Messages: Array<{
        __typename?: 'Messages';
        id: string;
        direction: string;
        conversationId?: string | null;
        prospectId?: string | null;
        channelType?: any | null;
        actionType?: any | null;
        contentType?: string | null;
        subjectLine?: string | null;
        content?: string | null;
        sentOn?: any | null;
        fullName?: string | null;
        linkedinUserId?: string | null;
        externalMessageId?: string | null;
        prospectFullName?: string | null;
        deliveryStatus?: any | null;
    }>;
};

export type GetMessagesSentFromAppQueryVariables = Exact<{ [key: string]: never }>;

export type GetMessagesSentFromAppQuery = {
    __typename?: 'query_root';
    Messages_aggregate: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
    };
};

export type GetAssistantSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAssistantSettingsQuery = {
    __typename?: 'query_root';
    AssistantSettings: Array<{
        __typename?: 'AssistantSettings';
        id: string;
        userId: string;
        organizationId: string;
        purpose: string;
        language: string;
        languages?: Array<string> | null;
        tone: string;
        context?: string | null;
        createdAt: any;
        updatedAt: any;
    }>;
};

export type GroupsQueryVariables = Exact<{ [key: string]: never }>;

export type GroupsQuery = {
    __typename?: 'query_root';
    Groups: Array<{
        __typename?: 'Groups';
        id: string;
        userId: string;
        default: boolean;
        name: string;
        assistantSettingsId: string;
        imgSrc?: string | null;
        createdAt: any;
        updatedAt: any;
    }>;
};

export type GetUserContactsByGroupIdsQueryVariables = Exact<{
    groupIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
    orderBy?: InputMaybe<Array<UserContacts_Order_By> | UserContacts_Order_By>;
}>;

export type GetUserContactsByGroupIdsQuery = {
    __typename?: 'query_root';
    UserContacts: Array<{
        __typename?: 'UserContacts';
        id: string;
        prospectId: string;
        status: any;
        createdAt: any;
        _GroupToUserContacts: Array<{
            __typename?: '_GroupToUserContact';
            Group: { __typename?: 'Groups'; id: string; name: string; imgSrc?: string | null };
        }>;
    }>;
    totalCount: {
        __typename?: 'UserContacts_aggregate';
        aggregate?: { __typename?: 'UserContacts_aggregate_fields'; count: number } | null;
    };
};

export type GetUserContactsProspectIdsByGroupIdsQueryVariables = Exact<{
    groupIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
    orderBy?: InputMaybe<Array<UserContacts_Order_By> | UserContacts_Order_By>;
}>;

export type GetUserContactsProspectIdsByGroupIdsQuery = {
    __typename?: 'query_root';
    UserContacts: Array<{ __typename?: 'UserContacts'; prospectId: string }>;
};

export type GetUserContactByProspectIdQueryVariables = Exact<{
    prospectId: Scalars['String']['input'];
}>;

export type GetUserContactByProspectIdQuery = {
    __typename?: 'query_root';
    UserContacts: Array<{
        __typename?: 'UserContacts';
        id: string;
        userId: string;
        prospectId: string;
        createdAt: any;
        updatedAt: any;
        status: any;
        _GroupToUserContacts: Array<{
            __typename?: '_GroupToUserContact';
            Group: {
                __typename?: 'Groups';
                id: string;
                userId: string;
                name: string;
                default: boolean;
                assistantSettingsId: string;
                imgSrc?: string | null;
                createdAt: any;
                updatedAt: any;
            };
        }>;
    }>;
};

export type GetUserContactIdsByProspectIdsQueryVariables = Exact<{
    prospectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type GetUserContactIdsByProspectIdsQuery = {
    __typename?: 'query_root';
    UserContacts: Array<{ __typename?: 'UserContacts'; id: string; prospectId: string }>;
};

export type GetTotalNumberOfUserContactsQueryVariables = Exact<{ [key: string]: never }>;

export type GetTotalNumberOfUserContactsQuery = {
    __typename?: 'query_root';
    UserContacts_aggregate: {
        __typename?: 'UserContacts_aggregate';
        aggregate?: { __typename?: 'UserContacts_aggregate_fields'; count: number } | null;
    };
};

export type GetTotalNumberOfUserContactsInAnyPlaybookQueryVariables = Exact<{ [key: string]: never }>;

export type GetTotalNumberOfUserContactsInAnyPlaybookQuery = {
    __typename?: 'query_root';
    UserContacts_aggregate: {
        __typename?: 'UserContacts_aggregate';
        aggregate?: { __typename?: 'UserContacts_aggregate_fields'; count: number } | null;
    };
};

export type GetUserContactByIdQueryVariables = Exact<{
    userContactId: Scalars['String']['input'];
}>;

export type GetUserContactByIdQuery = {
    __typename?: 'query_root';
    UserContacts: Array<{
        __typename?: 'UserContacts';
        id: string;
        userId: string;
        prospectId: string;
        createdAt: any;
        updatedAt: any;
        status: any;
        _GroupToUserContacts: Array<{
            __typename?: '_GroupToUserContact';
            Group: {
                __typename?: 'Groups';
                id: string;
                userId: string;
                name: string;
                default: boolean;
                assistantSettingsId: string;
                imgSrc?: string | null;
                createdAt: any;
                updatedAt: any;
            };
        }>;
    }>;
};

export type GetUserContactsByIdsQueryVariables = Exact<{
    ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type GetUserContactsByIdsQuery = {
    __typename?: 'query_root';
    UserContacts: Array<{
        __typename?: 'UserContacts';
        id: string;
        userId: string;
        prospectId: string;
        createdAt: any;
        updatedAt: any;
        status: any;
        _GroupToUserContacts: Array<{
            __typename?: '_GroupToUserContact';
            Group: {
                __typename?: 'Groups';
                id: string;
                userId: string;
                name: string;
                default: boolean;
                assistantSettingsId: string;
                imgSrc?: string | null;
                createdAt: any;
                updatedAt: any;
            };
        }>;
    }>;
};

export type GetAllUserContactsInAnyPlaybookQueryVariables = Exact<{
    orderBy?: InputMaybe<Array<UserContacts_Order_By> | UserContacts_Order_By>;
}>;

export type GetAllUserContactsInAnyPlaybookQuery = {
    __typename?: 'query_root';
    UserContacts: Array<{
        __typename?: 'UserContacts';
        id: string;
        prospectId: string;
        status: any;
        createdAt: any;
        _GroupToUserContacts: Array<{
            __typename?: '_GroupToUserContact';
            Group: { __typename?: 'Groups'; id: string; name: string; imgSrc?: string | null };
        }>;
    }>;
    totalCount: {
        __typename?: 'UserContacts_aggregate';
        aggregate?: { __typename?: 'UserContacts_aggregate_fields'; count: number } | null;
    };
};

export type GetAllUserContactsQueryVariables = Exact<{
    orderBy?: InputMaybe<Array<UserContacts_Order_By> | UserContacts_Order_By>;
}>;

export type GetAllUserContactsQuery = {
    __typename?: 'query_root';
    UserContacts: Array<{
        __typename?: 'UserContacts';
        id: string;
        prospectId: string;
        status: any;
        createdAt: any;
        _GroupToUserContacts: Array<{
            __typename?: '_GroupToUserContact';
            Group: { __typename?: 'Groups'; id: string; name: string; imgSrc?: string | null };
        }>;
    }>;
    totalCount: {
        __typename?: 'UserContacts_aggregate';
        aggregate?: { __typename?: 'UserContacts_aggregate_fields'; count: number } | null;
    };
};

export type GetActionsCountQueryVariables = Exact<{
    notYetSent?: Scalars['Boolean']['input'];
    scheduledOnLt: Scalars['timestamp']['input'];
}>;

export type GetActionsCountQuery = {
    __typename?: 'query_root';
    OutreachSuggestions_aggregate: {
        __typename?: 'OutreachSuggestions_aggregate';
        aggregate?: { __typename?: 'OutreachSuggestions_aggregate_fields'; count: number } | null;
    };
};

export type GetPlaybooksQueryVariables = Exact<{
    name?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetPlaybooksQuery = {
    __typename?: 'query_root';
    Groups: Array<{
        __typename?: 'Groups';
        id: string;
        userId: string;
        default: boolean;
        name: string;
        assistantSettingsId: string;
        imgSrc?: string | null;
        createdAt: any;
        updatedAt: any;
        AssistantSetting: {
            __typename?: 'AssistantSettings';
            id: string;
            userId: string;
            organizationId: string;
            purpose: string;
            language: string;
            languages?: Array<string> | null;
            tone: string;
            targetGroup?: string | null;
            context?: string | null;
            createdAt: any;
            updatedAt: any;
            defaultChannel: any;
        };
    }>;
};

export type GetPlaybookByGroupIdQueryVariables = Exact<{
    groupId: Scalars['String']['input'];
}>;

export type GetPlaybookByGroupIdQuery = {
    __typename?: 'query_root';
    Groups: Array<{
        __typename?: 'Groups';
        id: string;
        userId: string;
        default: boolean;
        name: string;
        assistantSettingsId: string;
        imgSrc?: string | null;
        createdAt: any;
        updatedAt: any;
        AssistantSetting: {
            __typename?: 'AssistantSettings';
            id: string;
            userId: string;
            organizationId: string;
            purpose: string;
            language: string;
            languages?: Array<string> | null;
            tone: string;
            context?: string | null;
            targetGroup?: string | null;
            createdAt: any;
            updatedAt: any;
            defaultChannel: any;
        };
        _GroupToUserContacts: Array<{
            __typename?: '_GroupToUserContact';
            UserContact: { __typename?: 'UserContacts'; id: string };
        }>;
    }>;
};

export type GetOutreachCompletionMetricsQueryVariables = Exact<{
    startDate: Scalars['timestamp']['input'];
    endDate: Scalars['timestamp']['input'];
    organizationId: Scalars['String']['input'];
}>;

export type GetOutreachCompletionMetricsQuery = {
    __typename?: 'query_root';
    OutreachCompletionMetrics: Array<{
        __typename?: 'OutreachCompletionMetrics';
        date: any;
        trailingTotalCompleted: number;
        trailingTotalGoalsReached: number;
        trailingTotalSuggestions: number;
        completedSameDay: number;
        completedWithin2Days: number;
        completedWithin3Days: number;
        completedWithin7Days: number;
        completedWithin30Days: number;
        goalsReachedSameDay: number;
        goalsReachedWithin2Days: number;
        goalsReachedWithin3Days: number;
        goalsReachedWithin7Days: number;
        goalsReachedWithin30Days: number;
        suggestionsSameDay: number;
        suggestionsWithin2Days: number;
        suggestionsWithin3Days: number;
        suggestionsWithin7Days: number;
        suggestionsWithin30Days: number;
    }>;
    numberOfUsers: {
        __typename?: 'OutreachSuggestions_aggregate';
        aggregate?: { __typename?: 'OutreachSuggestions_aggregate_fields'; count: number } | null;
    };
    numberOfUsersBeforePeriod: {
        __typename?: 'OutreachSuggestions_aggregate';
        aggregate?: { __typename?: 'OutreachSuggestions_aggregate_fields'; count: number } | null;
    };
};

export type GetDashboardMetricsQueryVariables = Exact<{
    startDate: Scalars['timestamp']['input'];
    endDate: Scalars['timestamp']['input'];
    previousStartDate: Scalars['timestamp']['input'];
    organizationId: Scalars['String']['input'];
}>;

export type GetDashboardMetricsQuery = {
    __typename?: 'query_root';
    numberOfSentMessages: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
        nodes: Array<{
            __typename?: 'Messages';
            prospectId?: string | null;
            isSentFromApp?: boolean | null;
            userId: string;
            channelType?: any | null;
            sentOn?: any | null;
        }>;
    };
    numberOfReceivedMessages: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
        nodes: Array<{
            __typename?: 'Messages';
            prospectId?: string | null;
            userId: string;
            channelType?: any | null;
            sentOn?: any | null;
        }>;
    };
    numberOfNewConnections: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
        nodes: Array<{
            __typename?: 'Messages';
            prospectId?: string | null;
            prospectFullName?: string | null;
            userId: string;
            channelType?: any | null;
            actionType?: any | null;
            sentOn?: any | null;
        }>;
    };
    numberOfSentMessagesPrev: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
        nodes: Array<{
            __typename?: 'Messages';
            prospectId?: string | null;
            isSentFromApp?: boolean | null;
            userId: string;
            channelType?: any | null;
            sentOn?: any | null;
        }>;
    };
    numberOfReceivedMessagesPrev: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
        nodes: Array<{
            __typename?: 'Messages';
            prospectId?: string | null;
            userId: string;
            channelType?: any | null;
            sentOn?: any | null;
        }>;
    };
    numberOfNewConnectionsPrev: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
        nodes: Array<{
            __typename?: 'Messages';
            prospectId?: string | null;
            prospectFullName?: string | null;
            userId: string;
            channelType?: any | null;
            actionType?: any | null;
            sentOn?: any | null;
        }>;
    };
};

export type GetTeamDashboardMetricsQueryVariables = Exact<{
    startDate: Scalars['timestamp']['input'];
    endDate: Scalars['timestamp']['input'];
    previousStartDate: Scalars['timestamp']['input'];
    organizationId: Scalars['String']['input'];
}>;

export type GetTeamDashboardMetricsQuery = {
    __typename?: 'query_root';
    numberOfSentMessages: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
        nodes: Array<{
            __typename?: 'Messages';
            prospectId?: string | null;
            isSentFromApp?: boolean | null;
            userId: string;
            channelType?: any | null;
            sentOn?: any | null;
        }>;
    };
    numberOfReceivedMessages: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
        nodes: Array<{
            __typename?: 'Messages';
            prospectId?: string | null;
            userId: string;
            channelType?: any | null;
            sentOn?: any | null;
        }>;
    };
    numberOfNewConnections: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
        nodes: Array<{
            __typename?: 'Messages';
            prospectId?: string | null;
            prospectFullName?: string | null;
            userId: string;
            channelType?: any | null;
            actionType?: any | null;
            sentOn?: any | null;
        }>;
    };
    numberOfSentMessagesPrev: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
        nodes: Array<{
            __typename?: 'Messages';
            prospectId?: string | null;
            isSentFromApp?: boolean | null;
            userId: string;
            channelType?: any | null;
            sentOn?: any | null;
        }>;
    };
    numberOfReceivedMessagesPrev: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
        nodes: Array<{
            __typename?: 'Messages';
            prospectId?: string | null;
            userId: string;
            channelType?: any | null;
            sentOn?: any | null;
        }>;
    };
    numberOfNewConnectionsPrev: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
        nodes: Array<{
            __typename?: 'Messages';
            prospectId?: string | null;
            prospectFullName?: string | null;
            userId: string;
            channelType?: any | null;
            actionType?: any | null;
            sentOn?: any | null;
        }>;
    };
};

export type GetMessagesSentTodayQueryVariables = Exact<{
    startDate: Scalars['timestamp']['input'];
    endDate: Scalars['timestamp']['input'];
}>;

export type GetMessagesSentTodayQuery = {
    __typename?: 'query_root';
    Messages_aggregate: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
    };
};

export type GetConversationsByMetadataQueryVariables = Exact<{
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
}>;

export type GetConversationsByMetadataQuery = {
    __typename?: 'query_root';
    Conversations: Array<{
        __typename?: 'Conversations';
        id: string;
        prospectId: string;
        contactId?: string | null;
        createdAt: any;
        updatedAt: any;
        metadata: any;
    }>;
};

export type GetMessagesByConversationMetadataQueryVariables = Exact<{
    metadata?: InputMaybe<Scalars['jsonb']['input']>;
}>;

export type GetMessagesByConversationMetadataQuery = {
    __typename?: 'query_root';
    Messages: Array<{
        __typename?: 'Messages';
        id: string;
        conversationId?: string | null;
        sentOn?: any | null;
        fullName?: string | null;
        content?: string | null;
        actionType?: any | null;
        channelType?: any | null;
    }>;
};

export type GetMessagesByMetadataFiltersQueryVariables = Exact<{
    where: Messages_Bool_Exp;
    limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetMessagesByMetadataFiltersQuery = {
    __typename?: 'query_root';
    Messages: Array<{
        __typename?: 'Messages';
        id: string;
        prospectId?: string | null;
        conversationId?: string | null;
        sentOn?: any | null;
        fullName?: string | null;
        content?: string | null;
        actionType?: any | null;
        channelType?: any | null;
        metadata?: any | null;
    }>;
};

export type GetUniqueMessageMetadataValuesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUniqueMessageMetadataValuesQuery = {
    __typename?: 'query_root';
    Messages: Array<{ __typename?: 'Messages'; metadata?: any | null }>;
};

export type GetConversationsByMetadataFiltersQueryVariables = Exact<{
    where: Conversations_Bool_Exp;
    limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetConversationsByMetadataFiltersQuery = {
    __typename?: 'query_root';
    Conversations: Array<{
        __typename?: 'Conversations';
        id: string;
        prospectId: string;
        contactId?: string | null;
        createdAt: any;
        updatedAt: any;
        metadata: any;
        metadataLastUpdatedAt?: any | null;
    }>;
};

export type GetUniqueConversationMetadataValuesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUniqueConversationMetadataValuesQuery = {
    __typename?: 'query_root';
    Conversations: Array<{ __typename?: 'Conversations'; metadata: any }>;
};

export type GetContactsWeightedScoresQueryVariables = Exact<{
    where?: Contacts_Bool_Exp;
    urgent_followup_boost?: InputMaybe<Scalars['numeric']['input']>;
    networking_objective_weight?: InputMaybe<Scalars['numeric']['input']>;
    sales_objective_weight?: InputMaybe<Scalars['numeric']['input']>;
    customer_success_objective_weight?: InputMaybe<Scalars['numeric']['input']>;
    fundraising_objective_weight?: InputMaybe<Scalars['numeric']['input']>;
    recruiting_objective_weight?: InputMaybe<Scalars['numeric']['input']>;
    internal_objective_weight?: InputMaybe<Scalars['numeric']['input']>;
    timing_urgency_max_boost?: InputMaybe<Scalars['numeric']['input']>;
    no_action_penalty?: InputMaybe<Scalars['numeric']['input']>;
    shelf_base_boost?: InputMaybe<Scalars['numeric']['input']>;
    shelf_period_days?: InputMaybe<Scalars['numeric']['input']>;
    very_old_overdue_base_boost?: InputMaybe<Scalars['numeric']['input']>;
    very_old_decay_rate?: InputMaybe<Scalars['numeric']['input']>;
    due_today_boost?: InputMaybe<Scalars['numeric']['input']>;
    due_curve_width?: InputMaybe<Scalars['numeric']['input']>;
    future_penalty?: InputMaybe<Scalars['numeric']['input']>;
    future_decay_rate?: InputMaybe<Scalars['numeric']['input']>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetContactsWeightedScoresQuery = {
    __typename?: 'query_root';
    contacts_weighted_scores: Array<{
        __typename?: 'Contacts';
        id: string;
        userId: string;
        organizationId: string;
        prospectId: string;
        source: string;
        sourceId?: string | null;
        personId?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        location?: string | null;
        email?: string | null;
        phoneNumbers?: Array<string> | null;
        skills?: Array<string> | null;
        interests?: Array<string> | null;
        linkedinProfileUrl?: string | null;
        linkedinUserId?: string | null;
        linkedinProfileImgUrl?: string | null;
        linkedinNumberOfConnections?: number | null;
        linkedinHeadline?: string | null;
        linkedinVerifiedAt?: any | null;
        occupationTitle?: string | null;
        organizationName?: string | null;
        organizationDomain?: string | null;
        organizationLinkedinUrl?: string | null;
        organizationIndustry?: string | null;
        organizationSize?: string | null;
        experiences?: any | null;
        education?: any | null;
        metadataLastUpdatedAt?: any | null;
        metadata?: any | null;
        userSetAsNotInterestedAt?: any | null;
        priorityScore: number;
        compositeScore: any;
        topActionType: string;
        region?: string | null;
        connectionStatus?: any | null;
        connectedAt?: any | null;
        snoozedUntil?: any | null;
        lastCompletedActionAt?: any | null;
        nextActionSuggestedAt?: any | null;
        lastContactedAt?: any | null;
        accountId?: string | null;
        objectiveScores?: any | null;
        contactType?: any | null;
        relationshipType?: any | null;
        recommendedActions?: any | null;
        urgent?: any | null;
        numberOfMessages: {
            __typename?: 'Messages_aggregate';
            aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
        };
        Messages: Array<{
            __typename?: 'Messages';
            id: string;
            content?: string | null;
            subjectLine?: string | null;
            sentOn?: any | null;
            prospectFullName?: string | null;
            fullName?: string | null;
            direction: string;
        }>;
    }>;
    total_contacts: {
        __typename?: 'Contacts_aggregate';
        aggregate?: { __typename?: 'Contacts_aggregate_fields'; count: number } | null;
    };
    filtered_contacts_count: {
        __typename?: 'Contacts_aggregate';
        aggregate?: { __typename?: 'Contacts_aggregate_fields'; count: number } | null;
    };
};

export type GetContactAndConversationByIdQueryVariables = Exact<{
    id: Scalars['String']['input'];
    messageLimit?: InputMaybe<Scalars['Int']['input']>;
    noteLimit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetContactAndConversationByIdQuery = {
    __typename?: 'query_root';
    Contacts_by_pk?: {
        __typename?: 'Contacts';
        id: string;
        userId: string;
        organizationId: string;
        prospectId: string;
        source: string;
        sourceId?: string | null;
        personId?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        location?: string | null;
        email?: string | null;
        phoneNumbers?: Array<string> | null;
        skills?: Array<string> | null;
        interests?: Array<string> | null;
        linkedinProfileUrl?: string | null;
        linkedinUserId?: string | null;
        linkedinProfileImgUrl?: string | null;
        linkedinNumberOfConnections?: number | null;
        linkedinHeadline?: string | null;
        linkedinVerifiedAt?: any | null;
        connectionStatus?: any | null;
        connectedAt?: any | null;
        occupationTitle?: string | null;
        organizationName?: string | null;
        organizationDomain?: string | null;
        organizationLinkedinUrl?: string | null;
        organizationIndustry?: string | null;
        organizationSize?: string | null;
        experiences?: any | null;
        education?: any | null;
        metadata?: any | null;
        metadataLastUpdatedAt?: any | null;
        actionsMetadata?: any | null;
        priorityScore: number;
        topActionType: string;
        region?: string | null;
        snoozedUntil?: any | null;
        lastCompletedActionAt?: any | null;
        nextActionSuggestedAt?: any | null;
        lastContactedAt?: any | null;
        accountId?: string | null;
        objectiveScores?: any | null;
        contactType?: any | null;
        relationshipType?: any | null;
        recommendedActions?: any | null;
        numberOfMessages: {
            __typename?: 'Messages_aggregate';
            aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
        };
        conversationMetadata: Array<{ __typename?: 'Conversations'; metadata: any }>;
        Messages: Array<{
            __typename?: 'Messages';
            id: string;
            direction: string;
            conversationId?: string | null;
            prospectId?: string | null;
            contactId?: string | null;
            channelType?: any | null;
            actionType?: any | null;
            contentType?: string | null;
            subjectLine?: string | null;
            content?: string | null;
            sentOn?: any | null;
            fullName?: string | null;
            linkedinUserId?: string | null;
            externalMessageId?: string | null;
            prospectFullName?: string | null;
            deliveryStatus?: any | null;
            Attachments: Array<{ __typename?: 'Attachments'; type: any; value: string }>;
        }>;
        Notes: Array<{
            __typename?: 'Notes';
            id: string;
            title: string;
            content: string;
            createdAt: any;
            creator: any;
            happenedOn: any;
        }>;
        _GroupToContacts: Array<{ __typename?: '_GroupToContact'; Group: { __typename?: 'Groups'; id: string } }>;
    } | null;
};

export type GetTotalNumberOfContactsQueryVariables = Exact<{ [key: string]: never }>;

export type GetTotalNumberOfContactsQuery = {
    __typename?: 'query_root';
    Contacts_aggregate: {
        __typename?: 'Contacts_aggregate';
        aggregate?: { __typename?: 'Contacts_aggregate_fields'; count: number } | null;
    };
};

export type GetContactsForTableQueryVariables = Exact<{
    limit: Scalars['Int']['input'];
    offset: Scalars['Int']['input'];
    orderBy: Array<Contacts_Order_By> | Contacts_Order_By;
    where: Contacts_Bool_Exp;
}>;

export type GetContactsForTableQuery = {
    __typename?: 'query_root';
    Contacts: Array<{
        __typename?: 'Contacts';
        id: string;
        userId: string;
        organizationId: string;
        prospectId: string;
        source: string;
        sourceId?: string | null;
        personId?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        location?: string | null;
        email?: string | null;
        phoneNumbers?: Array<string> | null;
        skills?: Array<string> | null;
        interests?: Array<string> | null;
        linkedinProfileUrl?: string | null;
        linkedinUserId?: string | null;
        linkedinProfileImgUrl?: string | null;
        linkedinNumberOfConnections?: number | null;
        linkedinHeadline?: string | null;
        linkedinVerifiedAt?: any | null;
        occupationTitle?: string | null;
        organizationName?: string | null;
        organizationDomain?: string | null;
        organizationLinkedinUrl?: string | null;
        organizationIndustry?: string | null;
        organizationSize?: string | null;
        experiences?: any | null;
        education?: any | null;
        metadata?: any | null;
        metadataLastUpdatedAt?: any | null;
        actionsMetadata?: any | null;
        priorityScore: number;
        topActionType: string;
        region?: string | null;
        connectedAt?: any | null;
        snoozedUntil?: any | null;
        lastCompletedActionAt?: any | null;
        nextActionSuggestedAt?: any | null;
        lastContactedAt?: any | null;
        accountId?: string | null;
        createdAt: any;
        _GroupToContacts: Array<{
            __typename?: '_GroupToContact';
            Group: {
                __typename?: 'Groups';
                id: string;
                name: string;
                imgSrc?: string | null;
                default: boolean;
                assistantSettingsId: string;
                createdAt: any;
                updatedAt: any;
            };
        }>;
    }>;
    Contacts_aggregate: {
        __typename?: 'Contacts_aggregate';
        aggregate?: { __typename?: 'Contacts_aggregate_fields'; count: number } | null;
    };
};

export type GetContactByIdQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetContactByIdQuery = {
    __typename?: 'query_root';
    Contacts_by_pk?: {
        __typename?: 'Contacts';
        id: string;
        userId: string;
        organizationId: string;
        prospectId: string;
        source: string;
        sourceId?: string | null;
        personId?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        location?: string | null;
        email?: string | null;
        phoneNumbers?: Array<string> | null;
        skills?: Array<string> | null;
        interests?: Array<string> | null;
        linkedinProfileUrl?: string | null;
        linkedinUserId?: string | null;
        linkedinProfileImgUrl?: string | null;
        linkedinNumberOfConnections?: number | null;
        linkedinHeadline?: string | null;
        linkedinVerifiedAt?: any | null;
        occupationTitle?: string | null;
        organizationName?: string | null;
        organizationDomain?: string | null;
        organizationLinkedinUrl?: string | null;
        organizationIndustry?: string | null;
        organizationSize?: string | null;
        experiences?: any | null;
        education?: any | null;
        metadata?: any | null;
        actionsMetadata?: any | null;
        priorityScore: number;
        topActionType: string;
        region?: string | null;
        connectedAt?: any | null;
        daysSinceLastMsg: number;
        lastContactedAt?: any | null;
        accountId?: string | null;
        objectiveScores?: any | null;
        contactType?: any | null;
        relationshipType?: any | null;
        recommendedActions?: any | null;
    } | null;
};

export type GetContactByIdsQueryVariables = Exact<{
    ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type GetContactByIdsQuery = {
    __typename?: 'query_root';
    Contacts: Array<{
        __typename?: 'Contacts';
        id: string;
        userId: string;
        organizationId: string;
        prospectId: string;
        source: string;
        sourceId?: string | null;
        personId?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        location?: string | null;
        email?: string | null;
        phoneNumbers?: Array<string> | null;
        skills?: Array<string> | null;
        interests?: Array<string> | null;
        linkedinProfileUrl?: string | null;
        linkedinUserId?: string | null;
        linkedinProfileImgUrl?: string | null;
        linkedinNumberOfConnections?: number | null;
        linkedinHeadline?: string | null;
        linkedinVerifiedAt?: any | null;
        occupationTitle?: string | null;
        organizationName?: string | null;
        organizationDomain?: string | null;
        organizationLinkedinUrl?: string | null;
        organizationIndustry?: string | null;
        organizationSize?: string | null;
        experiences?: any | null;
        education?: any | null;
        metadata?: any | null;
        actionsMetadata?: any | null;
        priorityScore: number;
        topActionType: string;
        region?: string | null;
        connectedAt?: any | null;
        daysSinceLastMsg: number;
        lastContactedAt?: any | null;
        accountId?: string | null;
        objectiveScores?: any | null;
        contactType?: any | null;
        relationshipType?: any | null;
        recommendedActions?: any | null;
    }>;
};

export type GetSampleContactsQueryVariables = Exact<{
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    orderBy?: InputMaybe<Array<SampleContacts_Order_By> | SampleContacts_Order_By>;
}>;

export type GetSampleContactsQuery = {
    __typename?: 'query_root';
    SampleContacts: Array<{
        __typename?: 'SampleContacts';
        id: string;
        contact: any;
        conversation?: any | null;
        createdAt: any;
        updatedAt: any;
    }>;
    SampleContacts_aggregate: {
        __typename?: 'SampleContacts_aggregate';
        aggregate?: { __typename?: 'SampleContacts_aggregate_fields'; count: number } | null;
    };
};

export type GetLatestMessageDraftOneQueryVariables = Exact<{
    contactId: Scalars['String']['input'];
}>;

export type GetLatestMessageDraftOneQuery = {
    __typename?: 'query_root';
    MessageDrafts: Array<{
        __typename?: 'MessageDrafts';
        id: string;
        content: string;
        subjectLine: string;
        channelType: any;
        source: string;
        userPrompt: string;
        updatedAt: any;
    }>;
};

export type GetAutoGenerateDraftDataQueryVariables = Exact<{
    contactId: Scalars['String']['input'];
}>;

export type GetAutoGenerateDraftDataQuery = {
    __typename?: 'query_root';
    Contacts_by_pk?: {
        __typename?: 'Contacts';
        id: string;
        lastCompletedActionAt?: any | null;
        latestMessage: Array<{
            __typename?: 'Messages';
            id: string;
            sentOn?: any | null;
            content?: string | null;
            subjectLine?: string | null;
            actionType?: any | null;
        }>;
        latestDraft: Array<{
            __typename?: 'MessageDrafts';
            id: string;
            updatedAt: any;
            content: string;
            subjectLine: string;
            channelType: any;
            source: string;
            createdAt: any;
        }>;
    } | null;
};

export type GetContactClassificationQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetContactClassificationQuery = {
    __typename?: 'query_root';
    Contacts_by_pk?: {
        __typename?: 'Contacts';
        id: string;
        metadata?: any | null;
        actionsMetadata?: any | null;
        priorityScore: number;
        topActionType: string;
        nextActionSuggestedAt?: any | null;
        snoozedUntil?: any | null;
        conversationMetadata: Array<{ __typename?: 'Conversations'; metadata: any }>;
        messagesMetadata: Array<{ __typename?: 'Messages'; metadata?: any | null }>;
    } | null;
};

export type GetContactsInteractionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetContactsInteractionsQuery = {
    __typename?: 'query_root';
    notInterestedInteractions: Array<{
        __typename?: 'ContactsInteractions';
        id: string;
        contactId?: string | null;
        metadata: any;
        weights: any;
        interactionType: any;
        createdAt: any;
    }>;
    otherInteractions: Array<{
        __typename?: 'ContactsInteractions';
        id: string;
        contactId?: string | null;
        metadata: any;
        weights: any;
        interactionType: any;
        createdAt: any;
    }>;
};

export type GetContactProfilesQueryVariables = Exact<{
    limit: Scalars['Int']['input'];
    search?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetContactProfilesQuery = {
    __typename?: 'query_root';
    Contacts: Array<{
        __typename?: 'Contacts';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        linkedinProfileImgUrl?: string | null;
        occupationTitle?: string | null;
        organizationName?: string | null;
    }>;
};

export type GetNumberOfUrgentActionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetNumberOfUrgentActionsQuery = {
    __typename?: 'query_root';
    urgentContacts: {
        __typename?: 'Contacts_aggregate';
        aggregate?: { __typename?: 'Contacts_aggregate_fields'; count: number } | null;
    };
};

export type GetConversationsWithContactsQueryQueryVariables = Exact<{
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<Conversations_Bool_Exp>;
}>;

export type GetConversationsWithContactsQueryQuery = {
    __typename?: 'query_root';
    Conversations: Array<{
        __typename?: 'Conversations';
        id: string;
        userId: string;
        organizationId: string;
        prospectId: string;
        contactId?: string | null;
        Contact?: {
            __typename?: 'Contacts';
            id: string;
            userId: string;
            organizationId: string;
            prospectId: string;
            firstName?: string | null;
            lastName?: string | null;
            fullName?: string | null;
            linkedinProfileImgUrl?: string | null;
            linkedinUserId?: string | null;
            occupationTitle?: string | null;
            organizationName?: string | null;
            nextActionSuggestedAt?: any | null;
            snoozedUntil?: any | null;
            _GroupToContacts: Array<{ __typename?: '_GroupToContact'; Group: { __typename?: 'Groups'; id: string } }>;
        } | null;
        Messages: Array<{
            __typename?: 'Messages';
            id: string;
            content?: string | null;
            subjectLine?: string | null;
            sentOn?: any | null;
            direction: string;
            actionType?: any | null;
            channelType?: any | null;
            deliveryStatus?: any | null;
        }>;
    }>;
};

export type GetConversationCountsByGroupsQueryVariables = Exact<{
    availableGroupIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type GetConversationCountsByGroupsQuery = {
    __typename?: 'query_root';
    totalCount: {
        __typename?: 'Conversations_aggregate';
        aggregate?: { __typename?: 'Conversations_aggregate_fields'; count: number } | null;
    };
    unassignedCount: {
        __typename?: 'Conversations_aggregate';
        aggregate?: { __typename?: 'Conversations_aggregate_fields'; count: number } | null;
    };
};

export type GetConversationCountByGroupQueryVariables = Exact<{
    groupId: Scalars['String']['input'];
}>;

export type GetConversationCountByGroupQuery = {
    __typename?: 'query_root';
    groupCount: {
        __typename?: 'Conversations_aggregate';
        aggregate?: { __typename?: 'Conversations_aggregate_fields'; count: number } | null;
    };
};

export type GetContactsByStartDatePatternQueryVariables = Exact<{
    pattern: Scalars['String']['input'];
}>;

export type GetContactsByStartDatePatternQuery = {
    __typename?: 'query_root';
    Contacts: Array<{
        __typename?: 'Contacts';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        experiences?: any | null;
        occupationTitle?: string | null;
        organizationName?: string | null;
        linkedinProfileUrl?: string | null;
        linkedinProfileImgUrl?: string | null;
    }>;
};

export type GetProspectNotesSubscriptionSubscriptionVariables = Exact<{
    prospectId: Scalars['String']['input'];
}>;

export type GetProspectNotesSubscriptionSubscription = {
    __typename?: 'subscription_root';
    Notes: Array<{ __typename?: 'Notes'; id: string }>;
};

export type NextScheduledOutreachSuggestionsSubscriptionVariables = Exact<{
    prospectId: Scalars['String']['input'];
}>;

export type NextScheduledOutreachSuggestionsSubscription = {
    __typename?: 'subscription_root';
    OutreachSuggestions: Array<{
        __typename?: 'OutreachSuggestions';
        accountName: string;
        name: string;
        id: string;
        createdAt: any;
        prospectId?: string | null;
        unread: boolean;
        scheduledOn?: any | null;
        scheduledOnMotivation?: string | null;
        Message: {
            __typename?: 'Messages';
            id: string;
            subjectLine?: string | null;
            content?: string | null;
            actionType?: any | null;
            channelType?: any | null;
            linkedinUserId?: string | null;
            direction: string;
            sentOn?: any | null;
            updatedAt: any;
        };
    }>;
};

export type OnMessageAddedByProspectIdSubscriptionVariables = Exact<{ [key: string]: never }>;

export type OnMessageAddedByProspectIdSubscription = {
    __typename?: 'subscription_root';
    Messages: Array<{
        __typename?: 'Messages';
        id: string;
        prospectId?: string | null;
        sentOn?: any | null;
        fullName?: string | null;
        content?: string | null;
        subjectLine?: string | null;
        direction: string;
        actionType?: any | null;
        prospectFullName?: string | null;
        deliveryStatus?: any | null;
        OutreachSuggestion?: { __typename?: 'OutreachSuggestions'; id: string } | null;
    }>;
};

export type GetLinkedinConversationsSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>;

export type GetLinkedinConversationsSubscriptionSubscription = {
    __typename?: 'subscription_root';
    LinkedinConversations: Array<{
        __typename?: 'LinkedinConversations';
        id: string;
        prospectId?: string | null;
        lastMessageType?: any | null;
        lastMessageText?: string | null;
        lastMessageSentAt?: any | null;
        lastMessageSentDirection?: string | null;
        participantMemberIds?: Array<string> | null;
    }>;
};

export type GetOutreachSuggestionSubscriptionVariables = Exact<{
    prospectId: Scalars['String']['input'];
    scheduledOnBefore: Scalars['timestamp']['input'];
}>;

export type GetOutreachSuggestionSubscription = {
    __typename?: 'subscription_root';
    OutreachSuggestions: Array<{
        __typename?: 'OutreachSuggestions';
        id: string;
        accountName: string;
        name: string;
        createdAt: any;
        updatedAt: any;
        userId: string;
        prospectId?: string | null;
        unread: boolean;
        scheduledOn?: any | null;
        score: number;
        goal?: string | null;
        isGenerating: boolean;
        Message: {
            __typename?: 'Messages';
            id: string;
            createdAt: any;
            subjectLine?: string | null;
            content?: string | null;
            actionType?: any | null;
            channelType?: any | null;
            linkedinUserId?: string | null;
        };
        ConversationMetaData?: { __typename?: 'ConversationMetaData'; topics: string } | null;
    }>;
};

export type GetProspectFutureActionsSubscriptionVariables = Exact<{
    prospectId: Scalars['String']['input'];
    scheduledOnBefore: Scalars['timestamp']['input'];
}>;

export type GetProspectFutureActionsSubscription = {
    __typename?: 'subscription_root';
    OutreachSuggestions: Array<{
        __typename?: 'OutreachSuggestions';
        id: string;
        scheduledOn?: any | null;
        scheduledOnMotivation?: string | null;
    }>;
};

export type GetProspectUnscheduledActionsSubscriptionVariables = Exact<{
    prospectId: Scalars['String']['input'];
}>;

export type GetProspectUnscheduledActionsSubscription = {
    __typename?: 'subscription_root';
    OutreachSuggestions: Array<{
        __typename?: 'OutreachSuggestions';
        id: string;
        scheduledOnMotivation?: string | null;
    }>;
};

export type OnMessageUpdatedSubscriptionVariables = Exact<{
    messageId: Scalars['String']['input'];
}>;

export type OnMessageUpdatedSubscription = {
    __typename?: 'subscription_root';
    Messages: Array<{
        __typename?: 'Messages';
        id: string;
        subjectLine?: string | null;
        content?: string | null;
        actionType?: any | null;
        channelType?: any | null;
        deliveryStatus?: any | null;
        Attachments: Array<{ __typename?: 'Attachments'; type: any; value: string }>;
    }>;
};

export type GetProspectMessagesHistorySubscriptionSubscriptionVariables = Exact<{
    prospectId: Scalars['String']['input'];
}>;

export type GetProspectMessagesHistorySubscriptionSubscription = {
    __typename?: 'subscription_root';
    Messages: Array<{ __typename?: 'Messages'; id: string }>;
};

export type GetAssistantSettingsStreamingSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>;

export type GetAssistantSettingsStreamingSubscriptionSubscription = {
    __typename?: 'subscription_root';
    AssistantSettings: Array<{
        __typename?: 'AssistantSettings';
        id: string;
        userId: string;
        organizationId: string;
        purpose: string;
        language: string;
        languages?: Array<string> | null;
        tone: string;
        context?: string | null;
        defaultChannel: any;
        createdAt: any;
        updatedAt: any;
    }>;
};

export type GetUserContactsSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>;

export type GetUserContactsSubscriptionSubscription = {
    __typename?: 'subscription_root';
    UserContacts: Array<{
        __typename?: 'UserContacts';
        id: string;
        prospectId: string;
        status: any;
        _GroupToUserContacts: Array<{
            __typename?: '_GroupToUserContact';
            Group: { __typename?: 'Groups'; id: string; name: string; imgSrc?: string | null };
        }>;
    }>;
};

export type OnUserContactsByIdsSubscriptionVariables = Exact<{
    prospectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type OnUserContactsByIdsSubscription = {
    __typename?: 'subscription_root';
    UserContacts: Array<{
        __typename?: 'UserContacts';
        id: string;
        prospectId: string;
        status: any;
        _GroupToUserContacts: Array<{
            __typename?: '_GroupToUserContact';
            Group: { __typename?: 'Groups'; id: string; name: string; imgSrc?: string | null };
        }>;
    }>;
};

export type GetGroupsSubscriptionVariables = Exact<{ [key: string]: never }>;

export type GetGroupsSubscription = {
    __typename?: 'subscription_root';
    Groups: Array<{
        __typename?: 'Groups';
        id: string;
        userId: string;
        default: boolean;
        name: string;
        assistantSettingsId: string;
        imgSrc?: string | null;
        createdAt: any;
        updatedAt: any;
    }>;
};

export type GetPlaybookByGroupIdSubscriptionSubscriptionVariables = Exact<{
    groupId: Scalars['String']['input'];
}>;

export type GetPlaybookByGroupIdSubscriptionSubscription = {
    __typename?: 'subscription_root';
    Groups_by_pk?: {
        __typename?: 'Groups';
        id: string;
        userId: string;
        default: boolean;
        name: string;
        assistantSettingsId: string;
        imgSrc?: string | null;
        createdAt: any;
        updatedAt: any;
        AssistantSetting: {
            __typename?: 'AssistantSettings';
            id: string;
            userId: string;
            organizationId: string;
            purpose: string;
            language: string;
            languages?: Array<string> | null;
            tone: string;
            context?: string | null;
            targetGroup?: string | null;
            createdAt: any;
            updatedAt: any;
            defaultChannel: any;
        };
        _GroupToUserContacts: Array<{
            __typename?: '_GroupToUserContact';
            UserContact: { __typename?: 'UserContacts'; id: string };
        }>;
    } | null;
};

export type GetNotesSubscriptionVariables = Exact<{ [key: string]: never }>;

export type GetNotesSubscription = {
    __typename?: 'subscription_root';
    Notes: Array<{
        __typename?: 'Notes';
        id: string;
        prospectId: string;
        creator: any;
        content: string;
        title: string;
        createdAt: any;
        updatedAt: any;
    }>;
};

export type GetContactSuggestionsCountSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>;

export type GetContactSuggestionsCountSubscriptionSubscription = {
    __typename?: 'subscription_root';
    ContactSuggestions_aggregate: {
        __typename?: 'ContactSuggestions_aggregate';
        aggregate?: { __typename?: 'ContactSuggestions_aggregate_fields'; count: number } | null;
    };
};

export type GetMessagesSentFromAppSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>;

export type GetMessagesSentFromAppSubscriptionSubscription = {
    __typename?: 'subscription_root';
    Messages_aggregate: {
        __typename?: 'Messages_aggregate';
        aggregate?: { __typename?: 'Messages_aggregate_fields'; count: number } | null;
    };
};

export const MarkActionAsNotInterestedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'MarkActionAsNotInterested' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'update_Contacts_by_pk' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pk_columns' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: '_set' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'priorityScore' },
                                            value: { kind: 'IntValue', value: '-1' },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'userSetAsNotInterestedAt' },
                                            value: { kind: 'StringValue', value: 'now()', block: false },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<MarkActionAsNotInterestedMutation, MarkActionAsNotInterestedMutationVariables>;
export const UndoMarkActionAsNotInterestedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UndoMarkActionAsNotInterested' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'update_Contacts_by_pk' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pk_columns' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: '_set' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'priorityScore' },
                                            value: { kind: 'IntValue', value: '-1' },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'userSetAsNotInterestedAt' },
                                            value: { kind: 'NullValue' },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UndoMarkActionAsNotInterestedMutation, UndoMarkActionAsNotInterestedMutationVariables>;
export const MarkActionAsCompletedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'MarkActionAsCompleted' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'update_Contacts_by_pk' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pk_columns' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: '_set' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'lastCompletedActionAt' },
                                            value: { kind: 'StringValue', value: 'now()', block: false },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<MarkActionAsCompletedMutation, MarkActionAsCompletedMutationVariables>;
export const UpdateSampleContactConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateSampleContactConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversation' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'update_SampleContacts_by_pk' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pk_columns' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: '_set' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'conversation' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'conversation' } },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversation' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UpdateSampleContactConversationMutation, UpdateSampleContactConversationMutationVariables>;
export const CreateSampleContactDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateSampleContact' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'contact' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversation' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'insert_SampleContacts_one' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'object' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'contact' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'contact' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'conversation' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'conversation' } },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversation' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CreateSampleContactMutation, CreateSampleContactMutationVariables>;
export const DeleteSampleContactDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeleteSampleContact' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'delete_SampleContacts_by_pk' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<DeleteSampleContactMutation, DeleteSampleContactMutationVariables>;
export const SnoozeActionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SnoozeAction' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'snoozedUntil' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'update_Contacts_by_pk' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pk_columns' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: '_set' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'snoozedUntil' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'snoozedUntil' } },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SnoozeActionMutation, SnoozeActionMutationVariables>;
export const SnoozeActionByProspectIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SnoozeActionByProspectId' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'snoozedUntil' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'update_Contacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: '_set' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'snoozedUntil' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'snoozedUntil' } },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SnoozeActionByProspectIdMutation, SnoozeActionByProspectIdMutationVariables>;
export const InsertMessageDraftDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'InsertMessageDraft' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'source' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectLine' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelType' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelType' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'userPrompt' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'insert_MessageDrafts_one' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'object' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'userId' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'organizationId' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'organizationId' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'contactId' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'source' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'source' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'content' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'subjectLine' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectLine' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'channelType' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'channelType' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'userPrompt' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userPrompt' } },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<InsertMessageDraftMutation, InsertMessageDraftMutationVariables>;
export const UpdateMessageDraftDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateMessageDraft' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectLine' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelType' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelType' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'userPrompt' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'update_MessageDrafts_by_pk' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pk_columns' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: '_set' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'content' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'subjectLine' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectLine' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'channelType' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'channelType' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'userPrompt' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userPrompt' } },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UpdateMessageDraftMutation, UpdateMessageDraftMutationVariables>;
export const ArchiveMessageDraftsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ArchiveMessageDrafts' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'update_MessageDrafts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'userId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'userId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'contactId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'contactId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'archivedAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: '_set' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'archivedAt' },
                                            value: { kind: 'StringValue', value: 'now()', block: false },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'returning' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ArchiveMessageDraftsMutation, ArchiveMessageDraftsMutationVariables>;
export const CreateContactsInteractionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateContactsInteractions' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactMetadata' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'weights' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'interactionType' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactInteractionType' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'insert_ContactsInteractions_one' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'object' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'userId' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'organizationId' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'organizationId' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'contactId' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'metadata' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'contactMetadata' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'weights' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'weights' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'interactionType' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'interactionType' },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CreateContactsInteractionsMutation, CreateContactsInteractionsMutationVariables>;
export const CreateSearchResultInteractionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateSearchResultInteractions' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'metadata' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'weights' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'interactionType' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactInteractionType' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'insert_ContactsInteractions_one' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'object' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'userId' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'organizationId' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'organizationId' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'metadata' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'metadata' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'weights' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'weights' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'interactionType' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'interactionType' },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CreateSearchResultInteractionsMutation, CreateSearchResultInteractionsMutationVariables>;
export const UpdateContactTypeDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateContactType' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactType' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'update_Contacts_by_pk' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pk_columns' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: '_append' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'metadata' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'contactType' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'contactType' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'contactType' },
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'contactType', block: false },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UpdateContactTypeMutation, UpdateContactTypeMutationVariables>;
export const GetMessagesByProspectIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetMessagesByProspectId' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Messages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sentOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'prospectId' },
                                                    value: { kind: 'EnumValue', value: 'desc' },
                                                },
                                            ],
                                        },
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'sentOn' },
                                                    value: { kind: 'EnumValue', value: 'desc' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'distinct_on' },
                                value: { kind: 'EnumValue', value: 'prospectId' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUserId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectFullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Attachments' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'OutreachSuggestion' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetMessagesByProspectIdQuery, GetMessagesByProspectIdQueryVariables>;
export const GetActionsByProspectIdsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetActionsByProspectIds' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledOnLt' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_lt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'scheduledOnLt' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: true },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_in' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectIds' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'Message' },
                                                    value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'createdAt' },
                                                                value: { kind: 'EnumValue', value: 'desc' },
                                                            },
                                                        ],
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'unread' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isGenerating' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationPaths' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Message' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ConversationMetaData' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'numberOfMessages' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'isNextMessageFollowUp' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'messagesPerDay' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastNetworkUpdateAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'youThemMessageRatio' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastUserNoteAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'hasMessagesSentFromApp' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'medianMessageLength' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'connectionStatus' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastTimeToAnswer' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userContactAddedAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastMessageAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'numberOfMessagesLastDay' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'numberOfMessagesLastWeek' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'userContactFromOnboarding' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'topics' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetActionsByProspectIdsQuery, GetActionsByProspectIdsQueryVariables>;
export const GetActionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetActions' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledOnLt' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_lt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'scheduledOnLt' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: true },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'Message' },
                                                    value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'createdAt' },
                                                                value: { kind: 'EnumValue', value: 'desc' },
                                                            },
                                                        ],
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'unread' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isGenerating' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationPaths' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Message' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ConversationMetaData' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'numberOfMessages' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'isNextMessageFollowUp' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'messagesPerDay' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastNetworkUpdateAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'youThemMessageRatio' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastUserNoteAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'hasMessagesSentFromApp' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'medianMessageLength' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'connectionStatus' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastTimeToAnswer' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userContactAddedAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastMessageAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'numberOfMessagesLastDay' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'numberOfMessagesLastWeek' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'userContactFromOnboarding' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'topics' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetActionsQuery, GetActionsQueryVariables>;
export const GetCompletedActionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetCompletedActions' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledOnLt' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'completedOnGte' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_lt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'scheduledOnLt' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: false },
                                                                },
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_gte' },
                                                                    value: {
                                                                        kind: 'Variable',
                                                                        name: { kind: 'Name', value: 'completedOnGte' },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: { kind: 'EnumValue', value: 'desc' },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Message' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ConversationMetaData' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topics' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetCompletedActionsQuery, GetCompletedActionsQueryVariables>;
export const GetOutreachSuggestionPathsByProspectIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetOutreachSuggestionPathsByProspectId' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledOnLt' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_lt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'scheduledOnLt' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: true },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'createdAt' },
                                            value: { kind: 'EnumValue', value: 'desc' },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'conversationPaths' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetOutreachSuggestionPathsByProspectIdQuery,
    GetOutreachSuggestionPathsByProspectIdQueryVariables
>;
export const GetOutreachSuggestionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetOutreachSuggestions' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'notYetSent' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    },
                    defaultValue: { kind: 'BooleanValue', value: true },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledOnLt' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'sentOnGte' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'focus' },
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: {
                                                                        kind: 'Variable',
                                                                        name: { kind: 'Name', value: 'notYetSent' },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_lt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'scheduledOnLt' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountWebsite' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'numberOfEmployees' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactLocation' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'unread' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Message' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ConversationMetaData' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'numberOfMessages' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'isNextMessageFollowUp' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'messagesPerDay' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastNetworkUpdateAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'youThemMessageRatio' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastUserNoteAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'hasMessagesSentFromApp' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'medianMessageLength' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'connectionStatus' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastTimeToAnswer' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userContactAddedAt' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'userContactFromOnboarding' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastMessageAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'numberOfMessagesLastDay' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'numberOfMessagesLastWeek' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'completed' },
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: false },
                                                                },
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_gte' },
                                                                    value: {
                                                                        kind: 'Variable',
                                                                        name: { kind: 'Name', value: 'sentOnGte' },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_lt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'scheduledOnLt' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountWebsite' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'numberOfEmployees' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactLocation' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'unread' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Message' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ConversationMetaData' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'numberOfMessages' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'isNextMessageFollowUp' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'messagesPerDay' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastNetworkUpdateAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'youThemMessageRatio' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastUserNoteAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'hasMessagesSentFromApp' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'medianMessageLength' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'connectionStatus' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastTimeToAnswer' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userContactAddedAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'focusCount' },
                        name: { kind: 'Name', value: 'OutreachSuggestions_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: {
                                                                        kind: 'Variable',
                                                                        name: { kind: 'Name', value: 'notYetSent' },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_lt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'scheduledOnLt' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'completedCount' },
                        name: { kind: 'Name', value: 'OutreachSuggestions_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: false },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_lt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'scheduledOnLt' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetOutreachSuggestionsQuery, GetOutreachSuggestionsQueryVariables>;
export const GetOutreachSuggestionsByProspectIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetOutreachSuggestionsByProspectId' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledOnBefore' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'focus' },
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_lt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'scheduledOnBefore' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: true },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'createdAt' },
                                                        value: { kind: 'EnumValue', value: 'desc' },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Message' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'completed' },
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_lt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'scheduledOnBefore' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: false },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'createdAt' },
                                                        value: { kind: 'EnumValue', value: 'desc' },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'future' },
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_gt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'scheduledOnBefore' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: true },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'createdAt' },
                                                        value: { kind: 'EnumValue', value: 'desc' },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'scheduledOn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'scheduledOnMotivation' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'unscheduled' },
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: true },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'createdAt' },
                                                        value: { kind: 'EnumValue', value: 'desc' },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetOutreachSuggestionsByProspectIdQuery, GetOutreachSuggestionsByProspectIdQueryVariables>;
export const GetActiveOutreachSuggestionByProspectIdsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetActiveOutreachSuggestionByProspectIds' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_in' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectIds' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: true },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'createdAt' },
                                                        value: { kind: 'EnumValue', value: 'desc' },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetActiveOutreachSuggestionByProspectIdsQuery,
    GetActiveOutreachSuggestionByProspectIdsQueryVariables
>;
export const GetContactSuggestionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetContactSuggestions' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ContactSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'approvedAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'rejectedAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'expiresAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_gt' },
                                                        value: { kind: 'StringValue', value: 'now()', block: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'createdAt' },
                                            value: { kind: 'EnumValue', value: 'desc' },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'personId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactEmailVerified' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactLinkedinUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactEmail' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactTitle' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactLocation' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'campaignName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountIndustry' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountWebsite' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountTags' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountAboutUs' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountNumberOfEmployees' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'suggestionMotivation' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactImgUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetContactSuggestionsQuery, GetContactSuggestionsQueryVariables>;
export const GetContactSuggestionByIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetContactSuggestionById' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ContactSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'id' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'personId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactEmailVerified' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactLinkedinUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactEmail' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactTitle' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactLocation' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'campaignName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountIndustry' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountWebsite' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountTags' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountAboutUs' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountNumberOfEmployees' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'suggestionMotivation' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactImgUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetContactSuggestionByIdQuery, GetContactSuggestionByIdQueryVariables>;
export const GetContactSuggestionsByGroupIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetContactSuggestionsByGroupId' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ContactSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'approvedAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'rejectedAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'expiresAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_gt' },
                                                        value: { kind: 'StringValue', value: 'now()', block: false },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'groupId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'groupId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'createdAt' },
                                            value: { kind: 'EnumValue', value: 'desc' },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'personId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactEmailVerified' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactLinkedinUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactEmail' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactTitle' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactLocation' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'campaignName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountIndustry' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountWebsite' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountTags' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountAboutUs' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountNumberOfEmployees' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'suggestionMotivation' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactImgUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetContactSuggestionsByGroupIdQuery, GetContactSuggestionsByGroupIdQueryVariables>;
export const GetContactSuggestionsCountDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetContactSuggestionsCount' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ContactSuggestions_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'approvedAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'rejectedAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'expiresAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_gt' },
                                                        value: { kind: 'StringValue', value: 'now()', block: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetContactSuggestionsCountQuery, GetContactSuggestionsCountQueryVariables>;
export const GetOutreachSuggestionByIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetOutreachSuggestionById' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'OutreachSuggestions_by_pk' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Message' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'approvedAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'linkedinUserId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectFullName' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'unread' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactLocation' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetOutreachSuggestionByIdQuery, GetOutreachSuggestionByIdQueryVariables>;
export const GetProspectMessagesHistoryDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetProspectMessagesHistory' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Messages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sentOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'sentOn' },
                                                    value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUserId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'externalMessageId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectFullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Attachments' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetProspectMessagesHistoryQuery, GetProspectMessagesHistoryQueryVariables>;
export const GetProspectNotesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetProspectNotes' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Notes' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'discarded' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'createdAt' },
                                                    value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'creator' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'happenedOn' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetProspectNotesQuery, GetProspectNotesQueryVariables>;
export const GetNoteByIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetNoteById' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'noteId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Notes' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'noteId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'discarded' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'creator' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetNoteByIdQuery, GetNoteByIdQueryVariables>;
export const GetAllProspectSubjectLinesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetAllProspectSubjectLines' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Messages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sentOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'sentOn' },
                                                    value: { kind: 'EnumValue', value: 'desc_nulls_last' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetAllProspectSubjectLinesQuery, GetAllProspectSubjectLinesQueryVariables>;
export const GetLastProspectMessageDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetLastProspectMessage' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Messages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sentOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sentOn' },
                                            value: { kind: 'EnumValue', value: 'desc' },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '1' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUserId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'externalMessageId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectFullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetLastProspectMessageQuery, GetLastProspectMessageQueryVariables>;
export const GetMessagesSentFromAppDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetMessagesSentFromApp' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'isSentFromApp' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sentOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'direction' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: { kind: 'StringValue', value: 'out', block: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetMessagesSentFromAppQuery, GetMessagesSentFromAppQueryVariables>;
export const GetAssistantSettingsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetAssistantSettings' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'AssistantSettings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'languages' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'tone' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'context' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetAssistantSettingsQuery, GetAssistantSettingsQueryVariables>;
export const GroupsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Groups' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Groups' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'createdAt' },
                                            value: { kind: 'EnumValue', value: 'asc' },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'assistantSettingsId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imgSrc' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GroupsQuery, GroupsQueryVariables>;
export const GetUserContactsByGroupIdsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetUserContactsByGroupIds' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UserContacts_order_by' } },
                        },
                    },
                    defaultValue: {
                        kind: 'ListValue',
                        values: [
                            {
                                kind: 'ObjectValue',
                                fields: [
                                    {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'createdAt' },
                                        value: { kind: 'EnumValue', value: 'desc' },
                                    },
                                ],
                            },
                        ],
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'UserContacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_GroupToUserContacts' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'Group' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: 'id' },
                                                                    value: {
                                                                        kind: 'ObjectValue',
                                                                        fields: [
                                                                            {
                                                                                kind: 'ObjectField',
                                                                                name: { kind: 'Name', value: '_in' },
                                                                                value: {
                                                                                    kind: 'Variable',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'groupIds',
                                                                                    },
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '_GroupToUserContacts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'Group' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'imgSrc' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'totalCount' },
                        name: { kind: 'Name', value: 'UserContacts_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_GroupToUserContacts' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'Group' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: 'id' },
                                                                    value: {
                                                                        kind: 'ObjectValue',
                                                                        fields: [
                                                                            {
                                                                                kind: 'ObjectField',
                                                                                name: { kind: 'Name', value: '_in' },
                                                                                value: {
                                                                                    kind: 'Variable',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'groupIds',
                                                                                    },
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetUserContactsByGroupIdsQuery, GetUserContactsByGroupIdsQueryVariables>;
export const GetUserContactsProspectIdsByGroupIdsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetUserContactsProspectIdsByGroupIds' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UserContacts_order_by' } },
                        },
                    },
                    defaultValue: {
                        kind: 'ListValue',
                        values: [
                            {
                                kind: 'ObjectValue',
                                fields: [
                                    {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'createdAt' },
                                        value: { kind: 'EnumValue', value: 'desc' },
                                    },
                                ],
                            },
                        ],
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'UserContacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_GroupToUserContacts' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'Group' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: 'id' },
                                                                    value: {
                                                                        kind: 'ObjectValue',
                                                                        fields: [
                                                                            {
                                                                                kind: 'ObjectField',
                                                                                name: { kind: 'Name', value: '_in' },
                                                                                value: {
                                                                                    kind: 'Variable',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'groupIds',
                                                                                    },
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'prospectId' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetUserContactsProspectIdsByGroupIdsQuery,
    GetUserContactsProspectIdsByGroupIdsQueryVariables
>;
export const GetUserContactByProspectIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetUserContactByProspectId' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'UserContacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '_GroupToUserContacts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'Group' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'assistantSettingsId' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'imgSrc' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetUserContactByProspectIdQuery, GetUserContactByProspectIdQueryVariables>;
export const GetUserContactIdsByProspectIdsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetUserContactIdsByProspectIds' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'UserContacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_in' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectIds' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetUserContactIdsByProspectIdsQuery, GetUserContactIdsByProspectIdsQueryVariables>;
export const GetTotalNumberOfUserContactsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetTotalNumberOfUserContacts' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'UserContacts_aggregate' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetTotalNumberOfUserContactsQuery, GetTotalNumberOfUserContactsQueryVariables>;
export const GetTotalNumberOfUserContactsInAnyPlaybookDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetTotalNumberOfUserContactsInAnyPlaybook' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'UserContacts_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_GroupToUserContacts' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'Group' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: 'id' },
                                                                    value: {
                                                                        kind: 'ObjectValue',
                                                                        fields: [
                                                                            {
                                                                                kind: 'ObjectField',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: '_is_null',
                                                                                },
                                                                                value: {
                                                                                    kind: 'BooleanValue',
                                                                                    value: false,
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetTotalNumberOfUserContactsInAnyPlaybookQuery,
    GetTotalNumberOfUserContactsInAnyPlaybookQueryVariables
>;
export const GetUserContactByIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetUserContactById' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'userContactId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'UserContacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'userContactId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '_GroupToUserContacts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'Group' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'assistantSettingsId' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'imgSrc' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetUserContactByIdQuery, GetUserContactByIdQueryVariables>;
export const GetUserContactsByIdsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetUserContactsByIds' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'UserContacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_in' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'ids' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '_GroupToUserContacts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'Group' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'assistantSettingsId' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'imgSrc' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetUserContactsByIdsQuery, GetUserContactsByIdsQueryVariables>;
export const GetAllUserContactsInAnyPlaybookDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetAllUserContactsInAnyPlaybook' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UserContacts_order_by' } },
                        },
                    },
                    defaultValue: {
                        kind: 'ListValue',
                        values: [
                            {
                                kind: 'ObjectValue',
                                fields: [
                                    {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'createdAt' },
                                        value: { kind: 'EnumValue', value: 'desc' },
                                    },
                                ],
                            },
                        ],
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'UserContacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_GroupToUserContacts' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'Group' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: 'id' },
                                                                    value: {
                                                                        kind: 'ObjectValue',
                                                                        fields: [
                                                                            {
                                                                                kind: 'ObjectField',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: '_is_null',
                                                                                },
                                                                                value: {
                                                                                    kind: 'BooleanValue',
                                                                                    value: false,
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '_GroupToUserContacts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'Group' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'imgSrc' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'totalCount' },
                        name: { kind: 'Name', value: 'UserContacts_aggregate' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetAllUserContactsInAnyPlaybookQuery, GetAllUserContactsInAnyPlaybookQueryVariables>;
export const GetAllUserContactsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetAllUserContacts' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UserContacts_order_by' } },
                        },
                    },
                    defaultValue: {
                        kind: 'ListValue',
                        values: [
                            {
                                kind: 'ObjectValue',
                                fields: [
                                    {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'createdAt' },
                                        value: { kind: 'EnumValue', value: 'desc' },
                                    },
                                ],
                            },
                        ],
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'UserContacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '_GroupToUserContacts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'Group' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'imgSrc' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'totalCount' },
                        name: { kind: 'Name', value: 'UserContacts_aggregate' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetAllUserContactsQuery, GetAllUserContactsQueryVariables>;
export const GetActionsCountDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetActionsCount' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'notYetSent' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    },
                    defaultValue: { kind: 'BooleanValue', value: true },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledOnLt' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'OutreachSuggestions_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: {
                                                                        kind: 'Variable',
                                                                        name: { kind: 'Name', value: 'notYetSent' },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_lt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'scheduledOnLt' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetActionsCountQuery, GetActionsCountQueryVariables>;
export const GetPlaybooksDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetPlaybooks' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Groups' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'name' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_ilike' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'name' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'createdAt' },
                                            value: { kind: 'EnumValue', value: 'asc' },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'assistantSettingsId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imgSrc' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'AssistantSetting' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'languages' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'tone' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'targetGroup' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'context' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'defaultChannel' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetPlaybooksQuery, GetPlaybooksQueryVariables>;
export const GetPlaybookByGroupIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetPlaybookByGroupId' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Groups' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'groupId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'assistantSettingsId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imgSrc' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'AssistantSetting' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'languages' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'tone' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'context' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'targetGroup' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'defaultChannel' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '_GroupToUserContacts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'UserContact' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetPlaybookByGroupIdQuery, GetPlaybookByGroupIdQueryVariables>;
export const GetOutreachCompletionMetricsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetOutreachCompletionMetrics' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'OutreachCompletionMetrics' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'date' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_gte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'startDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'date' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_lte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'endDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'organizationId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'organizationId',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'date' },
                                            value: { kind: 'EnumValue', value: 'asc' },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'trailingTotalCompleted' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'trailingTotalGoalsReached' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'trailingTotalSuggestions' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'completedSameDay' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'completedWithin2Days' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'completedWithin3Days' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'completedWithin7Days' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'completedWithin30Days' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'goalsReachedSameDay' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'goalsReachedWithin2Days' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'goalsReachedWithin3Days' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'goalsReachedWithin7Days' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'goalsReachedWithin30Days' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'suggestionsSameDay' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'suggestionsWithin2Days' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'suggestionsWithin3Days' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'suggestionsWithin7Days' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'suggestionsWithin30Days' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'numberOfUsers' },
                        name: { kind: 'Name', value: 'OutreachSuggestions_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'distinct_on' },
                                value: { kind: 'EnumValue', value: 'userId' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'numberOfUsersBeforePeriod' },
                        name: { kind: 'Name', value: 'OutreachSuggestions_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'distinct_on' },
                                value: { kind: 'EnumValue', value: 'userId' },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'createdAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_lt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'startDate' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetOutreachCompletionMetricsQuery, GetOutreachCompletionMetricsQueryVariables>;
export const GetDashboardMetricsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetDashboardMetrics' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'previousStartDate' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'numberOfSentMessages' },
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'organizationId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'organizationId',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'direction' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'out',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_gte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'startDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_lte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'endDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'actionType' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_in' },
                                                                            value: {
                                                                                kind: 'ListValue',
                                                                                values: [
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'LINKEDIN_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'EMAIL_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                ],
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'isSentFromApp' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'numberOfReceivedMessages' },
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'organizationId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'organizationId',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'direction' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'in',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_gte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'startDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_lte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'endDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'actionType' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_in' },
                                                                            value: {
                                                                                kind: 'ListValue',
                                                                                values: [
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'LINKEDIN_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'EMAIL_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                ],
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'numberOfNewConnections' },
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'organizationId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'organizationId',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'direction' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'in',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_gte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'startDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_lte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'endDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'actionType' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'LINKEDIN_CONNECTION_REQUEST_ACCEPTED',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectFullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'numberOfSentMessagesPrev' },
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'organizationId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'organizationId',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'direction' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'out',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_gte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'previousStartDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_lt' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'startDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'actionType' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_in' },
                                                                            value: {
                                                                                kind: 'ListValue',
                                                                                values: [
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'LINKEDIN_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'EMAIL_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                ],
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'isSentFromApp' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'numberOfReceivedMessagesPrev' },
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'organizationId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'organizationId',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'direction' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'in',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_gte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'previousStartDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_lt' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'startDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'actionType' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_in' },
                                                                            value: {
                                                                                kind: 'ListValue',
                                                                                values: [
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'LINKEDIN_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'EMAIL_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                ],
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'numberOfNewConnectionsPrev' },
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'organizationId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'organizationId',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'direction' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'in',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_gte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'previousStartDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_lt' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'startDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'actionType' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'LINKEDIN_CONNECTION_REQUEST_ACCEPTED',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectFullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetDashboardMetricsQuery, GetDashboardMetricsQueryVariables>;
export const GetTeamDashboardMetricsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetTeamDashboardMetrics' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'previousStartDate' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'numberOfSentMessages' },
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'organizationId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'organizationId',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'direction' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'out',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_gte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'startDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_lte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'endDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'actionType' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_in' },
                                                                            value: {
                                                                                kind: 'ListValue',
                                                                                values: [
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'LINKEDIN_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'EMAIL_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                ],
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'isSentFromApp' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'numberOfReceivedMessages' },
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'organizationId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'organizationId',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'direction' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'in',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_gte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'startDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_lte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'endDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'actionType' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_in' },
                                                                            value: {
                                                                                kind: 'ListValue',
                                                                                values: [
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'LINKEDIN_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'EMAIL_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                ],
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'numberOfNewConnections' },
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'organizationId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'organizationId',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'direction' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'in',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_gte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'startDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_lte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'endDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'actionType' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'LINKEDIN_CONNECTION_REQUEST_ACCEPTED',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectFullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'numberOfSentMessagesPrev' },
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'organizationId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'organizationId',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'direction' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'out',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_gte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'previousStartDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_lt' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'startDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'actionType' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_in' },
                                                                            value: {
                                                                                kind: 'ListValue',
                                                                                values: [
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'LINKEDIN_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'EMAIL_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                ],
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'isSentFromApp' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'numberOfReceivedMessagesPrev' },
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'organizationId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'organizationId',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'direction' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'in',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_gte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'previousStartDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_lt' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'startDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'actionType' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_in' },
                                                                            value: {
                                                                                kind: 'ListValue',
                                                                                values: [
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'LINKEDIN_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                    {
                                                                                        kind: 'StringValue',
                                                                                        value: 'EMAIL_MESSAGE',
                                                                                        block: false,
                                                                                    },
                                                                                ],
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'numberOfNewConnectionsPrev' },
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'organizationId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'organizationId',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'direction' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'in',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_gte' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'previousStartDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'sentOn' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_lt' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'startDate',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'actionType' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: {
                                                                                kind: 'StringValue',
                                                                                value: 'LINKEDIN_CONNECTION_REQUEST_ACCEPTED',
                                                                                block: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectFullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetTeamDashboardMetricsQuery, GetTeamDashboardMetricsQueryVariables>;
export const GetMessagesSentTodayDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetMessagesSentToday' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'isSentFromApp' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'direction' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: { kind: 'StringValue', value: 'out', block: false },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sentOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_gte' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'startDate' },
                                                        },
                                                    },
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_lte' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'endDate' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetMessagesSentTodayQuery, GetMessagesSentTodayQueryVariables>;
export const GetConversationsByMetadataDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetConversationsByMetadata' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'metadata' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Conversations' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'metadata' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'metadata' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetConversationsByMetadataQuery, GetConversationsByMetadataQueryVariables>;
export const GetMessagesByConversationMetadataDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetMessagesByConversationMetadata' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'metadata' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Messages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'metadata' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'metadata' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetMessagesByConversationMetadataQuery, GetMessagesByConversationMetadataQueryVariables>;
export const GetMessagesByMetadataFiltersDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetMessagesByMetadataFilters' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Messages_bool_exp' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '200' },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Messages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'prospectId' },
                                                    value: { kind: 'EnumValue', value: 'asc' },
                                                },
                                            ],
                                        },
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'sentOn' },
                                                    value: { kind: 'EnumValue', value: 'desc' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetMessagesByMetadataFiltersQuery, GetMessagesByMetadataFiltersQueryVariables>;
export const GetUniqueMessageMetadataValuesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetUniqueMessageMetadataValues' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Messages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'metadata' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'prospectId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '1000' },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'sentOn' },
                                                    value: { kind: 'EnumValue', value: 'desc' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'metadata' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetUniqueMessageMetadataValuesQuery, GetUniqueMessageMetadataValuesQueryVariables>;
export const GetConversationsByMetadataFiltersDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetConversationsByMetadataFilters' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Conversations_bool_exp' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '200' },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Conversations' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'prospectId' },
                                                    value: { kind: 'EnumValue', value: 'asc' },
                                                },
                                            ],
                                        },
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'updatedAt' },
                                                    value: { kind: 'EnumValue', value: 'desc' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadataLastUpdatedAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetConversationsByMetadataFiltersQuery, GetConversationsByMetadataFiltersQueryVariables>;
export const GetUniqueConversationMetadataValuesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetUniqueConversationMetadataValues' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Conversations' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_and' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'metadata' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'prospectId' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_is_null' },
                                                                            value: {
                                                                                kind: 'BooleanValue',
                                                                                value: false,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '1000' },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'updatedAt' },
                                                    value: { kind: 'EnumValue', value: 'desc' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'metadata' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetUniqueConversationMetadataValuesQuery,
    GetUniqueConversationMetadataValuesQueryVariables
>;
export const GetContactsWeightedScoresDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetContactsWeightedScores' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Contacts_bool_exp' } },
                    },
                    defaultValue: { kind: 'ObjectValue', fields: [] },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'urgent_followup_boost' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'IntValue', value: '1' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'networking_objective_weight' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'IntValue', value: '1' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'sales_objective_weight' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'IntValue', value: '1' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'customer_success_objective_weight' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'IntValue', value: '1' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'fundraising_objective_weight' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'IntValue', value: '1' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'recruiting_objective_weight' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'IntValue', value: '1' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'internal_objective_weight' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'IntValue', value: '1' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'timing_urgency_max_boost' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'FloatValue', value: '0.5' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'no_action_penalty' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'FloatValue', value: '0.05' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'shelf_base_boost' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'FloatValue', value: '1.0' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'shelf_period_days' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'FloatValue', value: '14.0' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'very_old_overdue_base_boost' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'FloatValue', value: '0.9' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'very_old_decay_rate' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'FloatValue', value: '3.0' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'due_today_boost' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'FloatValue', value: '0.8' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'due_curve_width' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'FloatValue', value: '1.5' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'future_penalty' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'FloatValue', value: '0.984' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'future_decay_rate' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'numeric' } },
                    defaultValue: { kind: 'FloatValue', value: '0.5' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '200' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contacts_weighted_scores' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'args' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'urgent_followup_boost' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'urgent_followup_boost' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'networking_objective_weight' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'networking_objective_weight' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sales_objective_weight' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'sales_objective_weight' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'customer_success_objective_weight' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'customer_success_objective_weight' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'fundraising_objective_weight' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'fundraising_objective_weight' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'recruiting_objective_weight' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'recruiting_objective_weight' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'internal_objective_weight' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'internal_objective_weight' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'timing_urgency_max_boost' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'timing_urgency_max_boost' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'no_action_penalty' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'no_action_penalty' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'shelf_base_boost' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'shelf_base_boost' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'shelf_period_days' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'shelf_period_days' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'very_old_overdue_base_boost' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'very_old_overdue_base_boost' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'very_old_decay_rate' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'very_old_decay_rate' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'due_today_boost' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'due_today_boost' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'due_curve_width' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'due_curve_width' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'future_penalty' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'future_penalty' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'future_decay_rate' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'future_decay_rate' },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'offset' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'compositeScore' },
                                            value: { kind: 'EnumValue', value: 'desc' },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'personId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumbers' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'interests' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfileUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUserId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfileImgUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinNumberOfConnections' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinHeadline' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinVerifiedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'occupationTitle' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationDomain' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationLinkedinUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationIndustry' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationSize' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'experiences' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'education' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadataLastUpdatedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userSetAsNotInterestedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'priorityScore' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'compositeScore' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'topActionType' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'objectiveScores' },
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'objectiveScores', block: false },
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'contactType' },
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'contactType', block: false },
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'relationshipType' },
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'relationshipType', block: false },
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'recommendedActions' },
                                    name: { kind: 'Name', value: 'actionsMetadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'recommendedActions', block: false },
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'urgent' },
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'urgentFollowUp', block: false },
                                        },
                                    ],
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'connectionStatus' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'connectedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastCompletedActionAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nextActionSuggestedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContactedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'numberOfMessages' },
                                    name: { kind: 'Name', value: 'Messages_aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'aggregate' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Messages' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'order_by' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: { kind: 'EnumValue', value: 'desc_nulls_last' },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'limit' },
                                            value: { kind: 'IntValue', value: '1' },
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectFullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'total_contacts' },
                        name: { kind: 'Name', value: 'Contacts_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_not' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'filtered_contacts_count' },
                        name: { kind: 'Name', value: 'contacts_weighted_scores_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'args' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'urgent_followup_boost' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'urgent_followup_boost' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'networking_objective_weight' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'networking_objective_weight' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sales_objective_weight' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'sales_objective_weight' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'customer_success_objective_weight' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'customer_success_objective_weight' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'fundraising_objective_weight' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'fundraising_objective_weight' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'recruiting_objective_weight' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'recruiting_objective_weight' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'internal_objective_weight' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'internal_objective_weight' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'timing_urgency_max_boost' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'timing_urgency_max_boost' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'no_action_penalty' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'no_action_penalty' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'shelf_base_boost' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'shelf_base_boost' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'shelf_period_days' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'shelf_period_days' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'very_old_overdue_base_boost' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'very_old_overdue_base_boost' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'very_old_decay_rate' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'very_old_decay_rate' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'due_today_boost' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'due_today_boost' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'due_curve_width' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'due_curve_width' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'future_penalty' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'future_penalty' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'future_decay_rate' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'future_decay_rate' },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetContactsWeightedScoresQuery, GetContactsWeightedScoresQueryVariables>;
export const GetContactAndConversationByIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetContactAndConversationById' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageLimit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '20' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'noteLimit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '20' },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Contacts_by_pk' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'personId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumbers' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'interests' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfileUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUserId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfileImgUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinNumberOfConnections' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinHeadline' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinVerifiedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'connectionStatus' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'connectedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'occupationTitle' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationDomain' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationLinkedinUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationIndustry' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationSize' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'experiences' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'education' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadataLastUpdatedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actionsMetadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'priorityScore' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'topActionType' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'objectiveScores' },
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'objectiveScores', block: false },
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'contactType' },
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'contactType', block: false },
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'relationshipType' },
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'relationshipType', block: false },
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'recommendedActions' },
                                    name: { kind: 'Name', value: 'actionsMetadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'recommendedActions', block: false },
                                        },
                                    ],
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'connectedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastCompletedActionAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nextActionSuggestedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContactedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'numberOfMessages' },
                                    name: { kind: 'Name', value: 'Messages_aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'aggregate' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'conversationMetadata' },
                                    name: { kind: 'Name', value: 'Conversations' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'metadata' },
                                                arguments: [
                                                    {
                                                        kind: 'Argument',
                                                        name: { kind: 'Name', value: 'path' },
                                                        value: {
                                                            kind: 'StringValue',
                                                            value: 'conversationSummary',
                                                            block: false,
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Messages' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'where' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: false },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'limit' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'messageLimit' } },
                                        },
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'order_by' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: { kind: 'EnumValue', value: 'asc' },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'linkedinUserId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'externalMessageId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectFullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'Attachments' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Notes' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'limit' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'noteLimit' } },
                                        },
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'order_by' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'happenedOn' },
                                                        value: { kind: 'EnumValue', value: 'desc_nulls_first' },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'where' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'discarded' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: false },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'creator' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'happenedOn' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '_GroupToContacts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'Group' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetContactAndConversationByIdQuery, GetContactAndConversationByIdQueryVariables>;
export const GetTotalNumberOfContactsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetTotalNumberOfContacts' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Contacts_aggregate' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetTotalNumberOfContactsQuery, GetTotalNumberOfContactsQueryVariables>;
export const GetContactsForTableDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetContactsForTable' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'Contacts_order_by' } },
                            },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Contacts_bool_exp' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Contacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'offset' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'personId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumbers' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'interests' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfileUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUserId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfileImgUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinNumberOfConnections' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinHeadline' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinVerifiedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'occupationTitle' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationDomain' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationLinkedinUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationIndustry' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationSize' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'experiences' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'education' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadataLastUpdatedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actionsMetadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'priorityScore' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'topActionType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'connectedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastCompletedActionAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nextActionSuggestedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContactedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '_GroupToContacts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'Group' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'imgSrc' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'assistantSettingsId' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Contacts_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetContactsForTableQuery, GetContactsForTableQueryVariables>;
export const GetContactByIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetContactById' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Contacts_by_pk' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'personId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumbers' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'interests' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfileUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUserId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfileImgUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinNumberOfConnections' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinHeadline' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinVerifiedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'occupationTitle' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationDomain' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationLinkedinUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationIndustry' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationSize' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'experiences' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'education' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actionsMetadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'priorityScore' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'topActionType' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'objectiveScores' },
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'objectiveScores', block: false },
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'contactType' },
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'contactType', block: false },
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'relationshipType' },
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'relationshipType', block: false },
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'recommendedActions' },
                                    name: { kind: 'Name', value: 'actionsMetadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'recommendedActions', block: false },
                                        },
                                    ],
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'connectedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'daysSinceLastMsg' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContactedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetContactByIdQuery, GetContactByIdQueryVariables>;
export const GetContactByIdsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetContactByIds' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Contacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_in' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'ids' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'personId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumbers' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'interests' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfileUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUserId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfileImgUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinNumberOfConnections' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinHeadline' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinVerifiedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'occupationTitle' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationDomain' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationLinkedinUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationIndustry' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationSize' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'experiences' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'education' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actionsMetadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'priorityScore' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'topActionType' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'objectiveScores' },
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'objectiveScores', block: false },
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'contactType' },
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'contactType', block: false },
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'relationshipType' },
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'relationshipType', block: false },
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'recommendedActions' },
                                    name: { kind: 'Name', value: 'actionsMetadata' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'path' },
                                            value: { kind: 'StringValue', value: 'recommendedActions', block: false },
                                        },
                                    ],
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'connectedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'daysSinceLastMsg' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContactedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetContactByIdsQuery, GetContactByIdsQueryVariables>;
export const GetSampleContactsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetSampleContacts' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SampleContacts_order_by' } },
                        },
                    },
                    defaultValue: {
                        kind: 'ListValue',
                        values: [
                            {
                                kind: 'ObjectValue',
                                fields: [
                                    {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'updatedAt' },
                                        value: { kind: 'EnumValue', value: 'desc' },
                                    },
                                ],
                            },
                        ],
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'SampleContacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'offset' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversation' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'SampleContacts_aggregate' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetSampleContactsQuery, GetSampleContactsQueryVariables>;
export const GetLatestMessageDraftOneDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetLatestMessageDraftOne' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'MessageDrafts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'contactId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'contactId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'archivedAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'updatedAt' },
                                            value: { kind: 'EnumValue', value: 'desc' },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '1' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userPrompt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetLatestMessageDraftOneQuery, GetLatestMessageDraftOneQueryVariables>;
export const GetAutoGenerateDraftDataDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetAutoGenerateDraftData' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Contacts_by_pk' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastCompletedActionAt' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'latestMessage' },
                                    name: { kind: 'Name', value: 'Messages' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'where' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: false },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'order_by' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: { kind: 'EnumValue', value: 'desc' },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'limit' },
                                            value: { kind: 'IntValue', value: '1' },
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'latestDraft' },
                                    name: { kind: 'Name', value: 'MessageDrafts' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'where' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'archivedAt' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: true },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'order_by' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'updatedAt' },
                                                        value: { kind: 'EnumValue', value: 'desc' },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'limit' },
                                            value: { kind: 'IntValue', value: '1' },
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetAutoGenerateDraftDataQuery, GetAutoGenerateDraftDataQueryVariables>;
export const GetContactClassificationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetContactClassification' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Contacts_by_pk' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actionsMetadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'priorityScore' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'topActionType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nextActionSuggestedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'conversationMetadata' },
                                    name: { kind: 'Name', value: 'Conversations' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'metadata' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'messagesMetadata' },
                                    name: { kind: 'Name', value: 'Messages' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'metadata' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetContactClassificationQuery, GetContactClassificationQueryVariables>;
export const GetContactsInteractionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetContactsInteractions' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'notInterestedInteractions' },
                        name: { kind: 'Name', value: 'ContactsInteractions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'interactionType' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'StringValue',
                                                            value: 'NOT_INTERESTED',
                                                            block: false,
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'createdAt' },
                                            value: { kind: 'EnumValue', value: 'desc' },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '10' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'weights' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'interactionType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'otherInteractions' },
                        name: { kind: 'Name', value: 'ContactsInteractions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'interactionType' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_neq' },
                                                        value: {
                                                            kind: 'StringValue',
                                                            value: 'NOT_INTERESTED',
                                                            block: false,
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'createdAt' },
                                            value: { kind: 'EnumValue', value: 'desc' },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '30' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'weights' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'interactionType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetContactsInteractionsQuery, GetContactsInteractionsQueryVariables>;
export const GetContactProfilesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetContactProfiles' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Contacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'metadataLastUpdatedAt' },
                                            value: { kind: 'EnumValue', value: 'desc' },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_or' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'fullName' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_ilike' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: { kind: 'Name', value: 'search' },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'organizationName' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_ilike' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: { kind: 'Name', value: 'search' },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'occupationTitle' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_ilike' },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: { kind: 'Name', value: 'search' },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfileImgUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'occupationTitle' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetContactProfilesQuery, GetContactProfilesQueryVariables>;
export const GetNumberOfUrgentActionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetNumberOfUrgentActions' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'urgentContacts' },
                        name: { kind: 'Name', value: 'Contacts_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'metadata' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_contains' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: 'urgentFollowUp' },
                                                                    value: { kind: 'BooleanValue', value: true },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetNumberOfUrgentActionsQuery, GetNumberOfUrgentActionsQueryVariables>;
export const GetConversationsWithContactsQueryDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetConversationsWithContactsQuery' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '25' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Conversations_bool_exp' } },
                    defaultValue: { kind: 'ObjectValue', fields: [] },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Conversations' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'offset' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'Messages_aggregate' },
                                                    value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'max' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: 'sentOn' },
                                                                            value: {
                                                                                kind: 'EnumValue',
                                                                                value: 'desc_nulls_last',
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Contact' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfileImgUrl' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'linkedinUserId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'occupationTitle' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'nextActionSuggestedAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '_GroupToContacts' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'Group' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'id' },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Messages' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'where' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: false },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'order_by' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: { kind: 'EnumValue', value: 'desc' },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'limit' },
                                            value: { kind: 'IntValue', value: '1' },
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetConversationsWithContactsQueryQuery, GetConversationsWithContactsQueryQueryVariables>;
export const GetConversationCountsByGroupsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetConversationCountsByGroups' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'availableGroupIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'totalCount' },
                        name: { kind: 'Name', value: 'Conversations_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Messages' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: false },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'unassignedCount' },
                        name: { kind: 'Name', value: 'Conversations_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Messages' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: false },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_or' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'Contact' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: {
                                                                                kind: 'Name',
                                                                                value: '_GroupToContacts',
                                                                            },
                                                                            value: {
                                                                                kind: 'ObjectValue',
                                                                                fields: [
                                                                                    {
                                                                                        kind: 'ObjectField',
                                                                                        name: {
                                                                                            kind: 'Name',
                                                                                            value: 'Group',
                                                                                        },
                                                                                        value: {
                                                                                            kind: 'ObjectValue',
                                                                                            fields: [
                                                                                                {
                                                                                                    kind: 'ObjectField',
                                                                                                    name: {
                                                                                                        kind: 'Name',
                                                                                                        value: 'id',
                                                                                                    },
                                                                                                    value: {
                                                                                                        kind: 'ObjectValue',
                                                                                                        fields: [
                                                                                                            {
                                                                                                                kind: 'ObjectField',
                                                                                                                name: {
                                                                                                                    kind: 'Name',
                                                                                                                    value: '_is_null',
                                                                                                                },
                                                                                                                value: {
                                                                                                                    kind: 'BooleanValue',
                                                                                                                    value: true,
                                                                                                                },
                                                                                                            },
                                                                                                        ],
                                                                                                    },
                                                                                                },
                                                                                            ],
                                                                                        },
                                                                                    },
                                                                                ],
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'Contact' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_not' },
                                                                            value: {
                                                                                kind: 'ObjectValue',
                                                                                fields: [
                                                                                    {
                                                                                        kind: 'ObjectField',
                                                                                        name: {
                                                                                            kind: 'Name',
                                                                                            value: '_GroupToContacts',
                                                                                        },
                                                                                        value: {
                                                                                            kind: 'ObjectValue',
                                                                                            fields: [
                                                                                                {
                                                                                                    kind: 'ObjectField',
                                                                                                    name: {
                                                                                                        kind: 'Name',
                                                                                                        value: 'Group',
                                                                                                    },
                                                                                                    value: {
                                                                                                        kind: 'ObjectValue',
                                                                                                        fields: [
                                                                                                            {
                                                                                                                kind: 'ObjectField',
                                                                                                                name: {
                                                                                                                    kind: 'Name',
                                                                                                                    value: 'id',
                                                                                                                },
                                                                                                                value: {
                                                                                                                    kind: 'ObjectValue',
                                                                                                                    fields: [
                                                                                                                        {
                                                                                                                            kind: 'ObjectField',
                                                                                                                            name: {
                                                                                                                                kind: 'Name',
                                                                                                                                value: '_in',
                                                                                                                            },
                                                                                                                            value: {
                                                                                                                                kind: 'Variable',
                                                                                                                                name: {
                                                                                                                                    kind: 'Name',
                                                                                                                                    value: 'availableGroupIds',
                                                                                                                                },
                                                                                                                            },
                                                                                                                        },
                                                                                                                    ],
                                                                                                                },
                                                                                                            },
                                                                                                        ],
                                                                                                    },
                                                                                                },
                                                                                            ],
                                                                                        },
                                                                                    },
                                                                                ],
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetConversationCountsByGroupsQuery, GetConversationCountsByGroupsQueryVariables>;
export const GetConversationCountByGroupDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetConversationCountByGroup' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'groupCount' },
                        name: { kind: 'Name', value: 'Conversations_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Messages' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: false },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Contact' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_GroupToContacts' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: 'Group' },
                                                                    value: {
                                                                        kind: 'ObjectValue',
                                                                        fields: [
                                                                            {
                                                                                kind: 'ObjectField',
                                                                                name: { kind: 'Name', value: 'id' },
                                                                                value: {
                                                                                    kind: 'ObjectValue',
                                                                                    fields: [
                                                                                        {
                                                                                            kind: 'ObjectField',
                                                                                            name: {
                                                                                                kind: 'Name',
                                                                                                value: '_eq',
                                                                                            },
                                                                                            value: {
                                                                                                kind: 'Variable',
                                                                                                name: {
                                                                                                    kind: 'Name',
                                                                                                    value: 'groupId',
                                                                                                },
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetConversationCountByGroupQuery, GetConversationCountByGroupQueryVariables>;
export const GetContactsByStartDatePatternDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetContactsByStartDatePattern' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'pattern' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Contacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'experiences' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_cast' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: 'String' },
                                                                    value: {
                                                                        kind: 'ObjectValue',
                                                                        fields: [
                                                                            {
                                                                                kind: 'ObjectField',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: '_iregex',
                                                                                },
                                                                                value: {
                                                                                    kind: 'Variable',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'pattern',
                                                                                    },
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '1' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'experiences' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'occupationTitle' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfileUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfileImgUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetContactsByStartDatePatternQuery, GetContactsByStartDatePatternQueryVariables>;
export const GetProspectNotesSubscriptionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'GetProspectNotesSubscription' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Notes' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'discarded' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'createdAt' },
                                                    value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetProspectNotesSubscriptionSubscription,
    GetProspectNotesSubscriptionSubscriptionVariables
>;
export const NextScheduledOutreachSuggestionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'NextScheduledOutreachSuggestions' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '1' },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: true },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'unread' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'scheduledOn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'scheduledOnMotivation' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Message' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'linkedinUserId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    NextScheduledOutreachSuggestionsSubscription,
    NextScheduledOutreachSuggestionsSubscriptionVariables
>;
export const OnMessageAddedByProspectIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'OnMessageAddedByProspectId' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Messages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sentOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'prospectId' },
                                                    value: { kind: 'EnumValue', value: 'desc' },
                                                },
                                            ],
                                        },
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'sentOn' },
                                                    value: { kind: 'EnumValue', value: 'desc' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'distinct_on' },
                                value: { kind: 'EnumValue', value: 'prospectId' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sentOn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectFullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'OutreachSuggestion' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<OnMessageAddedByProspectIdSubscription, OnMessageAddedByProspectIdSubscriptionVariables>;
export const GetLinkedinConversationsSubscriptionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'GetLinkedinConversationsSubscription' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'LinkedinConversations' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'lastMessageSentAt' },
                                            value: { kind: 'EnumValue', value: 'desc' },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastMessageType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastMessageText' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastMessageSentAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastMessageSentDirection' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'participantMemberIds' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetLinkedinConversationsSubscriptionSubscription,
    GetLinkedinConversationsSubscriptionSubscriptionVariables
>;
export const GetOutreachSuggestionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'GetOutreachSuggestion' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledOnBefore' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_lt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'scheduledOnBefore' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: true },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'createdAt' },
                                                        value: { kind: 'EnumValue', value: 'desc' },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'unread' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'scheduledOn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isGenerating' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Message' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'linkedinUserId' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ConversationMetaData' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topics' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetOutreachSuggestionSubscription, GetOutreachSuggestionSubscriptionVariables>;
export const GetProspectFutureActionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'GetProspectFutureActions' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledOnBefore' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamp' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_gt' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'scheduledOnBefore' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: true },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'createdAt' },
                                                        value: { kind: 'EnumValue', value: 'desc' },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'scheduledOn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'scheduledOnMotivation' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetProspectFutureActionsSubscription, GetProspectFutureActionsSubscriptionVariables>;
export const GetProspectUnscheduledActionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'GetProspectUnscheduledActions' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'OutreachSuggestions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'scheduledOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'sentOn' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: { kind: 'Name', value: '_is_null' },
                                                                    value: { kind: 'BooleanValue', value: true },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'Message' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'createdAt' },
                                                        value: { kind: 'EnumValue', value: 'desc' },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'scheduledOnMotivation' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetProspectUnscheduledActionsSubscription,
    GetProspectUnscheduledActionsSubscriptionVariables
>;
export const OnMessageUpdatedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'OnMessageUpdated' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Messages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'messageId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subjectLine' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Attachments' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<OnMessageUpdatedSubscription, OnMessageUpdatedSubscriptionVariables>;
export const GetProspectMessagesHistorySubscriptionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'GetProspectMessagesHistorySubscription' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Messages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectId' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sentOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'sentOn' },
                                                    value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetProspectMessagesHistorySubscriptionSubscription,
    GetProspectMessagesHistorySubscriptionSubscriptionVariables
>;
export const GetAssistantSettingsStreamingSubscriptionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'GetAssistantSettingsStreamingSubscription' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'AssistantSettings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'languages' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'tone' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'context' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'defaultChannel' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetAssistantSettingsStreamingSubscriptionSubscription,
    GetAssistantSettingsStreamingSubscriptionSubscriptionVariables
>;
export const GetUserContactsSubscriptionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'GetUserContactsSubscription' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'UserContacts' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '_GroupToUserContacts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'Group' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'imgSrc' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetUserContactsSubscriptionSubscription, GetUserContactsSubscriptionSubscriptionVariables>;
export const OnUserContactsByIdsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'OnUserContactsByIds' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'prospectIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'UserContacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'prospectId' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_in' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'prospectIds' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '_GroupToUserContacts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'Group' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'imgSrc' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<OnUserContactsByIdsSubscription, OnUserContactsByIdsSubscriptionVariables>;
export const GetGroupsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'GetGroups' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Groups' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'createdAt' },
                                            value: { kind: 'EnumValue', value: 'asc' },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'assistantSettingsId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imgSrc' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetGroupsSubscription, GetGroupsSubscriptionVariables>;
export const GetPlaybookByGroupIdSubscriptionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'GetPlaybookByGroupIdSubscription' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Groups_by_pk' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'assistantSettingsId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imgSrc' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'AssistantSetting' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'languages' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'tone' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'context' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'targetGroup' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'defaultChannel' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '_GroupToUserContacts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'UserContact' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetPlaybookByGroupIdSubscriptionSubscription,
    GetPlaybookByGroupIdSubscriptionSubscriptionVariables
>;
export const GetNotesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'GetNotes' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Notes' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'discarded' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'createdAt' },
                                            value: { kind: 'EnumValue', value: 'asc' },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'creator' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetNotesSubscription, GetNotesSubscriptionVariables>;
export const GetContactSuggestionsCountSubscriptionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'GetContactSuggestionsCountSubscription' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ContactSuggestions_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'approvedAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'rejectedAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'expiresAt' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_gt' },
                                                        value: { kind: 'StringValue', value: 'now()', block: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetContactSuggestionsCountSubscriptionSubscription,
    GetContactSuggestionsCountSubscriptionSubscriptionVariables
>;
export const GetMessagesSentFromAppSubscriptionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'GetMessagesSentFromAppSubscription' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Messages_aggregate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'isSentFromApp' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: { kind: 'BooleanValue', value: true },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sentOn' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_is_null' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'direction' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: { kind: 'StringValue', value: 'out', block: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetMessagesSentFromAppSubscriptionSubscription,
    GetMessagesSentFromAppSubscriptionSubscriptionVariables
>;
